/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Boot Notification Serializer */
export interface APIBootNotification {
  id: number;
  /** @maxLength 26 */
  charge_box_serial_number?: string | null;
  /** @maxLength 21 */
  charge_point_model: string;
  /** @maxLength 26 */
  charge_point_serial_number?: string | null;
  /** @maxLength 21 */
  charge_point_vendor: string;
  /** @maxLength 51 */
  firmware_version?: string | null;
  /** @maxLength 21 */
  iccid?: string | null;
  /** @maxLength 21 */
  imsi?: string | null;
  /** @maxLength 26 */
  meter_serial_number?: string | null;
  /** @maxLength 26 */
  meter_type?: string | null;
  /** @format date-time */
  current_time: string;
  /**
   * @min 0
   * @max 2147483647
   */
  interval?: number;
  /**
   * * `Accepted` - Accepted
   * * `Pending` - Pending
   * * `Rejected` - Rejected
   */
  status: RegistrationStatusEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

export interface LatLng {
  latitude: number;
  longitude: number;
}

/** Charge Point Serializer */
export interface APIChargePoint {
  id: number;
  connectors: APIConnector[];
  configuration_keys: APIConfigurationKey[];
  latest_heartbeat: APIHeartbeat;
  latest_boot_notification: APIBootNotification;
  latest_status_notification: APIStatusNotification;
  /** @example {"latitude":-33.41476682287769,"longitude":-70.584030204484} */
  location?: LatLng;
  /**
   * Charge Point Identity
   * @maxLength 40
   * @pattern ^[a-zA-Z\d\-_.]+$
   */
  name: string;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @maxLength 21 */
  vendor?: string | null;
  /** @maxLength 21 */
  model?: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  charger_efficiency?: string | null;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  /** Use P=V·I·cos(0) */
  use_vi?: boolean;
  /** Is single Phase? */
  is_single_phase?: boolean;
  /**
   * Local Authorization List Version
   * @min 0
   * @max 2147483647
   */
  local_list_version?: number;
  /** Enable Free Pass */
  free_pass?: boolean;
  /** Enable Auto Start */
  auto_start?: boolean;
  /** Enable Vehicle RFID */
  vehicle_rfid?: boolean;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable Manual Filling of Fields */
  fill_manual_fields?: boolean;
  /**
   * Remaining Time Threshold for Notifications (seconds)
   * @min 0
   * @max 32767
   */
  remaining_time_threshold?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * Start Period
   * @format time
   */
  start_day?: string;
  /** @maxLength 300 */
  additional_info?: string | null;
  grid_connection?: number;
  vehicle_station?: number | null;
  /** Charge Point Group */
  group?: number;
  firmware?: number | null;
}

/** Charging Profile Serializer */
export interface APIChargingProfile {
  id: number;
  charging_schedule: APIChargingSchedule;
  /**
   * @min 0
   * @max 32767
   * @default 0
   */
  stack_level?: number;
  /**
   * * `ChargePointMaxProfile` - ChargePointMaxProfile
   * * `TxDefaultProfile` - TxDefaultProfile
   * * `TxProfile` - TxProfile
   */
  charging_profile_purpose: ChargingProfilePurposeEnum;
  /**
   * * `Absolute` - Absolute
   * * `Recurring` - Recurring
   * * `Relative` - Relative
   */
  charging_profile_kind: ChargingProfileKindEnum;
  recurrency_kind?: RecurrencyKindEnum | null;
  /** @format date-time */
  valid_from?: string | null;
  /** @format date-time */
  valid_to?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** Synchronizing Status */
  sync_status?: SyncStatusD22Enum | null;
  /**
   * Synchronizing Task Id
   * @maxLength 37
   */
  sync_task_id?: string | null;
  connector: number;
  transaction?: number | null;
}

/** Charging Schedule Serializer */
export interface APIChargingSchedule {
  charging_profile: number;
  charging_schedule_periods?: APIChargingSchedulePeriod[];
  duration?: string | null;
  /** @format date-time */
  start_schedule?: string | null;
  /**
   * * `W` - W
   * * `A` - A
   */
  charging_rate_unit?: ChargingRateUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  min_charging_rate?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Charging Schedule Period Serializer */
export interface APIChargingSchedulePeriod {
  id: number;
  start_period: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  limit: string;
  /**
   * Number of Phases
   * @min 0
   * @max 32767
   */
  number_phases?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charging_schedule: number;
}

/** Configuration Key Serializer */
export interface APIConfigurationKey {
  id: number;
  /** Configuration Key Name */
  key: KeyEnum;
  /** Read Only */
  readonly: boolean;
  /** @maxLength 501 */
  value?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/** Connector Serializer */
export interface APIConnector {
  id: number;
  charging_profiles: APIChargingProfile[];
  latest_transaction: APITransaction;
  latest_meter_value: APIMeterValue;
  latest_status_notification: APIStatusNotification;
  qr_code: string | null;
  latest_reservation: APIReservationBasic;
  /**
   * @min 0
   * @max 2147483647
   * @default 0
   */
  connector_id?: number;
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  availability?: AvailabilityTypeEnum;
  /**
   * Connector Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /**
   * * `NoPlug` - No Plug
   * * `CCS1` - Ccs1
   * * `CCS2` - Ccs2
   * * `CHAdeMO` - CHAdeMO (Type 4)
   * * `GB/T DC` - Gbt Dc
   * * `Tesla` - Tesla
   * * `GB/T AC` - Gbt Ac
   * * `J1772` - J1772 (Type 1)
   * * `Mennekes` - Mennekes (Type 2)
   */
  plug_type?: PlugTypeEnum;
  /**
   * @min 1
   * @max 100
   */
  final_soc?: number;
  enabled?: boolean;
  /** @maxLength 100 */
  math_price?: string;
  /**
   * Power by connector
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,1})?$
   */
  power?: string;
  power_category?: PowerCategoryEb2Enum | null;
  supports_preparing?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/** Contract Snapshot Serializer */
export interface APIContractSnapshot {
  id: number;
  gross_price: string;
  net_price: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  transaction: number;
  contract?: number | null;
}

/** Credit card serializer */
export interface APICreditCard {
  id: number;
  kushki_subscription_id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  default?: boolean;
  /** @maxLength 256 */
  card_holder_name: string;
  /** @maxLength 4 */
  last_four_digits: string;
  /** @maxLength 32 */
  payment_brand: string;
  /**
   * Bank identification number
   * @maxLength 6
   */
  bin: string;
  /** @maxLength 12 */
  card_type: string;
  /** @maxLength 128 */
  bank: string;
  /** @maxLength 32 */
  country: string;
  user: number;
}

/** Heartbeat Serializer */
export interface APIHeartbeat {
  id: number;
  /** @format date-time */
  current_time?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/** Meter Value Serializer */
export interface APIMeterValue {
  id: number;
  sampled_values: APISampledValue[];
  /** Price Processed? */
  price_processed?: boolean;
  /** @format date-time */
  timestamp?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  connector: number;
  transaction?: number | null;
}

/** ModelSerializer for PaymentAuthorization */
export interface APIPaymentAuthorization {
  id: number;
  gross_amount: string;
  net_amount: string;
  /** @maxLength 32 */
  payment_ticket_id: string;
  /** @maxLength 64 */
  kushki_transaction_reference: string;
  /** Payment Status */
  status?: Status9DcEnum | null;
}

export interface TsRange {
  lower: string;
  upper: string;
  bounds: string;
}

/** PricingDetail Serializer */
export interface APIPricingDetail {
  id: number;
  gross_price: string;
  net_price: string;
  gross_price_per_unit: string;
  net_price_per_unit: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop: string;
  /**
   * Pricing Detail Range
   * @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"}
   */
  tsrange: TsRange;
  /**
   * * `PER_MINUTE` - Per Minute
   * * `PER_KWH` - Per kWh
   */
  contract_kind: ContractKind4D9Enum;
  /**
   * * `Slow` - Slow
   * * `Intermediate` - Intermediate
   * * `Fast` - Fast
   * * `Ultra_Fast` - Ultra Fast
   */
  power_category: PowerCategoryEb2Enum;
  /**
   * * `FLAT_RATE` - Flat Rate
   * * `PEAK_RATE` - Peak Rate
   * * `OFF_PEAK_RATE` - Off-peak Rate
   */
  contract_period_verbose_name?: ContractPeriodVerboseNameEnum;
  transaction: number;
}

/** Reservation Basic Serializer (no data about User or Transaction) */
export interface APIReservationBasic {
  connector: number;
  /** @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"} */
  tsrange: TsRange;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Sampled Value Serializer */
export interface APISampledValue {
  id: number;
  connector: number;
  /** @format date-time */
  timestamp: string;
  /** @maxLength 255 */
  value: string;
  /**
   * * `Interruption.Begin` - Interruption.Begin
   * * `Interruption.End` - Interruption.End
   * * `Other` - Other
   * * `Sample.Clock` - Sample.Clock
   * * `Sample.Periodic` - Sample.Periodic
   * * `Transaction.Begin` - Transaction.Begin
   * * `Transaction.End` - Transaction.End
   * * `Trigger` - Trigger
   */
  context?: ContextEnum;
  /**
   * * `Raw` - Raw
   * * `SignedData` - SignedData
   */
  value_format?: ValueFormatEnum;
  /** @default "Energy.Active.Import.Register" */
  measurand?: Measurand2D5Enum;
  phase?: PhaseEnum | null;
  /**
   * * `Inlet` - Inlet
   * * `Outlet` - Outlet
   * * `Body` - Body
   * * `Cable` - Cable
   * * `EV` - EV
   */
  location?: LocationEnum;
  /** Unit Of Measure */
  unit?: UnitEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  meter_value: number;
}

/** Status Notification Serializer */
export interface APIStatusNotification {
  id: number;
  /** Charge Point Error Code */
  error_code: ErrorCodeEnum;
  /**
   * Information Related to the Error
   * @maxLength 51
   */
  info?: string | null;
  /** Charge Point Status */
  status: ChargePointStatusEnum;
  /** @format date-time */
  timestamp?: string;
  /** @maxLength 256 */
  vendor_id?: string | null;
  /** @maxLength 51 */
  vendor_error_code?: string | null;
  /**
   * * `Error not interpreted` - Not Interpreted
   * * `UpdateFail` - Fail to update software
   * * `ResetFailure` - Fail to reset
   * * `GunTemperature` - Gun over-temperature
   * * `TrialPeriodOver` - The trial period is over
   * * `EmergencyStop` - Emergency stop
   * * `BleederResistor` - Bleeder resistor failure
   * * `Insulation` - Insulation failure (several times)
   * * `OpenDoor` - Open door
   * * `MeterFault` - Meter failure
   * * `BEMAlarmStop` - BEM alarm stop
   * * `BSMMessage` - BSM message
   * * `BROFault` - BRO fault
   * * `OuterVoltageRelay` - Outer voltage relay
   * * `BRMTimeOut` - BRM timeout
   * * `BCPTimeOut` - BCP timeout
   * * `BROTimeOut` - BRO timeout
   * * `BCLTimeOut` - BCL timeout
   * * `BSTTimeOut` - BST timeout
   * * `BSDTimeOut` - BSD timeout
   * * `BSMInsulation` - BSM insulation fault
   * * `BMSOutputTemperature` - BMS output over-temperature
   * * `BMSComponentTemperature` - BMS component over-temperature
   * * `BMSBatteryOverTemperature` - BMS Battery over-temperature
   * * `BMSHighCurrent` - BMS over current
   * * `BMSVoltageAbnormality` - BMS Voltage Abnormality
   * * `BMSOtherErrors` - BMS Other Errors
   * * `PowerModuleCommunicationFault` - Power Module Communication Fault
   * * `InputOverVoltage` - Input Over Voltage
   * * `InputUnderVoltage` - Input Under Voltage
   * * `GenericError` - Generic Error
   * * `MainsPowerSupply` - Mains Power Supply Failure
   * * `TemperatureOutOfRange` - Temperature out of range
   * * `InternalComunicationsError` - Internal communications error
   * * `ConfigurationError` - Configuration Error
   * * `MainsGroundFailure` - Mains ground failure
   * * `MainsVoltageOutOfRange` - Mains voltage out of range
   * * `MainsFrequencyOutOfRange` - Mains Frequency out of range
   * * `HighTemperatureError` - High temperature error
   * * `LowTemperatureError` - Low temperature error
   * * `ExternalComunicationsError` - External communications error
   * * `ErrorMasterEntity` - Error in master entity
   * * `SlaveError` - Error in slave entity
   * * `DoorTamperAlarm` - Door Tamper Error
   * * `TiltError` - Tilt error
   * * `DisplayFailure` - Display Failure
   * * `RfidReaderFailure` - RFID reader failure
   * * `PowerMeterFailure` - Power Meter Comunication Error
   * * `GenericVehicleError` - Generic Vehicle Error
   * * `VehicleComunicationError` - Vehicle Comunication Error
   * * `VehicleNotDetected` - Vehicle not detected
   * * `VehicleOverCurrent` - Vehicle over current consumption
   * * `CordMalfunction` - Cord malfunction
   * * `CordSensorMalfunction` - Cord sensor malfunction
   * * `ConnectorLockFailure` - Connector Lock Failure
   * * `InternalPowerSupplyFailure` - Internal power supply failure
   * * `ComponentTemperatureOutRange` - Component temperature out of range
   * * `HardwareFailureMode4` - Hardware Failure Mode4
   * * `HardwareFailureNodes` - Hardware Failure Nodes
   * * `AcDcConvertersGenericError` - AC/DC converters Error
   * * `AcDcConvertersTimeOutError` - AC/DC converters time out Error
   * * `AcDcConvertersVoltageOutRange` - AC/DC converters voltage out of range
   * * `AcDcConvertersCurrentOutRange` - AC/DC converters current out of range
   * * `WeldingContactor` - Welding Contactor
   * * `CurrentLeakDetected` - Current Leak Detected
   * * `ElectricalProtectionTriggered` - Electrica Protection Triggered
   * * `IsolationError` - Isolation error
   * * `RcdProtectionTriggered` - RCD protection triggered
   * * `McbProtectionTriggered` - MCB protection triggered (Over Current protection Triggered)
   * * `ProgramCounterFailure` - Program Counter Failure
   * * `Invalid` - Reason for stopping cannot be identified
   * * `NoError` - No error ocurred, similar to a normal stop
   * * `UserRequestStop` - User pressed the stop button on HMI
   * * `ConnectorButtonPressed` - CSS1 connector button is pressed by user
   * * `VehicleStop` - This vehicle requested to stop the session by a driver request
   * * `IncompatibleVehicle` - This vehicle cannot be charged on this outlet
   * * `IsolationTestFailed` - Isolation resistance is to low
   * * `CableCheckFailed` - Isolation failure during cable check phase
   * * `BatteryFull` - Stopped because the vehicle battery is full
   * * `BudgetExceeded` - Stopped because the vehicle asked for or tried to draw to much power
   * * `ChargerError` - Chargin Protocol Interface (CPI) board error
   * * `ChargerContactorProblem` - Charger contactor problem
   * * `ChargerLoweringCurrentTimeout` - Charge does not follow the request reduction of current near to full charge
   * * `ConnectorError` - Connector Error
   * * `ConnectorPilotError` - Conector pilot error
   * * `ControlPilotShorCircuit` - Control pilot is in short-circuit. it can be caused by bad wiring
   * * `ConnectorTemperatureError` - The connector is too hot
   * * `Outlet error` - problem of CPI/IMI assebly, CCB or CAN cable between CCB and CPI
   * * `chargerPreChargerTimeout` - Precharger timeout is reached
   * * `ChargerVoltageDrop` - Measure voltage is lower than the expected
   * * `ChargerMaxVoltage` - Maximum voltage exceeded
   * * `ChargedStopTimeout` - Vehicle takes too log to send the stop command
   * * `ChargerConnectorPresenceLost` - Charger was not able to pick Control pilor state changes from the vehicle
   * * `ChargerErrorCurrentDifference` - The charger detected thar the current difference is too large
   * * `ChargerCANCommunicationLost` - he power cabinet internal CAN bus communication is lost
   * * `ChargerMCBTripped` - Charger circuit breaker tripped
   * * `ChargedRCDTriped` - the AC input (from the grid) Residual Current Device tripped
   * * `ChargerRCDCloseError` - Residual Current Device Closing Error
   * * `ChargefTemperatureError` - The temperature of the power cabinet or charge is high
   * * `ChargerNeutralMismatch` - Charger neutral mismatch
   * * `ChargerOutletDetection` - Charger outlet detection
   * * `VehicleProtocolError` - Vehicle protocol error
   * * `PowerPortVipError` - The powerport vip value is showing zero
   * * `Power port power error` - Power module does not respond fast enough
   * * `PowerPortFanFailure` - All power module affected by a fan failure
   * * `PowerPortOverheat` - All power modules show a high temperature
   * * `PowerPortInterlock` - Interlock of power modules acttive
   * * `PowerPortErrorOther` - Umbrella error for any other power modules related errors
   * * `VehicleErrorReversePolarity` - The polarityo the vehicle is reversed
   * * `VehicleErrorVoltageApplied` - There is a voltage applied to the DC output when this is not expected
   * * `LockError` - Unable to lock the connector, no dangerous voltage present
   * * `UnlockError` - Unable to unlock the connector, no dangerous voltage present
   * * `LockTampering` - Tampering with the connector lock detected
   * * `CableError` - Charger cannot detect chargin cable type e.g. after cable replacement
   * * `GlobalInterlockFail` - Global Interlock activated
   * * `VehicleShiftPosition` - Vehicle shift position indicator is incorrect
   * * `VehicleBatteryTemperatureOutOfRange` - Vehicle communicated that its battery temperature is out of range
   * * `VehicleLookError` - Vehicle is unable to lock the connector
   * * `VehicleBatteryMalfunction` - Vehicle battery malfunction
   * * `VehicleCurrentDifference` - Vehicle detected current is not within specs
   * * `VehicleVoltageOutOfRange` - Vehicle detected voltage is out of range
   * * `VehicleError` - General vehicle error
   * * `oardPowerSupplyError` - Charge auxiliary power supply (24V) has issues
   * * `OcmNotAlive` - Over current monitor not alive
   * * `OcmInterlockVeriicationError` - Interlock by over current monitor is not functioning properly
   * * `OcmCableRatingMismatch` - Over current monitor and cable rating does not match
   * * `OnBoardEnergymeterError` - Vehicle onboard energy meter error
   * * `VehicleWeldingDetectionTimeout` - Vehicle contador weldin detection request took to long
   * * `CableCheckCurrentRunning` - The isolation test failed during this session
   * * `CableCheckVoltageTooLow` - Power module that was selected for the cable check is not functioning
   * * `CableCheckVoltageTooHigh` - The power module voltage were too high during the cable check
   * * `CableCheckVoltageNotDropping` - Voltage is not dropping when expected during the cable check
   * * `ChargerTimeCompleted` - stopped because car has been charging long enough
   * * `VehicleNotConnected` - Vehicle not connected
   * * `SoftError` - Software induce error
   * * `StoppedByVehicle` - Stopped by vehicle
   * * `AcsErrorExtending` - Problem happened that prevent the pantograph from extending
   * * `AcsErrorRetracting` - Pantograph error retracting
   * * `AcsExtendedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AcsRetractedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AccErrorAligment` - No complete chargin circuit when the pantograph is lowered
   * * `ChargerCabinetOvp` - The Over Coltage protection in cabinet is tripped
   * * `ChargerCableCoolerFailure` - Cable cooler is not reachable or gives an error
   * * `ChargerCableCoolerTemperature` - Temperature of cooler out of range
   * * `ChargerCableTemperature` - The cable is too hot at the charger end
   * * `ChargerContactorTemperature` - Contactor temperature is out-of-range
   * * `EstCorrect` - Normal stop
   * * `blocked` - ID tag for OCPP authorization is blocked on server
   * * `Expired` - ID tag for OCPP authorization is expired on server
   * * `InvalidOnServer` - ID tag is marked as Invalid by the OCP server
   * * `InvalidOnCharged` - ID tag is marked as Invalid by the charger software
   * * `RequestReject` - Charged software rejects request for authorization
   * * `WrongMessage` - Wrong parameters provided for the authorization request
   * * `NoMatchingIDs` - ID tags for OCPP Star and Stop do not match
   * * `ServerUnreachable` - The authorization failed as the server could not be reached
   * * `NoCardPresented` - The authorization failed bcause the user did not present a card
   * * `AuthorizedStop` - Authorization was used to stop chargin
   * * `ForcedStop` - Used when it is required to stop the charging without an authorization
   * * `NormalStop` - Normal Stop that does not fall into any of other categories
   * * `ImiDisconnectedFromDcbus` - CPI disconnected from DC bus and thresfore measure 0 Volts
   * * `ChargerCommunicationFailure` - Communication between Host A8 and DCB Failed
   * * `ChargerSubunitCommunicationFailure` - Communication beetween Host A8 and Subunit DCB Failed
   * * `DCElectricMeterCommunicationFailed` - DC Electric Meter communication Detection Failed
   * * `PowerModuleCANCommunicationFailure` - Possibly Due to module Address Configuration Issueor Module CAN communication problem
   * * `InsulationCommunication` - Gun 1 and 2 Insulation Communication module are in alarm state possibly due to power supply or communication issues with the insulation modules
   * * `Timeout` - Self-test Timeout. Abnormal Status. DCB has not Reported charging status messages for a long time
   * * `ACElectricMeterCommunicationFailure` - AC Electric Meter communication Detection Failed
   * * `NFC Communication Failure` - NFC communication failure
   * * `CommunicationFailureLightPanel` - Communication failure with the Light Panel
   * * `BluetoothCommunicationFailure` - Bluetooth board communication failure
   * * `ChargerFANMalfunction` - Charger FAN malfunction
   * * `DCBTCUAbnormality` - DCB Received TCU Abnormality
   * * `ChargerOtherFaults` - Charger other faults (avoid using whenever possible)
   * * `TCUVINVerificationTimedOut` - Waiting fot TCU VIN verification result timed out
   * * `VehicleAuthenticationFailed` - Vehicle authentication Failed (VIN Verification)
   * * `FanSpeedControlFailure` - Fan speed cntrol board communication failure
   * * `InsulationAlarm` - Insulation alarm (Alert without Shutdown)
   * * `InsulationFault` - Insulation Fault
   * * `PowerModuleAlarm` - Power module alarm
   * * `PowerModuleConflict` - (C6) Power module address conflict, (C2) charging station not initialized
   * * `PowerModuleFault` - Power module fault. Record the modules that have experienced a fault in the data
   * * `PowerModuleStatusChange` - Power module status change ( number of availabke modules)
   * * `PowerModulePhaseLossFault` - Power module phase loss fault
   * * `PowerModuleFanFault` - Power module FAN fault
   * * `PowerModuleOvertemperatureFault` - Power module overtemperature fault
   * * `PowerModuleACInputFault` - Power module AC input Fault
   * * `PowerModuleOutputShortCircuitFault` - Power module output short circuit fault
   * * `PowerModuleOutputOvercurrentFault` - Power module output overcurrent fault
   * * `PowerModuleOutputOvervoltageFault` - Power module output overvoltage fault
   * * `PowerModuleOutputUndervoltageFault` - Power module output undervoltage fault
   * * `PowerModuleInputOvervoltageFault` - Power module input overvoltage fault
   * * `PowerModuleInputUndervoltageFault` - Power module input undervoltage fault
   * * `PowerModuleDischargeFault` - Power module discharge fault
   * * `PowerModuleCurrentLimit` - Power module current limit
   * * `PowerModuleShutdown` - Power module shutdown
   * * `NoAvailableSparePowerModule` - No available spare power module
   * * `ChargerAccessControlFailure` - Charger access control failure
   * * `LiquidLevelAlarm` - Liquid level alarm
   * * `ACSurgeAlarm` - AC surge alarm
   * * `DCSurgeAlarm` - DC Surge alarm. If It's a subunit DC surge, specify the subunit number in the data
   * * `GunEndContactFault` - Gun end contactor fault. Displayed as charging port end contact fault on WeChat
   * * `ChargigStationSmokeDetectorFault` - Charging station smoke detector fault
   * * `CabinetTemperatureAlarm` - Cabinet Temperature Alarm. Abnormal Status
   * * `CabinetHumidityAlarm` - Cabinete humidity alarm. Abnormal status
   * * `TiltAngleAlarm` - Tilt angle alarm. abnormal status
   * * `LiquidCooledHeadExceedsShutdown` - Liquid-Cooled gun Head exceeds shutdown temperature. shutdown
   * * `LiquidCooledHeadExceedsCurrentShutdown` - Liquid-Cooled gun head exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledTailExceedsShutdown` - Liquid-Cooled gun Tail exceeds shutdown temperature. shutdown
   * * `LiquidCooledTailExceedsCurrentShutdown` - Liquid-Cooled gun Tail exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledHeadTemperatureRiseExceedsShutdown` - Liquid-Cooled gun head temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledHeadTemperatureRiseCurrentShutdown` - Liquid-Cooled gun head temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LiquidCooledTailTemperatureRiseExceedsShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledTailTemperatureRiseCurrentShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LowLiquidLevel` - Low liquid level in  Liquid cooling, current limit without shutdown.
   * * `LiquidCoolingOvertemperatureOvervoltage` - Liquid coolink liquid overtemperature and overvoltage. Overtemperature and overvoltage are the same fault in this context
   * * `LiquidCooledHeadDifferenceExceeds` - Liquid-cooled gun head and tail temperature difference exceeds current limit rate, but not shutdown rate. current limit without shutdown
   * * `LiquidCooledHeadTailShutdown` - Liquid-Cooled gun head and tail temperature difference exceeds shutdown rate. Shutdown
   * * `LiquidCoolingFault` - Liquid cooling fault
   * * `ChargingStationFault` - Charging station fault
   * * `TiltAngleFault` - Tilt angle fault
   * * `LiquidCoolingCoolantLowLevelFault` - Liquid cooling coolant low level fault, shutdown. This fault may indicate a coolant leak
   * * `OtherHardwareFaultsInLiquidCooling` - Other hardware fault in liquid cooling
   * * `LiquidCoolingDischargeNoShutdown` - Liquid cooling discharge and return temperature difference alarm, but no shutdown
   * * `LiquidCoolingDischargeShutdown` - Liquid cooling discharge and return temperature difference alarm shutdown
   * * `LiquidCoolingReturnNoShutdown` - Liquid cooling return temperature difference alarm, but no shutdown
   * * `LiquidCoolingReturnShutdown` - Liquid cooling return temperature difference alarm, shutdown
   * * `LiquidCoolingPumpLowAlarm` - Liquid cooling pump low temperature alarm, but no shutdown
   * * `LiquidCoolingPumpLowFault` - Liquid cooling pump low temperature fault, shutdown
   * * `LiquidCoolingPumpFault` - Liquid cooling pump temperature fault, shutdown
   * * `LiquidCoolingPumpSesingFault` - Liquid cooling pump temperature sensing fault, shutdown
   * * `EmergencyStopCircuitFault` - Emergency stop circuit fault
   * * `ChargingGunTemperatureAlarm` - Charging gun temperature alarm. Displayed as charging port temperature alarm on WeChat. Abnormal status
   * * `ElectromagneticLockLockingFailed` - Electromagnetic lock locking operation failed. Abnormal status
   * * `ElectromagneticLockUnlockingFailed` - Electromagnetic lock unlocking operation failed. At this point, the charging gun is locked and cannot be removed. Abnormal status
   * * `AbnormalityChargingGunPort` - Abnormality at the charging gun port, meannig a change in CC voltageduring charging (other than 4V), abnormal status
   * * `ChargingGunNotProperlyPositioned` - Charging gun not properly positioned
   * * `BMSVoltageLowOrHigh` - BMS demands voltage too low or high. If it can be ditinguished as 'high' or 'low'
   * * `BMSVoltageHigh` - BMS demands voltage too high
   * * `BMSVoltageLow` - BMS demands voltage too Low
   * * `APhaseHigh` - A-phase voltage too high
   * * `BPhaseHigh` - B-phase voltage too high
   * * `CPhaseHigh` - C-phase voltage too high
   * * `APhaseLow` - A-phase voltage too low
   * * `BPhaseLow` - B-phase voltage too low
   * * `CPhaseLow` - C-phase voltage too low
   * * `GroundWireAlarm` - Ground wire alarm
   * * `NLineNotConnected` - N-Line not connected
   * * `ACInputCircuitBrakerFailure` - AC Input circuit breaker failure
   * * `ACInputContadorRefusarFault` - AC Input contador refursar fault
   * * `ACInputContadorStickingFault` - AC input contador sticking fault
   * * `SystemPowerFailure` - System power failure. 220V no input
   * * `ACPowerMeterReadingAbnormal` - AC power meter reading abnormal
   * * `ACInputPhaseLoss` - AC input phase loss
   * * `VoltageAbnormalityOvervoltage` - Coltage abnormality overvoltage
   * * `VoltageAbnormalityUndervoltage` - Voltage abnormality undervoltage
   * * `VoltageAbnormalityShortCircuit` - Voltageabnormality short circuit
   * * `VoltageAbnormalityOverload` - Voltage abnormality overload
   * * `BatteryReverseConnection` - Battery reverse connection
   * * `DCDetectionFailure` - DC detection failure
   * * `DischargeDetectionFailure` - Dicharge detection failure
   * * `ParallelContadorRefusalFault` - Parallel contador refusal fault
   * * `ParallelContadorAhesionFault` - Parallel contador adhesion fault
   * * `DCBusOutputFuseFault` - DC bus output fuse fault
   * * `ChargingHostPreChargingFailureFault` - Charging host pre-charging failure fault
   * * `ChargingHostResponseChargingFailureFault` - Charging host response charging failure fault
   * * `BatteryUndervoltage` - During the charging permission stage, the charging station measures the battery voltage lower than 5% of the battery voltage in BCP
   * * `BatteryOvervoltage` - During the charging permission stage, the charging station measures the battery voltage higher than 5% of the battery voltage in BCP
   * * `AbnormalDC` - Abnormal DC meter reading
   * * `GunheadDCRefusalFault` - Gunhead DC output contactor refusal fault
   * * `GunheadDCAdhesionFault` - Gunhead DC output contadctor adhesion fault
   * * `PrechargeTimeout` - Precharge timeout
   * * `AuxiliaryPowerNotPowered` - The auxiliar power supply is not powered on
   * * `CRMTimeout` - CRM timeout
   * * `CRM00Timeout` - CRM00 timeout
   * * `CRMaaTimeout` - CRMaa timeout
   * * `CROTimeout` - CRO timeout
   * * `CTSTimeout` - CTS timeout
   * * `CMLTimeout` - CML timeout
   * * `CCSTimeout` - CSS timeout
   * * `CSTTimeout` - CST timeout
   * * `CSDTimeout` - CSD timeout
   * * `OtherTimeoutFaultBEM` - Other timeout fault as defined in BEM
   * * `ChargerOutputCurrentExcedsDC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the DC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargerOutputCurrentExcedsAC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the AC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargingHostEmergencyStop` - Charging host emergency stop
   * * `ChargingostDCBusbarFuse` - Charging host DC busbar fuse
   * * `ChargingHostAccessControlFAilure` - Charging host access control failure
   * * `ChargingHostSmokeDetectorFailure` - Charging host smoke detector failure
   * * `ChargingHostACInputCircuitBreakerFailure` - Charging host AC input circuit breaker failure
   * * `ChargingHostACInputContactorMalfunction` - charging host AC input contactor malfunction
   * * `ChargingHostACInputStickingMalfunction` - charging host AC input sticking malfunction
   * * `ChargingHostFanMalfunction` - Charging host fan malfunction
   * * `ChargingHostParallelContactorMalfunction` - Charging host parallel contactor malfunction
   * * `ChargingHostParallelStickingMalfunction` - Charging host parallel sticking malfunction
   * * `ChargingHostLiquidCoolingModuleMalfunction` - Charging host liquid cooling module malfunction
   * * `ChargingHostLiquidCoolingModuleCommunicationFailure` - Charging host liquid cooling module communication failure
   * * `ChargingHostSurgeArresterMAlfunction` - Charging host surge arrester malfunction
   * * `ChargingHostACEnergyMeterCommunicationFailure` - Charging host AC energy meter communication failure
   * * `ChargingHostOverTemperatureFault` - Charging host over temperature fault
   * * `ChargingHostOverTemperatureWarning` - Charging host over temperature warning
   * * `ChargingHostInputVoltageOvervoltageFault` - Charging host input voltage overvoltage fault
   * * `ChargingHostInputVoltageUndervoltageFault` - Charging host input voltage undervoltage fault
   * * `ChargingHostWaterLevelMonitoringAbnormality` - Charging host water level monitoring abnormality
   * * `ChargingHostPowerModuleFault` - Charging host power module fault
   * * `ChargingHostPowerModuleCommunicationFailure` - Charging host power module communication failure
   * * `ChargingHostPowerModuleFanMalfunction` - Charging host power module fan malfunction
   * * `ChargingHostPowerModuleOverTemperatureFault` - Charging host power module over-temperature fault
   * * `ChargingHostPowerModuleACInputFault` - Charging host power module AC input fault
   * * `ChargingHostPowerModuleOutputShortCircuitFault` - Charging host power module output short circuit fault
   * * `ChargingHostPowerModuleOutputOvercurrentFault` - Charging host power module output overcurrent fault
   * * `ChargingHostModuleOutputOvervoltageFault` - Charging host power module output overvoltage fault
   * * `ChargingHostModuleOutputUndervoltageFault` - Charging host power module output undervoltage fault
   * * `ChargingHostModuleInputOvervoltageFault` - Charging host power module input overvoltage fault
   * * `ChargingHostModuleInputUndevoltagetFault` - Charging host power module input undevoltage fault
   * * `ChargingHostModuleInputPhaseLossFault` - Charging host charging module input phase loss fault
   * * `ChargingHostChargingModuleFault` - Charging host charging module fault
   * * `ChargingHostChargingModuleCommunicationFailure` - Charging host charging module communication failure
   * * `ChargingHostAdhesiveDetectionTimeout` - Charging host adhesive detection response timeout
   * * `ChargingHostChargingStopCompletionTimeout` - Charging host charging stop completion response timeout
   * * `ChargingHostInsulationDetectionFrameTimeout` - Charging host insulation detection frame response timeout
   * * `ChargingHostInsulationDetectionCompletionTimeout` - Charging host insulation detection completion response timeout
   * * `ChargingHostPreChargeFrameTimeout` - Charging host pre-charge frame response timeout
   * * `ChargingHostPreChargeCompletionTimeout` - Charging host pre-charge completion response timeout
   * * `ChargingHostReceptionFirmwareUpgradeFrameTimeout` - Charging host reception of remote firmware upgrade file data frame timeout
   * * `ChargingHostReceptionChargingDemandDataFrameTimeout` - Charging host reception of charging demad data frame timeout
   * * `ChargingHostChargingTerminalTelesinalFrameTimeout` - Charging host charging terminal telesignal frame reception timeout
   * * `ChargingHostChargingStartupTimeout` - Charging host charging startup response timeout
   * * `ChargingHostChargingStopTimeout` - Charging host charging stop response timeout
   * * `ChargingHostTimeSynchronizationOperationTimeout` - Charging host time synchronization operation response timeout
   * * `ChargingHostVersionVerificationTimeout` - Charging host version verification response timeout
   * * `ChargingHostChargingParameterTimeout` - Charging host charging parameter response timeout
   * * `ChargingHostPreChargerTimeout` - Charging host pre-charger response timeout
   * * `ChargingHostInsulationDetectionTimeout` - Charging host insulation detection reponse timeout
   * * `ChargingHostRemoteUpgradeRequestTimeout` - Charging host remote upgrade request response timeout
   * * `ChargingHostDebuggingDataRequestTimeout` - Charging host debugging data request response timeout
   * * `ChargingHostControlRequestTimeout` - Charging host control request response timeout
   * * `ChargingHostRemoteFirmwareTransferFrameTimeout` - Charging host remote firmware upgrade file transfer completion frame reception timeout
   * * `ChargingHostRemoteUpgradeCompletionFrameTimeout` - Chaging host remote upgrade completion reception timeout
   * * `ChargingHostTelecontrolFrameTimeout` - Charging host telecontrol frame reception timeout
   * * `CharginghostTelemetryFrameTimeout` - Charging host telemetry frame reception timeout
   * * `ChargingHostInsulationDetectionCompletionFrameTimeout` - Charging host insulation detection completion frame reception timeout
   * * `ChargingHostAdhesiveDetectionFrameTimeout` - Charging host adhesive detection frame reception timeout
   * * `ChargingHostPreChargeCompletionFrameTimeout` - Charging host pre-charge completion frame reception timeout
   * * `ChargingHostChargingStopFrameTimeout` - Charging host charging stop completion frame reception timeout
   * * `ChargingHostAndSubCommunicationNotCompleted` - Charging host and sub-communication initialization not completed
   * * `ChargingHostHeartbeatReceptionStatus` - Charging host heartbeat reception status
   * * `BSTHighVoltageRelayMalfunction` - BST high voltage relay malfunction
   * * `BSTChargingConnectorMalfunction` - BST charging connector malfunction. Abnormal status
   * * `BSTBatteryPackTemperatureHigh` - BST battery pack temperature too high
   * * `BSTCurrentExceedsRequiredValue` - BST current exceeds the required value
   * * `BSTVoltageAbnormal` - BST voltage abnormal
   * * `BSTDetectionPoint2VoltageDetectionMalfunction` - BST detection point 2 voltage detection malfunction. Abnormal status
   * * `BSTOtherMalfunction` - BST other malfunction
   * * `BSTOutputConnectorOverheated` - BST output connector overheated
   * * `BSTStopSendData0Malfunction` - BST stops and send data as 0 malfunction, not a malfunction.
   * * `BSTVehicleInsulation` - BST vehicle insulation
   * * `BMSCurrentExceedsVoltageMode` - BMS current request exceeds the maximum allowed current in constant voltage mode
   * * `BMSCurrentExceedsCurrentMode` - BMS current request exceeds the maximum allowed current in constant current mode
   * * `ChargingProhibited` - Charging prohibited, 10-minute timeout
   * * `BHMVoltageMatchingFailure` - BHM voltage matching failure
   * * `VoltageDetectionFailure` - Voltage detection failure
   * * `BMSCoponentOutputConnectorOverTemperature` - BHM component output connector over temperature
   * * `BSMIndividualPowerBatteryHigh` - BSM individual power battery voltage too high
   * * `BSMIndividualPowerBatteryLow` - BSM individual power battery voltage too low
   * * `BSMVehiclePowerBatteryHigh` - BSM whole vehicle power battery state of charge (SOC) too high
   * * `BSMVehiclePowerBatterylow` - BSM whole vehicle power battery state of charge (SOC) too low
   * * `BSMVehiclePowerBatteryInsulationAbnormal` - BSM power battery insulation status abnormal
   * * `BSMBatteryOvercurrentCharging` - BSM power battery overcurrent during charging
   * * `BSMBatteryTemperatureHigh` - BSM power battery temperature high
   * * `BSMBatteryOutputConnectorConnectionAbnormal` - BSM power battery pack output connector connection status abnormal
   * * `BMSCommunicationProtocolVersionMismatch` - BMS communication protocol version mismatch
   * * `VehicleFullyCharged` - The vehicle is fully charged; this is feedback from the vehicle
   * * `ReachedSetTotalVoltage` - Reached the set total voltage. Not considered abnormal; can be regarded as fully charged
   * * `ReachedSetIndividualVoltage` - Reached the set individual cell voltage. Not considered abnormal; can be regarded as fully charged
   * * `MetChargerSettingConditions` - Met the charger setting conditions. Not considered abnormal; can be regarded as fully charged
   * * `VehicleSideManualTermination` - Vehicle-side indicates manual temination
   * * `PowerCannotBeTransmitted` - Power cannot be transmitted this is a vehicle malfunction, it might be fully charged.
   * * `CurrentMismatchVehicleMalfunction` - Current mismathc, this is a vehicle malfunction, it might be fully charged
   * * `ChargedTeminated` - Charged teminated
   * * `BRMTimeout` - BRM timeout
   * * `BCPTimeout` - BCP timeout
   * * `BRO_TIMEOUT` - BRO timeout
   * * `BCSTimeout` - BCS timeout
   * * `BCLTimeout` - BCL timeout
   * * `BSTTimeout` - BST timeout
   * * `BSDTimeout` - BSD timeout
   * * `BSMTimeout` - BSM timeout
   * * `CHAdeMoCodeWaitJ3TimeOut` - Waiting for vehicle-side Switch = ON timeout. Vehicle-side malfunction
   * * `CHAdeMoCodeDCVoltExceed10V` - DC bus voltage exceeds 10V before charging. Bus has voltage or vehicle-side malfunction
   * * `CHAdeMoCodeJ3StatusErr` - Vehicle-side Switch status error. Vehicle-side malfunction
   * * `CHAdeMOCodeEvReadyStatusErr` - Vehicel-side readiness status error. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitEVSEOutVoltErr` - Waiting for output voltage timeout
   * * `CHAdeMOCodeDCVoltExceed20V` - Insulation check completed voltage anomaly after discharge
   * * `CHAdeMOCodeCommunicationTimeOut` - Vehicle-side CAN communication timeout
   * * `CHAdeMOCodeWaitCAN10XTimeOut` - Waiting for vehicle-side CAN communication timeout at beginning of charging. Vehicle malfunction
   * * `CHAdeMOCodeWaitEVCurrentReqTimeOut` - Waiting for current request failed. VEhicle-side malfunction
   * * `CHAdeMOCodeWaitEVContadorTimeOut` - Waiting for vehicle-side contacdt closure failed. Vehicle-side malfunction
   * * `CHAdeMOCodeDCVoltExceed10VNormalEnd` - Abnormal discharge at the end of charging. Vehicle-side malfunction
   * * `CHAdeMOCodeCommunicationOpenTimeOut` - Waiting for the vehicle to disconnect communication timeout after charging ends. Vehicle-side malfunction
   * * `CHAdeMOCodeChargingSystemFault` - Vehicle-side reported charging system error. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOverVoltage` - Output voltage abnormal. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOvercurrent` - Output current abnormal.
   * * `CHAdeMOCodeBatterPolarity` - Battery polarity error
   * * `CHAdeMOCodeEVSEIsolationStatusFail` - Insulation fault error
   * * `CHAdeMOCodeMalfunctionDetectionFail` - Charging plug electromagnetic lock failed to lock. Charging cable electromagnetic lock malfunction
   * * `CHAdeMOCodeCANInitFail` - CCAN initialization failed. Board malfunction
   * * `CHAdeMOCodeVehicleShiftPositionStop` - Vehicle-side Vehicle_shift_position stops. Issue on the vehicle side
   * * `CHAdeMOCodeWaitJ3OpenErr` - Waiting for vehicle-side Switch = OFF timeout. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitCommunicationCloseTimeOut` - Wait for communication closure anomaly. Vehicle-side malfunction
   * * `CHAdeMOCodeBEforeChargeJ3StatusErr` - Switch status abnormal before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeTargetBatterVoltageErr` - EEV target battery voltage abnormal. Vehiccle-side malfunction
   * * `CHAdeMOCodeBatteryInccompatibilityErr` - EV battery mismatch. Vehicle-side mismatch
   * * `CHAdeMOCodeRequestCurrentErr` - Current request failed. Vehicle-side malfunction
   * * `CHAdeMOCodeMinimumCurrentErr` - Minimum current error. Vehicle-side malfunction
   * * `CHAdeMOCodeNormalStopRequestBefoeCharging` - Vehicle-side requests to stop before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeRemainingChargingTimeIsZero` - Remaining charging time is 0. Charging stopped
   * * `CHAdeMOCodeWaitPowerReadyTimeout` - Waiting for the power module to be ready exceeded timeout. Power module anomaly
   * * `CHAdeMOCodeVehicleCChargingEnable` - Vehicle-side 'Vehicle_charging_enabled' status error. Vehicle-side malfunction
   * * `CHAdeMOCodeCurrent5AOrLess` - Waiting dot charging to end and current to drop below 5A exceeded timeout. Power module or current detection issue
   * * `CHAdeMOCodeEVErrorCanid1024A` - Vehicle-side reported 102.4 error stop. Vehicle-side malfunction
   * * `CHAdeMOCodeEVErrorCanid10240` - Vehicle-side reported: Battery_Overvoltage
   * * `CHAdeMOCodeEVErrorCanid10241` - Vehicle-side reported: Battery_Undervoltage
   * * `CHAdeMOCodeEVErrorCanid1024` - Vehicle-side reported: Battery_Current_deviation_Error
   * * `CHAdeMOCodeEVErrorCanid10243` - Vehicle-side reported: Battery_High_Temperature
   * * `CHAdeMOCodeEVErrorCanid10244` - Vehicle-side reported: Battery_Voltage_Deviation_Error
   * * `CHAdeMOCodeOther` - Cannot use if not matched, try not to use it
   * * `CCSStopCodePlugOut` - Detected that the charging plug was remover during charging. CP immediately changes to 12v
   * * `CCSStopCodeReadyToChargePerformanceTimeOut` - Waiting to start charging timeout
   * * `CCSStopCodeCommEVSessionStop` - Vehicle-side sent Session stop for normal termination
   * * `CCSStopCodeEVSEIsolationStatusFail` - Stopped due to isulation fault
   * * `CCSStopCodeEVTargetVoltageFail` - Vehicle-side demanded coltage exceeds the maximum allowable voltage for for the vehicle
   * * `CCSStopCodeEVTargetCurrentFail` - Vehicle-side demanded voltage  exceeds the maximum allowable current for the vehicle
   * * `CCSStopCodeEVSEPresentVoltageFail` - DC output over-voltage
   * * `CCSStopCodeEVSEPresentCurrentFail` - DC output overcurrent
   * * `CCSStopCodeCPFail` - CP voltage abnormal, exceeds 6v, 9v with a tolerance of plus or minus 0.8V
   * * `CCSStopCodeEVSEBatterPolarityFail` - BAttery polarity reversed
   * * `CCSStopCodeEvseChargeBeforeOvervoltageFail` - Overvoltage before charging
   * * `CCSStopCodeEvseChargeInsulationAfterOvervoltageFail` - Overvoltage after insulation charge
   * * `CSSStopCodeEVSEUndervoltage` - Output undervoltage
   * * `CCSStopCodeOngoingPerformanceTimeout` - WAiting for charging permission timeout
   * * `CCSStopCodePDVoltAlarm` - American standard plug PD detection error; not applicable for European Standar
   * * `CCSStopCodeOther` - not matched, try not to use
   * * `V2GFailed` - V2G failed
   * * `V2GFailedSequenceError` - V2G failed sequence error
   * * `V2GFailedServiceIdInvalid` - V2G failed service id invalid
   * * `V2GFailedUnknownSession` - V2G failed unknow session
   * * `V2GFailedServiceSelectionInvalid` - V2G failed service selection invalid
   * * `V2GFailedPaymentSelectionInvelid` - V2G failed payment selection invalid
   * * `V2GFailedCertificateExpired` - V2G failed certificate expired
   * * `V2GFailedSignatureError` - V2G failed signature error
   * * `V2GFailedNoCertificateAvailable` - V2G failed no certificate available
   * * `V2GFailedCertChainError` - V2G failed cert chain error
   * * `V2GFailedChallengeInvalid` - V2G failed challenge invalid
   * * `V2GFailedContractCanceled` - V2G failed contract canceled
   * * `V2GFailedWrongChargeParameter` - V2G failed wrong charge parameter
   * * `V2GFailedPowerDeliveryNotApplied` - V2G failed power delivery not applied
   * * `V2GFailedTariffSelectionInvalid` - V2G failed tariff selection invalid
   * * `V2GFailedChargingProfileInvalid` - V2G failed charging profile invalid
   * * `V2GFailedEVSEPresentVoltToLow` - V2G failed EVSE present volt to low
   * * `V2GFailedMeteringsignatureNotValid` - V2G failed metering signature not velid
   * * `V2GFailedWrongEnergyTranferType` - V2G failed wrong energy transfer type
   * * `V2GFailedAppHandResponse` - V2G failed app hand response code type failed no negotiation
   * * `V2GInitErrorQCA7000` - V2G inir error QCA 7000
   * * `V2GInitErrorOther` - V2G init error other
   * * `V2GInitErrorGeneral` - V2G init error general
   * * `V2GInitErrorIfaddr` - V2G init error ifaddr
   * * `V2GInitErrorThread` - V2G init error thread
   * * `V2GInitErrorOpenchannel` - V2G init error openchannel
   * * `V2GInitErrorKey` - V2G init error key
   * * `V2GSlacErrorGeneral` - V2G slac error general
   * * `V2GSlacErrorTimerInit` - V2G slac error timer init
   * * `V2GSlacErrorTimerTimeout` - V2G slac error timer timeout
   * * `V2GSlacErrorTimerMisc` - V2G slac error timer misc
   * * `V2GSlacErrorParamTimeout` - V2G slac error param timeout
   * * `V2GSlacErrorParamSocket` - V2G slac error param socket
   * * `V2GSlacErrorStartAttenCharTimeout` - V2G slac error start atten char timeout
   * * `V2GSlacErrorMNBCSoundTimeout` - V2G slac error MNBC sound timeout
   * * `V2GSlacErrorAttenCharTimeout` - V2G slac error atten char timeout
   * * `V2GSlacErrorAttenCharSocket` - V2G slac error atten char Socket
   * * `V2GSlacErrorValidate1Timeout` - V2G slac error validate 1 timeout
   * * `V2GSlacErrorValidate1Socket` - V2G slac error validate 1 socket
   * * `V2GSlacErrorValidate2Timeout` - V2G slac error validate 2 timeout
   * * `V2GSlacErrorValidate2Socket` - V2G slac error validate 2 socket
   * * `V2GSlacErrorBCBToggleTimeout` - V2G slac error BCB toggle timeout
   * * `V2GSlacErrorMatchTimeout` - V2G slac error match timeout
   * * `V2GSlacErrorMatchSocket` - V2G slac error match Socket
   * * `V2GSlacErrorReadSocket` - V2G slac error read Socket
   * * `V2GSlacErrorSetKey` - V2G slac error set key
   * * `V2GSlacErrorLinkTimeout` - V2G slac error link timeout
   * * `V2GSDPErrorGeneral` - V2G SDP error general
   * * `V2GSDPErrorInitSocket` - V2G SDP error init socket
   * * `V2GSDPErrorInitSockOPT1` - V2G SDP error init sockotp1
   * * `V2GSDPErrorInitSockOPT2` - V2G SDP error init sockotp2
   * * `V2GSDPErrorInitBind` - V2G SDP error init bind
   * * `V2GSDPErrorThreadSocket1` - V2G SDP error thread docket 1
   * * `V2GSDPErrorThreadSocket2` - V2G SDP error thread docket 2
   * * `V2GSDPErrorTimeout` - V2G SDP error timeout
   * * `V2GSDPErrorTCPDisconnected` - V2G SDP error tcp disconnected
   * * `V2GDinErrorGeneral` - V2G DIN error general
   * * `V2GDinErrorInitSocket` - V2G DIN error init socket
   * * `V2GDinErrorInitSockOPT` - V2G DIN error init sockOPT
   * * `V2GDinErrorInitBind` - V2G DIN error init bind
   * * `V2GDinErrorInitListen` - V2G DIN error init listen
   * * `V2GDinErrorInitSelect` - V2G DIN error init select
   * * `V2GDinErrorInitAccept` - V2G DIN error init accept
   * * `V2GDinErrorTimeout` - V2G DIN error timeout
   * * `V2GDinErrorV2GTPHeader` - V2G DIN error V2GTP header
   * * `V2GDinErrorV2GTPHeaderLen` - V2G DIN error V2GTP header Len
   * * `V2GDinErrorV2GTPHeaderWrite` - V2G DIN error V2GTP header write
   * * `V2GDinErrorDecodeExi` - V2G DIN error Decode Exi
   * * `V2GDinErrorEncodeExi` - V2G DIN error Encode Exi
   * * `V2GDinErrorCreateResponse` - V2G DIN error create response
   * * `V2GDinErrorSocketException` - V2G DIN error socket exception
   * * `V2GDinErrorSocketSend` - V2G DIN error socket send
   * * `V2GDinErrorNoProtocol` - V2G DIN error no protocol
   */
  verbose_error?: VerboseErrorEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  connector: number;
}

/** Custom Serializer for external telemetry data */
export interface APITrackerLogExternal {
  /**
   * @maxLength 10
   * @pattern ^[A-Z0-9]{1,10}$
   */
  number_plate: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  soc?: string;
  location: any;
  /**
   * @format decimal
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  angle?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  altitude?: string;
  /** @min 0 */
  satellites?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  velocity?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  min_battery_temp?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,3})?$
   */
  max_battery_temp?: string;
  /** @format date-time */
  timestamp: string;
}

/** Transaction Serializer */
export interface APITransaction {
  id: number;
  vehicle: VehicleTransaction;
  user_start: APIUserTransaction;
  user_stop: APIUserTransaction;
  /** TransactionRequest Serializer for using in Transaction */
  transaction_request?: APITransactionRequestInTransaction;
  contract_snapshots: APIContractSnapshot[];
  pricing_details: APIPricingDetail[];
  gross_price: string;
  net_price: string;
  /** ModelSerializer for PaymentAuthorization */
  payment_authorization: APIPaymentAuthorization;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** Finalizing Notification Sent? */
  finalizing_notification_sent?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
  connector: number;
  /** Charging Authorization at Start */
  charging_authorization_start?: number | null;
  /** Charging Authorization at Stop */
  charging_authorization_stop?: number | null;
}

/** TransactionRequest Serializer for using in Transaction */
export interface APITransactionRequestInTransaction {
  id: number;
  user: number;
  /** Credit card serializer */
  credit_card: APICreditCard;
  /** User Group Serializer */
  user_group: APIUserGroup;
}

/** Transaction Summary Serializer */
export interface APITransactionSummary {
  periods?: APITransactionSummaryPeriod[];
  /**
   * @maxLength 6
   * @default "none"
   */
  periods_type?: string;
  /** @min 0 */
  count: number;
  /** @min 0 */
  cost?: number;
  /** @min 0 */
  price?: number;
  /** @min 0 */
  total_energy?: number;
}

/** Transaction Summary Period Serializer */
export interface APITransactionSummaryPeriod {
  /** @min 0 */
  period: number;
  /** @min 0 */
  count: number;
  /** @min 0 */
  cost?: number;
  /** @min 0 */
  price?: number;
  /** @min 0 */
  total_energy?: number;
}

/** User Group Serializer */
export interface APIUserGroup {
  id: number;
  /** @maxLength 32 */
  name: string;
  profiles: string[];
  profiles_count: number;
  contracts: number[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** User Transaction Serializer */
export interface APIUserTransaction {
  id: number;
  /** @format date-time */
  last_login?: string | null;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** @format date-time */
  date_joined?: string;
}

export interface Action {
  action_name: string;
  action_code: string;
  tooltip: string;
}

export interface ActionByCategory {
  category_name: string;
  topics: Topic[];
}

/** Anonymous Transaction Request Serializer */
export interface AnonymousTransactionRequest {
  id: number;
  connector: number;
  /** Synchronizing Status */
  sync_status?: SyncStatus695Enum | null;
  /**
   * Synchronizing Task Id
   * @maxLength 37
   */
  sync_task_id?: string | null;
  kushki_transaction_id: string;
  /**
   * @format email
   * @maxLength 254
   */
  email?: string | null;
}

/** TransactionRequest Serializer for using in Transaction */
export interface AnonymousTransactionRequestInTransaction {
  id: number;
  /**
   * Net Price at Stop
   * @format decimal
   * @pattern ^-?\d{0,22}(?:\.\d{0,10})?$
   */
  net_price_stop: string;
  /**
   * @format email
   * @maxLength 254
   */
  email?: string | null;
}

/** Anonymous Transaction Request Input Serializer */
export interface AnonymousTransactionRequestInput {
  /** ID of the connector to be used */
  connector: number;
  /**
   * Email of the user
   * @default "user@example.com"
   */
  email?: string;
  /**
   * Token representing the credit card
   * @default "your_credit_card_token_here"
   */
  credit_card_token?: string;
  /**
   * Net price for the transaction
   * @format decimal
   * @default "10.00"
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  net_price_stop?: string;
}

/** Apple Credencial Serializer Class */
export interface AppleCredential {
  /** @maxLength 2048 */
  apple_token: string;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
}

/** Asset Serializer */
export interface Asset {
  id: number;
  grid_connections: GridConnection[];
  /** @maxLength 64 */
  name: string;
  /** @maxLength 64 */
  address: string;
  /** @maxLength 64 */
  town: string;
  /** @maxLength 64 */
  region: string;
  /**
   * Contact Number
   * @maxLength 32
   */
  phone_number?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_public?: boolean;
}

export type AssetPoly = AssetUnauthenticated | Asset;

/** Asset serializer for unathenticated users */
export interface AssetUnauthenticated {
  id: number;
  grid_connections: GridConnectionUnauthenticated[];
  /** @maxLength 64 */
  name: string;
  /** @maxLength 64 */
  address: string;
  /** @maxLength 64 */
  town: string;
  /** @maxLength 64 */
  region: string;
  /**
   * Contact Number
   * @maxLength 32
   */
  phone_number?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_public?: boolean;
}

/** TransactionRequest Serializer for using in Transaction */
export interface AuthenticatedTransactionRequestInTransaction {
  id: number;
  user: number;
  /** User Group Serializer */
  user_group: UserGroup;
  /** Credit card serializer */
  credit_card: CreditCard;
}

/** Authenticated Transaction Request Serializer (for input) */
export interface AuthenticatedTransactionRequestInput {
  credit_card_id?: number;
  connector: number;
  user_group: number;
}

/** Authenticated Transaction Request Serializer (for output) */
export interface AuthenticatedTransactionRequestOutput {
  id: number;
  user: number;
  connector: number;
  user_group: number;
  /** Credit card serializer */
  credit_card: CreditCard;
  /** Transaction Serializer */
  transaction: Transaction;
  sync_status: string;
  sync_task_id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface AvailabilityPeriod {
  id: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  week_day?: WeekDayEnum;
  /** With access? */
  with_access?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: string;
}

/** Availability Period Unauthenticated serializer */
export interface AvailabilityPeriodUnauthenticated {
  id: number;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  week_day?: WeekDayEnum;
  /** With access? */
  with_access?: boolean;
  charge_point: number;
}

/** Availability Type Serializer */
export interface AvailabilityType {
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  type: AvailabilityTypeEnum;
}

/**
 * * `Inoperative` - Inoperative
 * * `Operative` - Operative
 */
export enum AvailabilityTypeEnum {
  Inoperative = 'Inoperative',
  Operative = 'Operative',
}

/** Boot Notification Serializer */
export interface BootNotification {
  id: number;
  /** @maxLength 26 */
  charge_box_serial_number?: string | null;
  /** @maxLength 21 */
  charge_point_model: string;
  /** @maxLength 26 */
  charge_point_serial_number?: string | null;
  /** @maxLength 21 */
  charge_point_vendor: string;
  /** @maxLength 51 */
  firmware_version?: string | null;
  /** @maxLength 21 */
  iccid?: string | null;
  /** @maxLength 21 */
  imsi?: string | null;
  /** @maxLength 26 */
  meter_serial_number?: string | null;
  /** @maxLength 26 */
  meter_type?: string | null;
  /** @format date-time */
  current_time: string;
  /**
   * @min 0
   * @max 2147483647
   */
  interval?: number;
  /**
   * * `Accepted` - Accepted
   * * `Pending` - Pending
   * * `Rejected` - Rejected
   */
  status: RegistrationStatusEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

export interface CMSAsset {
  id: number;
  /** @maxLength 64 */
  name: string;
  /** @maxLength 64 */
  address: string;
  /** @maxLength 64 */
  town: string;
  /**
   * Contact Number
   * @maxLength 32
   */
  phone_number?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_public?: boolean;
}

export interface CMSOcppChargePoint {
  id: number;
  grid_connection: CMSInlineGridConnection;
  vehicle_station: CMSInlineVehicleStation;
  /**
   * Charge Point Identity
   * @maxLength 40
   * @pattern ^[a-zA-Z\d\-_.]+$
   */
  name: string;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @maxLength 21 */
  vendor?: string | null;
  /** @maxLength 21 */
  model?: string | null;
  group: CMSInlineChargepointGroup;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  charger_efficiency?: string | null;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  /** Use P=V·I·cos(0) */
  use_vi?: boolean;
  /** Is single Phase? */
  is_single_phase?: boolean;
  /**
   * Local Authorization List Version
   * @min 0
   * @max 2147483647
   */
  local_list_version?: number;
  firmware: CMSInlineFirmware;
  /** Enable Free Pass */
  free_pass?: boolean;
  /** Enable Auto Start */
  auto_start?: boolean;
  /** Enable Vehicle RFID */
  vehicle_rfid?: boolean;
  latest_heartbeat?: number | null;
  latest_boot_notification?: number | null;
  latest_status_notification?: number | null;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable Manual Filling of Fields */
  fill_manual_fields?: boolean;
  /**
   * Remaining Time Threshold for Notifications (seconds)
   * @min 0
   * @max 32767
   */
  remaining_time_threshold?: number;
  /** @format date-time */
  created: string;
  /** Charge_Point_Location */
  location?: string | null;
  /** @format date-time */
  updated: string;
  /**
   * Start Period
   * @format time
   */
  start_day?: string;
  /** @maxLength 300 */
  additional_info?: string | null;
}

export interface CMSConnector {
  id: number;
  charge_point: CMSInlineChargePoint;
  /**
   * @min 0
   * @max 2147483647
   * @default 0
   */
  connector_id?: number;
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  availability?: AvailabilityTypeEnum;
  /**
   * Connector Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /**
   * * `NoPlug` - No Plug
   * * `CCS1` - Ccs1
   * * `CCS2` - Ccs2
   * * `CHAdeMO` - CHAdeMO (Type 4)
   * * `GB/T DC` - Gbt Dc
   * * `Tesla` - Tesla
   * * `GB/T AC` - Gbt Ac
   * * `J1772` - J1772 (Type 1)
   * * `Mennekes` - Mennekes (Type 2)
   */
  plug_type?: PlugTypeEnum;
  /**
   * @min 1
   * @max 100
   */
  final_soc?: number;
  enabled?: boolean;
  /** @maxLength 100 */
  math_price?: string;
  qr_code?: number | null;
  latest_transaction: CMSInlineTransaction;
  latest_meter_value: CMSInlineMeterValue;
  latest_status_notification: CMSInlineStatusNotification;
  latest_reservation?: number | null;
  /**
   * Power by connector
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,1})?$
   */
  power?: string;
  power_category?: PowerCategoryEb2Enum | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  supports_preparing?: boolean;
  connection_timeout: number;
}

export interface CMSContract {
  id: number;
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  user_group: CMSUserGroup;
  charge_point_group: CMSInlineChargepointGroup;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSContractSnapshot {
  id: number;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,22}(?:\.\d{0,10})?$
   */
  gross_price: string;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
  transaction: number;
  contract: CMSInlineContract;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
}

export interface CMSInlineChargePoint {
  id: number;
  grid_connection?: number;
  vehicle_station?: number | null;
  /**
   * Charge Point Identity
   * @maxLength 40
   * @pattern ^[a-zA-Z\d\-_.]+$
   */
  name: string;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @maxLength 21 */
  vendor?: string | null;
  /** @maxLength 21 */
  model?: string | null;
  /** Charge Point Group */
  group?: number;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  charger_efficiency?: string | null;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  /** Use P=V·I·cos(0) */
  use_vi?: boolean;
  /** Is single Phase? */
  is_single_phase?: boolean;
  /**
   * Local Authorization List Version
   * @min 0
   * @max 2147483647
   */
  local_list_version?: number;
  firmware?: number | null;
  /** Enable Free Pass */
  free_pass?: boolean;
  /** Enable Auto Start */
  auto_start?: boolean;
  /** Enable Vehicle RFID */
  vehicle_rfid?: boolean;
  latest_heartbeat?: number | null;
  latest_boot_notification?: number | null;
  latest_status_notification?: number | null;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable Manual Filling of Fields */
  fill_manual_fields?: boolean;
  /**
   * Remaining Time Threshold for Notifications (seconds)
   * @min 0
   * @max 32767
   */
  remaining_time_threshold?: number;
  /** @format date-time */
  created: string;
  /** Charge_Point_Location */
  location?: string | null;
  /** @format date-time */
  updated: string;
  /**
   * Start Period
   * @format time
   */
  start_day?: string;
  /** @maxLength 300 */
  additional_info?: string | null;
}

export interface CMSInlineChargepointGroup {
  id: number;
  /** @maxLength 64 */
  name: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineChargingAuthorization {
  id: number;
  vehicle?: string | null;
  user?: number | null;
  user_group: number;
  /** @maxLength 20 */
  token: string;
  /**
   * * `VIN` - VIN
   * * `RFID` - RFID
   * * `MAC` - MAC
   */
  token_format: TokenFormatEnum;
}

export interface CMSInlineConnector {
  charge_point: number;
  /**
   * @min 0
   * @max 2147483647
   * @default 0
   */
  connector_id?: number;
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  availability?: AvailabilityTypeEnum;
  /**
   * Connector Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /**
   * * `NoPlug` - No Plug
   * * `CCS1` - Ccs1
   * * `CCS2` - Ccs2
   * * `CHAdeMO` - CHAdeMO (Type 4)
   * * `GB/T DC` - Gbt Dc
   * * `Tesla` - Tesla
   * * `GB/T AC` - Gbt Ac
   * * `J1772` - J1772 (Type 1)
   * * `Mennekes` - Mennekes (Type 2)
   */
  plug_type?: PlugTypeEnum;
  /**
   * @min 1
   * @max 100
   */
  final_soc?: number;
  enabled?: boolean;
  /** @maxLength 100 */
  math_price?: string;
  qr_code?: number | null;
  latest_transaction?: number | null;
  latest_meter_value?: number | null;
  latest_status_notification?: number | null;
  latest_reservation?: number | null;
  /**
   * Power by connector
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,1})?$
   */
  power?: string;
  power_category?: PowerCategoryEb2Enum | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  supports_preparing?: boolean;
  connection_timeout: number;
}

export interface CMSInlineContract {
  id: number;
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  user_group: number;
  charge_point_group: number;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineCreditCard {
  id: number;
  user: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @maxLength 32 */
  kushki_subscription_id: string;
  default?: boolean;
  /** @maxLength 256 */
  card_holder_name: string;
  /** @maxLength 4 */
  last_four_digits: string;
  /** @maxLength 32 */
  payment_brand: string;
  /**
   * Bank identification number
   * @maxLength 6
   */
  bin: string;
  /** @maxLength 12 */
  card_type: string;
  /** @maxLength 128 */
  bank: string;
  /** @maxLength 32 */
  country: string;
}

export interface CMSInlineFirmware {
  id: number;
  /**
   * Charge Point Vendor
   * @maxLength 21
   */
  vendor: string;
  /**
   * Charge Point Model
   * @maxLength 21
   */
  model: string;
  /**
   * Firmware Version
   * @maxLength 51
   */
  version: string;
  /**
   * Firmware File
   * @format uri
   */
  firmware: string;
  /** @maxLength 200 */
  description?: string | null;
  /**
   * * `FTP` - Ftp
   * * `FTPS` - Ftps
   * * `HTTP` - Http
   * * `HTTPS` - Https
   */
  download_schema?: DownloadSchemaEnum;
  /**
   * @format uri
   * @maxLength 200
   */
  uri?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineGridConnection {
  id: number;
  asset?: number;
  /** Vehicle Station */
  station?: number;
  /** @maxLength 40 */
  name: string;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Charging Capacity in W
   * @min 0
   * @max 2147483647
   */
  charging_capacity?: number;
  /** @maxLength 100 */
  math_cost?: string;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  charge_points_power?: string | null;
  /** @maxLength 32 */
  client_internal_id?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineGroup {
  id: number;
  /** @maxLength 150 */
  name: string;
  permissions?: number[];
}

export interface CMSInlineMeterValue {
  id: number;
  connector: number;
  /** Transacción */
  transaction?: number | null;
  /** Price Processed? */
  price_processed?: boolean;
  /** @format date-time */
  timestamp?: string;
  /**
   * Fecha de creación
   * @format date-time
   */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineProfile {
  user: number;
  username: string;
  first_name: string;
  last_name: string;
  second_last_name: string;
  email: string;
}

export interface CMSInlineStatusNotification {
  id: number;
  connector: number;
  /** Charge Point Status */
  status: ChargePointStatusEnum;
  /** Charge Point Error Code */
  error_code: ErrorCodeEnum;
  /**
   * Information Related to the Error
   * @maxLength 51
   */
  info?: string | null;
  /** @format date-time */
  timestamp?: string;
  /** @maxLength 256 */
  vendor_id?: string | null;
  /** @maxLength 51 */
  vendor_error_code?: string | null;
  /**
   * * `Error not interpreted` - Not Interpreted
   * * `UpdateFail` - Fail to update software
   * * `ResetFailure` - Fail to reset
   * * `GunTemperature` - Gun over-temperature
   * * `TrialPeriodOver` - The trial period is over
   * * `EmergencyStop` - Emergency stop
   * * `BleederResistor` - Bleeder resistor failure
   * * `Insulation` - Insulation failure (several times)
   * * `OpenDoor` - Open door
   * * `MeterFault` - Meter failure
   * * `BEMAlarmStop` - BEM alarm stop
   * * `BSMMessage` - BSM message
   * * `BROFault` - BRO fault
   * * `OuterVoltageRelay` - Outer voltage relay
   * * `BRMTimeOut` - BRM timeout
   * * `BCPTimeOut` - BCP timeout
   * * `BROTimeOut` - BRO timeout
   * * `BCLTimeOut` - BCL timeout
   * * `BSTTimeOut` - BST timeout
   * * `BSDTimeOut` - BSD timeout
   * * `BSMInsulation` - BSM insulation fault
   * * `BMSOutputTemperature` - BMS output over-temperature
   * * `BMSComponentTemperature` - BMS component over-temperature
   * * `BMSBatteryOverTemperature` - BMS Battery over-temperature
   * * `BMSHighCurrent` - BMS over current
   * * `BMSVoltageAbnormality` - BMS Voltage Abnormality
   * * `BMSOtherErrors` - BMS Other Errors
   * * `PowerModuleCommunicationFault` - Power Module Communication Fault
   * * `InputOverVoltage` - Input Over Voltage
   * * `InputUnderVoltage` - Input Under Voltage
   * * `GenericError` - Generic Error
   * * `MainsPowerSupply` - Mains Power Supply Failure
   * * `TemperatureOutOfRange` - Temperature out of range
   * * `InternalComunicationsError` - Internal communications error
   * * `ConfigurationError` - Configuration Error
   * * `MainsGroundFailure` - Mains ground failure
   * * `MainsVoltageOutOfRange` - Mains voltage out of range
   * * `MainsFrequencyOutOfRange` - Mains Frequency out of range
   * * `HighTemperatureError` - High temperature error
   * * `LowTemperatureError` - Low temperature error
   * * `ExternalComunicationsError` - External communications error
   * * `ErrorMasterEntity` - Error in master entity
   * * `SlaveError` - Error in slave entity
   * * `DoorTamperAlarm` - Door Tamper Error
   * * `TiltError` - Tilt error
   * * `DisplayFailure` - Display Failure
   * * `RfidReaderFailure` - RFID reader failure
   * * `PowerMeterFailure` - Power Meter Comunication Error
   * * `GenericVehicleError` - Generic Vehicle Error
   * * `VehicleComunicationError` - Vehicle Comunication Error
   * * `VehicleNotDetected` - Vehicle not detected
   * * `VehicleOverCurrent` - Vehicle over current consumption
   * * `CordMalfunction` - Cord malfunction
   * * `CordSensorMalfunction` - Cord sensor malfunction
   * * `ConnectorLockFailure` - Connector Lock Failure
   * * `InternalPowerSupplyFailure` - Internal power supply failure
   * * `ComponentTemperatureOutRange` - Component temperature out of range
   * * `HardwareFailureMode4` - Hardware Failure Mode4
   * * `HardwareFailureNodes` - Hardware Failure Nodes
   * * `AcDcConvertersGenericError` - AC/DC converters Error
   * * `AcDcConvertersTimeOutError` - AC/DC converters time out Error
   * * `AcDcConvertersVoltageOutRange` - AC/DC converters voltage out of range
   * * `AcDcConvertersCurrentOutRange` - AC/DC converters current out of range
   * * `WeldingContactor` - Welding Contactor
   * * `CurrentLeakDetected` - Current Leak Detected
   * * `ElectricalProtectionTriggered` - Electrica Protection Triggered
   * * `IsolationError` - Isolation error
   * * `RcdProtectionTriggered` - RCD protection triggered
   * * `McbProtectionTriggered` - MCB protection triggered (Over Current protection Triggered)
   * * `ProgramCounterFailure` - Program Counter Failure
   * * `Invalid` - Reason for stopping cannot be identified
   * * `NoError` - No error ocurred, similar to a normal stop
   * * `UserRequestStop` - User pressed the stop button on HMI
   * * `ConnectorButtonPressed` - CSS1 connector button is pressed by user
   * * `VehicleStop` - This vehicle requested to stop the session by a driver request
   * * `IncompatibleVehicle` - This vehicle cannot be charged on this outlet
   * * `IsolationTestFailed` - Isolation resistance is to low
   * * `CableCheckFailed` - Isolation failure during cable check phase
   * * `BatteryFull` - Stopped because the vehicle battery is full
   * * `BudgetExceeded` - Stopped because the vehicle asked for or tried to draw to much power
   * * `ChargerError` - Chargin Protocol Interface (CPI) board error
   * * `ChargerContactorProblem` - Charger contactor problem
   * * `ChargerLoweringCurrentTimeout` - Charge does not follow the request reduction of current near to full charge
   * * `ConnectorError` - Connector Error
   * * `ConnectorPilotError` - Conector pilot error
   * * `ControlPilotShorCircuit` - Control pilot is in short-circuit. it can be caused by bad wiring
   * * `ConnectorTemperatureError` - The connector is too hot
   * * `Outlet error` - problem of CPI/IMI assebly, CCB or CAN cable between CCB and CPI
   * * `chargerPreChargerTimeout` - Precharger timeout is reached
   * * `ChargerVoltageDrop` - Measure voltage is lower than the expected
   * * `ChargerMaxVoltage` - Maximum voltage exceeded
   * * `ChargedStopTimeout` - Vehicle takes too log to send the stop command
   * * `ChargerConnectorPresenceLost` - Charger was not able to pick Control pilor state changes from the vehicle
   * * `ChargerErrorCurrentDifference` - The charger detected thar the current difference is too large
   * * `ChargerCANCommunicationLost` - he power cabinet internal CAN bus communication is lost
   * * `ChargerMCBTripped` - Charger circuit breaker tripped
   * * `ChargedRCDTriped` - the AC input (from the grid) Residual Current Device tripped
   * * `ChargerRCDCloseError` - Residual Current Device Closing Error
   * * `ChargefTemperatureError` - The temperature of the power cabinet or charge is high
   * * `ChargerNeutralMismatch` - Charger neutral mismatch
   * * `ChargerOutletDetection` - Charger outlet detection
   * * `VehicleProtocolError` - Vehicle protocol error
   * * `PowerPortVipError` - The powerport vip value is showing zero
   * * `Power port power error` - Power module does not respond fast enough
   * * `PowerPortFanFailure` - All power module affected by a fan failure
   * * `PowerPortOverheat` - All power modules show a high temperature
   * * `PowerPortInterlock` - Interlock of power modules acttive
   * * `PowerPortErrorOther` - Umbrella error for any other power modules related errors
   * * `VehicleErrorReversePolarity` - The polarityo the vehicle is reversed
   * * `VehicleErrorVoltageApplied` - There is a voltage applied to the DC output when this is not expected
   * * `LockError` - Unable to lock the connector, no dangerous voltage present
   * * `UnlockError` - Unable to unlock the connector, no dangerous voltage present
   * * `LockTampering` - Tampering with the connector lock detected
   * * `CableError` - Charger cannot detect chargin cable type e.g. after cable replacement
   * * `GlobalInterlockFail` - Global Interlock activated
   * * `VehicleShiftPosition` - Vehicle shift position indicator is incorrect
   * * `VehicleBatteryTemperatureOutOfRange` - Vehicle communicated that its battery temperature is out of range
   * * `VehicleLookError` - Vehicle is unable to lock the connector
   * * `VehicleBatteryMalfunction` - Vehicle battery malfunction
   * * `VehicleCurrentDifference` - Vehicle detected current is not within specs
   * * `VehicleVoltageOutOfRange` - Vehicle detected voltage is out of range
   * * `VehicleError` - General vehicle error
   * * `oardPowerSupplyError` - Charge auxiliary power supply (24V) has issues
   * * `OcmNotAlive` - Over current monitor not alive
   * * `OcmInterlockVeriicationError` - Interlock by over current monitor is not functioning properly
   * * `OcmCableRatingMismatch` - Over current monitor and cable rating does not match
   * * `OnBoardEnergymeterError` - Vehicle onboard energy meter error
   * * `VehicleWeldingDetectionTimeout` - Vehicle contador weldin detection request took to long
   * * `CableCheckCurrentRunning` - The isolation test failed during this session
   * * `CableCheckVoltageTooLow` - Power module that was selected for the cable check is not functioning
   * * `CableCheckVoltageTooHigh` - The power module voltage were too high during the cable check
   * * `CableCheckVoltageNotDropping` - Voltage is not dropping when expected during the cable check
   * * `ChargerTimeCompleted` - stopped because car has been charging long enough
   * * `VehicleNotConnected` - Vehicle not connected
   * * `SoftError` - Software induce error
   * * `StoppedByVehicle` - Stopped by vehicle
   * * `AcsErrorExtending` - Problem happened that prevent the pantograph from extending
   * * `AcsErrorRetracting` - Pantograph error retracting
   * * `AcsExtendedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AcsRetractedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AccErrorAligment` - No complete chargin circuit when the pantograph is lowered
   * * `ChargerCabinetOvp` - The Over Coltage protection in cabinet is tripped
   * * `ChargerCableCoolerFailure` - Cable cooler is not reachable or gives an error
   * * `ChargerCableCoolerTemperature` - Temperature of cooler out of range
   * * `ChargerCableTemperature` - The cable is too hot at the charger end
   * * `ChargerContactorTemperature` - Contactor temperature is out-of-range
   * * `EstCorrect` - Normal stop
   * * `blocked` - ID tag for OCPP authorization is blocked on server
   * * `Expired` - ID tag for OCPP authorization is expired on server
   * * `InvalidOnServer` - ID tag is marked as Invalid by the OCP server
   * * `InvalidOnCharged` - ID tag is marked as Invalid by the charger software
   * * `RequestReject` - Charged software rejects request for authorization
   * * `WrongMessage` - Wrong parameters provided for the authorization request
   * * `NoMatchingIDs` - ID tags for OCPP Star and Stop do not match
   * * `ServerUnreachable` - The authorization failed as the server could not be reached
   * * `NoCardPresented` - The authorization failed bcause the user did not present a card
   * * `AuthorizedStop` - Authorization was used to stop chargin
   * * `ForcedStop` - Used when it is required to stop the charging without an authorization
   * * `NormalStop` - Normal Stop that does not fall into any of other categories
   * * `ImiDisconnectedFromDcbus` - CPI disconnected from DC bus and thresfore measure 0 Volts
   * * `ChargerCommunicationFailure` - Communication between Host A8 and DCB Failed
   * * `ChargerSubunitCommunicationFailure` - Communication beetween Host A8 and Subunit DCB Failed
   * * `DCElectricMeterCommunicationFailed` - DC Electric Meter communication Detection Failed
   * * `PowerModuleCANCommunicationFailure` - Possibly Due to module Address Configuration Issueor Module CAN communication problem
   * * `InsulationCommunication` - Gun 1 and 2 Insulation Communication module are in alarm state possibly due to power supply or communication issues with the insulation modules
   * * `Timeout` - Self-test Timeout. Abnormal Status. DCB has not Reported charging status messages for a long time
   * * `ACElectricMeterCommunicationFailure` - AC Electric Meter communication Detection Failed
   * * `NFC Communication Failure` - NFC communication failure
   * * `CommunicationFailureLightPanel` - Communication failure with the Light Panel
   * * `BluetoothCommunicationFailure` - Bluetooth board communication failure
   * * `ChargerFANMalfunction` - Charger FAN malfunction
   * * `DCBTCUAbnormality` - DCB Received TCU Abnormality
   * * `ChargerOtherFaults` - Charger other faults (avoid using whenever possible)
   * * `TCUVINVerificationTimedOut` - Waiting fot TCU VIN verification result timed out
   * * `VehicleAuthenticationFailed` - Vehicle authentication Failed (VIN Verification)
   * * `FanSpeedControlFailure` - Fan speed cntrol board communication failure
   * * `InsulationAlarm` - Insulation alarm (Alert without Shutdown)
   * * `InsulationFault` - Insulation Fault
   * * `PowerModuleAlarm` - Power module alarm
   * * `PowerModuleConflict` - (C6) Power module address conflict, (C2) charging station not initialized
   * * `PowerModuleFault` - Power module fault. Record the modules that have experienced a fault in the data
   * * `PowerModuleStatusChange` - Power module status change ( number of availabke modules)
   * * `PowerModulePhaseLossFault` - Power module phase loss fault
   * * `PowerModuleFanFault` - Power module FAN fault
   * * `PowerModuleOvertemperatureFault` - Power module overtemperature fault
   * * `PowerModuleACInputFault` - Power module AC input Fault
   * * `PowerModuleOutputShortCircuitFault` - Power module output short circuit fault
   * * `PowerModuleOutputOvercurrentFault` - Power module output overcurrent fault
   * * `PowerModuleOutputOvervoltageFault` - Power module output overvoltage fault
   * * `PowerModuleOutputUndervoltageFault` - Power module output undervoltage fault
   * * `PowerModuleInputOvervoltageFault` - Power module input overvoltage fault
   * * `PowerModuleInputUndervoltageFault` - Power module input undervoltage fault
   * * `PowerModuleDischargeFault` - Power module discharge fault
   * * `PowerModuleCurrentLimit` - Power module current limit
   * * `PowerModuleShutdown` - Power module shutdown
   * * `NoAvailableSparePowerModule` - No available spare power module
   * * `ChargerAccessControlFailure` - Charger access control failure
   * * `LiquidLevelAlarm` - Liquid level alarm
   * * `ACSurgeAlarm` - AC surge alarm
   * * `DCSurgeAlarm` - DC Surge alarm. If It's a subunit DC surge, specify the subunit number in the data
   * * `GunEndContactFault` - Gun end contactor fault. Displayed as charging port end contact fault on WeChat
   * * `ChargigStationSmokeDetectorFault` - Charging station smoke detector fault
   * * `CabinetTemperatureAlarm` - Cabinet Temperature Alarm. Abnormal Status
   * * `CabinetHumidityAlarm` - Cabinete humidity alarm. Abnormal status
   * * `TiltAngleAlarm` - Tilt angle alarm. abnormal status
   * * `LiquidCooledHeadExceedsShutdown` - Liquid-Cooled gun Head exceeds shutdown temperature. shutdown
   * * `LiquidCooledHeadExceedsCurrentShutdown` - Liquid-Cooled gun head exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledTailExceedsShutdown` - Liquid-Cooled gun Tail exceeds shutdown temperature. shutdown
   * * `LiquidCooledTailExceedsCurrentShutdown` - Liquid-Cooled gun Tail exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledHeadTemperatureRiseExceedsShutdown` - Liquid-Cooled gun head temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledHeadTemperatureRiseCurrentShutdown` - Liquid-Cooled gun head temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LiquidCooledTailTemperatureRiseExceedsShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledTailTemperatureRiseCurrentShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LowLiquidLevel` - Low liquid level in  Liquid cooling, current limit without shutdown.
   * * `LiquidCoolingOvertemperatureOvervoltage` - Liquid coolink liquid overtemperature and overvoltage. Overtemperature and overvoltage are the same fault in this context
   * * `LiquidCooledHeadDifferenceExceeds` - Liquid-cooled gun head and tail temperature difference exceeds current limit rate, but not shutdown rate. current limit without shutdown
   * * `LiquidCooledHeadTailShutdown` - Liquid-Cooled gun head and tail temperature difference exceeds shutdown rate. Shutdown
   * * `LiquidCoolingFault` - Liquid cooling fault
   * * `ChargingStationFault` - Charging station fault
   * * `TiltAngleFault` - Tilt angle fault
   * * `LiquidCoolingCoolantLowLevelFault` - Liquid cooling coolant low level fault, shutdown. This fault may indicate a coolant leak
   * * `OtherHardwareFaultsInLiquidCooling` - Other hardware fault in liquid cooling
   * * `LiquidCoolingDischargeNoShutdown` - Liquid cooling discharge and return temperature difference alarm, but no shutdown
   * * `LiquidCoolingDischargeShutdown` - Liquid cooling discharge and return temperature difference alarm shutdown
   * * `LiquidCoolingReturnNoShutdown` - Liquid cooling return temperature difference alarm, but no shutdown
   * * `LiquidCoolingReturnShutdown` - Liquid cooling return temperature difference alarm, shutdown
   * * `LiquidCoolingPumpLowAlarm` - Liquid cooling pump low temperature alarm, but no shutdown
   * * `LiquidCoolingPumpLowFault` - Liquid cooling pump low temperature fault, shutdown
   * * `LiquidCoolingPumpFault` - Liquid cooling pump temperature fault, shutdown
   * * `LiquidCoolingPumpSesingFault` - Liquid cooling pump temperature sensing fault, shutdown
   * * `EmergencyStopCircuitFault` - Emergency stop circuit fault
   * * `ChargingGunTemperatureAlarm` - Charging gun temperature alarm. Displayed as charging port temperature alarm on WeChat. Abnormal status
   * * `ElectromagneticLockLockingFailed` - Electromagnetic lock locking operation failed. Abnormal status
   * * `ElectromagneticLockUnlockingFailed` - Electromagnetic lock unlocking operation failed. At this point, the charging gun is locked and cannot be removed. Abnormal status
   * * `AbnormalityChargingGunPort` - Abnormality at the charging gun port, meannig a change in CC voltageduring charging (other than 4V), abnormal status
   * * `ChargingGunNotProperlyPositioned` - Charging gun not properly positioned
   * * `BMSVoltageLowOrHigh` - BMS demands voltage too low or high. If it can be ditinguished as 'high' or 'low'
   * * `BMSVoltageHigh` - BMS demands voltage too high
   * * `BMSVoltageLow` - BMS demands voltage too Low
   * * `APhaseHigh` - A-phase voltage too high
   * * `BPhaseHigh` - B-phase voltage too high
   * * `CPhaseHigh` - C-phase voltage too high
   * * `APhaseLow` - A-phase voltage too low
   * * `BPhaseLow` - B-phase voltage too low
   * * `CPhaseLow` - C-phase voltage too low
   * * `GroundWireAlarm` - Ground wire alarm
   * * `NLineNotConnected` - N-Line not connected
   * * `ACInputCircuitBrakerFailure` - AC Input circuit breaker failure
   * * `ACInputContadorRefusarFault` - AC Input contador refursar fault
   * * `ACInputContadorStickingFault` - AC input contador sticking fault
   * * `SystemPowerFailure` - System power failure. 220V no input
   * * `ACPowerMeterReadingAbnormal` - AC power meter reading abnormal
   * * `ACInputPhaseLoss` - AC input phase loss
   * * `VoltageAbnormalityOvervoltage` - Coltage abnormality overvoltage
   * * `VoltageAbnormalityUndervoltage` - Voltage abnormality undervoltage
   * * `VoltageAbnormalityShortCircuit` - Voltageabnormality short circuit
   * * `VoltageAbnormalityOverload` - Voltage abnormality overload
   * * `BatteryReverseConnection` - Battery reverse connection
   * * `DCDetectionFailure` - DC detection failure
   * * `DischargeDetectionFailure` - Dicharge detection failure
   * * `ParallelContadorRefusalFault` - Parallel contador refusal fault
   * * `ParallelContadorAhesionFault` - Parallel contador adhesion fault
   * * `DCBusOutputFuseFault` - DC bus output fuse fault
   * * `ChargingHostPreChargingFailureFault` - Charging host pre-charging failure fault
   * * `ChargingHostResponseChargingFailureFault` - Charging host response charging failure fault
   * * `BatteryUndervoltage` - During the charging permission stage, the charging station measures the battery voltage lower than 5% of the battery voltage in BCP
   * * `BatteryOvervoltage` - During the charging permission stage, the charging station measures the battery voltage higher than 5% of the battery voltage in BCP
   * * `AbnormalDC` - Abnormal DC meter reading
   * * `GunheadDCRefusalFault` - Gunhead DC output contactor refusal fault
   * * `GunheadDCAdhesionFault` - Gunhead DC output contadctor adhesion fault
   * * `PrechargeTimeout` - Precharge timeout
   * * `AuxiliaryPowerNotPowered` - The auxiliar power supply is not powered on
   * * `CRMTimeout` - CRM timeout
   * * `CRM00Timeout` - CRM00 timeout
   * * `CRMaaTimeout` - CRMaa timeout
   * * `CROTimeout` - CRO timeout
   * * `CTSTimeout` - CTS timeout
   * * `CMLTimeout` - CML timeout
   * * `CCSTimeout` - CSS timeout
   * * `CSTTimeout` - CST timeout
   * * `CSDTimeout` - CSD timeout
   * * `OtherTimeoutFaultBEM` - Other timeout fault as defined in BEM
   * * `ChargerOutputCurrentExcedsDC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the DC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargerOutputCurrentExcedsAC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the AC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargingHostEmergencyStop` - Charging host emergency stop
   * * `ChargingostDCBusbarFuse` - Charging host DC busbar fuse
   * * `ChargingHostAccessControlFAilure` - Charging host access control failure
   * * `ChargingHostSmokeDetectorFailure` - Charging host smoke detector failure
   * * `ChargingHostACInputCircuitBreakerFailure` - Charging host AC input circuit breaker failure
   * * `ChargingHostACInputContactorMalfunction` - charging host AC input contactor malfunction
   * * `ChargingHostACInputStickingMalfunction` - charging host AC input sticking malfunction
   * * `ChargingHostFanMalfunction` - Charging host fan malfunction
   * * `ChargingHostParallelContactorMalfunction` - Charging host parallel contactor malfunction
   * * `ChargingHostParallelStickingMalfunction` - Charging host parallel sticking malfunction
   * * `ChargingHostLiquidCoolingModuleMalfunction` - Charging host liquid cooling module malfunction
   * * `ChargingHostLiquidCoolingModuleCommunicationFailure` - Charging host liquid cooling module communication failure
   * * `ChargingHostSurgeArresterMAlfunction` - Charging host surge arrester malfunction
   * * `ChargingHostACEnergyMeterCommunicationFailure` - Charging host AC energy meter communication failure
   * * `ChargingHostOverTemperatureFault` - Charging host over temperature fault
   * * `ChargingHostOverTemperatureWarning` - Charging host over temperature warning
   * * `ChargingHostInputVoltageOvervoltageFault` - Charging host input voltage overvoltage fault
   * * `ChargingHostInputVoltageUndervoltageFault` - Charging host input voltage undervoltage fault
   * * `ChargingHostWaterLevelMonitoringAbnormality` - Charging host water level monitoring abnormality
   * * `ChargingHostPowerModuleFault` - Charging host power module fault
   * * `ChargingHostPowerModuleCommunicationFailure` - Charging host power module communication failure
   * * `ChargingHostPowerModuleFanMalfunction` - Charging host power module fan malfunction
   * * `ChargingHostPowerModuleOverTemperatureFault` - Charging host power module over-temperature fault
   * * `ChargingHostPowerModuleACInputFault` - Charging host power module AC input fault
   * * `ChargingHostPowerModuleOutputShortCircuitFault` - Charging host power module output short circuit fault
   * * `ChargingHostPowerModuleOutputOvercurrentFault` - Charging host power module output overcurrent fault
   * * `ChargingHostModuleOutputOvervoltageFault` - Charging host power module output overvoltage fault
   * * `ChargingHostModuleOutputUndervoltageFault` - Charging host power module output undervoltage fault
   * * `ChargingHostModuleInputOvervoltageFault` - Charging host power module input overvoltage fault
   * * `ChargingHostModuleInputUndevoltagetFault` - Charging host power module input undevoltage fault
   * * `ChargingHostModuleInputPhaseLossFault` - Charging host charging module input phase loss fault
   * * `ChargingHostChargingModuleFault` - Charging host charging module fault
   * * `ChargingHostChargingModuleCommunicationFailure` - Charging host charging module communication failure
   * * `ChargingHostAdhesiveDetectionTimeout` - Charging host adhesive detection response timeout
   * * `ChargingHostChargingStopCompletionTimeout` - Charging host charging stop completion response timeout
   * * `ChargingHostInsulationDetectionFrameTimeout` - Charging host insulation detection frame response timeout
   * * `ChargingHostInsulationDetectionCompletionTimeout` - Charging host insulation detection completion response timeout
   * * `ChargingHostPreChargeFrameTimeout` - Charging host pre-charge frame response timeout
   * * `ChargingHostPreChargeCompletionTimeout` - Charging host pre-charge completion response timeout
   * * `ChargingHostReceptionFirmwareUpgradeFrameTimeout` - Charging host reception of remote firmware upgrade file data frame timeout
   * * `ChargingHostReceptionChargingDemandDataFrameTimeout` - Charging host reception of charging demad data frame timeout
   * * `ChargingHostChargingTerminalTelesinalFrameTimeout` - Charging host charging terminal telesignal frame reception timeout
   * * `ChargingHostChargingStartupTimeout` - Charging host charging startup response timeout
   * * `ChargingHostChargingStopTimeout` - Charging host charging stop response timeout
   * * `ChargingHostTimeSynchronizationOperationTimeout` - Charging host time synchronization operation response timeout
   * * `ChargingHostVersionVerificationTimeout` - Charging host version verification response timeout
   * * `ChargingHostChargingParameterTimeout` - Charging host charging parameter response timeout
   * * `ChargingHostPreChargerTimeout` - Charging host pre-charger response timeout
   * * `ChargingHostInsulationDetectionTimeout` - Charging host insulation detection reponse timeout
   * * `ChargingHostRemoteUpgradeRequestTimeout` - Charging host remote upgrade request response timeout
   * * `ChargingHostDebuggingDataRequestTimeout` - Charging host debugging data request response timeout
   * * `ChargingHostControlRequestTimeout` - Charging host control request response timeout
   * * `ChargingHostRemoteFirmwareTransferFrameTimeout` - Charging host remote firmware upgrade file transfer completion frame reception timeout
   * * `ChargingHostRemoteUpgradeCompletionFrameTimeout` - Chaging host remote upgrade completion reception timeout
   * * `ChargingHostTelecontrolFrameTimeout` - Charging host telecontrol frame reception timeout
   * * `CharginghostTelemetryFrameTimeout` - Charging host telemetry frame reception timeout
   * * `ChargingHostInsulationDetectionCompletionFrameTimeout` - Charging host insulation detection completion frame reception timeout
   * * `ChargingHostAdhesiveDetectionFrameTimeout` - Charging host adhesive detection frame reception timeout
   * * `ChargingHostPreChargeCompletionFrameTimeout` - Charging host pre-charge completion frame reception timeout
   * * `ChargingHostChargingStopFrameTimeout` - Charging host charging stop completion frame reception timeout
   * * `ChargingHostAndSubCommunicationNotCompleted` - Charging host and sub-communication initialization not completed
   * * `ChargingHostHeartbeatReceptionStatus` - Charging host heartbeat reception status
   * * `BSTHighVoltageRelayMalfunction` - BST high voltage relay malfunction
   * * `BSTChargingConnectorMalfunction` - BST charging connector malfunction. Abnormal status
   * * `BSTBatteryPackTemperatureHigh` - BST battery pack temperature too high
   * * `BSTCurrentExceedsRequiredValue` - BST current exceeds the required value
   * * `BSTVoltageAbnormal` - BST voltage abnormal
   * * `BSTDetectionPoint2VoltageDetectionMalfunction` - BST detection point 2 voltage detection malfunction. Abnormal status
   * * `BSTOtherMalfunction` - BST other malfunction
   * * `BSTOutputConnectorOverheated` - BST output connector overheated
   * * `BSTStopSendData0Malfunction` - BST stops and send data as 0 malfunction, not a malfunction.
   * * `BSTVehicleInsulation` - BST vehicle insulation
   * * `BMSCurrentExceedsVoltageMode` - BMS current request exceeds the maximum allowed current in constant voltage mode
   * * `BMSCurrentExceedsCurrentMode` - BMS current request exceeds the maximum allowed current in constant current mode
   * * `ChargingProhibited` - Charging prohibited, 10-minute timeout
   * * `BHMVoltageMatchingFailure` - BHM voltage matching failure
   * * `VoltageDetectionFailure` - Voltage detection failure
   * * `BMSCoponentOutputConnectorOverTemperature` - BHM component output connector over temperature
   * * `BSMIndividualPowerBatteryHigh` - BSM individual power battery voltage too high
   * * `BSMIndividualPowerBatteryLow` - BSM individual power battery voltage too low
   * * `BSMVehiclePowerBatteryHigh` - BSM whole vehicle power battery state of charge (SOC) too high
   * * `BSMVehiclePowerBatterylow` - BSM whole vehicle power battery state of charge (SOC) too low
   * * `BSMVehiclePowerBatteryInsulationAbnormal` - BSM power battery insulation status abnormal
   * * `BSMBatteryOvercurrentCharging` - BSM power battery overcurrent during charging
   * * `BSMBatteryTemperatureHigh` - BSM power battery temperature high
   * * `BSMBatteryOutputConnectorConnectionAbnormal` - BSM power battery pack output connector connection status abnormal
   * * `BMSCommunicationProtocolVersionMismatch` - BMS communication protocol version mismatch
   * * `VehicleFullyCharged` - The vehicle is fully charged; this is feedback from the vehicle
   * * `ReachedSetTotalVoltage` - Reached the set total voltage. Not considered abnormal; can be regarded as fully charged
   * * `ReachedSetIndividualVoltage` - Reached the set individual cell voltage. Not considered abnormal; can be regarded as fully charged
   * * `MetChargerSettingConditions` - Met the charger setting conditions. Not considered abnormal; can be regarded as fully charged
   * * `VehicleSideManualTermination` - Vehicle-side indicates manual temination
   * * `PowerCannotBeTransmitted` - Power cannot be transmitted this is a vehicle malfunction, it might be fully charged.
   * * `CurrentMismatchVehicleMalfunction` - Current mismathc, this is a vehicle malfunction, it might be fully charged
   * * `ChargedTeminated` - Charged teminated
   * * `BRMTimeout` - BRM timeout
   * * `BCPTimeout` - BCP timeout
   * * `BRO_TIMEOUT` - BRO timeout
   * * `BCSTimeout` - BCS timeout
   * * `BCLTimeout` - BCL timeout
   * * `BSTTimeout` - BST timeout
   * * `BSDTimeout` - BSD timeout
   * * `BSMTimeout` - BSM timeout
   * * `CHAdeMoCodeWaitJ3TimeOut` - Waiting for vehicle-side Switch = ON timeout. Vehicle-side malfunction
   * * `CHAdeMoCodeDCVoltExceed10V` - DC bus voltage exceeds 10V before charging. Bus has voltage or vehicle-side malfunction
   * * `CHAdeMoCodeJ3StatusErr` - Vehicle-side Switch status error. Vehicle-side malfunction
   * * `CHAdeMOCodeEvReadyStatusErr` - Vehicel-side readiness status error. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitEVSEOutVoltErr` - Waiting for output voltage timeout
   * * `CHAdeMOCodeDCVoltExceed20V` - Insulation check completed voltage anomaly after discharge
   * * `CHAdeMOCodeCommunicationTimeOut` - Vehicle-side CAN communication timeout
   * * `CHAdeMOCodeWaitCAN10XTimeOut` - Waiting for vehicle-side CAN communication timeout at beginning of charging. Vehicle malfunction
   * * `CHAdeMOCodeWaitEVCurrentReqTimeOut` - Waiting for current request failed. VEhicle-side malfunction
   * * `CHAdeMOCodeWaitEVContadorTimeOut` - Waiting for vehicle-side contacdt closure failed. Vehicle-side malfunction
   * * `CHAdeMOCodeDCVoltExceed10VNormalEnd` - Abnormal discharge at the end of charging. Vehicle-side malfunction
   * * `CHAdeMOCodeCommunicationOpenTimeOut` - Waiting for the vehicle to disconnect communication timeout after charging ends. Vehicle-side malfunction
   * * `CHAdeMOCodeChargingSystemFault` - Vehicle-side reported charging system error. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOverVoltage` - Output voltage abnormal. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOvercurrent` - Output current abnormal.
   * * `CHAdeMOCodeBatterPolarity` - Battery polarity error
   * * `CHAdeMOCodeEVSEIsolationStatusFail` - Insulation fault error
   * * `CHAdeMOCodeMalfunctionDetectionFail` - Charging plug electromagnetic lock failed to lock. Charging cable electromagnetic lock malfunction
   * * `CHAdeMOCodeCANInitFail` - CCAN initialization failed. Board malfunction
   * * `CHAdeMOCodeVehicleShiftPositionStop` - Vehicle-side Vehicle_shift_position stops. Issue on the vehicle side
   * * `CHAdeMOCodeWaitJ3OpenErr` - Waiting for vehicle-side Switch = OFF timeout. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitCommunicationCloseTimeOut` - Wait for communication closure anomaly. Vehicle-side malfunction
   * * `CHAdeMOCodeBEforeChargeJ3StatusErr` - Switch status abnormal before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeTargetBatterVoltageErr` - EEV target battery voltage abnormal. Vehiccle-side malfunction
   * * `CHAdeMOCodeBatteryInccompatibilityErr` - EV battery mismatch. Vehicle-side mismatch
   * * `CHAdeMOCodeRequestCurrentErr` - Current request failed. Vehicle-side malfunction
   * * `CHAdeMOCodeMinimumCurrentErr` - Minimum current error. Vehicle-side malfunction
   * * `CHAdeMOCodeNormalStopRequestBefoeCharging` - Vehicle-side requests to stop before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeRemainingChargingTimeIsZero` - Remaining charging time is 0. Charging stopped
   * * `CHAdeMOCodeWaitPowerReadyTimeout` - Waiting for the power module to be ready exceeded timeout. Power module anomaly
   * * `CHAdeMOCodeVehicleCChargingEnable` - Vehicle-side 'Vehicle_charging_enabled' status error. Vehicle-side malfunction
   * * `CHAdeMOCodeCurrent5AOrLess` - Waiting dot charging to end and current to drop below 5A exceeded timeout. Power module or current detection issue
   * * `CHAdeMOCodeEVErrorCanid1024A` - Vehicle-side reported 102.4 error stop. Vehicle-side malfunction
   * * `CHAdeMOCodeEVErrorCanid10240` - Vehicle-side reported: Battery_Overvoltage
   * * `CHAdeMOCodeEVErrorCanid10241` - Vehicle-side reported: Battery_Undervoltage
   * * `CHAdeMOCodeEVErrorCanid1024` - Vehicle-side reported: Battery_Current_deviation_Error
   * * `CHAdeMOCodeEVErrorCanid10243` - Vehicle-side reported: Battery_High_Temperature
   * * `CHAdeMOCodeEVErrorCanid10244` - Vehicle-side reported: Battery_Voltage_Deviation_Error
   * * `CHAdeMOCodeOther` - Cannot use if not matched, try not to use it
   * * `CCSStopCodePlugOut` - Detected that the charging plug was remover during charging. CP immediately changes to 12v
   * * `CCSStopCodeReadyToChargePerformanceTimeOut` - Waiting to start charging timeout
   * * `CCSStopCodeCommEVSessionStop` - Vehicle-side sent Session stop for normal termination
   * * `CCSStopCodeEVSEIsolationStatusFail` - Stopped due to isulation fault
   * * `CCSStopCodeEVTargetVoltageFail` - Vehicle-side demanded coltage exceeds the maximum allowable voltage for for the vehicle
   * * `CCSStopCodeEVTargetCurrentFail` - Vehicle-side demanded voltage  exceeds the maximum allowable current for the vehicle
   * * `CCSStopCodeEVSEPresentVoltageFail` - DC output over-voltage
   * * `CCSStopCodeEVSEPresentCurrentFail` - DC output overcurrent
   * * `CCSStopCodeCPFail` - CP voltage abnormal, exceeds 6v, 9v with a tolerance of plus or minus 0.8V
   * * `CCSStopCodeEVSEBatterPolarityFail` - BAttery polarity reversed
   * * `CCSStopCodeEvseChargeBeforeOvervoltageFail` - Overvoltage before charging
   * * `CCSStopCodeEvseChargeInsulationAfterOvervoltageFail` - Overvoltage after insulation charge
   * * `CSSStopCodeEVSEUndervoltage` - Output undervoltage
   * * `CCSStopCodeOngoingPerformanceTimeout` - WAiting for charging permission timeout
   * * `CCSStopCodePDVoltAlarm` - American standard plug PD detection error; not applicable for European Standar
   * * `CCSStopCodeOther` - not matched, try not to use
   * * `V2GFailed` - V2G failed
   * * `V2GFailedSequenceError` - V2G failed sequence error
   * * `V2GFailedServiceIdInvalid` - V2G failed service id invalid
   * * `V2GFailedUnknownSession` - V2G failed unknow session
   * * `V2GFailedServiceSelectionInvalid` - V2G failed service selection invalid
   * * `V2GFailedPaymentSelectionInvelid` - V2G failed payment selection invalid
   * * `V2GFailedCertificateExpired` - V2G failed certificate expired
   * * `V2GFailedSignatureError` - V2G failed signature error
   * * `V2GFailedNoCertificateAvailable` - V2G failed no certificate available
   * * `V2GFailedCertChainError` - V2G failed cert chain error
   * * `V2GFailedChallengeInvalid` - V2G failed challenge invalid
   * * `V2GFailedContractCanceled` - V2G failed contract canceled
   * * `V2GFailedWrongChargeParameter` - V2G failed wrong charge parameter
   * * `V2GFailedPowerDeliveryNotApplied` - V2G failed power delivery not applied
   * * `V2GFailedTariffSelectionInvalid` - V2G failed tariff selection invalid
   * * `V2GFailedChargingProfileInvalid` - V2G failed charging profile invalid
   * * `V2GFailedEVSEPresentVoltToLow` - V2G failed EVSE present volt to low
   * * `V2GFailedMeteringsignatureNotValid` - V2G failed metering signature not velid
   * * `V2GFailedWrongEnergyTranferType` - V2G failed wrong energy transfer type
   * * `V2GFailedAppHandResponse` - V2G failed app hand response code type failed no negotiation
   * * `V2GInitErrorQCA7000` - V2G inir error QCA 7000
   * * `V2GInitErrorOther` - V2G init error other
   * * `V2GInitErrorGeneral` - V2G init error general
   * * `V2GInitErrorIfaddr` - V2G init error ifaddr
   * * `V2GInitErrorThread` - V2G init error thread
   * * `V2GInitErrorOpenchannel` - V2G init error openchannel
   * * `V2GInitErrorKey` - V2G init error key
   * * `V2GSlacErrorGeneral` - V2G slac error general
   * * `V2GSlacErrorTimerInit` - V2G slac error timer init
   * * `V2GSlacErrorTimerTimeout` - V2G slac error timer timeout
   * * `V2GSlacErrorTimerMisc` - V2G slac error timer misc
   * * `V2GSlacErrorParamTimeout` - V2G slac error param timeout
   * * `V2GSlacErrorParamSocket` - V2G slac error param socket
   * * `V2GSlacErrorStartAttenCharTimeout` - V2G slac error start atten char timeout
   * * `V2GSlacErrorMNBCSoundTimeout` - V2G slac error MNBC sound timeout
   * * `V2GSlacErrorAttenCharTimeout` - V2G slac error atten char timeout
   * * `V2GSlacErrorAttenCharSocket` - V2G slac error atten char Socket
   * * `V2GSlacErrorValidate1Timeout` - V2G slac error validate 1 timeout
   * * `V2GSlacErrorValidate1Socket` - V2G slac error validate 1 socket
   * * `V2GSlacErrorValidate2Timeout` - V2G slac error validate 2 timeout
   * * `V2GSlacErrorValidate2Socket` - V2G slac error validate 2 socket
   * * `V2GSlacErrorBCBToggleTimeout` - V2G slac error BCB toggle timeout
   * * `V2GSlacErrorMatchTimeout` - V2G slac error match timeout
   * * `V2GSlacErrorMatchSocket` - V2G slac error match Socket
   * * `V2GSlacErrorReadSocket` - V2G slac error read Socket
   * * `V2GSlacErrorSetKey` - V2G slac error set key
   * * `V2GSlacErrorLinkTimeout` - V2G slac error link timeout
   * * `V2GSDPErrorGeneral` - V2G SDP error general
   * * `V2GSDPErrorInitSocket` - V2G SDP error init socket
   * * `V2GSDPErrorInitSockOPT1` - V2G SDP error init sockotp1
   * * `V2GSDPErrorInitSockOPT2` - V2G SDP error init sockotp2
   * * `V2GSDPErrorInitBind` - V2G SDP error init bind
   * * `V2GSDPErrorThreadSocket1` - V2G SDP error thread docket 1
   * * `V2GSDPErrorThreadSocket2` - V2G SDP error thread docket 2
   * * `V2GSDPErrorTimeout` - V2G SDP error timeout
   * * `V2GSDPErrorTCPDisconnected` - V2G SDP error tcp disconnected
   * * `V2GDinErrorGeneral` - V2G DIN error general
   * * `V2GDinErrorInitSocket` - V2G DIN error init socket
   * * `V2GDinErrorInitSockOPT` - V2G DIN error init sockOPT
   * * `V2GDinErrorInitBind` - V2G DIN error init bind
   * * `V2GDinErrorInitListen` - V2G DIN error init listen
   * * `V2GDinErrorInitSelect` - V2G DIN error init select
   * * `V2GDinErrorInitAccept` - V2G DIN error init accept
   * * `V2GDinErrorTimeout` - V2G DIN error timeout
   * * `V2GDinErrorV2GTPHeader` - V2G DIN error V2GTP header
   * * `V2GDinErrorV2GTPHeaderLen` - V2G DIN error V2GTP header Len
   * * `V2GDinErrorV2GTPHeaderWrite` - V2G DIN error V2GTP header write
   * * `V2GDinErrorDecodeExi` - V2G DIN error Decode Exi
   * * `V2GDinErrorEncodeExi` - V2G DIN error Encode Exi
   * * `V2GDinErrorCreateResponse` - V2G DIN error create response
   * * `V2GDinErrorSocketException` - V2G DIN error socket exception
   * * `V2GDinErrorSocketSend` - V2G DIN error socket send
   * * `V2GDinErrorNoProtocol` - V2G DIN error no protocol
   */
  verbose_error?: VerboseErrorEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineTransaction {
  id: number;
  connector: number;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  /** Charging Authorization at Start */
  charging_authorization_start?: number | null;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  /** Charging Authorization at Stop */
  charging_authorization_stop?: number | null;
  /** User Who Started */
  user_start?: number | null;
  /** User Who Stopped */
  user_stop?: number | null;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  gross_price: string;
  net_price: string;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  vehicle?: CMSInlineVehicle | null;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
}

export interface CMSInlineUserGroup {
  id: number;
  /** @maxLength 64 */
  name: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSInlineVehicle {
  /**
   * @maxLength 10
   * @pattern ^[A-Z0-9]{1,10}$
   */
  number_plate: string;
  /** Flota */
  fleet?: number;
  /**
   * Vehicle Verbose Name
   * @maxLength 10
   */
  verbose_name?: string | null;
  /**
   * Vehicle Identification Number
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin?: string | null;
  /**
   * Vehicle Identification Number 2
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin2?: string | null;
  /** @maxLength 64 */
  brand?: string | null;
  /** @maxLength 64 */
  model?: string | null;
  /**
   * * `Sedan` - Sedan
   * * `Van` - Van
   * * `Bus` - Bus
   * * `Truck` - Truck
   */
  class_type?: ClassTypeEnum;
  /**
   * Nominal Range in km
   * @min 0
   * @max 2147483647
   */
  nominal_range?: number;
  /**
   * Consumption in Wh/km
   * @min 0
   * @max 2147483647
   */
  consumption?: number;
  /**
   * Battery Nominal Capacity in Wh
   * @min 0
   * @max 2147483647
   */
  battery_nominal_capacity?: number | null;
  /**
   * Carbon Footprint of equivalent Internal Combustion Engine Vehicle in gCO2/km
   * @min 0
   * @max 2147483647
   */
  co2eqIC?: number;
  /** Use VIN as ID TAG */
  vin_as_id_tag?: boolean;
  latest_tracker_log?: number | null;
  latest_transaction?: number | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_soc?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_odometer?: string | null;
  /**
   * Latest Remaing Kilometers
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_remaing_km?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,3})?$
   */
  latest_temperature?: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Esperando
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  /**
   * @min 0
   * @max 32767
   */
  low_soc_threshold?: number;
  /** Has Low SoC Notification been sent? */
  low_soc_notification_sent?: boolean;
}

export interface CMSInlineVehicleStation {
  id: number;
  /** @maxLength 64 */
  name: string;
  contour?: string;
  fleets?: number[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** ModelSerializer for Payment */
export interface CMSPayment {
  id: number;
  transaction: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  gross_amount: string;
  net_amount: string;
  credit_card: CMSInlineCreditCard;
  /** @maxLength 32 */
  payment_ticket_id: string;
  /** @maxLength 64 */
  kushki_transaction_reference: string;
}

export interface CMSProfile {
  user: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  date_joined: string;
  groups: CMSInlineGroup[];
  /** @format uri */
  image?: string | null;
  /**
   * * `en-us` - English
   * * `es` - Spanish
   */
  language?: LanguageEnum;
  /** Time zone */
  timezone?: TimezoneEnum | null;
  /** @maxLength 255 */
  startpage?: string | null;
  document_type?: DocumentTypeAbeEnum | null;
  /** @maxLength 64 */
  document_number?: string | null;
  /** @maxLength 64 */
  second_last_name?: string | null;
  /** @maxLength 64 */
  phone_number?: string | null;
  /**
   * End-user license agreement
   * @format date-time
   */
  eula?: string | null;
  email_validated?: boolean;
  /** @maxLength 64 */
  google_userid?: string | null;
  /** @maxLength 64 */
  apple_userid?: string | null;
  is_mobile?: boolean;
  is_google_auth?: boolean;
  assets: Nested[];
  fleets: Nested[];
  spot_user_groups: Nested[];
  deferred_user_groups: Nested[];
  created_at: string;
}

export interface CMSSampledValue {
  id: number;
  /** @maxLength 255 */
  value: string;
  /**
   * * `Raw` - Raw
   * * `SignedData` - SignedData
   */
  value_format?: ValueFormatEnum;
  /** @default "Energy.Active.Import.Register" */
  measurand?: Measurand2D5Enum;
  meter_value: CMSInlineMeterValue;
  phase?: PhaseEnum | null;
  /** Unit Of Measure */
  unit?: UnitEnum;
  /** @format date-time */
  timestamp?: string | null;
  /**
   * Fecha de creación
   * @format date-time
   */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface CMSTransaction {
  id: number;
  connector: CMSInlineConnector;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  charging_authorization_start: CMSInlineChargingAuthorization;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  charging_authorization_stop: CMSInlineChargingAuthorization;
  user_start?: CMSInlineProfile;
  user_stop?: CMSInlineProfile;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  gross_price: string;
  net_price: string;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  vehicle?: CMSInlineVehicle;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
}

export interface CMSTransactionRequest {
  id: number;
  user: CMSInlineProfile;
  transaction: CMSInlineTransaction;
  connector: CMSInlineConnector;
  user_group: CMSInlineUserGroup;
  credit_card: CMSInlineCreditCard;
  /** Synchronizing Status */
  sync_status?: SyncStatus695Enum | null;
  /**
   * Synchronizing Task Id
   * @maxLength 37
   */
  sync_task_id?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  anonymous_user: string;
  anonymous_net_price_stop: string;
}

/** Serializer for table shown in module Sales->User Groups */
export interface CMSUserGroup {
  id: number;
  name: string;
  type: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Charge Point Serializer */
export interface ChargePoint {
  id: number;
  connectors: Connector[];
  configuration_keys: ConfigurationKey[];
  latest_heartbeat: Heartbeat;
  latest_boot_notification: BootNotification;
  latest_status_notification: StatusNotification;
  /** @example {"latitude":-33.41476682287769,"longitude":-70.584030204484} */
  location?: LatLng;
  /**
   * Charge Point Identity
   * @maxLength 40
   * @pattern ^[a-zA-Z\d\-_.]+$
   */
  name: string;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @maxLength 21 */
  vendor?: string | null;
  /** @maxLength 21 */
  model?: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  charger_efficiency?: string | null;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  /** Use P=V·I·cos(0) */
  use_vi?: boolean;
  /** Is single Phase? */
  is_single_phase?: boolean;
  /**
   * Local Authorization List Version
   * @min 0
   * @max 2147483647
   */
  local_list_version?: number;
  /** Enable Free Pass */
  free_pass?: boolean;
  /** Enable Auto Start */
  auto_start?: boolean;
  /** Enable Vehicle RFID */
  vehicle_rfid?: boolean;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable Manual Filling of Fields */
  fill_manual_fields?: boolean;
  /**
   * Remaining Time Threshold for Notifications (seconds)
   * @min 0
   * @max 32767
   */
  remaining_time_threshold?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * Start Period
   * @format time
   */
  start_day?: string;
  /** @maxLength 300 */
  additional_info?: string | null;
  grid_connection?: number;
  vehicle_station?: number | null;
  /** Charge Point Group */
  group?: number;
  firmware?: number | null;
}

export interface ChargePointGroup {
  id: string;
  /** @maxLength 64 */
  name: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_points: string[];
}

/** Charge Point Image Serializer */
export interface ChargePointImageUnauthenticated {
  id: number;
  /** @format uri */
  image: string;
  charge_point: number;
}

/** Charge Point Minimal Serializer */
export interface ChargePointMinimal {
  id: number;
  /** @example {"latitude":-33.41476682287769,"longitude":-70.584030204484} */
  location?: LatLng;
  /**
   * Charge Point Identity
   * @maxLength 40
   * @pattern ^[a-zA-Z\d\-_.]+$
   */
  name: string;
  /**
   * Charge Point Password Hash
   * @maxLength 200
   */
  key?: string | null;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @maxLength 21 */
  vendor?: string | null;
  /** @maxLength 21 */
  model?: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
   */
  charger_efficiency?: string | null;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  /** Use P=V·I·cos(0) */
  use_vi?: boolean;
  /** Is single Phase? */
  is_single_phase?: boolean;
  /**
   * Local Authorization List Version
   * @min 0
   * @max 2147483647
   */
  local_list_version?: number;
  /** Enable Free Pass */
  free_pass?: boolean;
  /** Enable Auto Start */
  auto_start?: boolean;
  /** Enable Vehicle RFID */
  vehicle_rfid?: boolean;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable Manual Filling of Fields */
  fill_manual_fields?: boolean;
  /**
   * Remaining Time Threshold for Notifications (seconds)
   * @min 0
   * @max 32767
   */
  remaining_time_threshold?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * Start Period
   * @format time
   */
  start_day?: string;
  /** @maxLength 300 */
  additional_info?: string | null;
  grid_connection?: number;
  vehicle_station?: number | null;
  /** Charge Point Group */
  group?: number;
  firmware?: number | null;
  latest_heartbeat?: number | null;
  latest_boot_notification?: number | null;
  latest_status_notification?: number | null;
}

export type ChargePointPoly = ChargePointUnathenticated | ChargePoint;

/**
 * * `Available` - Available
 * * `Preparing` - Preparing
 * * `Charging` - Charging
 * * `SuspendedEVSE` - SuspendedEVSE
 * * `SuspendedEV` - SuspendedEV
 * * `Finishing` - Finishing
 * * `Reserved` - Reserved
 * * `Unavailable` - Unavailable
 * * `Faulted` - Faulted
 */
export enum ChargePointStatusEnum {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
}

export enum ConnectorStatusEnum {
  Available = 'Available',
  Preparing = 'Preparing',
  Charging = 'Charging',
  SuspendedEVSE = 'SuspendedEVSE',
  SuspendedEV = 'SuspendedEV',
  Finishing = 'Finishing',
  Reserved = 'Reserved',
  Unavailable = 'Unavailable',
  Faulted = 'Faulted',
}

/**
 * Charge Point Serializer for unathenticated users.
 * No fields with sensitive information should be here.
 */
export interface ChargePointUnathenticated {
  id: number;
  /**
   * Charge Point Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /** @example {"latitude":-33.41476682287769,"longitude":-70.584030204484} */
  location?: LatLng;
  /** Charge Point Group */
  group?: number;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   */
  status?: StatusCb8Enum;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Capacity in A
   * @min 0
   * @max 2147483647
   */
  output_current?: number;
  /**
   * Nominal Voltage
   * @min 1
   * @max 2147483647
   */
  voltage?: number;
  connectors: ConnectorUnathenticated[];
  grid_connection?: number;
  /** @maxLength 300 */
  additional_info?: string | null;
}

/** Serializer for Charge Point Summary. */
export interface ChargePointUptimeSummary {
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  uptime: string;
  connectors: ConnectorListSummaryValidator[];
  charge_point_id: number;
  total_seconds: number;
}

/** Charge Point Group Serializer */
export interface ChargepointGroup {
  id: number;
  /** @maxLength 64 */
  name: string;
  charge_points: number[];
  charge_points_count: number;
  contracts: number[];
  connectors_count: number;
}

/**
 * Serializer for charging uptime data in the last 24 hours.
 *
 * Serializes and validates data with 'current_time' and 'online' fields,
 * representing timestamps and online status. Used in the 'uptime_day' endpoint.
 */
export interface ChargepointUptimeDay {
  /** @format date-time */
  current_time: string;
  online: boolean;
}

export interface ChargingAuthorization {
  id: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @maxLength 20 */
  token: string;
  /**
   * * `VIN` - VIN
   * * `RFID` - RFID
   * * `MAC` - MAC
   */
  token_format: TokenFormatEnum;
  vehicle?: string | null;
  user?: number | null;
  user_group: number;
}

/** Charging Profile Serializer */
export interface ChargingProfile {
  id: number;
  charging_schedule: ChargingSchedule;
  /**
   * @min 0
   * @max 32767
   * @default 0
   */
  stack_level?: number;
  /**
   * * `ChargePointMaxProfile` - ChargePointMaxProfile
   * * `TxDefaultProfile` - TxDefaultProfile
   * * `TxProfile` - TxProfile
   */
  charging_profile_purpose: ChargingProfilePurposeEnum;
  /**
   * * `Absolute` - Absolute
   * * `Recurring` - Recurring
   * * `Relative` - Relative
   */
  charging_profile_kind: ChargingProfileKindEnum;
  recurrency_kind?: RecurrencyKindEnum | null;
  /** @format date-time */
  valid_from?: string | null;
  /** @format date-time */
  valid_to?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** Synchronizing Status */
  sync_status?: SyncStatusD22Enum | null;
  /**
   * Synchronizing Task Id
   * @maxLength 37
   */
  sync_task_id?: string | null;
  connector: number;
  transaction?: number | null;
}

/**
 * * `Absolute` - Absolute
 * * `Recurring` - Recurring
 * * `Relative` - Relative
 */
export enum ChargingProfileKindEnum {
  Absolute = 'Absolute',
  Recurring = 'Recurring',
  Relative = 'Relative',
}

/**
 * * `ChargePointMaxProfile` - ChargePointMaxProfile
 * * `TxDefaultProfile` - TxDefaultProfile
 * * `TxProfile` - TxProfile
 */
export enum ChargingProfilePurposeEnum {
  ChargePointMaxProfile = 'ChargePointMaxProfile',
  TxDefaultProfile = 'TxDefaultProfile',
  TxProfile = 'TxProfile',
}

/**
 * * `W` - W
 * * `A` - A
 */
export enum ChargingRateUnitEnum {
  W = 'W',
  A = 'A',
}

/** Charging Schedule Serializer */
export interface ChargingSchedule {
  charging_profile: number;
  charging_schedule_periods?: ChargingSchedulePeriod[];
  duration?: string | null;
  /** @format date-time */
  start_schedule?: string | null;
  /**
   * * `W` - W
   * * `A` - A
   */
  charging_rate_unit?: ChargingRateUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  min_charging_rate?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Charging Schedule Period Serializer */
export interface ChargingSchedulePeriod {
  id: number;
  start_period: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  limit: string;
  /**
   * Number of Phases
   * @min 0
   * @max 32767
   */
  number_phases?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charging_schedule: number;
}

/**
 * * `Sedan` - Sedan
 * * `Van` - Van
 * * `Bus` - Bus
 * * `Truck` - Truck
 */
export enum ClassTypeEnum {
  Sedan = 'Sedan',
  Van = 'Van',
  Bus = 'Bus',
  Truck = 'Truck',
}

/** Clear Charging Profile Request Serializer */
export interface ClearChargingProfileRequest {
  /** @min 1 */
  id?: number | null;
  /** @min 0 */
  connector_id?: number | null;
  /**
   * * `ChargePointMaxProfile` - ChargePointMaxProfile
   * * `TxDefaultProfile` - TxDefaultProfile
   * * `TxProfile` - TxProfile
   */
  charging_profile_purpose?: ChargingProfilePurposeEnum;
  /** @min 0 */
  stack_level?: number | null;
}

/** An alternative Transaction Serializer with less fields and ChargingAuthorization */
export interface CollectionNote {
  id: number;
  /** TransactionRequest Serializer for using in Transaction */
  transaction_request?: AuthenticatedTransactionRequestInTransaction;
  /** TransactionRequest Serializer for using in Transaction */
  anonymous_transaction_request?: AnonymousTransactionRequestInTransaction;
  contract_snapshots: ContractSnapshot[];
  gross_price: string;
  net_price: string;
  /** ModelSerializer for PaymentAuthorization */
  payment_authorization: PaymentAuthorization;
  charging_authorization: ChargingAuthorization;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** Finalizing Notification Sent? */
  finalizing_notification_sent?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
  connector: number;
  /** Charging Authorization at Start */
  charging_authorization_start?: number | null;
  /** Charging Authorization at Stop */
  charging_authorization_stop?: number | null;
}

/** A serialiser for collection notes summary */
export interface CollectionNoteSummary {
  user_group: UserGroup[];
  contract: ContractOutput[];
  user_count: number;
  transaction_count: number;
  total_energy: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  avg_power: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,18}(?:\.\d{0,2})?$
   */
  avg_max_power: string;
  energy_charges: Record<string, any>;
  time_charges: Record<string, any>;
  taxes: string;
  gross_total: string;
}

/** Configuration Key Serializer */
export interface ConfigurationKey {
  id: number;
  /** Configuration Key Name */
  key: KeyEnum;
  /** Read Only */
  readonly: boolean;
  /** @maxLength 501 */
  value?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/** Connector Serializer */
export interface Connector {
  id: number;
  charging_profiles: ChargingProfile[];
  latest_transaction: Transaction;
  latest_meter_value: MeterValue;
  latest_status_notification: StatusNotification;
  qr_code: string | null;
  latest_reservation: ReservationBasic;
  connection_timeout: number;
  /**
   * @min 0
   * @max 2147483647
   * @default 0
   */
  connector_id?: number;
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  availability?: AvailabilityTypeEnum;
  /**
   * Connector Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /**
   * * `NoPlug` - No Plug
   * * `CCS1` - Ccs1
   * * `CCS2` - Ccs2
   * * `CHAdeMO` - CHAdeMO (Type 4)
   * * `GB/T DC` - Gbt Dc
   * * `Tesla` - Tesla
   * * `GB/T AC` - Gbt Ac
   * * `J1772` - J1772 (Type 1)
   * * `Mennekes` - Mennekes (Type 2)
   */
  plug_type?: PlugTypeEnum;
  /**
   * @min 1
   * @max 100
   */
  final_soc?: number;
  enabled?: boolean;
  /** @maxLength 100 */
  math_price?: string;
  /**
   * Power by connector
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,1})?$
   */
  power?: string;
  power_category?: PowerCategoryEb2Enum | null;
  supports_preparing?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/**
 * This is a Serializer made to pass a dictionary as data for
 * ChargePointUptimeSummarySerializer. It should be deleted and incorporated into
 * MonthlyConnectorSummarySerializer s soon as we find a way to make the status
 * field work as DictField and SerializerMethodField inside that serializer.
 */
export interface ConnectorListSummaryValidator {
  id: number;
  connector_id: string;
  /**
   * @min 0
   * @max 2147483647
   */
  transactions: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  energy: number;
  /** Serializer for an uptime serializer of a ChargePoint */
  status: ConnectorUptimeSummary;
}

/**
 * Connector Serializer for unathenticated users.
 * No fields with sensitive information should be here.
 */
export interface ConnectorUnathenticated {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   * @default 0
   */
  connector_id?: number;
  /**
   * * `Inoperative` - Inoperative
   * * `Operative` - Operative
   */
  availability?: AvailabilityTypeEnum;
  /**
   * Connector Verbose Name
   * @maxLength 40
   */
  verbose_name?: string | null;
  /**
   * * `NoPlug` - No Plug
   * * `CCS1` - Ccs1
   * * `CCS2` - Ccs2
   * * `CHAdeMO` - CHAdeMO (Type 4)
   * * `GB/T DC` - Gbt Dc
   * * `Tesla` - Tesla
   * * `GB/T AC` - Gbt Ac
   * * `J1772` - J1772 (Type 1)
   * * `Mennekes` - Mennekes (Type 2)
   */
  plug_type?: PlugTypeEnum;
  charge_point: number;
  qr_code: string | null;
  /** Status Notification Serializer */
  latest_status_notification?: StatusNotification;
  power_category?: PowerCategoryEb2Enum | null;
  /**
   * Power by connector
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,1})?$
   */
  power?: string;
  supports_preparing?: boolean;
  connection_timeout: number;
}

/** Serializer for an uptime serializer of a ChargePoint */
export interface ConnectorUptimeSummary {
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  Idle: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  Charging: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  Faulted: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  Offline: string;
}

/**
 * * `Interruption.Begin` - Interruption.Begin
 * * `Interruption.End` - Interruption.End
 * * `Other` - Other
 * * `Sample.Clock` - Sample.Clock
 * * `Sample.Periodic` - Sample.Periodic
 * * `Transaction.Begin` - Transaction.Begin
 * * `Transaction.End` - Transaction.End
 * * `Trigger` - Trigger
 */
export enum ContextEnum {
  InterruptionBegin = 'Interruption.Begin',
  InterruptionEnd = 'Interruption.End',
  Other = 'Other',
  SampleClock = 'Sample.Clock',
  SamplePeriodic = 'Sample.Periodic',
  TransactionBegin = 'Transaction.Begin',
  TransactionEnd = 'Transaction.End',
  Trigger = 'Trigger',
}

export interface Contract {
  id: string;
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  user_group: string;
  charge_point_group: string;
  contract_periods: ContractPeriod[];
}

/**
 * Contract serializer to be used for incoming data and outgoing data with higher
 * precision
 */
export interface ContractFourDecimalsWithPrecision {
  id: number;
  contract_periods?: ContractPeriodFourDecimals[];
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  user_group: number;
  charge_point_group: number;
}

/**
 * * `PER_MINUTE` - PER_MINUTE
 * * `PER_KWH` - PER_KWH
 */
export enum ContractKind0BdEnum {
  PER_MINUTE = 'PER_MINUTE',
  PER_KWH = 'PER_KWH',
}

/**
 * * `PER_MINUTE` - Per Minute
 * * `PER_KWH` - Per kWh
 */
export enum ContractKind4D9Enum {
  PER_MINUTE = 'PER_MINUTE',
  PER_KWH = 'PER_KWH',
}

/**
 * Contract serializer for outgoing data, all prices should be CharFields with
 * rounding logic delegated to the model itself.
 */
export interface ContractOutput {
  id: number;
  contract_periods: ContractPeriodTwoDecimals[];
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  user_group: number;
  charge_point_group: number;
}

export interface ContractPeriod {
  id: string;
  gross_price: string;
  net_price: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
}

export interface ContractPeriodFourDecimals {
  id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,28}(?:\.\d{0,4})?$
   */
  gross_price: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,28}(?:\.\d{0,4})?$
   */
  net_price: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
}

export interface ContractPeriodTwoDecimals {
  id: number;
  gross_price: string;
  net_price: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
}

/**
 * * `FLAT_RATE` - Flat Rate
 * * `PEAK_RATE` - Peak Rate
 * * `OFF_PEAK_RATE` - Off-peak Rate
 */
export enum ContractPeriodVerboseNameEnum {
  FLAT_RATE = 'FLAT_RATE',
  PEAK_RATE = 'PEAK_RATE',
  OFF_PEAK_RATE = 'OFF_PEAK_RATE',
}

/** Contract Snapshot Serializer */
export interface ContractSnapshot {
  id: number;
  gross_price: string;
  net_price: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  start_period: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  day_of_week?: number;
  /** Charge Type */
  power_category: PowerCategory777Enum;
  /** Contract Period Verbose Name */
  verbose_name?: VerboseNameEnum;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  transaction: number;
  contract?: number | null;
}

/** Credencial Serializer Class */
export interface Credential {
  /** @maxLength 256 */
  username: string;
  /** @maxLength 256 */
  password: string;
}

/** Credit card serializer */
export interface CreditCard {
  id: number;
  kushki_subscription_id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  default?: boolean;
  /** @maxLength 256 */
  card_holder_name: string;
  /** @maxLength 4 */
  last_four_digits: string;
  /** @maxLength 32 */
  payment_brand: string;
  /**
   * Bank identification number
   * @maxLength 6
   */
  bin: string;
  /** @maxLength 12 */
  card_type: string;
  /** @maxLength 128 */
  bank: string;
  /** @maxLength 32 */
  country: string;
  user: number;
}

/**
 * * `CLP` - CLP
 * * `COP` - COP
 * * `USD` - USD
 * * `MXN` - MXN
 * * `BRL` - BRL
 * * `PEN` - PEN
 * * `EUR` - EUR
 */
export enum CurrencyEnum {
  CLP = 'CLP',
  COP = 'COP',
  USD = 'USD',
  MXN = 'MXN',
  BRL = 'BRL',
  PEN = 'PEN',
  EUR = 'EUR',
  UYU = 'UYU',
}

/** Custom Token Serializer Class */
export interface CustomToken {
  /** @maxLength 256 */
  refresh: string;
  /** @maxLength 256 */
  access?: string;
}

/**
 * * `Passport` - Passport
 * * `RUT` - Rut
 * * `RFC` - RFC
 * * `DNI` - DNI
 * * `NIT` - NIT
 * * `CC` - CC
 * * `CE` - CE
 */
export enum DocumentTypeAbeEnum {
  Passport = 'Passport',
  RUT = 'RUT',
  RFC = 'RFC',
  DNI = 'DNI',
  NIT = 'NIT',
  CC = 'CC',
  CE = 'CE',
}

/**
 * * `Passport` - Passport
 * * `RUT` - Rut
 * * `RFC` - RFC
 * * `DNI` - DNI
 * * `NIT` - NIT
 * * `CC` - CC
 * * `CE` - CE
 */
export enum DocumentTypesEnum {
  Passport = 'Passport',
  RUT = 'RUT',
  RFC = 'RFC',
  DNI = 'DNI',
  NIT = 'NIT',
  CC = 'CC',
  CE = 'CE',
}

/**
 * * `FTP` - Ftp
 * * `FTPS` - Ftps
 * * `HTTP` - Http
 * * `HTTPS` - Https
 */
export enum DownloadSchemaEnum {
  FTP = 'FTP',
  FTPS = 'FTPS',
  HTTP = 'HTTP',
  HTTPS = 'HTTPS',
}

/** Electricity Meter Serializer */
export interface ElectricityMeter {
  /**
   * Pk of SMI Meter
   * @format int64
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id: number;
  /** @maxLength 100 */
  name?: string | null;
  /** @maxLength 30 */
  status: string;
  /** @format date-time */
  timestamp?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  grid_connection?: number;
}

export interface Email {
  /** @format email */
  email: string;
}

/** Credit card serializer */
export interface EnrollCreditCard {
  token: string;
  /** @default false */
  default?: boolean;
}

/**
 * * `Odoo` - Odoo
 * * `JDE` - JDE
 */
export enum ErpNameEnum {
  Odoo = 'Odoo',
  JDE = 'JDE',
}

/**
 * * `ConnectorLockFailure` - ConnectorLockFailure
 * * `EVCommunicationError` - EVCommunicationError
 * * `GroundFailure` - GroundFailure
 * * `HighTemperature` - HighTemperature
 * * `InternalError` - InternalError
 * * `LocalListConflict` - LocalListConflict
 * * `NoError` - NoError
 * * `OtherError` - OtherError
 * * `OverCurrentFailure` - OverCurrentFailure
 * * `OverVoltage` - OverVoltage
 * * `PowerMeterFailure` - PowerMeterFailure
 * * `PowerSwitchFailure` - PowerSwitchFailure
 * * `ReaderFailure` - ReaderFailure
 * * `ResetFailure` - ResetFailure
 * * `UnderVoltage` - UnderVoltage
 * * `WeakSignal` - WeakSignal
 */
export enum ErrorCodeEnum {
  ConnectorLockFailure = 'ConnectorLockFailure',
  EVCommunicationError = 'EVCommunicationError',
  GroundFailure = 'GroundFailure',
  HighTemperature = 'HighTemperature',
  InternalError = 'InternalError',
  LocalListConflict = 'LocalListConflict',
  NoError = 'NoError',
  OtherError = 'OtherError',
  OverCurrentFailure = 'OverCurrentFailure',
  OverVoltage = 'OverVoltage',
  PowerMeterFailure = 'PowerMeterFailure',
  PowerSwitchFailure = 'PowerSwitchFailure',
  ReaderFailure = 'ReaderFailure',
  ResetFailure = 'ResetFailure',
  UnderVoltage = 'UnderVoltage',
  WeakSignal = 'WeakSignal',
}

/**
 * Response format of endpoints that execute async tasks to
 * generate export files (xlsx, pdf, etc).
 *
 * These files are afterwards retrieved by the APP/CMS over websocket.
 */
export interface ExportOutput {
  task_id: string;
  file_name: string;
}

/** Firmware Serializer */
export interface Firmware {
  id: number;
  uri: string;
  /**
   * Charge Point Vendor
   * @maxLength 21
   */
  vendor: string;
  /**
   * Charge Point Model
   * @maxLength 21
   */
  model: string;
  /**
   * Firmware Version
   * @maxLength 51
   */
  version: string;
  /**
   * Firmware File
   * @format uri
   */
  firmware: string;
  /** @maxLength 200 */
  description?: string | null;
  /**
   * * `FTP` - Ftp
   * * `FTPS` - Ftps
   * * `HTTP` - Http
   * * `HTTPS` - Https
   */
  download_schema?: DownloadSchemaEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Fleet Serializer */
export interface Fleet {
  id: number;
  vehicles: Vehicle[];
  /**
   * Fleet Name
   * @maxLength 64
   */
  name: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export enum GisFeatureCollectionEnum {
  FeatureCollection = 'FeatureCollection',
}

export enum GisFeatureEnum {
  Feature = 'Feature',
}

/** Google Credencial Serializer Class */
export interface GoogleCredential {
  /** @maxLength 2048 */
  google_token: string;
}

/** Grid Connection Serializer */
export interface GridConnection {
  id: number;
  charge_points: ChargePointMinimal[];
  electricity_meters: ElectricityMeter[];
  /** @maxLength 40 */
  name: string;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Charging Capacity in W
   * @min 0
   * @max 2147483647
   */
  charging_capacity?: number;
  /** @maxLength 100 */
  math_cost?: string;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  charge_points_power?: string | null;
  /** @maxLength 32 */
  client_internal_id?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  asset?: number;
  /** Vehicle Station */
  station?: number;
}

/** Grid Connection Serializer for unauthenticated users */
export interface GridConnectionUnauthenticated {
  id: number;
  /** @maxLength 40 */
  name: string;
  asset?: number;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
}

/** Heartbeat Serializer */
export interface Heartbeat {
  id: number;
  /** @format date-time */
  current_time?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  charge_point: number;
}

/**
 * * `AllowOfflineTxForUnknownId` - AllowOfflineTxForUnknownId
 * * `AuthorizationCacheEnabled` - AuthorizationCacheEnabled
 * * `AuthorizeRemoteTxRequests` - AuthorizeRemoteTxRequests
 * * `BlinkRepeat` - BlinkRepeat
 * * `ClockAlignedDataInterval` - ClockAlignedDataInterval
 * * `ConnectionTimeOut` - ConnectionTimeOut
 * * `ConnectorPhaseRotation` - ConnectorPhaseRotation
 * * `ConnectorPhaseRotationMaxLength` - ConnectorPhaseRotationMaxLength
 * * `GetConfigurationMaxKeys` - GetConfigurationMaxKeys
 * * `HeartbeatInterval` - HeartbeatInterval
 * * `LightIntensity` - LightIntensity
 * * `LocalAuthorizeOffline` - LocalAuthorizeOffline
 * * `LocalPreAuthorize` - LocalPreAuthorize
 * * `MaxEnergyOnInvalidId` - MaxEnergyOnInvalidId
 * * `MeterValuesAlignedData` - MeterValuesAlignedData
 * * `MeterValuesAlignedDataMaxLength` - MeterValuesAlignedDataMaxLength
 * * `MeterValuesSampledData` - MeterValuesSampledData
 * * `MeterValuesSampledDataMaxLength` - MeterValuesSampledDataMaxLength
 * * `MeterValueSampleInterval` - MeterValueSampleInterval
 * * `MinimumStatusDuration` - MinimumStatusDuration
 * * `NumberOfConnectors` - NumberOfConnectors
 * * `ResetRetries` - ResetRetries
 * * `StopTransactionOnEVSideDisconnect` - StopTransactionOnEVSideDisconnect
 * * `StopTransactionOnInvalidId` - StopTransactionOnInvalidId
 * * `StopTxnAlignedData` - StopTxnAlignedData
 * * `StopTxnAlignedDataMaxLength` - StopTxnAlignedDataMaxLength
 * * `StopTxnSampledData` - StopTxnSampledData
 * * `StopTxnSampledDataMaxLength` - StopTxnSampledDataMaxLength
 * * `SupportedFeatureProfiles` - SupportedFeatureProfiles
 * * `SupportedFeatureProfilesMaxLength` - SupportedFeatureProfilesMaxLength
 * * `TransactionMessageAttempts` - TransactionMessageAttempts
 * * `TransactionMessageRetryInterval` - TransactionMessageRetryInterval
 * * `UnlockConnectorOnEVSideDisconnect` - UnlockConnectorOnEVSideDisconnect
 * * `WebSocketPingInterval` - WebSocketPingInterval
 * * `LocalAuthListEnabled` - LocalAuthListEnabled
 * * `LocalAuthListMaxLength` - LocalAuthListMaxLength
 * * `SendLocalListMaxLength` - SendLocalListMaxLength
 * * `ReserveConnectorZeroSupported` - ReserveConnectorZeroSupported
 * * `ChargeProfileMaxStackLevel` - ChargeProfileMaxStackLevel
 * * `ChargingScheduleAllowedChargingRateUnit` - ChargingScheduleAllowedChargingRateUnit
 * * `ChargingScheduleMaxPeriods` - ChargingScheduleMaxPeriods
 * * `ConnectorSwitch3to1PhaseSupported` - ConnectorSwitch3to1PhaseSupported
 * * `MaxChargingProfilesInstalled` - MaxChargingProfilesInstalled
 * * `AuthorizationKey` - AuthorizationKey
 * * `PUK` - PUK
 * * `EVSEId` - EVSEId
 * * `ChargeBoxId` - ChargeBoxId
 * * `CentralSystemURL` - CentralSystemURL
 * * `MeterStartValueRelative` - MeterStartValueRelative
 * * `PWMPause` - PWMPause
 * * `EVReadyMode` - EVReadyMode
 * * `TARActive` - TARActive
 * * `EVSEMaxCurrent` - EVSEMaxCurrent
 * * `EVSEPhases` - EVSEPhases
 * * `FreeCharging` - FreeCharging
 * * `FreeChargingOffline` - FreeChargingOffline
 * * `FreeChargingUID` - FreeChargingUID
 * * `OperatorCurrentLimit` - OperatorCurrentLimit
 * * `AccessPointUser` - AccessPointUser
 * * `AccessPointPassword` - AccessPointPassword
 * * `AccessPointName` - AccessPointName
 * * `OutOfService` - OutOfService
 * * `CentralManagementEndPoint` - CentralManagementEndPoint
 * * `TariffCCS` - TariffCCS
 * * `MaxPowerCCS1` - MaxPowerCCS1
 * * `UIClientShowEnergy` - UIClientShowEnergy
 * * `FreeVendIdTag` - FreeVendIdTag
 * * `ChargeTimeLimit` - ChargeTimeLimit
 * * `PriceModelCCS` - PriceModelCCS
 * * `ISMI` - ISMI
 * * `CCDefaultUserID` - CCDefaultUserID
 * * `TariffCHAdeMO` - TariffCHAdeMO
 * * `OCPPCheckCardOnline` - OCPPCheckCardOnline
 * * `CommunicationProtocol` - CommunicationProtocol
 * * `OfflineReportTimeOut` - OfflineReportTimeOut
 * * `VendorId` - VendorId
 * * `QCBattPeriodicInfo` - QCBattPeriodicInfo
 * * `AllowOfflineCharging` - AllowOfflineCharging
 * * `LoadBalanceEnabled` - LoadBalanceEnabled
 * * `ChargingNoEnergyMaxTime` - ChargingNoEnergyMaxTime
 * * `QCBattSOC` - QCBattSOC
 * * `FreeVendEnabled` - FreeVendEnabled
 * * `CCVTKSOrderNR` - CCVTKSOrderNR
 * * `CardIdInverted` - CardIdInverted
 * * `CCVTID` - CCVTID
 * * `UIClientShowdOwnInfo` - UIClientShowdOwnInfo
 * * `BootNotificationInterval` - BootNotificationInterval
 * * `RouterIPCheckInterval` - RouterIPCheckInterval
 * * `QCBattAvailablePower` - QCBattAvailablePower
 * * `TariffAC` - TariffAC
 * * `PriceModelCHAdeMO` - PriceModelCHAdeMO
 * * `DCMaxPowerFixed` - DCMaxPowerFixed
 * * `ACMaxPowerFixed` - ACMaxPowerFixed
 * * `UseSETicketCard` - UseSETicketCard
 * * `CommunicationType` - CommunicationType
 * * `UIClientShowDTC` - UIClientShowDTC
 * * `ICCID` - ICCID
 * * `QCBattBatteryCurrent` - QCBattBatteryCurrent
 * * `MaxPowerCharger` - MaxPowerCharger
 * * `OpenHours` - OpenHours
 * * `Modus1UserID` - Modus1UserID
 * * `MinimumTimeBill` - MinimumTimeBill
 * * `ReservationsEnabled` - ReservationsEnabled
 * * `MaxPower` - MaxPower
 * * `HMILanguage` - HMILanguage
 * * `CCVPreAuthorizationAmount` - CCVPreAuthorizationAmount
 * * `ChargerModus` - ChargerModus
 * * `DefaultTimeOut` - DefaultTimeOut
 * * `UseSessionStartTime` - UseSessionStartTime
 * * `PriceModelAC` - PriceModelAC
 * * `InUseMaxTime` - InUseMaxTime
 * * `ChargeBoxName` - ChargeBoxName
 * * `ChargeBoxTimeZone` - ChargeBoxTimeZone
 * * `ContactCenter` - ContactCenter
 * * `DiscardTxProfileWhenConnectionLoss` - DiscardTxProfileWhenConnectionLoss
 * * `EvseChargingStationCertConfig` - EvseChargingStationCertConfig
 * * `EVSEID_1` - EVSEID_1
 * * `EVSEID_2` - EVSEID_2
 * * `EVSEID_3` - EVSEID_3
 * * `EvseV2GCertConfig` - EvseV2GCertConfig
 * * `FallbackDelay` - FallbackDelay
 * * `FallbackMode` - FallbackMode
 * * `FreeModeRfid` - FreeModeRfid
 * * `PriceKWh` - PriceKWh
 * * `PriceMinute` - PriceMinute
 * * `PreAuthorizeAmount` - PreAuthorizeAmount
 * * `PostPaidMode` - PostPaidMode
 * * `csEndPoint` - csEndPoint
 * * `isLitleEndian` - isLitleEndian
 * * `cbId` - cbId
 * * `cbUseOcppTSync` - cbUseOcppTSync
 * * `cbUsePartialEnergy` - cbUsePartialEnergy
 * * `cbStopIfConcurrentTx` - cbStopIfConcurrentTx
 * * `cbUsePssSockets` - cbUsePssSockets
 * * `cbCacheListMaxLength` - cbCacheListMaxLength
 * * `csVerifyCert` - csVerifyCert
 * * `csAcceptUnknownSelfSigned` - csAcceptUnknownSelfSigned
 * * `cbConnTimeOut` - cbConnTimeOut
 * * `PlugAndChargeEnabled` - PlugAndChargeEnabled
 * * `PlugAndChargeUID` - PlugAndChargeUID
 * * `MeterValuesOnlyOnChargingStatus` - MeterValuesOnlyOnChargingStatus
 * * `SupportedFileTransferProtocols` - SupportedFileTransferProtocols
 * * `cbRequireUserConfirmation` - cbRequireUserConfirmation
 */
export enum KeyEnum {
  AllowOfflineTxForUnknownId = 'AllowOfflineTxForUnknownId',
  AuthorizationCacheEnabled = 'AuthorizationCacheEnabled',
  AuthorizeRemoteTxRequests = 'AuthorizeRemoteTxRequests',
  BlinkRepeat = 'BlinkRepeat',
  ClockAlignedDataInterval = 'ClockAlignedDataInterval',
  ConnectionTimeOut = 'ConnectionTimeOut',
  ConnectorPhaseRotation = 'ConnectorPhaseRotation',
  ConnectorPhaseRotationMaxLength = 'ConnectorPhaseRotationMaxLength',
  GetConfigurationMaxKeys = 'GetConfigurationMaxKeys',
  HeartbeatInterval = 'HeartbeatInterval',
  LightIntensity = 'LightIntensity',
  LocalAuthorizeOffline = 'LocalAuthorizeOffline',
  LocalPreAuthorize = 'LocalPreAuthorize',
  MaxEnergyOnInvalidId = 'MaxEnergyOnInvalidId',
  MeterValuesAlignedData = 'MeterValuesAlignedData',
  MeterValuesAlignedDataMaxLength = 'MeterValuesAlignedDataMaxLength',
  MeterValuesSampledData = 'MeterValuesSampledData',
  MeterValuesSampledDataMaxLength = 'MeterValuesSampledDataMaxLength',
  MeterValueSampleInterval = 'MeterValueSampleInterval',
  MinimumStatusDuration = 'MinimumStatusDuration',
  NumberOfConnectors = 'NumberOfConnectors',
  ResetRetries = 'ResetRetries',
  StopTransactionOnEVSideDisconnect = 'StopTransactionOnEVSideDisconnect',
  StopTransactionOnInvalidId = 'StopTransactionOnInvalidId',
  StopTxnAlignedData = 'StopTxnAlignedData',
  StopTxnAlignedDataMaxLength = 'StopTxnAlignedDataMaxLength',
  StopTxnSampledData = 'StopTxnSampledData',
  StopTxnSampledDataMaxLength = 'StopTxnSampledDataMaxLength',
  SupportedFeatureProfiles = 'SupportedFeatureProfiles',
  SupportedFeatureProfilesMaxLength = 'SupportedFeatureProfilesMaxLength',
  TransactionMessageAttempts = 'TransactionMessageAttempts',
  TransactionMessageRetryInterval = 'TransactionMessageRetryInterval',
  UnlockConnectorOnEVSideDisconnect = 'UnlockConnectorOnEVSideDisconnect',
  WebSocketPingInterval = 'WebSocketPingInterval',
  LocalAuthListEnabled = 'LocalAuthListEnabled',
  LocalAuthListMaxLength = 'LocalAuthListMaxLength',
  SendLocalListMaxLength = 'SendLocalListMaxLength',
  ReserveConnectorZeroSupported = 'ReserveConnectorZeroSupported',
  ChargeProfileMaxStackLevel = 'ChargeProfileMaxStackLevel',
  ChargingScheduleAllowedChargingRateUnit = 'ChargingScheduleAllowedChargingRateUnit',
  ChargingScheduleMaxPeriods = 'ChargingScheduleMaxPeriods',
  ConnectorSwitch3To1PhaseSupported = 'ConnectorSwitch3to1PhaseSupported',
  MaxChargingProfilesInstalled = 'MaxChargingProfilesInstalled',
  AuthorizationKey = 'AuthorizationKey',
  PUK = 'PUK',
  EVSEId = 'EVSEId',
  ChargeBoxId = 'ChargeBoxId',
  CentralSystemURL = 'CentralSystemURL',
  MeterStartValueRelative = 'MeterStartValueRelative',
  PWMPause = 'PWMPause',
  EVReadyMode = 'EVReadyMode',
  TARActive = 'TARActive',
  EVSEMaxCurrent = 'EVSEMaxCurrent',
  EVSEPhases = 'EVSEPhases',
  FreeCharging = 'FreeCharging',
  FreeChargingOffline = 'FreeChargingOffline',
  FreeChargingUID = 'FreeChargingUID',
  OperatorCurrentLimit = 'OperatorCurrentLimit',
  AccessPointUser = 'AccessPointUser',
  AccessPointPassword = 'AccessPointPassword',
  AccessPointName = 'AccessPointName',
  OutOfService = 'OutOfService',
  CentralManagementEndPoint = 'CentralManagementEndPoint',
  TariffCCS = 'TariffCCS',
  MaxPowerCCS1 = 'MaxPowerCCS1',
  UIClientShowEnergy = 'UIClientShowEnergy',
  FreeVendIdTag = 'FreeVendIdTag',
  ChargeTimeLimit = 'ChargeTimeLimit',
  PriceModelCCS = 'PriceModelCCS',
  ISMI = 'ISMI',
  CCDefaultUserID = 'CCDefaultUserID',
  TariffCHAdeMO = 'TariffCHAdeMO',
  OCPPCheckCardOnline = 'OCPPCheckCardOnline',
  CommunicationProtocol = 'CommunicationProtocol',
  OfflineReportTimeOut = 'OfflineReportTimeOut',
  VendorId = 'VendorId',
  QCBattPeriodicInfo = 'QCBattPeriodicInfo',
  AllowOfflineCharging = 'AllowOfflineCharging',
  LoadBalanceEnabled = 'LoadBalanceEnabled',
  ChargingNoEnergyMaxTime = 'ChargingNoEnergyMaxTime',
  QCBattSOC = 'QCBattSOC',
  FreeVendEnabled = 'FreeVendEnabled',
  CCVTKSOrderNR = 'CCVTKSOrderNR',
  CardIdInverted = 'CardIdInverted',
  CCVTID = 'CCVTID',
  UIClientShowdOwnInfo = 'UIClientShowdOwnInfo',
  BootNotificationInterval = 'BootNotificationInterval',
  RouterIPCheckInterval = 'RouterIPCheckInterval',
  QCBattAvailablePower = 'QCBattAvailablePower',
  TariffAC = 'TariffAC',
  PriceModelCHAdeMO = 'PriceModelCHAdeMO',
  DCMaxPowerFixed = 'DCMaxPowerFixed',
  ACMaxPowerFixed = 'ACMaxPowerFixed',
  UseSETicketCard = 'UseSETicketCard',
  CommunicationType = 'CommunicationType',
  UIClientShowDTC = 'UIClientShowDTC',
  ICCID = 'ICCID',
  QCBattBatteryCurrent = 'QCBattBatteryCurrent',
  MaxPowerCharger = 'MaxPowerCharger',
  OpenHours = 'OpenHours',
  Modus1UserID = 'Modus1UserID',
  MinimumTimeBill = 'MinimumTimeBill',
  ReservationsEnabled = 'ReservationsEnabled',
  MaxPower = 'MaxPower',
  HMILanguage = 'HMILanguage',
  CCVPreAuthorizationAmount = 'CCVPreAuthorizationAmount',
  ChargerModus = 'ChargerModus',
  DefaultTimeOut = 'DefaultTimeOut',
  UseSessionStartTime = 'UseSessionStartTime',
  PriceModelAC = 'PriceModelAC',
  InUseMaxTime = 'InUseMaxTime',
  ChargeBoxName = 'ChargeBoxName',
  ChargeBoxTimeZone = 'ChargeBoxTimeZone',
  ContactCenter = 'ContactCenter',
  DiscardTxProfileWhenConnectionLoss = 'DiscardTxProfileWhenConnectionLoss',
  EvseChargingStationCertConfig = 'EvseChargingStationCertConfig',
  EVSEID1 = 'EVSEID_1',
  EVSEID2 = 'EVSEID_2',
  EVSEID3 = 'EVSEID_3',
  EvseV2GCertConfig = 'EvseV2GCertConfig',
  FallbackDelay = 'FallbackDelay',
  FallbackMode = 'FallbackMode',
  FreeModeRfid = 'FreeModeRfid',
  PriceKWh = 'PriceKWh',
  PriceMinute = 'PriceMinute',
  PreAuthorizeAmount = 'PreAuthorizeAmount',
  PostPaidMode = 'PostPaidMode',
  CsEndPoint = 'csEndPoint',
  IsLitleEndian = 'isLitleEndian',
  CbId = 'cbId',
  CbUseOcppTSync = 'cbUseOcppTSync',
  CbUsePartialEnergy = 'cbUsePartialEnergy',
  CbStopIfConcurrentTx = 'cbStopIfConcurrentTx',
  CbUsePssSockets = 'cbUsePssSockets',
  CbCacheListMaxLength = 'cbCacheListMaxLength',
  CsVerifyCert = 'csVerifyCert',
  CsAcceptUnknownSelfSigned = 'csAcceptUnknownSelfSigned',
  CbConnTimeOut = 'cbConnTimeOut',
  PlugAndChargeEnabled = 'PlugAndChargeEnabled',
  PlugAndChargeUID = 'PlugAndChargeUID',
  MeterValuesOnlyOnChargingStatus = 'MeterValuesOnlyOnChargingStatus',
  SupportedFileTransferProtocols = 'SupportedFileTransferProtocols',
  CbRequireUserConfirmation = 'cbRequireUserConfirmation',
}

/** Kilometers traveled Serializer */
export interface Kilometers {
  /** @min 0 */
  count?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  real?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,15}(?:\.\d{0,0})?$
   */
  virtual?: string;
}

export interface KushkiEnrollError {
  id: number;
  enerlink_error_message: string;
  enerlink_recommended_action: string;
  /** @format date-time */
  created: string;
  /** @maxLength 32 */
  code?: string | null;
  /** @maxLength 32 */
  processor_error?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  status_code?: number | null;
  user?: number | null;
}

export interface KushkiPaymentError {
  id: number;
  enerlink_error_message: string;
  enerlink_recommended_action: string;
  /** @format date-time */
  created: string;
  /** @maxLength 32 */
  code?: string | null;
  /** @maxLength 32 */
  processor_error?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  status_code?: number | null;
  transaction: number;
  credit_card?: number | null;
}

/**
 * * `default-select` - Default Select
 * * `minimal-select` - Minimal Select
 */
export enum LanguageChooserControlEnum {
  DefaultSelect = 'default-select',
  MinimalSelect = 'minimal-select',
}

/**
 * * `code` - code
 * * `name` - name
 */
export enum LanguageChooserDisplayEnum {
  Code = 'code',
  Name = 'name',
}

/**
 * * `en-us` - English
 * * `es` - Spanish
 */
export enum LanguageEnum {
  EnUs = 'en-us',
  Es = 'es',
}

/**
 * * `Inlet` - Inlet
 * * `Outlet` - Outlet
 * * `Body` - Body
 * * `Cable` - Cable
 * * `EV` - EV
 */
export enum LocationEnum {
  Inlet = 'Inlet',
  Outlet = 'Outlet',
  Body = 'Body',
  Cable = 'Cable',
  EV = 'EV',
}

/** Microsoft Entra ID Credencial Serializer Class */
export interface MSEntra {
  /** @maxLength 2048 */
  ms_entra_token?: string;
}

/**
 * * `Estimated.Charging.Time` - Measurand.estimated_charging_time
 * * `Current.Export` - Measurand.current_export
 * * `Current.Import` - Measurand.current_import
 * * `Current.Offered` - Measurand.current_offered
 * * `Energy.Active.Export.Register` - Measurand.energy_active_export_register
 * * `Energy.Active.Import.Register` - Measurand.energy_active_import_register
 * * `Energy.Reactive.Export.Register` - Measurand.energy_reactive_export_register
 * * `Energy.Reactive.Import.Register` - Measurand.energy_reactive_import_register
 * * `Energy.Active.Export.Interval` - Measurand.energy_active_export_interval
 * * `Energy.Active.Import.Interval` - Measurand.energy_active_import_interval
 * * `Energy.Reactive.Export.Interval` - Measurand.energy_reactive_export_interval
 * * `Energy.Reactive.Import.Interval` - Measurand.energy_reactive_import_interval
 * * `Frequency` - Measurand.frequency
 * * `Power.Active.Export` - Measurand.power_active_export
 * * `Power.Active.Import` - Measurand.power_active_import
 * * `Power.Factor` - Measurand.power_factor
 * * `Power.Offered` - Measurand.power_offered
 * * `Power.Reactive.Export` - Measurand.power_reactive_export
 * * `Power.Reactive.Import` - Measurand.power_reactive_import
 * * `RPM` - Measurand.rpm
 * * `SoC` - Measurand.soc
 * * `Temperature` - Measurand.temperature
 * * `Voltage` - Measurand.voltage
 */
export enum Measurand2D5Enum {
  EstimatedChargingTime = 'Estimated.Charging.Time',
  CurrentExport = 'Current.Export',
  CurrentImport = 'Current.Import',
  CurrentOffered = 'Current.Offered',
  EnergyActiveExportRegister = 'Energy.Active.Export.Register',
  EnergyActiveImportRegister = 'Energy.Active.Import.Register',
  EnergyReactiveExportRegister = 'Energy.Reactive.Export.Register',
  EnergyReactiveImportRegister = 'Energy.Reactive.Import.Register',
  EnergyActiveExportInterval = 'Energy.Active.Export.Interval',
  EnergyActiveImportInterval = 'Energy.Active.Import.Interval',
  EnergyReactiveExportInterval = 'Energy.Reactive.Export.Interval',
  EnergyReactiveImportInterval = 'Energy.Reactive.Import.Interval',
  Frequency = 'Frequency',
  PowerActiveExport = 'Power.Active.Export',
  PowerActiveImport = 'Power.Active.Import',
  PowerFactor = 'Power.Factor',
  PowerOffered = 'Power.Offered',
  PowerReactiveExport = 'Power.Reactive.Export',
  PowerReactiveImport = 'Power.Reactive.Import',
  RPM = 'RPM',
  SoC = 'SoC',
  Temperature = 'Temperature',
  Voltage = 'Voltage',
}

/**
 * * `BootNotification` - BootNotification
 * * `FirmwareStatusNotification` - FirmwareStatusNotification
 * * `Heartbeat` - Heartbeat
 * * `MeterValues` - MeterValues
 * * `StatusNotification` - StatusNotification
 * * `DiagnosticsStatusNotification` - DiagnosticsStatusNotification
 * * `LogStatusNotification` - LogStatusNotification
 * * `SignChargePointCertificate` - SignChargePointCertificate
 */
export enum MessageTriggerEnum {
  BootNotification = 'BootNotification',
  FirmwareStatusNotification = 'FirmwareStatusNotification',
  Heartbeat = 'Heartbeat',
  MeterValues = 'MeterValues',
  StatusNotification = 'StatusNotification',
  DiagnosticsStatusNotification = 'DiagnosticsStatusNotification',
  LogStatusNotification = 'LogStatusNotification',
  SignChargePointCertificate = 'SignChargePointCertificate',
}

/** Meter Value Serializer */
export interface MeterValue {
  id: number;
  sampled_values: SampledValue[];
  /** Price Processed? */
  price_processed?: boolean;
  /** @format date-time */
  timestamp?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  connector: number;
  transaction?: number | null;
}

/** Module Serializer */
export interface Module {
  id: number;
  /**
   * * `Charging Center` - Charging Center
   * * `Charging Center Admin` - Charging Center Admin
   * * `Smart Charging` - Smart Charging
   * * `Fleet Management` - Fleet Management
   * * `Fleet Management Admin` - Fleet Management Admin
   */
  module: ModuleEnum;
  status?: boolean;
  /** @format date-time */
  created: string | null;
  /** @format date-time */
  updated: string | null;
}

/**
 * * `Charging Center` - Charging Center
 * * `Charging Center Admin` - Charging Center Admin
 * * `Smart Charging` - Smart Charging
 * * `Fleet Management` - Fleet Management
 * * `Fleet Management Admin` - Fleet Management Admin
 */
export enum ModuleEnum {
  ChargingCenter = 'Charging Center',
  ChargingCenterAdmin = 'Charging Center Admin',
  SmartCharging = 'Smart Charging',
  FleetManagement = 'Fleet Management',
  FleetManagementAdmin = 'Fleet Management Admin',
}

/**
 * * `Slow` - Slow
 * * `Intermediate` - Intermediate
 * * `Fast` - Fast
 * * `Ultra_Fast` - Ultra Fast
 */
export enum NameEnum {
  Slow = 'Slow',
  Intermediate = 'Intermediate',
  Fast = 'Fast',
  UltraFast = 'Ultra_Fast',
}

export interface Nested {
  id: number;
  /** @maxLength 64 */
  name: string;
  /** @maxLength 64 */
  address: string;
  /** @maxLength 64 */
  town: string;
  /** @maxLength 64 */
  region: string;
  /**
   * Contact Number
   * @maxLength 32
   */
  phone_number?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_public?: boolean;
}

export interface Notification {
  id: number;
  method: string;
  data: any;
  message: string;
  title: string;
  seen: boolean;
  action_code: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Orphan Charging Schedule Serializer */
export interface OrphanChargingSchedule {
  /** @default 0 */
  charging_profile?: number;
  charging_schedule_periods?: OrphanChargingSchedulePeriod[];
  duration?: string | null;
  /** @format date-time */
  start_schedule?: string | null;
  /**
   * * `W` - W
   * * `A` - A
   */
  charging_rate_unit?: ChargingRateUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  min_charging_rate?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Orphan Charging Schedule Period Serializer */
export interface OrphanChargingSchedulePeriod {
  id: number;
  /** @default 0 */
  charging_schedule?: number;
  start_period: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  limit: string;
  /**
   * Number of Phases
   * @min 0
   * @max 32767
   */
  number_phases?: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface PaginatedAPIChargePointList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: APIChargePoint[];
}

export interface PaginatedAPISampledValueList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: APISampledValue[];
}

export interface PaginatedAPITransactionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: APITransaction[];
}

export interface PaginatedActionByCategoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ActionByCategory[];
}

export interface PaginatedAssetList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Asset[];
}

export interface PaginatedAssetPolyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AssetPoly[];
}

export interface PaginatedAuthenticatedTransactionRequestOutputList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AuthenticatedTransactionRequestOutput[];
}

export interface PaginatedAvailabilityPeriodList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AvailabilityPeriod[];
}

export interface PaginatedAvailabilityPeriodUnauthenticatedList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: AvailabilityPeriodUnauthenticated[];
}

export interface PaginatedCMSAssetList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSAsset[];
}

export interface PaginatedCMSOcppChargePointList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSOcppChargePoint[];
}

export interface PaginatedCMSConnectorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSConnector[];
}

export interface PaginatedCMSContractList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSContract[];
}

export interface PaginatedCMSContractSnapshotList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSContractSnapshot[];
}

export interface PaginatedCMSPaymentList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSPayment[];
}

export interface PaginatedCMSProfileList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSProfile[];
}

export interface PaginatedCMSSampledValueList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSSampledValue[];
}

export interface PaginatedCMSTransactionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSTransaction[];
}

export interface PaginatedCMSTransactionRequestList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSTransactionRequest[];
}

export interface PaginatedCMSUserGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CMSUserGroup[];
}

export interface PaginatedChargePointGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargePointGroup[];
}

export interface PaginatedChargePointImageUnauthenticatedList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargePointImageUnauthenticated[];
}

export interface PaginatedChargePointList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargePoint[];
}

export interface PaginatedChargePointPolyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargePointPoly[];
}

export interface PaginatedChargePointUptimeSummaryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargePointUptimeSummary[];
}

export interface PaginatedChargepointGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargepointGroup[];
}

export interface PaginatedChargingAuthorizationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargingAuthorization[];
}

export interface PaginatedChargingProfileList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargingProfile[];
}

export interface PaginatedChargingScheduleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargingSchedule[];
}

export interface PaginatedChargingSchedulePeriodList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ChargingSchedulePeriod[];
}

export interface PaginatedCollectionNoteList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: CollectionNote[];
}

export interface PaginatedConnectorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Connector[];
}

export interface PaginatedConnectorUnathenticatedList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ConnectorUnathenticated[];
}

export interface PaginatedContractFourDecimalsWithPrecisionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ContractFourDecimalsWithPrecision[];
}

export interface PaginatedContractList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Contract[];
}

export interface PaginatedElectricityMeterList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ElectricityMeter[];
}

export interface PaginatedExportOutputList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ExportOutput[];
}

export interface PaginatedFirmwareList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Firmware[];
}

export interface PaginatedFleetList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Fleet[];
}

export interface PaginatedGridConnectionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: GridConnection[];
}

export interface PaginatedHeartbeatList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Heartbeat[];
}

export interface PaginatedKushkiEnrollErrorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: KushkiEnrollError[];
}

export interface PaginatedKushkiPaymentErrorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: KushkiPaymentError[];
}

export interface PaginatedModuleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Module[];
}

export interface PaginatedNotificationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Notification[];
}

export interface PaginatedPaymentTableList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: PaymentTable[];
}

export interface PaginatedPowerCategoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: PowerCategory[];
}

export interface PaginatedProfileDeferredUserGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ProfileDeferredUserGroup[];
}

export interface PaginatedProfileList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Profile[];
}

export interface PaginatedProfileSpotUserGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: ProfileSpotUserGroup[];
}

export interface PaginatedPushSubscriptionCreateDeleteList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: PushSubscriptionCreateDelete[];
}

export interface PaginatedReservationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Reservation[];
}

export interface PaginatedSampledValueList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: SampledValue[];
}

export interface PaginatedSessionSDMList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: SessionSDM[];
}

export interface PaginatedStatusNotificationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: StatusNotification[];
}

export interface PaginatedSubscriptionCreateDeleteList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: SubscriptionCreateDelete[];
}

export interface PaginatedThemeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Theme[];
}

export interface PaginatedTrackerList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Tracker[];
}

export interface PaginatedTrackerLogList {
  type?: GisFeatureCollectionEnum;
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  features?: TrackerLogList;
}

export interface PaginatedTrackerPathList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TrackerPath[];
}

export interface PaginatedTrackerPathMobileWindowList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TrackerPathMobileWindow[];
}

export interface PaginatedTrackerSampleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: TrackerSample[];
}

export interface PaginatedTransactionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Transaction[];
}

export interface PaginatedUserGroupListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: UserGroupList[];
}

export interface PaginatedUserList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: User[];
}

export interface PaginatedUserListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: UserList[];
}

export interface PaginatedVehicleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: Vehicle[];
}

export interface PaginatedVehicleStationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null;
  results: VehicleStationList;
}

export interface PasswordToken {
  password: string;
  token: string;
}

/** Asset serializer for unathenticated users */
export interface PatchedAssetUnauthenticated {
  id?: number;
  grid_connections?: GridConnectionUnauthenticated[];
  /** @maxLength 64 */
  name?: string;
  /** @maxLength 64 */
  address?: string;
  /** @maxLength 64 */
  town?: string;
  /** @maxLength 64 */
  region?: string;
  /**
   * Contact Number
   * @maxLength 32
   */
  phone_number?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  is_public?: boolean;
}

/** Availability Period Unauthenticated serializer */
export interface PatchedAvailabilityPeriodUnauthenticated {
  id?: number;
  start_period?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   * @default 0
   */
  week_day?: WeekDayEnum;
  /** With access? */
  with_access?: boolean;
  charge_point?: number;
}

/** Charge Point Image Serializer */
export interface PatchedChargePointImageUnauthenticated {
  id?: number;
  /** @format uri */
  image?: string;
  charge_point?: number;
}

export interface PatchedChargePointUpdateGroup {
  /** Charge Point Group */
  group?: number;
}

/** Charge Point Group Serializer */
export interface PatchedChargepointGroup {
  id?: number;
  /** @maxLength 64 */
  name?: string;
  charge_points?: number[];
  charge_points_count?: number;
  contracts?: number[];
  connectors_count?: number;
}

export interface PatchedChargingAuthorization {
  id?: number;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  /** @maxLength 20 */
  token?: string;
  /**
   * * `VIN` - VIN
   * * `RFID` - RFID
   * * `MAC` - MAC
   */
  token_format?: TokenFormatEnum;
  vehicle?: string | null;
  user?: number | null;
  user_group?: number;
}

/** Charging Profile Serializer */
export interface PatchedChargingProfile {
  id?: number;
  charging_schedule?: ChargingSchedule;
  /**
   * @min 0
   * @max 32767
   * @default 0
   */
  stack_level?: number;
  /**
   * * `ChargePointMaxProfile` - ChargePointMaxProfile
   * * `TxDefaultProfile` - TxDefaultProfile
   * * `TxProfile` - TxProfile
   */
  charging_profile_purpose?: ChargingProfilePurposeEnum;
  /**
   * * `Absolute` - Absolute
   * * `Recurring` - Recurring
   * * `Relative` - Relative
   */
  charging_profile_kind?: ChargingProfileKindEnum;
  recurrency_kind?: RecurrencyKindEnum | null;
  /** @format date-time */
  valid_from?: string | null;
  /** @format date-time */
  valid_to?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  /** Synchronizing Status */
  sync_status?: SyncStatusD22Enum | null;
  /**
   * Synchronizing Task Id
   * @maxLength 37
   */
  sync_task_id?: string | null;
  connector?: number;
  transaction?: number | null;
}

/** Charging Schedule Serializer */
export interface PatchedChargingSchedule {
  charging_profile?: number;
  charging_schedule_periods?: ChargingSchedulePeriod[];
  duration?: string | null;
  /** @format date-time */
  start_schedule?: string | null;
  /**
   * * `W` - W
   * * `A` - A
   */
  charging_rate_unit?: ChargingRateUnitEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  min_charging_rate?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
}

/** Charging Schedule Period Serializer */
export interface PatchedChargingSchedulePeriod {
  id?: number;
  start_period?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,1})?$
   */
  limit?: string;
  /**
   * Number of Phases
   * @min 0
   * @max 32767
   */
  number_phases?: number;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  charging_schedule?: number;
}

export interface PatchedConnectorUpdateSoc {
  /**
   * @min 1
   * @max 100
   */
  final_soc?: number;
}

/**
 * Contract serializer to be used for incoming data and outgoing data with higher
 * precision
 */
export interface PatchedContractFourDecimalsWithPrecision {
  id?: number;
  contract_periods?: ContractPeriodFourDecimals[];
  /**
   * Name
   * @maxLength 144
   */
  verbose_name?: string | null;
  /**
   * * `PER_MINUTE` - PER_MINUTE
   * * `PER_KWH` - PER_KWH
   */
  contract_kind?: ContractKind0BdEnum;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  user_group?: number;
  charge_point_group?: number;
}

export interface PatchedCreditCardDefault {
  default?: boolean;
}

/** Electricity Meter Serializer */
export interface PatchedElectricityMeter {
  /**
   * Pk of SMI Meter
   * @format int64
   * @min -9223372036854776000
   * @max 9223372036854776000
   */
  id?: number;
  /** @maxLength 100 */
  name?: string | null;
  /** @maxLength 30 */
  status?: string;
  /** @format date-time */
  timestamp?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  grid_connection?: number;
}

/** Firmware Serializer */
export interface PatchedFirmware {
  id?: number;
  uri?: string;
  /**
   * Charge Point Vendor
   * @maxLength 21
   */
  vendor?: string;
  /**
   * Charge Point Model
   * @maxLength 21
   */
  model?: string;
  /**
   * Firmware Version
   * @maxLength 51
   */
  version?: string;
  /**
   * Firmware File
   * @format uri
   */
  firmware?: string;
  /** @maxLength 200 */
  description?: string | null;
  /**
   * * `FTP` - Ftp
   * * `FTPS` - Ftps
   * * `HTTP` - Http
   * * `HTTPS` - Https
   */
  download_schema?: DownloadSchemaEnum;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
}

/** Fleet Serializer */
export interface PatchedFleet {
  id?: number;
  vehicles?: Vehicle[];
  /**
   * Fleet Name
   * @maxLength 64
   */
  name?: string;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
}

/** Grid Connection Serializer */
export interface PatchedGridConnection {
  id?: number;
  charge_points?: ChargePointMinimal[];
  electricity_meters?: ElectricityMeter[];
  /** @maxLength 40 */
  name?: string;
  /**
   * Capacity in W
   * @min 0
   * @max 2147483647
   */
  capacity?: number;
  /**
   * Charging Capacity in W
   * @min 0
   * @max 2147483647
   */
  charging_capacity?: number;
  /** @maxLength 100 */
  math_cost?: string;
  /**
   * * `CLP` - CLP
   * * `COP` - COP
   * * `USD` - USD
   * * `MXN` - MXN
   * * `BRL` - BRL
   * * `PEN` - PEN
   * * `EUR` - EUR
   */
  currency?: CurrencyEnum;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  charge_points_power?: string | null;
  /** @maxLength 32 */
  client_internal_id?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  asset?: number;
  /** Vehicle Station */
  station?: number;
}

/** Heartbeat Serializer */
export interface PatchedHeartbeat {
  id?: number;
  /** @format date-time */
  current_time?: string;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  charge_point?: number;
}

/** Power Category Serializer */
export interface PatchedPowerCategory {
  id?: number;
  /** Category */
  name?: NameEnum;
  /** @maxLength 50 */
  verbose_name?: string | null;
  /**
   * MIN POWER (W)
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  min_power?: string;
  /**
   * MAX POWER (W)
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  max_power?: string;
}

/** Profile Serializer Class */
export interface PatchedProfile {
  user?: number;
  /** @format uri */
  image?: string;
  spot_user_groups?: ProfileSpotUserGroup[];
  deferred_user_groups?: ProfileDeferredUserGroup[];
  /**
   * * `en-us` - English
   * * `es` - Spanish
   */
  language?: LanguageEnum;
  /** Time zone */
  timezone?: TimezoneEnum | null;
  /** @maxLength 255 */
  startpage?: string | null;
  document_type?: DocumentTypeAbeEnum | null;
  /** @maxLength 64 */
  document_number?: string | null;
  /** @maxLength 64 */
  second_last_name?: string | null;
  /** @maxLength 64 */
  phone_number?: string | null;
  /**
   * End-user license agreement
   * @format date-time
   */
  eula?: string | null;
  email_validated?: boolean;
  /** @maxLength 64 */
  google_userid?: string | null;
  /** @maxLength 64 */
  apple_userid?: string | null;
  is_mobile?: boolean;
  is_google_auth?: boolean;
  assets?: number[];
  fleets?: number[];
}

/** Serializer for M2M between Profile and DeferredUserGroup */
export interface PatchedProfileDeferredUserGroup {
  id?: number;
  user_group?: number;
  /** @default false */
  default?: boolean;
  profile?: number;
}

/** Serializer for M2M between Profile and SpotUserGroup */
export interface PatchedProfileSpotUserGroup {
  id?: number;
  user_group?: number;
  /** @default false */
  default?: boolean;
  profile?: number;
}

/** Reservation Serializer */
export interface PatchedReservation {
  id?: number;
  sync_task_id?: string;
  sync_status?: string;
  user?: number;
  /** @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"} */
  tsrange?: TsRange;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  connector?: number;
  /** TransactionRequest */
  transaction_request?: number | null;
}

/** Sampled Value Serializer */
export interface PatchedSampledValue {
  id?: number;
  connector?: number;
  /** @format date-time */
  timestamp?: string;
  /** @maxLength 255 */
  value?: string;
  /**
   * * `Interruption.Begin` - Interruption.Begin
   * * `Interruption.End` - Interruption.End
   * * `Other` - Other
   * * `Sample.Clock` - Sample.Clock
   * * `Sample.Periodic` - Sample.Periodic
   * * `Transaction.Begin` - Transaction.Begin
   * * `Transaction.End` - Transaction.End
   * * `Trigger` - Trigger
   */
  context?: ContextEnum;
  /**
   * * `Raw` - Raw
   * * `SignedData` - SignedData
   */
  value_format?: ValueFormatEnum;
  /** @default "Energy.Active.Import.Register" */
  measurand?: Measurand2D5Enum;
  phase?: PhaseEnum | null;
  /**
   * * `Inlet` - Inlet
   * * `Outlet` - Outlet
   * * `Body` - Body
   * * `Cable` - Cable
   * * `EV` - EV
   */
  location?: LocationEnum;
  /** Unit Of Measure */
  unit?: UnitEnum;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  meter_value?: number;
}

/** Status Notification Serializer */
export interface PatchedStatusNotification {
  id?: number;
  /** Charge Point Error Code */
  error_code?: ErrorCodeEnum;
  /**
   * Information Related to the Error
   * @maxLength 51
   */
  info?: string | null;
  /** Charge Point Status */
  status?: ChargePointStatusEnum;
  /** @format date-time */
  timestamp?: string;
  /** @maxLength 256 */
  vendor_id?: string | null;
  /** @maxLength 51 */
  vendor_error_code?: string | null;
  /**
   * * `Error not interpreted` - Not Interpreted
   * * `UpdateFail` - Fail to update software
   * * `ResetFailure` - Fail to reset
   * * `GunTemperature` - Gun over-temperature
   * * `TrialPeriodOver` - The trial period is over
   * * `EmergencyStop` - Emergency stop
   * * `BleederResistor` - Bleeder resistor failure
   * * `Insulation` - Insulation failure (several times)
   * * `OpenDoor` - Open door
   * * `MeterFault` - Meter failure
   * * `BEMAlarmStop` - BEM alarm stop
   * * `BSMMessage` - BSM message
   * * `BROFault` - BRO fault
   * * `OuterVoltageRelay` - Outer voltage relay
   * * `BRMTimeOut` - BRM timeout
   * * `BCPTimeOut` - BCP timeout
   * * `BROTimeOut` - BRO timeout
   * * `BCLTimeOut` - BCL timeout
   * * `BSTTimeOut` - BST timeout
   * * `BSDTimeOut` - BSD timeout
   * * `BSMInsulation` - BSM insulation fault
   * * `BMSOutputTemperature` - BMS output over-temperature
   * * `BMSComponentTemperature` - BMS component over-temperature
   * * `BMSBatteryOverTemperature` - BMS Battery over-temperature
   * * `BMSHighCurrent` - BMS over current
   * * `BMSVoltageAbnormality` - BMS Voltage Abnormality
   * * `BMSOtherErrors` - BMS Other Errors
   * * `PowerModuleCommunicationFault` - Power Module Communication Fault
   * * `InputOverVoltage` - Input Over Voltage
   * * `InputUnderVoltage` - Input Under Voltage
   * * `GenericError` - Generic Error
   * * `MainsPowerSupply` - Mains Power Supply Failure
   * * `TemperatureOutOfRange` - Temperature out of range
   * * `InternalComunicationsError` - Internal communications error
   * * `ConfigurationError` - Configuration Error
   * * `MainsGroundFailure` - Mains ground failure
   * * `MainsVoltageOutOfRange` - Mains voltage out of range
   * * `MainsFrequencyOutOfRange` - Mains Frequency out of range
   * * `HighTemperatureError` - High temperature error
   * * `LowTemperatureError` - Low temperature error
   * * `ExternalComunicationsError` - External communications error
   * * `ErrorMasterEntity` - Error in master entity
   * * `SlaveError` - Error in slave entity
   * * `DoorTamperAlarm` - Door Tamper Error
   * * `TiltError` - Tilt error
   * * `DisplayFailure` - Display Failure
   * * `RfidReaderFailure` - RFID reader failure
   * * `PowerMeterFailure` - Power Meter Comunication Error
   * * `GenericVehicleError` - Generic Vehicle Error
   * * `VehicleComunicationError` - Vehicle Comunication Error
   * * `VehicleNotDetected` - Vehicle not detected
   * * `VehicleOverCurrent` - Vehicle over current consumption
   * * `CordMalfunction` - Cord malfunction
   * * `CordSensorMalfunction` - Cord sensor malfunction
   * * `ConnectorLockFailure` - Connector Lock Failure
   * * `InternalPowerSupplyFailure` - Internal power supply failure
   * * `ComponentTemperatureOutRange` - Component temperature out of range
   * * `HardwareFailureMode4` - Hardware Failure Mode4
   * * `HardwareFailureNodes` - Hardware Failure Nodes
   * * `AcDcConvertersGenericError` - AC/DC converters Error
   * * `AcDcConvertersTimeOutError` - AC/DC converters time out Error
   * * `AcDcConvertersVoltageOutRange` - AC/DC converters voltage out of range
   * * `AcDcConvertersCurrentOutRange` - AC/DC converters current out of range
   * * `WeldingContactor` - Welding Contactor
   * * `CurrentLeakDetected` - Current Leak Detected
   * * `ElectricalProtectionTriggered` - Electrica Protection Triggered
   * * `IsolationError` - Isolation error
   * * `RcdProtectionTriggered` - RCD protection triggered
   * * `McbProtectionTriggered` - MCB protection triggered (Over Current protection Triggered)
   * * `ProgramCounterFailure` - Program Counter Failure
   * * `Invalid` - Reason for stopping cannot be identified
   * * `NoError` - No error ocurred, similar to a normal stop
   * * `UserRequestStop` - User pressed the stop button on HMI
   * * `ConnectorButtonPressed` - CSS1 connector button is pressed by user
   * * `VehicleStop` - This vehicle requested to stop the session by a driver request
   * * `IncompatibleVehicle` - This vehicle cannot be charged on this outlet
   * * `IsolationTestFailed` - Isolation resistance is to low
   * * `CableCheckFailed` - Isolation failure during cable check phase
   * * `BatteryFull` - Stopped because the vehicle battery is full
   * * `BudgetExceeded` - Stopped because the vehicle asked for or tried to draw to much power
   * * `ChargerError` - Chargin Protocol Interface (CPI) board error
   * * `ChargerContactorProblem` - Charger contactor problem
   * * `ChargerLoweringCurrentTimeout` - Charge does not follow the request reduction of current near to full charge
   * * `ConnectorError` - Connector Error
   * * `ConnectorPilotError` - Conector pilot error
   * * `ControlPilotShorCircuit` - Control pilot is in short-circuit. it can be caused by bad wiring
   * * `ConnectorTemperatureError` - The connector is too hot
   * * `Outlet error` - problem of CPI/IMI assebly, CCB or CAN cable between CCB and CPI
   * * `chargerPreChargerTimeout` - Precharger timeout is reached
   * * `ChargerVoltageDrop` - Measure voltage is lower than the expected
   * * `ChargerMaxVoltage` - Maximum voltage exceeded
   * * `ChargedStopTimeout` - Vehicle takes too log to send the stop command
   * * `ChargerConnectorPresenceLost` - Charger was not able to pick Control pilor state changes from the vehicle
   * * `ChargerErrorCurrentDifference` - The charger detected thar the current difference is too large
   * * `ChargerCANCommunicationLost` - he power cabinet internal CAN bus communication is lost
   * * `ChargerMCBTripped` - Charger circuit breaker tripped
   * * `ChargedRCDTriped` - the AC input (from the grid) Residual Current Device tripped
   * * `ChargerRCDCloseError` - Residual Current Device Closing Error
   * * `ChargefTemperatureError` - The temperature of the power cabinet or charge is high
   * * `ChargerNeutralMismatch` - Charger neutral mismatch
   * * `ChargerOutletDetection` - Charger outlet detection
   * * `VehicleProtocolError` - Vehicle protocol error
   * * `PowerPortVipError` - The powerport vip value is showing zero
   * * `Power port power error` - Power module does not respond fast enough
   * * `PowerPortFanFailure` - All power module affected by a fan failure
   * * `PowerPortOverheat` - All power modules show a high temperature
   * * `PowerPortInterlock` - Interlock of power modules acttive
   * * `PowerPortErrorOther` - Umbrella error for any other power modules related errors
   * * `VehicleErrorReversePolarity` - The polarityo the vehicle is reversed
   * * `VehicleErrorVoltageApplied` - There is a voltage applied to the DC output when this is not expected
   * * `LockError` - Unable to lock the connector, no dangerous voltage present
   * * `UnlockError` - Unable to unlock the connector, no dangerous voltage present
   * * `LockTampering` - Tampering with the connector lock detected
   * * `CableError` - Charger cannot detect chargin cable type e.g. after cable replacement
   * * `GlobalInterlockFail` - Global Interlock activated
   * * `VehicleShiftPosition` - Vehicle shift position indicator is incorrect
   * * `VehicleBatteryTemperatureOutOfRange` - Vehicle communicated that its battery temperature is out of range
   * * `VehicleLookError` - Vehicle is unable to lock the connector
   * * `VehicleBatteryMalfunction` - Vehicle battery malfunction
   * * `VehicleCurrentDifference` - Vehicle detected current is not within specs
   * * `VehicleVoltageOutOfRange` - Vehicle detected voltage is out of range
   * * `VehicleError` - General vehicle error
   * * `oardPowerSupplyError` - Charge auxiliary power supply (24V) has issues
   * * `OcmNotAlive` - Over current monitor not alive
   * * `OcmInterlockVeriicationError` - Interlock by over current monitor is not functioning properly
   * * `OcmCableRatingMismatch` - Over current monitor and cable rating does not match
   * * `OnBoardEnergymeterError` - Vehicle onboard energy meter error
   * * `VehicleWeldingDetectionTimeout` - Vehicle contador weldin detection request took to long
   * * `CableCheckCurrentRunning` - The isolation test failed during this session
   * * `CableCheckVoltageTooLow` - Power module that was selected for the cable check is not functioning
   * * `CableCheckVoltageTooHigh` - The power module voltage were too high during the cable check
   * * `CableCheckVoltageNotDropping` - Voltage is not dropping when expected during the cable check
   * * `ChargerTimeCompleted` - stopped because car has been charging long enough
   * * `VehicleNotConnected` - Vehicle not connected
   * * `SoftError` - Software induce error
   * * `StoppedByVehicle` - Stopped by vehicle
   * * `AcsErrorExtending` - Problem happened that prevent the pantograph from extending
   * * `AcsErrorRetracting` - Pantograph error retracting
   * * `AcsExtendedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AcsRetractedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AccErrorAligment` - No complete chargin circuit when the pantograph is lowered
   * * `ChargerCabinetOvp` - The Over Coltage protection in cabinet is tripped
   * * `ChargerCableCoolerFailure` - Cable cooler is not reachable or gives an error
   * * `ChargerCableCoolerTemperature` - Temperature of cooler out of range
   * * `ChargerCableTemperature` - The cable is too hot at the charger end
   * * `ChargerContactorTemperature` - Contactor temperature is out-of-range
   * * `EstCorrect` - Normal stop
   * * `blocked` - ID tag for OCPP authorization is blocked on server
   * * `Expired` - ID tag for OCPP authorization is expired on server
   * * `InvalidOnServer` - ID tag is marked as Invalid by the OCP server
   * * `InvalidOnCharged` - ID tag is marked as Invalid by the charger software
   * * `RequestReject` - Charged software rejects request for authorization
   * * `WrongMessage` - Wrong parameters provided for the authorization request
   * * `NoMatchingIDs` - ID tags for OCPP Star and Stop do not match
   * * `ServerUnreachable` - The authorization failed as the server could not be reached
   * * `NoCardPresented` - The authorization failed bcause the user did not present a card
   * * `AuthorizedStop` - Authorization was used to stop chargin
   * * `ForcedStop` - Used when it is required to stop the charging without an authorization
   * * `NormalStop` - Normal Stop that does not fall into any of other categories
   * * `ImiDisconnectedFromDcbus` - CPI disconnected from DC bus and thresfore measure 0 Volts
   * * `ChargerCommunicationFailure` - Communication between Host A8 and DCB Failed
   * * `ChargerSubunitCommunicationFailure` - Communication beetween Host A8 and Subunit DCB Failed
   * * `DCElectricMeterCommunicationFailed` - DC Electric Meter communication Detection Failed
   * * `PowerModuleCANCommunicationFailure` - Possibly Due to module Address Configuration Issueor Module CAN communication problem
   * * `InsulationCommunication` - Gun 1 and 2 Insulation Communication module are in alarm state possibly due to power supply or communication issues with the insulation modules
   * * `Timeout` - Self-test Timeout. Abnormal Status. DCB has not Reported charging status messages for a long time
   * * `ACElectricMeterCommunicationFailure` - AC Electric Meter communication Detection Failed
   * * `NFC Communication Failure` - NFC communication failure
   * * `CommunicationFailureLightPanel` - Communication failure with the Light Panel
   * * `BluetoothCommunicationFailure` - Bluetooth board communication failure
   * * `ChargerFANMalfunction` - Charger FAN malfunction
   * * `DCBTCUAbnormality` - DCB Received TCU Abnormality
   * * `ChargerOtherFaults` - Charger other faults (avoid using whenever possible)
   * * `TCUVINVerificationTimedOut` - Waiting fot TCU VIN verification result timed out
   * * `VehicleAuthenticationFailed` - Vehicle authentication Failed (VIN Verification)
   * * `FanSpeedControlFailure` - Fan speed cntrol board communication failure
   * * `InsulationAlarm` - Insulation alarm (Alert without Shutdown)
   * * `InsulationFault` - Insulation Fault
   * * `PowerModuleAlarm` - Power module alarm
   * * `PowerModuleConflict` - (C6) Power module address conflict, (C2) charging station not initialized
   * * `PowerModuleFault` - Power module fault. Record the modules that have experienced a fault in the data
   * * `PowerModuleStatusChange` - Power module status change ( number of availabke modules)
   * * `PowerModulePhaseLossFault` - Power module phase loss fault
   * * `PowerModuleFanFault` - Power module FAN fault
   * * `PowerModuleOvertemperatureFault` - Power module overtemperature fault
   * * `PowerModuleACInputFault` - Power module AC input Fault
   * * `PowerModuleOutputShortCircuitFault` - Power module output short circuit fault
   * * `PowerModuleOutputOvercurrentFault` - Power module output overcurrent fault
   * * `PowerModuleOutputOvervoltageFault` - Power module output overvoltage fault
   * * `PowerModuleOutputUndervoltageFault` - Power module output undervoltage fault
   * * `PowerModuleInputOvervoltageFault` - Power module input overvoltage fault
   * * `PowerModuleInputUndervoltageFault` - Power module input undervoltage fault
   * * `PowerModuleDischargeFault` - Power module discharge fault
   * * `PowerModuleCurrentLimit` - Power module current limit
   * * `PowerModuleShutdown` - Power module shutdown
   * * `NoAvailableSparePowerModule` - No available spare power module
   * * `ChargerAccessControlFailure` - Charger access control failure
   * * `LiquidLevelAlarm` - Liquid level alarm
   * * `ACSurgeAlarm` - AC surge alarm
   * * `DCSurgeAlarm` - DC Surge alarm. If It's a subunit DC surge, specify the subunit number in the data
   * * `GunEndContactFault` - Gun end contactor fault. Displayed as charging port end contact fault on WeChat
   * * `ChargigStationSmokeDetectorFault` - Charging station smoke detector fault
   * * `CabinetTemperatureAlarm` - Cabinet Temperature Alarm. Abnormal Status
   * * `CabinetHumidityAlarm` - Cabinete humidity alarm. Abnormal status
   * * `TiltAngleAlarm` - Tilt angle alarm. abnormal status
   * * `LiquidCooledHeadExceedsShutdown` - Liquid-Cooled gun Head exceeds shutdown temperature. shutdown
   * * `LiquidCooledHeadExceedsCurrentShutdown` - Liquid-Cooled gun head exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledTailExceedsShutdown` - Liquid-Cooled gun Tail exceeds shutdown temperature. shutdown
   * * `LiquidCooledTailExceedsCurrentShutdown` - Liquid-Cooled gun Tail exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledHeadTemperatureRiseExceedsShutdown` - Liquid-Cooled gun head temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledHeadTemperatureRiseCurrentShutdown` - Liquid-Cooled gun head temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LiquidCooledTailTemperatureRiseExceedsShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledTailTemperatureRiseCurrentShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LowLiquidLevel` - Low liquid level in  Liquid cooling, current limit without shutdown.
   * * `LiquidCoolingOvertemperatureOvervoltage` - Liquid coolink liquid overtemperature and overvoltage. Overtemperature and overvoltage are the same fault in this context
   * * `LiquidCooledHeadDifferenceExceeds` - Liquid-cooled gun head and tail temperature difference exceeds current limit rate, but not shutdown rate. current limit without shutdown
   * * `LiquidCooledHeadTailShutdown` - Liquid-Cooled gun head and tail temperature difference exceeds shutdown rate. Shutdown
   * * `LiquidCoolingFault` - Liquid cooling fault
   * * `ChargingStationFault` - Charging station fault
   * * `TiltAngleFault` - Tilt angle fault
   * * `LiquidCoolingCoolantLowLevelFault` - Liquid cooling coolant low level fault, shutdown. This fault may indicate a coolant leak
   * * `OtherHardwareFaultsInLiquidCooling` - Other hardware fault in liquid cooling
   * * `LiquidCoolingDischargeNoShutdown` - Liquid cooling discharge and return temperature difference alarm, but no shutdown
   * * `LiquidCoolingDischargeShutdown` - Liquid cooling discharge and return temperature difference alarm shutdown
   * * `LiquidCoolingReturnNoShutdown` - Liquid cooling return temperature difference alarm, but no shutdown
   * * `LiquidCoolingReturnShutdown` - Liquid cooling return temperature difference alarm, shutdown
   * * `LiquidCoolingPumpLowAlarm` - Liquid cooling pump low temperature alarm, but no shutdown
   * * `LiquidCoolingPumpLowFault` - Liquid cooling pump low temperature fault, shutdown
   * * `LiquidCoolingPumpFault` - Liquid cooling pump temperature fault, shutdown
   * * `LiquidCoolingPumpSesingFault` - Liquid cooling pump temperature sensing fault, shutdown
   * * `EmergencyStopCircuitFault` - Emergency stop circuit fault
   * * `ChargingGunTemperatureAlarm` - Charging gun temperature alarm. Displayed as charging port temperature alarm on WeChat. Abnormal status
   * * `ElectromagneticLockLockingFailed` - Electromagnetic lock locking operation failed. Abnormal status
   * * `ElectromagneticLockUnlockingFailed` - Electromagnetic lock unlocking operation failed. At this point, the charging gun is locked and cannot be removed. Abnormal status
   * * `AbnormalityChargingGunPort` - Abnormality at the charging gun port, meannig a change in CC voltageduring charging (other than 4V), abnormal status
   * * `ChargingGunNotProperlyPositioned` - Charging gun not properly positioned
   * * `BMSVoltageLowOrHigh` - BMS demands voltage too low or high. If it can be ditinguished as 'high' or 'low'
   * * `BMSVoltageHigh` - BMS demands voltage too high
   * * `BMSVoltageLow` - BMS demands voltage too Low
   * * `APhaseHigh` - A-phase voltage too high
   * * `BPhaseHigh` - B-phase voltage too high
   * * `CPhaseHigh` - C-phase voltage too high
   * * `APhaseLow` - A-phase voltage too low
   * * `BPhaseLow` - B-phase voltage too low
   * * `CPhaseLow` - C-phase voltage too low
   * * `GroundWireAlarm` - Ground wire alarm
   * * `NLineNotConnected` - N-Line not connected
   * * `ACInputCircuitBrakerFailure` - AC Input circuit breaker failure
   * * `ACInputContadorRefusarFault` - AC Input contador refursar fault
   * * `ACInputContadorStickingFault` - AC input contador sticking fault
   * * `SystemPowerFailure` - System power failure. 220V no input
   * * `ACPowerMeterReadingAbnormal` - AC power meter reading abnormal
   * * `ACInputPhaseLoss` - AC input phase loss
   * * `VoltageAbnormalityOvervoltage` - Coltage abnormality overvoltage
   * * `VoltageAbnormalityUndervoltage` - Voltage abnormality undervoltage
   * * `VoltageAbnormalityShortCircuit` - Voltageabnormality short circuit
   * * `VoltageAbnormalityOverload` - Voltage abnormality overload
   * * `BatteryReverseConnection` - Battery reverse connection
   * * `DCDetectionFailure` - DC detection failure
   * * `DischargeDetectionFailure` - Dicharge detection failure
   * * `ParallelContadorRefusalFault` - Parallel contador refusal fault
   * * `ParallelContadorAhesionFault` - Parallel contador adhesion fault
   * * `DCBusOutputFuseFault` - DC bus output fuse fault
   * * `ChargingHostPreChargingFailureFault` - Charging host pre-charging failure fault
   * * `ChargingHostResponseChargingFailureFault` - Charging host response charging failure fault
   * * `BatteryUndervoltage` - During the charging permission stage, the charging station measures the battery voltage lower than 5% of the battery voltage in BCP
   * * `BatteryOvervoltage` - During the charging permission stage, the charging station measures the battery voltage higher than 5% of the battery voltage in BCP
   * * `AbnormalDC` - Abnormal DC meter reading
   * * `GunheadDCRefusalFault` - Gunhead DC output contactor refusal fault
   * * `GunheadDCAdhesionFault` - Gunhead DC output contadctor adhesion fault
   * * `PrechargeTimeout` - Precharge timeout
   * * `AuxiliaryPowerNotPowered` - The auxiliar power supply is not powered on
   * * `CRMTimeout` - CRM timeout
   * * `CRM00Timeout` - CRM00 timeout
   * * `CRMaaTimeout` - CRMaa timeout
   * * `CROTimeout` - CRO timeout
   * * `CTSTimeout` - CTS timeout
   * * `CMLTimeout` - CML timeout
   * * `CCSTimeout` - CSS timeout
   * * `CSTTimeout` - CST timeout
   * * `CSDTimeout` - CSD timeout
   * * `OtherTimeoutFaultBEM` - Other timeout fault as defined in BEM
   * * `ChargerOutputCurrentExcedsDC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the DC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargerOutputCurrentExcedsAC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the AC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargingHostEmergencyStop` - Charging host emergency stop
   * * `ChargingostDCBusbarFuse` - Charging host DC busbar fuse
   * * `ChargingHostAccessControlFAilure` - Charging host access control failure
   * * `ChargingHostSmokeDetectorFailure` - Charging host smoke detector failure
   * * `ChargingHostACInputCircuitBreakerFailure` - Charging host AC input circuit breaker failure
   * * `ChargingHostACInputContactorMalfunction` - charging host AC input contactor malfunction
   * * `ChargingHostACInputStickingMalfunction` - charging host AC input sticking malfunction
   * * `ChargingHostFanMalfunction` - Charging host fan malfunction
   * * `ChargingHostParallelContactorMalfunction` - Charging host parallel contactor malfunction
   * * `ChargingHostParallelStickingMalfunction` - Charging host parallel sticking malfunction
   * * `ChargingHostLiquidCoolingModuleMalfunction` - Charging host liquid cooling module malfunction
   * * `ChargingHostLiquidCoolingModuleCommunicationFailure` - Charging host liquid cooling module communication failure
   * * `ChargingHostSurgeArresterMAlfunction` - Charging host surge arrester malfunction
   * * `ChargingHostACEnergyMeterCommunicationFailure` - Charging host AC energy meter communication failure
   * * `ChargingHostOverTemperatureFault` - Charging host over temperature fault
   * * `ChargingHostOverTemperatureWarning` - Charging host over temperature warning
   * * `ChargingHostInputVoltageOvervoltageFault` - Charging host input voltage overvoltage fault
   * * `ChargingHostInputVoltageUndervoltageFault` - Charging host input voltage undervoltage fault
   * * `ChargingHostWaterLevelMonitoringAbnormality` - Charging host water level monitoring abnormality
   * * `ChargingHostPowerModuleFault` - Charging host power module fault
   * * `ChargingHostPowerModuleCommunicationFailure` - Charging host power module communication failure
   * * `ChargingHostPowerModuleFanMalfunction` - Charging host power module fan malfunction
   * * `ChargingHostPowerModuleOverTemperatureFault` - Charging host power module over-temperature fault
   * * `ChargingHostPowerModuleACInputFault` - Charging host power module AC input fault
   * * `ChargingHostPowerModuleOutputShortCircuitFault` - Charging host power module output short circuit fault
   * * `ChargingHostPowerModuleOutputOvercurrentFault` - Charging host power module output overcurrent fault
   * * `ChargingHostModuleOutputOvervoltageFault` - Charging host power module output overvoltage fault
   * * `ChargingHostModuleOutputUndervoltageFault` - Charging host power module output undervoltage fault
   * * `ChargingHostModuleInputOvervoltageFault` - Charging host power module input overvoltage fault
   * * `ChargingHostModuleInputUndevoltagetFault` - Charging host power module input undevoltage fault
   * * `ChargingHostModuleInputPhaseLossFault` - Charging host charging module input phase loss fault
   * * `ChargingHostChargingModuleFault` - Charging host charging module fault
   * * `ChargingHostChargingModuleCommunicationFailure` - Charging host charging module communication failure
   * * `ChargingHostAdhesiveDetectionTimeout` - Charging host adhesive detection response timeout
   * * `ChargingHostChargingStopCompletionTimeout` - Charging host charging stop completion response timeout
   * * `ChargingHostInsulationDetectionFrameTimeout` - Charging host insulation detection frame response timeout
   * * `ChargingHostInsulationDetectionCompletionTimeout` - Charging host insulation detection completion response timeout
   * * `ChargingHostPreChargeFrameTimeout` - Charging host pre-charge frame response timeout
   * * `ChargingHostPreChargeCompletionTimeout` - Charging host pre-charge completion response timeout
   * * `ChargingHostReceptionFirmwareUpgradeFrameTimeout` - Charging host reception of remote firmware upgrade file data frame timeout
   * * `ChargingHostReceptionChargingDemandDataFrameTimeout` - Charging host reception of charging demad data frame timeout
   * * `ChargingHostChargingTerminalTelesinalFrameTimeout` - Charging host charging terminal telesignal frame reception timeout
   * * `ChargingHostChargingStartupTimeout` - Charging host charging startup response timeout
   * * `ChargingHostChargingStopTimeout` - Charging host charging stop response timeout
   * * `ChargingHostTimeSynchronizationOperationTimeout` - Charging host time synchronization operation response timeout
   * * `ChargingHostVersionVerificationTimeout` - Charging host version verification response timeout
   * * `ChargingHostChargingParameterTimeout` - Charging host charging parameter response timeout
   * * `ChargingHostPreChargerTimeout` - Charging host pre-charger response timeout
   * * `ChargingHostInsulationDetectionTimeout` - Charging host insulation detection reponse timeout
   * * `ChargingHostRemoteUpgradeRequestTimeout` - Charging host remote upgrade request response timeout
   * * `ChargingHostDebuggingDataRequestTimeout` - Charging host debugging data request response timeout
   * * `ChargingHostControlRequestTimeout` - Charging host control request response timeout
   * * `ChargingHostRemoteFirmwareTransferFrameTimeout` - Charging host remote firmware upgrade file transfer completion frame reception timeout
   * * `ChargingHostRemoteUpgradeCompletionFrameTimeout` - Chaging host remote upgrade completion reception timeout
   * * `ChargingHostTelecontrolFrameTimeout` - Charging host telecontrol frame reception timeout
   * * `CharginghostTelemetryFrameTimeout` - Charging host telemetry frame reception timeout
   * * `ChargingHostInsulationDetectionCompletionFrameTimeout` - Charging host insulation detection completion frame reception timeout
   * * `ChargingHostAdhesiveDetectionFrameTimeout` - Charging host adhesive detection frame reception timeout
   * * `ChargingHostPreChargeCompletionFrameTimeout` - Charging host pre-charge completion frame reception timeout
   * * `ChargingHostChargingStopFrameTimeout` - Charging host charging stop completion frame reception timeout
   * * `ChargingHostAndSubCommunicationNotCompleted` - Charging host and sub-communication initialization not completed
   * * `ChargingHostHeartbeatReceptionStatus` - Charging host heartbeat reception status
   * * `BSTHighVoltageRelayMalfunction` - BST high voltage relay malfunction
   * * `BSTChargingConnectorMalfunction` - BST charging connector malfunction. Abnormal status
   * * `BSTBatteryPackTemperatureHigh` - BST battery pack temperature too high
   * * `BSTCurrentExceedsRequiredValue` - BST current exceeds the required value
   * * `BSTVoltageAbnormal` - BST voltage abnormal
   * * `BSTDetectionPoint2VoltageDetectionMalfunction` - BST detection point 2 voltage detection malfunction. Abnormal status
   * * `BSTOtherMalfunction` - BST other malfunction
   * * `BSTOutputConnectorOverheated` - BST output connector overheated
   * * `BSTStopSendData0Malfunction` - BST stops and send data as 0 malfunction, not a malfunction.
   * * `BSTVehicleInsulation` - BST vehicle insulation
   * * `BMSCurrentExceedsVoltageMode` - BMS current request exceeds the maximum allowed current in constant voltage mode
   * * `BMSCurrentExceedsCurrentMode` - BMS current request exceeds the maximum allowed current in constant current mode
   * * `ChargingProhibited` - Charging prohibited, 10-minute timeout
   * * `BHMVoltageMatchingFailure` - BHM voltage matching failure
   * * `VoltageDetectionFailure` - Voltage detection failure
   * * `BMSCoponentOutputConnectorOverTemperature` - BHM component output connector over temperature
   * * `BSMIndividualPowerBatteryHigh` - BSM individual power battery voltage too high
   * * `BSMIndividualPowerBatteryLow` - BSM individual power battery voltage too low
   * * `BSMVehiclePowerBatteryHigh` - BSM whole vehicle power battery state of charge (SOC) too high
   * * `BSMVehiclePowerBatterylow` - BSM whole vehicle power battery state of charge (SOC) too low
   * * `BSMVehiclePowerBatteryInsulationAbnormal` - BSM power battery insulation status abnormal
   * * `BSMBatteryOvercurrentCharging` - BSM power battery overcurrent during charging
   * * `BSMBatteryTemperatureHigh` - BSM power battery temperature high
   * * `BSMBatteryOutputConnectorConnectionAbnormal` - BSM power battery pack output connector connection status abnormal
   * * `BMSCommunicationProtocolVersionMismatch` - BMS communication protocol version mismatch
   * * `VehicleFullyCharged` - The vehicle is fully charged; this is feedback from the vehicle
   * * `ReachedSetTotalVoltage` - Reached the set total voltage. Not considered abnormal; can be regarded as fully charged
   * * `ReachedSetIndividualVoltage` - Reached the set individual cell voltage. Not considered abnormal; can be regarded as fully charged
   * * `MetChargerSettingConditions` - Met the charger setting conditions. Not considered abnormal; can be regarded as fully charged
   * * `VehicleSideManualTermination` - Vehicle-side indicates manual temination
   * * `PowerCannotBeTransmitted` - Power cannot be transmitted this is a vehicle malfunction, it might be fully charged.
   * * `CurrentMismatchVehicleMalfunction` - Current mismathc, this is a vehicle malfunction, it might be fully charged
   * * `ChargedTeminated` - Charged teminated
   * * `BRMTimeout` - BRM timeout
   * * `BCPTimeout` - BCP timeout
   * * `BRO_TIMEOUT` - BRO timeout
   * * `BCSTimeout` - BCS timeout
   * * `BCLTimeout` - BCL timeout
   * * `BSTTimeout` - BST timeout
   * * `BSDTimeout` - BSD timeout
   * * `BSMTimeout` - BSM timeout
   * * `CHAdeMoCodeWaitJ3TimeOut` - Waiting for vehicle-side Switch = ON timeout. Vehicle-side malfunction
   * * `CHAdeMoCodeDCVoltExceed10V` - DC bus voltage exceeds 10V before charging. Bus has voltage or vehicle-side malfunction
   * * `CHAdeMoCodeJ3StatusErr` - Vehicle-side Switch status error. Vehicle-side malfunction
   * * `CHAdeMOCodeEvReadyStatusErr` - Vehicel-side readiness status error. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitEVSEOutVoltErr` - Waiting for output voltage timeout
   * * `CHAdeMOCodeDCVoltExceed20V` - Insulation check completed voltage anomaly after discharge
   * * `CHAdeMOCodeCommunicationTimeOut` - Vehicle-side CAN communication timeout
   * * `CHAdeMOCodeWaitCAN10XTimeOut` - Waiting for vehicle-side CAN communication timeout at beginning of charging. Vehicle malfunction
   * * `CHAdeMOCodeWaitEVCurrentReqTimeOut` - Waiting for current request failed. VEhicle-side malfunction
   * * `CHAdeMOCodeWaitEVContadorTimeOut` - Waiting for vehicle-side contacdt closure failed. Vehicle-side malfunction
   * * `CHAdeMOCodeDCVoltExceed10VNormalEnd` - Abnormal discharge at the end of charging. Vehicle-side malfunction
   * * `CHAdeMOCodeCommunicationOpenTimeOut` - Waiting for the vehicle to disconnect communication timeout after charging ends. Vehicle-side malfunction
   * * `CHAdeMOCodeChargingSystemFault` - Vehicle-side reported charging system error. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOverVoltage` - Output voltage abnormal. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOvercurrent` - Output current abnormal.
   * * `CHAdeMOCodeBatterPolarity` - Battery polarity error
   * * `CHAdeMOCodeEVSEIsolationStatusFail` - Insulation fault error
   * * `CHAdeMOCodeMalfunctionDetectionFail` - Charging plug electromagnetic lock failed to lock. Charging cable electromagnetic lock malfunction
   * * `CHAdeMOCodeCANInitFail` - CCAN initialization failed. Board malfunction
   * * `CHAdeMOCodeVehicleShiftPositionStop` - Vehicle-side Vehicle_shift_position stops. Issue on the vehicle side
   * * `CHAdeMOCodeWaitJ3OpenErr` - Waiting for vehicle-side Switch = OFF timeout. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitCommunicationCloseTimeOut` - Wait for communication closure anomaly. Vehicle-side malfunction
   * * `CHAdeMOCodeBEforeChargeJ3StatusErr` - Switch status abnormal before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeTargetBatterVoltageErr` - EEV target battery voltage abnormal. Vehiccle-side malfunction
   * * `CHAdeMOCodeBatteryInccompatibilityErr` - EV battery mismatch. Vehicle-side mismatch
   * * `CHAdeMOCodeRequestCurrentErr` - Current request failed. Vehicle-side malfunction
   * * `CHAdeMOCodeMinimumCurrentErr` - Minimum current error. Vehicle-side malfunction
   * * `CHAdeMOCodeNormalStopRequestBefoeCharging` - Vehicle-side requests to stop before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeRemainingChargingTimeIsZero` - Remaining charging time is 0. Charging stopped
   * * `CHAdeMOCodeWaitPowerReadyTimeout` - Waiting for the power module to be ready exceeded timeout. Power module anomaly
   * * `CHAdeMOCodeVehicleCChargingEnable` - Vehicle-side 'Vehicle_charging_enabled' status error. Vehicle-side malfunction
   * * `CHAdeMOCodeCurrent5AOrLess` - Waiting dot charging to end and current to drop below 5A exceeded timeout. Power module or current detection issue
   * * `CHAdeMOCodeEVErrorCanid1024A` - Vehicle-side reported 102.4 error stop. Vehicle-side malfunction
   * * `CHAdeMOCodeEVErrorCanid10240` - Vehicle-side reported: Battery_Overvoltage
   * * `CHAdeMOCodeEVErrorCanid10241` - Vehicle-side reported: Battery_Undervoltage
   * * `CHAdeMOCodeEVErrorCanid1024` - Vehicle-side reported: Battery_Current_deviation_Error
   * * `CHAdeMOCodeEVErrorCanid10243` - Vehicle-side reported: Battery_High_Temperature
   * * `CHAdeMOCodeEVErrorCanid10244` - Vehicle-side reported: Battery_Voltage_Deviation_Error
   * * `CHAdeMOCodeOther` - Cannot use if not matched, try not to use it
   * * `CCSStopCodePlugOut` - Detected that the charging plug was remover during charging. CP immediately changes to 12v
   * * `CCSStopCodeReadyToChargePerformanceTimeOut` - Waiting to start charging timeout
   * * `CCSStopCodeCommEVSessionStop` - Vehicle-side sent Session stop for normal termination
   * * `CCSStopCodeEVSEIsolationStatusFail` - Stopped due to isulation fault
   * * `CCSStopCodeEVTargetVoltageFail` - Vehicle-side demanded coltage exceeds the maximum allowable voltage for for the vehicle
   * * `CCSStopCodeEVTargetCurrentFail` - Vehicle-side demanded voltage  exceeds the maximum allowable current for the vehicle
   * * `CCSStopCodeEVSEPresentVoltageFail` - DC output over-voltage
   * * `CCSStopCodeEVSEPresentCurrentFail` - DC output overcurrent
   * * `CCSStopCodeCPFail` - CP voltage abnormal, exceeds 6v, 9v with a tolerance of plus or minus 0.8V
   * * `CCSStopCodeEVSEBatterPolarityFail` - BAttery polarity reversed
   * * `CCSStopCodeEvseChargeBeforeOvervoltageFail` - Overvoltage before charging
   * * `CCSStopCodeEvseChargeInsulationAfterOvervoltageFail` - Overvoltage after insulation charge
   * * `CSSStopCodeEVSEUndervoltage` - Output undervoltage
   * * `CCSStopCodeOngoingPerformanceTimeout` - WAiting for charging permission timeout
   * * `CCSStopCodePDVoltAlarm` - American standard plug PD detection error; not applicable for European Standar
   * * `CCSStopCodeOther` - not matched, try not to use
   * * `V2GFailed` - V2G failed
   * * `V2GFailedSequenceError` - V2G failed sequence error
   * * `V2GFailedServiceIdInvalid` - V2G failed service id invalid
   * * `V2GFailedUnknownSession` - V2G failed unknow session
   * * `V2GFailedServiceSelectionInvalid` - V2G failed service selection invalid
   * * `V2GFailedPaymentSelectionInvelid` - V2G failed payment selection invalid
   * * `V2GFailedCertificateExpired` - V2G failed certificate expired
   * * `V2GFailedSignatureError` - V2G failed signature error
   * * `V2GFailedNoCertificateAvailable` - V2G failed no certificate available
   * * `V2GFailedCertChainError` - V2G failed cert chain error
   * * `V2GFailedChallengeInvalid` - V2G failed challenge invalid
   * * `V2GFailedContractCanceled` - V2G failed contract canceled
   * * `V2GFailedWrongChargeParameter` - V2G failed wrong charge parameter
   * * `V2GFailedPowerDeliveryNotApplied` - V2G failed power delivery not applied
   * * `V2GFailedTariffSelectionInvalid` - V2G failed tariff selection invalid
   * * `V2GFailedChargingProfileInvalid` - V2G failed charging profile invalid
   * * `V2GFailedEVSEPresentVoltToLow` - V2G failed EVSE present volt to low
   * * `V2GFailedMeteringsignatureNotValid` - V2G failed metering signature not velid
   * * `V2GFailedWrongEnergyTranferType` - V2G failed wrong energy transfer type
   * * `V2GFailedAppHandResponse` - V2G failed app hand response code type failed no negotiation
   * * `V2GInitErrorQCA7000` - V2G inir error QCA 7000
   * * `V2GInitErrorOther` - V2G init error other
   * * `V2GInitErrorGeneral` - V2G init error general
   * * `V2GInitErrorIfaddr` - V2G init error ifaddr
   * * `V2GInitErrorThread` - V2G init error thread
   * * `V2GInitErrorOpenchannel` - V2G init error openchannel
   * * `V2GInitErrorKey` - V2G init error key
   * * `V2GSlacErrorGeneral` - V2G slac error general
   * * `V2GSlacErrorTimerInit` - V2G slac error timer init
   * * `V2GSlacErrorTimerTimeout` - V2G slac error timer timeout
   * * `V2GSlacErrorTimerMisc` - V2G slac error timer misc
   * * `V2GSlacErrorParamTimeout` - V2G slac error param timeout
   * * `V2GSlacErrorParamSocket` - V2G slac error param socket
   * * `V2GSlacErrorStartAttenCharTimeout` - V2G slac error start atten char timeout
   * * `V2GSlacErrorMNBCSoundTimeout` - V2G slac error MNBC sound timeout
   * * `V2GSlacErrorAttenCharTimeout` - V2G slac error atten char timeout
   * * `V2GSlacErrorAttenCharSocket` - V2G slac error atten char Socket
   * * `V2GSlacErrorValidate1Timeout` - V2G slac error validate 1 timeout
   * * `V2GSlacErrorValidate1Socket` - V2G slac error validate 1 socket
   * * `V2GSlacErrorValidate2Timeout` - V2G slac error validate 2 timeout
   * * `V2GSlacErrorValidate2Socket` - V2G slac error validate 2 socket
   * * `V2GSlacErrorBCBToggleTimeout` - V2G slac error BCB toggle timeout
   * * `V2GSlacErrorMatchTimeout` - V2G slac error match timeout
   * * `V2GSlacErrorMatchSocket` - V2G slac error match Socket
   * * `V2GSlacErrorReadSocket` - V2G slac error read Socket
   * * `V2GSlacErrorSetKey` - V2G slac error set key
   * * `V2GSlacErrorLinkTimeout` - V2G slac error link timeout
   * * `V2GSDPErrorGeneral` - V2G SDP error general
   * * `V2GSDPErrorInitSocket` - V2G SDP error init socket
   * * `V2GSDPErrorInitSockOPT1` - V2G SDP error init sockotp1
   * * `V2GSDPErrorInitSockOPT2` - V2G SDP error init sockotp2
   * * `V2GSDPErrorInitBind` - V2G SDP error init bind
   * * `V2GSDPErrorThreadSocket1` - V2G SDP error thread docket 1
   * * `V2GSDPErrorThreadSocket2` - V2G SDP error thread docket 2
   * * `V2GSDPErrorTimeout` - V2G SDP error timeout
   * * `V2GSDPErrorTCPDisconnected` - V2G SDP error tcp disconnected
   * * `V2GDinErrorGeneral` - V2G DIN error general
   * * `V2GDinErrorInitSocket` - V2G DIN error init socket
   * * `V2GDinErrorInitSockOPT` - V2G DIN error init sockOPT
   * * `V2GDinErrorInitBind` - V2G DIN error init bind
   * * `V2GDinErrorInitListen` - V2G DIN error init listen
   * * `V2GDinErrorInitSelect` - V2G DIN error init select
   * * `V2GDinErrorInitAccept` - V2G DIN error init accept
   * * `V2GDinErrorTimeout` - V2G DIN error timeout
   * * `V2GDinErrorV2GTPHeader` - V2G DIN error V2GTP header
   * * `V2GDinErrorV2GTPHeaderLen` - V2G DIN error V2GTP header Len
   * * `V2GDinErrorV2GTPHeaderWrite` - V2G DIN error V2GTP header write
   * * `V2GDinErrorDecodeExi` - V2G DIN error Decode Exi
   * * `V2GDinErrorEncodeExi` - V2G DIN error Encode Exi
   * * `V2GDinErrorCreateResponse` - V2G DIN error create response
   * * `V2GDinErrorSocketException` - V2G DIN error socket exception
   * * `V2GDinErrorSocketSend` - V2G DIN error socket send
   * * `V2GDinErrorNoProtocol` - V2G DIN error no protocol
   */
  verbose_error?: VerboseErrorEnum;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  connector?: number;
}

/** Theme Serializer */
export interface PatchedTheme {
  id?: number;
  /** @format uri */
  logo?: string;
  /** @format uri */
  favicon?: string;
  /** @maxLength 50 */
  name?: string;
  active?: boolean;
  /** @maxLength 50 */
  title?: string;
  /**
   * Color
   * #F5DD5D
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  title_color?: string;
  /** Visible */
  title_visible?: boolean;
  /**
   * Color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  logo_color?: string;
  /**
   * Max width
   * @min 0
   * @max 32767
   */
  logo_max_width?: number;
  /**
   * Max height
   * @min 0
   * @max 32767
   */
  logo_max_height?: number;
  /** Visible */
  logo_visible?: boolean;
  /**
   * Name
   * @maxLength 50
   */
  env_name?: string;
  /**
   * Color
   * (red: #E74C3C, orange: #E67E22, yellow: #F1C40F, green: #2ECC71, blue: #3498DB)
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  env_color?: string;
  /** Visible in header (marker and name) */
  env_visible_in_header?: boolean;
  /** Visible in favicon (marker) */
  env_visible_in_favicon?: boolean;
  /** Active */
  language_chooser_active?: boolean;
  /** Control */
  language_chooser_control?: LanguageChooserControlEnum;
  /** Display */
  language_chooser_display?: LanguageChooserDisplayEnum;
  /**
   * Background color
   * #0C4B33
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_background_color?: string;
  /**
   * Text color
   * #44B78B
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_text_color?: string;
  /**
   * Link color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_link_color?: string;
  /**
   * Link hover color
   * #C9F0DD
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_link_hover_color?: string;
  /**
   * Background color
   * #44B78B
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_background_color?: string;
  /**
   * Background selected color
   * #FFFFCC
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_background_selected_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_text_color?: string;
  /**
   * Link color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_color?: string;
  /**
   * Link selected color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_selected_color?: string;
  /**
   * Link hover color
   * #C9F0DD
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_hover_color?: string;
  /** Rounded corners */
  css_module_rounded_corners?: boolean;
  /**
   * Link color
   * #0C3C26
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_color?: string;
  /**
   * Link hover color
   * #156641
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_hover_color?: string;
  /**
   * Link active color
   * #29B864
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_active_color?: string;
  /**
   * Background color
   * #0C4B33
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_background_color?: string;
  /**
   * Background hover color
   * #0C3C26
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_background_hover_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_text_color?: string;
  /**
   * Background color
   * #BA2121
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_background_color?: string;
  /**
   * Background hover color
   * #A41515
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_background_hover_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_text_color?: string;
  /** Active */
  related_modal_active?: boolean;
  /**
   * Background color
   * #000000
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  related_modal_background_color?: string;
  /**
   * Background opacity
   * 20%
   *
   * * `0.1` - 10%
   * * `0.2` - 20%
   * * `0.3` - 30%
   * * `0.4` - 40%
   * * `0.5` - 50%
   * * `0.6` - 60%
   * * `0.7` - 70%
   * * `0.8` - 80%
   * * `0.9` - 90%
   */
  related_modal_background_opacity?: RelatedModalBackgroundOpacityEnum;
  /** Rounded corners */
  related_modal_rounded_corners?: boolean;
  /** Close button visible */
  related_modal_close_button_visible?: boolean;
  /** Highlight active */
  list_filter_highlight?: boolean;
  /** Use dropdown */
  list_filter_dropdown?: boolean;
  /** Sticky position */
  list_filter_sticky?: boolean;
  /** Quick remove links for active filters at top of sidebar */
  list_filter_removal_links?: boolean;
  foldable_apps?: boolean;
  /** Fieldsets as tabs */
  show_fieldsets_as_tabs?: boolean;
  /** Inlines as tabs */
  show_inlines_as_tabs?: boolean;
  collapsible_stacked_inlines?: boolean;
  collapsible_stacked_inlines_collapsed?: boolean;
  collapsible_tabular_inlines?: boolean;
  collapsible_tabular_inlines_collapsed?: boolean;
  /** Visible */
  recent_actions_visible?: boolean;
  /** Sticky submit */
  form_submit_sticky?: boolean;
  /** Sticky pagination */
  form_pagination_sticky?: boolean;
}

/** Tracker Serializer */
export interface PatchedTracker {
  /**
   * @maxLength 16
   * @pattern ^[0-9]{15}$
   */
  imei?: string;
  /**
   * @min 0
   * @max 2147483647
   */
  heartbeat_interval?: number;
  /**
   * @min 1
   * @max 2147483647
   */
  record_interval?: number;
  serial_protocol?: SerialProtocolEnum | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  overflow_management?: boolean;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable as External Integration */
  external_integration?: boolean;
  /** @maxLength 15 */
  geotab_id?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  track_unit_id?: number | null;
  /**
   * Volvo ID (VIN)
   * @maxLength 17
   */
  volvo_id?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  vehicle?: string;
  latest_heartbeat?: number | null;
}

/** Tracker Log Serializer */
export interface PatchedTrackerLog {
  type?: GisFeatureEnum;
  id?: number;
  geometry?: {
    type?: 'Point';
    /**
     * @maxItems 3
     * @minItems 2
     * @example [12.9721,77.5933]
     */
    coordinates?: number[];
  };
  properties?: {
    vehicle?: string;
    samples?: TrackerSample[];
    /** @format date-time */
    timestamp?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    altitude?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
     */
    angle?: string;
    /**
     * @min 0
     * @max 2147483647
     */
    satellites?: number;
    /**
     * * `InStation` - In Station
     * * `OnRoute` - On Route
     * * `Charging` - Charging
     */
    place?: 'InStation' | 'OnRoute' | 'Charging';
    process?: boolean;
    tracker?: string;
    /** Latest Vehicle Station */
    latest_station?: number | null;
    path?: number | null;
  };
}

/** Tracker Path Serializer */
export interface PatchedTrackerPath {
  id?: number;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * Remaining Kilometer at Start
   * @min 0
   * @max 32767
   */
  rk_start?: number | null;
  /**
   * Remaining Kilometer at Stop
   * @min 0
   * @max 32767
   */
  rk_stop?: number | null;
  /**
   * Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_start?: string | null;
  /**
   * Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_stop?: string | null;
  /**
   * Virtual Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_start?: string | null;
  /**
   * Virtual Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_stop?: string | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Carbon Avoided (g)
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  co2_avoided?: string | null;
  vehicle?: string;
  /** Station at Start */
  station_start?: number;
  /** Station at Stop */
  station_stop?: number | null;
}

/** Tracker Sample Serializer */
export interface PatchedTrackerSample {
  id?: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  value?: string;
  /** @format date-time */
  timestamp?: string | null;
  /**
   * * `GPS` - GPS
   * * `Serial` - Serial
   * * `IO-data` - IO-data
   * * `External` - External
   */
  source?: SourceEnum;
  /**
   * * `Velocity` - Velocity
   * * `RPM` - Rpm
   * * `RPM2` - Rpm2
   * * `SOC` - Soc
   * * `Odometer` - Odometer
   * * `Virtual Odometer` - Virtual Odometer
   * * `Tachometer` - Tachometer
   * * `Battery Current` - Battery Current
   * * `Battery Voltage` - Battery Voltage
   * * `Remaining Kilometers` - Remaining Kilometer
   * * `Trip Counter` - Trip Counter
   * * `Acceleration Pedal` - Acceleration Pedal
   * * `Gear Shift` - Gear Shift
   * * `Ignition Contact` - Ignition Contact
   * * `Breake Pedal` - Breake Pedal
   * * `Air Conditioner` - Air Conditioner
   * * `Fan` - Fan
   * * `Regeneration` - Regeneration
   * * `Regeneration Level` - Regeneration Level
   * * `Temperature` - Temperature
   * * `Minimum Battery Temperature` - Min Battery Temp
   * * `Maximum Battery Temperature` - Max Battery Temp
   * * `Cumulative Moving Hours` - Cumulative Moving Hours
   * * `Cumulative Operating Hours` - Cumulative Operating Hours
   */
  measurand?: TrackerSampleMeasurandEnum;
  /** TrackerLog */
  log?: number;
}

/** A serializer for receiving a credit_card_id */
export interface PatchedTransactionRequestPatchCreditCard {
  credit_card_id?: number;
}

/** User Serializer Class */
export interface PatchedUser {
  id?: number;
  /** Profile Serializer Class */
  profile?: Profile;
  credit_cards?: CreditCard[];
  groups?: string[];
  /** @format email */
  username?: string;
  /** @format date-time */
  last_login?: string | null;
  /**
   * Superuser status
   * Designates that this user has all permissions without explicitly assigning them.
   */
  is_superuser?: boolean;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /**
   * Staff status
   * Designates whether the user can log into this admin site.
   */
  is_staff?: boolean;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  is_active?: boolean;
  /** @format date-time */
  date_joined?: string;
}

/** User Group Serializer */
export interface PatchedUserGroup {
  id?: number;
  /** @maxLength 32 */
  name?: string;
  profiles?: string[];
  profiles_count?: number;
  contracts?: number[];
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
}

/** Vehicle Serializer */
export interface PatchedVehicle {
  /**
   * @maxLength 10
   * @pattern ^[A-Z0-9]{1,10}$
   */
  number_plate?: string;
  /** Tracker Log Serializer */
  latest_tracker_log?: TrackerLog;
  /** Transaction Simple Serializer (without Vehicle) */
  latest_transaction?: TransactionSimple;
  /**
   * Vehicle Verbose Name
   * @maxLength 10
   */
  verbose_name?: string | null;
  /**
   * Vehicle Identification Number
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin?: string | null;
  /**
   * Vehicle Identification Number 2
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin2?: string | null;
  /** @maxLength 64 */
  brand?: string | null;
  /** @maxLength 64 */
  model?: string | null;
  /**
   * * `Sedan` - Sedan
   * * `Van` - Van
   * * `Bus` - Bus
   * * `Truck` - Truck
   */
  class_type?: ClassTypeEnum;
  /**
   * Nominal Range in km
   * @min 0
   * @max 2147483647
   */
  nominal_range?: number;
  /**
   * Consumption in Wh/km
   * @min 0
   * @max 2147483647
   */
  consumption?: number;
  /**
   * Battery Nominal Capacity in Wh
   * @min 0
   * @max 2147483647
   */
  battery_nominal_capacity?: number | null;
  /**
   * Carbon Footprint of equivalent Internal Combustion Engine Vehicle in gCO2/km
   * @min 0
   * @max 2147483647
   */
  co2eqIC?: number;
  /** Use VIN as ID TAG */
  vin_as_id_tag?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_soc?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_odometer?: string | null;
  /**
   * Latest Remaing Kilometers
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_remaing_km?: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,3})?$
   */
  latest_temperature?: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  /**
   * @min 0
   * @max 32767
   */
  low_soc_threshold?: number;
  /** Has Low SoC Notification been sent? */
  low_soc_notification_sent?: boolean;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  fleet?: number;
}

/** Vehicle Station Serializer */
export interface PatchedVehicleStation {
  type?: GisFeatureEnum;
  id?: number;
  geometry?: {
    type?: 'Polygon';
    /** @example [[[0,0],[0,50],[50,50],[50,0],[0,0]]] */
    coordinates?: number[][][];
  };
  properties?: {
    /** @maxLength 64 */
    name?: string;
    fleets?: number[];
  };
}

/** ModelSerializer for PaymentAuthorization */
export interface PaymentAuthorization {
  id: number;
  gross_amount: string;
  net_amount: string;
  /** @maxLength 32 */
  payment_ticket_id: string;
  /** @maxLength 64 */
  kushki_transaction_reference: string;
  /** Payment Status */
  status?: Status9DcEnum | null;
}

/**
 * * `Waiting` - Waiting
 * * `Pending` - Pending
 * * `Processing` - Processing
 * * `Success` - Success
 * * `Partial` - Partial
 * * `Failed` - Failed
 * * `Void` - Void
 * * `Error` - Error
 * * `Min Price` - Min Price
 */
export enum PaymentStatusEnum {
  Waiting = 'Waiting',
  Pending = 'Pending',
  Processing = 'Processing',
  Success = 'Success',
  Partial = 'Partial',
  Failed = 'Failed',
  Void = 'Void',
  Error = 'Error',
  MinPrice = 'Min Price',
}

/** Serializer for table shown in module Sales->Collections */
export interface PaymentTable {
  id: number;
  gross_amount: string;
  net_amount: string;
  gross_price: string;
  net_price: string;
  payment_type: PaymentTypeEnum;
  user_group_name: string;
  erp_name: string;
  erp_invoice_id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @maxLength 32 */
  payment_ticket_id: string;
  /** @maxLength 64 */
  kushki_transaction_reference: string;
  transaction: number;
}

export enum PaymentTypeEnum {
  Payment = 'Payment',
  Void = 'Void',
}

/**
 * * `L1` - L1
 * * `L2` - L2
 * * `L3` - L3
 * * `N` - N
 * * `L1-N` - L1-N
 * * `L2-N` - L2-N
 * * `L3-N` - L3-N
 * * `L1-L2` - L1-L2
 * * `L2-L3` - L2-L3
 * * `L3-L1` - L3-L1
 */
export enum PhaseEnum {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  N = 'N',
  L1N = 'L1-N',
  L2N = 'L2-N',
  L3N = 'L3-N',
  L1L2 = 'L1-L2',
  L2L3 = 'L2-L3',
  L3L1 = 'L3-L1',
}

/**
 * * `NoPlug` - No Plug
 * * `CCS1` - Ccs1
 * * `CCS2` - Ccs2
 * * `CHAdeMO` - CHAdeMO (Type 4)
 * * `GB/T DC` - Gbt Dc
 * * `Tesla` - Tesla
 * * `GB/T AC` - Gbt Ac
 * * `J1772` - J1772 (Type 1)
 * * `Mennekes` - Mennekes (Type 2)
 */
export enum PlugTypeEnum {
  NoPlug = 'NoPlug',
  CCS1 = 'CCS1',
  CCS2 = 'CCS2',
  CHAdeMO = 'CHAdeMO',
  GBTDC = 'GB/T DC',
  Tesla = 'Tesla',
  GBTAC = 'GB/T AC',
  J1772 = 'J1772',
  Mennekes = 'Mennekes',
}

/** Power Serializer */
export interface Power {
  /**
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  power: string;
}

/** Power Category Serializer */
export interface PowerCategory {
  id: number;
  /** Category */
  name: NameEnum;
  /** @maxLength 50 */
  verbose_name?: string | null;
  /**
   * MIN POWER (W)
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  min_power: string;
  /**
   * MAX POWER (W)
   * @format decimal
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  max_power: string;
}

/**
 * * `Slow` - Slow
 * * `Intermediate` - Intermediate
 * * `Fast` - Fast
 * * `Ultra_Fast` - Ultra_Fast
 */
export enum PowerCategory777Enum {
  Slow = 'Slow',
  Intermediate = 'Intermediate',
  Fast = 'Fast',
  UltraFast = 'Ultra_Fast',
}

/**
 * * `Slow` - Slow
 * * `Intermediate` - Intermediate
 * * `Fast` - Fast
 * * `Ultra_Fast` - Ultra Fast
 */
export enum PowerCategoryEb2Enum {
  Slow = 'Slow',
  Intermediate = 'Intermediate',
  Fast = 'Fast',
  UltraFast = 'Ultra_Fast',
}

/** PricingDetail Serializer */
export interface PricingDetail {
  id: number;
  gross_price: string;
  net_price: string;
  gross_price_per_unit: string;
  net_price_per_unit: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop: string;
  /**
   * Pricing Detail Range
   * @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"}
   */
  tsrange: TsRange;
  /**
   * * `PER_MINUTE` - Per Minute
   * * `PER_KWH` - Per kWh
   */
  contract_kind: ContractKind4D9Enum;
  /**
   * * `Slow` - Slow
   * * `Intermediate` - Intermediate
   * * `Fast` - Fast
   * * `Ultra_Fast` - Ultra Fast
   */
  power_category: PowerCategoryEb2Enum;
  /**
   * * `FLAT_RATE` - Flat Rate
   * * `PEAK_RATE` - Peak Rate
   * * `OFF_PEAK_RATE` - Off-peak Rate
   */
  contract_period_verbose_name?: ContractPeriodVerboseNameEnum;
  transaction: number;
}

/** Profile Serializer Class */
export interface Profile {
  user: number;
  /** @format uri */
  image?: string;
  spot_user_groups?: ProfileSpotUserGroup[];
  deferred_user_groups?: ProfileDeferredUserGroup[];
  /**
   * * `en-us` - English
   * * `es` - Spanish
   */
  language?: LanguageEnum;
  unseen_notifications_count: number;
  /** Time zone */
  timezone?: TimezoneEnum | null;
  /** @maxLength 255 */
  startpage?: string | null;
  document_type?: DocumentTypeAbeEnum | null;
  /** @maxLength 64 */
  document_number?: string | null;
  /** @maxLength 64 */
  second_last_name?: string | null;
  /** @maxLength 64 */
  phone_number?: string | null;
  /**
   * End-user license agreement
   * @format date-time
   */
  eula?: string | null;
  email_validated?: boolean;
  /** @maxLength 64 */
  google_userid?: string | null;
  /** @maxLength 64 */
  apple_userid?: string | null;
  is_mobile?: boolean;
  is_google_auth?: boolean;
  assets?: number[];
  fleets?: number[];
}

/** Serializer for M2M between Profile and DeferredUserGroup */
export interface ProfileDeferredUserGroup {
  id: number;
  user_group: number;
  /** @default false */
  default?: boolean;
  profile: number;
}

/** Serializer for M2M between Profile and SpotUserGroup */
export interface ProfileSpotUserGroup {
  id: number;
  user_group: number;
  /** @default false */
  default?: boolean;
  profile: number;
}

/** Public key serializer */
export interface PublicKey {
  kushki_public_key: string;
  test_environment: boolean;
}

export interface PushDeviceToken {
  token: string;
}

export interface PushSubscriptionCreateDelete {
  action_code: string;
  token: string;
}

/**
 * * `EmergencyStop` - EmergencyStop
 * * `EVDisconnected` - EVDisconnected
 * * `HardReset` - HardReset
 * * `Local` - Local
 * * `Other` - Other
 * * `PowerLoss` - PowerLoss
 * * `Reboot` - Reboot
 * * `Remote` - Remote
 * * `SoftReset` - SoftReset
 * * `UnlockCommand` - UnlockCommand
 * * `DeAuthorized` - DeAuthorized
 */
export enum ReasonStopEnum {
  EmergencyStop = 'EmergencyStop',
  EVDisconnected = 'EVDisconnected',
  HardReset = 'HardReset',
  Local = 'Local',
  Other = 'Other',
  PowerLoss = 'PowerLoss',
  Reboot = 'Reboot',
  Remote = 'Remote',
  SoftReset = 'SoftReset',
  UnlockCommand = 'UnlockCommand',
  DeAuthorized = 'DeAuthorized',
}

/**
 * * `Daily` - Daily
 * * `Weekly` - Weekly
 */
export enum RecurrencyKindEnum {
  Daily = 'Daily',
  Weekly = 'Weekly',
}

/**
 * * `Accepted` - Accepted
 * * `Pending` - Pending
 * * `Rejected` - Rejected
 */
export enum RegistrationStatusEnum {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export enum ChargeStatusEnum {
  Accepted = 'Accepted',
  Failed = 'Failed',
  Rejected = 'Rejected',
}

/**
 * * `0.1` - 10%
 * * `0.2` - 20%
 * * `0.3` - 30%
 * * `0.4` - 40%
 * * `0.5` - 50%
 * * `0.6` - 60%
 * * `0.7` - 70%
 * * `0.8` - 80%
 * * `0.9` - 90%
 */
export enum RelatedModalBackgroundOpacityEnum {
  Value01 = '0.1',
  Value02 = '0.2',
  Value03 = '0.3',
  Value04 = '0.4',
  Value05 = '0.5',
  Value06 = '0.6',
  Value07 = '0.7',
  Value08 = '0.8',
  Value09 = '0.9',
}

/** Reservation Serializer */
export interface Reservation {
  id: number;
  sync_task_id: string;
  sync_status: string;
  user: number;
  /** @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"} */
  tsrange: TsRange;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  connector: number;
  /** TransactionRequest */
  transaction_request?: number | null;
}

/** Reservation Basic Serializer (no data about User or Transaction) */
export interface ReservationBasic {
  connector: number;
  /** @example {"lower":"2023-07-12T20:23:34.910Z","upper":"2023-07-12T20:23:34.910Z","bounds":"[)"} */
  tsrange: TsRange;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface ResetToken {
  token: string;
}

/** Reset Type Serializer */
export interface ResetType {
  /**
   * * `Hard` - Hard
   * * `Soft` - Soft
   */
  type: ResetTypeEnum;
}

/**
 * * `Hard` - Hard
 * * `Soft` - Soft
 */
export enum ResetTypeEnum {
  Hard = 'Hard',
  Soft = 'Soft',
}

/** Response Serializer */
export interface Response {
  /** @maxLength 64 */
  detail?: string;
  /** @maxLength 37 */
  task_id?: string;
}

/** Sampled Value Serializer */
export interface SampledValue {
  id: number;
  connector: number;
  /** @format date-time */
  timestamp: string;
  /** @maxLength 255 */
  value: string;
  /**
   * * `Interruption.Begin` - Interruption.Begin
   * * `Interruption.End` - Interruption.End
   * * `Other` - Other
   * * `Sample.Clock` - Sample.Clock
   * * `Sample.Periodic` - Sample.Periodic
   * * `Transaction.Begin` - Transaction.Begin
   * * `Transaction.End` - Transaction.End
   * * `Trigger` - Trigger
   */
  context?: ContextEnum;
  /**
   * * `Raw` - Raw
   * * `SignedData` - SignedData
   */
  value_format?: ValueFormatEnum;
  /** @default "Energy.Active.Import.Register" */
  measurand?: Measurand2D5Enum;
  phase?: PhaseEnum | null;
  /**
   * * `Inlet` - Inlet
   * * `Outlet` - Outlet
   * * `Body` - Body
   * * `Cable` - Cable
   * * `EV` - EV
   */
  location?: LocationEnum;
  /** Unit Of Measure */
  unit?: UnitEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  meter_value: number;
}

/** * `Belectronics` - Belectronics */
export enum SerialProtocolEnum {
  Belectronics = 'Belectronics',
}

export interface SessionSDM {
  id: string;
  /** @format date-time */
  start_date_time: string;
  /** @format date-time */
  end_date_time: string;
  /** @format float */
  kwh: number | null;
  location_id: string;
  evse_id: string;
  connector_id: string;
  status: string;
}

/**
 * * `GPS` - GPS
 * * `Serial` - Serial
 * * `IO-data` - IO-data
 * * `External` - External
 */
export enum SourceEnum {
  GPS = 'GPS',
  Serial = 'Serial',
  IOData = 'IO-data',
  External = 'External',
}

/**
 * * `Success` - Success
 * * `Failed` - Failed
 * * `Finished` - Finished
 * * `Uncaptured` - Uncaptured
 */
export enum Status9DcEnum {
  Success = 'Success',
  Failed = 'Failed',
  Finished = 'Finished',
  Uncaptured = 'Uncaptured',
}

/**
 * * `Online` - Online
 * * `Offline` - Offline
 * * `Waiting` - Waiting
 * * `Disabled` - Disabled
 */
export enum StatusCb8Enum {
  Online = 'Online',
  Offline = 'Offline',
  Waiting = 'Waiting',
  Disabled = 'Disabled',
}

/** Status Notification Serializer */
export interface StatusNotification {
  id: number;
  /** Charge Point Error Code */
  error_code: ErrorCodeEnum;
  /**
   * Information Related to the Error
   * @maxLength 51
   */
  info?: string | null;
  /** Charge Point Status */
  status: ChargePointStatusEnum;
  /** @format date-time */
  timestamp?: string;
  /** @maxLength 256 */
  vendor_id?: string | null;
  /** @maxLength 51 */
  vendor_error_code?: string | null;
  /**
   * * `Error not interpreted` - Not Interpreted
   * * `UpdateFail` - Fail to update software
   * * `ResetFailure` - Fail to reset
   * * `GunTemperature` - Gun over-temperature
   * * `TrialPeriodOver` - The trial period is over
   * * `EmergencyStop` - Emergency stop
   * * `BleederResistor` - Bleeder resistor failure
   * * `Insulation` - Insulation failure (several times)
   * * `OpenDoor` - Open door
   * * `MeterFault` - Meter failure
   * * `BEMAlarmStop` - BEM alarm stop
   * * `BSMMessage` - BSM message
   * * `BROFault` - BRO fault
   * * `OuterVoltageRelay` - Outer voltage relay
   * * `BRMTimeOut` - BRM timeout
   * * `BCPTimeOut` - BCP timeout
   * * `BROTimeOut` - BRO timeout
   * * `BCLTimeOut` - BCL timeout
   * * `BSTTimeOut` - BST timeout
   * * `BSDTimeOut` - BSD timeout
   * * `BSMInsulation` - BSM insulation fault
   * * `BMSOutputTemperature` - BMS output over-temperature
   * * `BMSComponentTemperature` - BMS component over-temperature
   * * `BMSBatteryOverTemperature` - BMS Battery over-temperature
   * * `BMSHighCurrent` - BMS over current
   * * `BMSVoltageAbnormality` - BMS Voltage Abnormality
   * * `BMSOtherErrors` - BMS Other Errors
   * * `PowerModuleCommunicationFault` - Power Module Communication Fault
   * * `InputOverVoltage` - Input Over Voltage
   * * `InputUnderVoltage` - Input Under Voltage
   * * `GenericError` - Generic Error
   * * `MainsPowerSupply` - Mains Power Supply Failure
   * * `TemperatureOutOfRange` - Temperature out of range
   * * `InternalComunicationsError` - Internal communications error
   * * `ConfigurationError` - Configuration Error
   * * `MainsGroundFailure` - Mains ground failure
   * * `MainsVoltageOutOfRange` - Mains voltage out of range
   * * `MainsFrequencyOutOfRange` - Mains Frequency out of range
   * * `HighTemperatureError` - High temperature error
   * * `LowTemperatureError` - Low temperature error
   * * `ExternalComunicationsError` - External communications error
   * * `ErrorMasterEntity` - Error in master entity
   * * `SlaveError` - Error in slave entity
   * * `DoorTamperAlarm` - Door Tamper Error
   * * `TiltError` - Tilt error
   * * `DisplayFailure` - Display Failure
   * * `RfidReaderFailure` - RFID reader failure
   * * `PowerMeterFailure` - Power Meter Comunication Error
   * * `GenericVehicleError` - Generic Vehicle Error
   * * `VehicleComunicationError` - Vehicle Comunication Error
   * * `VehicleNotDetected` - Vehicle not detected
   * * `VehicleOverCurrent` - Vehicle over current consumption
   * * `CordMalfunction` - Cord malfunction
   * * `CordSensorMalfunction` - Cord sensor malfunction
   * * `ConnectorLockFailure` - Connector Lock Failure
   * * `InternalPowerSupplyFailure` - Internal power supply failure
   * * `ComponentTemperatureOutRange` - Component temperature out of range
   * * `HardwareFailureMode4` - Hardware Failure Mode4
   * * `HardwareFailureNodes` - Hardware Failure Nodes
   * * `AcDcConvertersGenericError` - AC/DC converters Error
   * * `AcDcConvertersTimeOutError` - AC/DC converters time out Error
   * * `AcDcConvertersVoltageOutRange` - AC/DC converters voltage out of range
   * * `AcDcConvertersCurrentOutRange` - AC/DC converters current out of range
   * * `WeldingContactor` - Welding Contactor
   * * `CurrentLeakDetected` - Current Leak Detected
   * * `ElectricalProtectionTriggered` - Electrica Protection Triggered
   * * `IsolationError` - Isolation error
   * * `RcdProtectionTriggered` - RCD protection triggered
   * * `McbProtectionTriggered` - MCB protection triggered (Over Current protection Triggered)
   * * `ProgramCounterFailure` - Program Counter Failure
   * * `Invalid` - Reason for stopping cannot be identified
   * * `NoError` - No error ocurred, similar to a normal stop
   * * `UserRequestStop` - User pressed the stop button on HMI
   * * `ConnectorButtonPressed` - CSS1 connector button is pressed by user
   * * `VehicleStop` - This vehicle requested to stop the session by a driver request
   * * `IncompatibleVehicle` - This vehicle cannot be charged on this outlet
   * * `IsolationTestFailed` - Isolation resistance is to low
   * * `CableCheckFailed` - Isolation failure during cable check phase
   * * `BatteryFull` - Stopped because the vehicle battery is full
   * * `BudgetExceeded` - Stopped because the vehicle asked for or tried to draw to much power
   * * `ChargerError` - Chargin Protocol Interface (CPI) board error
   * * `ChargerContactorProblem` - Charger contactor problem
   * * `ChargerLoweringCurrentTimeout` - Charge does not follow the request reduction of current near to full charge
   * * `ConnectorError` - Connector Error
   * * `ConnectorPilotError` - Conector pilot error
   * * `ControlPilotShorCircuit` - Control pilot is in short-circuit. it can be caused by bad wiring
   * * `ConnectorTemperatureError` - The connector is too hot
   * * `Outlet error` - problem of CPI/IMI assebly, CCB or CAN cable between CCB and CPI
   * * `chargerPreChargerTimeout` - Precharger timeout is reached
   * * `ChargerVoltageDrop` - Measure voltage is lower than the expected
   * * `ChargerMaxVoltage` - Maximum voltage exceeded
   * * `ChargedStopTimeout` - Vehicle takes too log to send the stop command
   * * `ChargerConnectorPresenceLost` - Charger was not able to pick Control pilor state changes from the vehicle
   * * `ChargerErrorCurrentDifference` - The charger detected thar the current difference is too large
   * * `ChargerCANCommunicationLost` - he power cabinet internal CAN bus communication is lost
   * * `ChargerMCBTripped` - Charger circuit breaker tripped
   * * `ChargedRCDTriped` - the AC input (from the grid) Residual Current Device tripped
   * * `ChargerRCDCloseError` - Residual Current Device Closing Error
   * * `ChargefTemperatureError` - The temperature of the power cabinet or charge is high
   * * `ChargerNeutralMismatch` - Charger neutral mismatch
   * * `ChargerOutletDetection` - Charger outlet detection
   * * `VehicleProtocolError` - Vehicle protocol error
   * * `PowerPortVipError` - The powerport vip value is showing zero
   * * `Power port power error` - Power module does not respond fast enough
   * * `PowerPortFanFailure` - All power module affected by a fan failure
   * * `PowerPortOverheat` - All power modules show a high temperature
   * * `PowerPortInterlock` - Interlock of power modules acttive
   * * `PowerPortErrorOther` - Umbrella error for any other power modules related errors
   * * `VehicleErrorReversePolarity` - The polarityo the vehicle is reversed
   * * `VehicleErrorVoltageApplied` - There is a voltage applied to the DC output when this is not expected
   * * `LockError` - Unable to lock the connector, no dangerous voltage present
   * * `UnlockError` - Unable to unlock the connector, no dangerous voltage present
   * * `LockTampering` - Tampering with the connector lock detected
   * * `CableError` - Charger cannot detect chargin cable type e.g. after cable replacement
   * * `GlobalInterlockFail` - Global Interlock activated
   * * `VehicleShiftPosition` - Vehicle shift position indicator is incorrect
   * * `VehicleBatteryTemperatureOutOfRange` - Vehicle communicated that its battery temperature is out of range
   * * `VehicleLookError` - Vehicle is unable to lock the connector
   * * `VehicleBatteryMalfunction` - Vehicle battery malfunction
   * * `VehicleCurrentDifference` - Vehicle detected current is not within specs
   * * `VehicleVoltageOutOfRange` - Vehicle detected voltage is out of range
   * * `VehicleError` - General vehicle error
   * * `oardPowerSupplyError` - Charge auxiliary power supply (24V) has issues
   * * `OcmNotAlive` - Over current monitor not alive
   * * `OcmInterlockVeriicationError` - Interlock by over current monitor is not functioning properly
   * * `OcmCableRatingMismatch` - Over current monitor and cable rating does not match
   * * `OnBoardEnergymeterError` - Vehicle onboard energy meter error
   * * `VehicleWeldingDetectionTimeout` - Vehicle contador weldin detection request took to long
   * * `CableCheckCurrentRunning` - The isolation test failed during this session
   * * `CableCheckVoltageTooLow` - Power module that was selected for the cable check is not functioning
   * * `CableCheckVoltageTooHigh` - The power module voltage were too high during the cable check
   * * `CableCheckVoltageNotDropping` - Voltage is not dropping when expected during the cable check
   * * `ChargerTimeCompleted` - stopped because car has been charging long enough
   * * `VehicleNotConnected` - Vehicle not connected
   * * `SoftError` - Software induce error
   * * `StoppedByVehicle` - Stopped by vehicle
   * * `AcsErrorExtending` - Problem happened that prevent the pantograph from extending
   * * `AcsErrorRetracting` - Pantograph error retracting
   * * `AcsExtendedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AcsRetractedTimeout` - Malfunctioning pantograph motor or lowering arm
   * * `AccErrorAligment` - No complete chargin circuit when the pantograph is lowered
   * * `ChargerCabinetOvp` - The Over Coltage protection in cabinet is tripped
   * * `ChargerCableCoolerFailure` - Cable cooler is not reachable or gives an error
   * * `ChargerCableCoolerTemperature` - Temperature of cooler out of range
   * * `ChargerCableTemperature` - The cable is too hot at the charger end
   * * `ChargerContactorTemperature` - Contactor temperature is out-of-range
   * * `EstCorrect` - Normal stop
   * * `blocked` - ID tag for OCPP authorization is blocked on server
   * * `Expired` - ID tag for OCPP authorization is expired on server
   * * `InvalidOnServer` - ID tag is marked as Invalid by the OCP server
   * * `InvalidOnCharged` - ID tag is marked as Invalid by the charger software
   * * `RequestReject` - Charged software rejects request for authorization
   * * `WrongMessage` - Wrong parameters provided for the authorization request
   * * `NoMatchingIDs` - ID tags for OCPP Star and Stop do not match
   * * `ServerUnreachable` - The authorization failed as the server could not be reached
   * * `NoCardPresented` - The authorization failed bcause the user did not present a card
   * * `AuthorizedStop` - Authorization was used to stop chargin
   * * `ForcedStop` - Used when it is required to stop the charging without an authorization
   * * `NormalStop` - Normal Stop that does not fall into any of other categories
   * * `ImiDisconnectedFromDcbus` - CPI disconnected from DC bus and thresfore measure 0 Volts
   * * `ChargerCommunicationFailure` - Communication between Host A8 and DCB Failed
   * * `ChargerSubunitCommunicationFailure` - Communication beetween Host A8 and Subunit DCB Failed
   * * `DCElectricMeterCommunicationFailed` - DC Electric Meter communication Detection Failed
   * * `PowerModuleCANCommunicationFailure` - Possibly Due to module Address Configuration Issueor Module CAN communication problem
   * * `InsulationCommunication` - Gun 1 and 2 Insulation Communication module are in alarm state possibly due to power supply or communication issues with the insulation modules
   * * `Timeout` - Self-test Timeout. Abnormal Status. DCB has not Reported charging status messages for a long time
   * * `ACElectricMeterCommunicationFailure` - AC Electric Meter communication Detection Failed
   * * `NFC Communication Failure` - NFC communication failure
   * * `CommunicationFailureLightPanel` - Communication failure with the Light Panel
   * * `BluetoothCommunicationFailure` - Bluetooth board communication failure
   * * `ChargerFANMalfunction` - Charger FAN malfunction
   * * `DCBTCUAbnormality` - DCB Received TCU Abnormality
   * * `ChargerOtherFaults` - Charger other faults (avoid using whenever possible)
   * * `TCUVINVerificationTimedOut` - Waiting fot TCU VIN verification result timed out
   * * `VehicleAuthenticationFailed` - Vehicle authentication Failed (VIN Verification)
   * * `FanSpeedControlFailure` - Fan speed cntrol board communication failure
   * * `InsulationAlarm` - Insulation alarm (Alert without Shutdown)
   * * `InsulationFault` - Insulation Fault
   * * `PowerModuleAlarm` - Power module alarm
   * * `PowerModuleConflict` - (C6) Power module address conflict, (C2) charging station not initialized
   * * `PowerModuleFault` - Power module fault. Record the modules that have experienced a fault in the data
   * * `PowerModuleStatusChange` - Power module status change ( number of availabke modules)
   * * `PowerModulePhaseLossFault` - Power module phase loss fault
   * * `PowerModuleFanFault` - Power module FAN fault
   * * `PowerModuleOvertemperatureFault` - Power module overtemperature fault
   * * `PowerModuleACInputFault` - Power module AC input Fault
   * * `PowerModuleOutputShortCircuitFault` - Power module output short circuit fault
   * * `PowerModuleOutputOvercurrentFault` - Power module output overcurrent fault
   * * `PowerModuleOutputOvervoltageFault` - Power module output overvoltage fault
   * * `PowerModuleOutputUndervoltageFault` - Power module output undervoltage fault
   * * `PowerModuleInputOvervoltageFault` - Power module input overvoltage fault
   * * `PowerModuleInputUndervoltageFault` - Power module input undervoltage fault
   * * `PowerModuleDischargeFault` - Power module discharge fault
   * * `PowerModuleCurrentLimit` - Power module current limit
   * * `PowerModuleShutdown` - Power module shutdown
   * * `NoAvailableSparePowerModule` - No available spare power module
   * * `ChargerAccessControlFailure` - Charger access control failure
   * * `LiquidLevelAlarm` - Liquid level alarm
   * * `ACSurgeAlarm` - AC surge alarm
   * * `DCSurgeAlarm` - DC Surge alarm. If It's a subunit DC surge, specify the subunit number in the data
   * * `GunEndContactFault` - Gun end contactor fault. Displayed as charging port end contact fault on WeChat
   * * `ChargigStationSmokeDetectorFault` - Charging station smoke detector fault
   * * `CabinetTemperatureAlarm` - Cabinet Temperature Alarm. Abnormal Status
   * * `CabinetHumidityAlarm` - Cabinete humidity alarm. Abnormal status
   * * `TiltAngleAlarm` - Tilt angle alarm. abnormal status
   * * `LiquidCooledHeadExceedsShutdown` - Liquid-Cooled gun Head exceeds shutdown temperature. shutdown
   * * `LiquidCooledHeadExceedsCurrentShutdown` - Liquid-Cooled gun head exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledTailExceedsShutdown` - Liquid-Cooled gun Tail exceeds shutdown temperature. shutdown
   * * `LiquidCooledTailExceedsCurrentShutdown` - Liquid-Cooled gun Tail exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
   * * `LiquidCooledHeadTemperatureRiseExceedsShutdown` - Liquid-Cooled gun head temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledHeadTemperatureRiseCurrentShutdown` - Liquid-Cooled gun head temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LiquidCooledTailTemperatureRiseExceedsShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds shutdown rate. Shutdown
   * * `LiquidCooledTailTemperatureRiseCurrentShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
   * * `LowLiquidLevel` - Low liquid level in  Liquid cooling, current limit without shutdown.
   * * `LiquidCoolingOvertemperatureOvervoltage` - Liquid coolink liquid overtemperature and overvoltage. Overtemperature and overvoltage are the same fault in this context
   * * `LiquidCooledHeadDifferenceExceeds` - Liquid-cooled gun head and tail temperature difference exceeds current limit rate, but not shutdown rate. current limit without shutdown
   * * `LiquidCooledHeadTailShutdown` - Liquid-Cooled gun head and tail temperature difference exceeds shutdown rate. Shutdown
   * * `LiquidCoolingFault` - Liquid cooling fault
   * * `ChargingStationFault` - Charging station fault
   * * `TiltAngleFault` - Tilt angle fault
   * * `LiquidCoolingCoolantLowLevelFault` - Liquid cooling coolant low level fault, shutdown. This fault may indicate a coolant leak
   * * `OtherHardwareFaultsInLiquidCooling` - Other hardware fault in liquid cooling
   * * `LiquidCoolingDischargeNoShutdown` - Liquid cooling discharge and return temperature difference alarm, but no shutdown
   * * `LiquidCoolingDischargeShutdown` - Liquid cooling discharge and return temperature difference alarm shutdown
   * * `LiquidCoolingReturnNoShutdown` - Liquid cooling return temperature difference alarm, but no shutdown
   * * `LiquidCoolingReturnShutdown` - Liquid cooling return temperature difference alarm, shutdown
   * * `LiquidCoolingPumpLowAlarm` - Liquid cooling pump low temperature alarm, but no shutdown
   * * `LiquidCoolingPumpLowFault` - Liquid cooling pump low temperature fault, shutdown
   * * `LiquidCoolingPumpFault` - Liquid cooling pump temperature fault, shutdown
   * * `LiquidCoolingPumpSesingFault` - Liquid cooling pump temperature sensing fault, shutdown
   * * `EmergencyStopCircuitFault` - Emergency stop circuit fault
   * * `ChargingGunTemperatureAlarm` - Charging gun temperature alarm. Displayed as charging port temperature alarm on WeChat. Abnormal status
   * * `ElectromagneticLockLockingFailed` - Electromagnetic lock locking operation failed. Abnormal status
   * * `ElectromagneticLockUnlockingFailed` - Electromagnetic lock unlocking operation failed. At this point, the charging gun is locked and cannot be removed. Abnormal status
   * * `AbnormalityChargingGunPort` - Abnormality at the charging gun port, meannig a change in CC voltageduring charging (other than 4V), abnormal status
   * * `ChargingGunNotProperlyPositioned` - Charging gun not properly positioned
   * * `BMSVoltageLowOrHigh` - BMS demands voltage too low or high. If it can be ditinguished as 'high' or 'low'
   * * `BMSVoltageHigh` - BMS demands voltage too high
   * * `BMSVoltageLow` - BMS demands voltage too Low
   * * `APhaseHigh` - A-phase voltage too high
   * * `BPhaseHigh` - B-phase voltage too high
   * * `CPhaseHigh` - C-phase voltage too high
   * * `APhaseLow` - A-phase voltage too low
   * * `BPhaseLow` - B-phase voltage too low
   * * `CPhaseLow` - C-phase voltage too low
   * * `GroundWireAlarm` - Ground wire alarm
   * * `NLineNotConnected` - N-Line not connected
   * * `ACInputCircuitBrakerFailure` - AC Input circuit breaker failure
   * * `ACInputContadorRefusarFault` - AC Input contador refursar fault
   * * `ACInputContadorStickingFault` - AC input contador sticking fault
   * * `SystemPowerFailure` - System power failure. 220V no input
   * * `ACPowerMeterReadingAbnormal` - AC power meter reading abnormal
   * * `ACInputPhaseLoss` - AC input phase loss
   * * `VoltageAbnormalityOvervoltage` - Coltage abnormality overvoltage
   * * `VoltageAbnormalityUndervoltage` - Voltage abnormality undervoltage
   * * `VoltageAbnormalityShortCircuit` - Voltageabnormality short circuit
   * * `VoltageAbnormalityOverload` - Voltage abnormality overload
   * * `BatteryReverseConnection` - Battery reverse connection
   * * `DCDetectionFailure` - DC detection failure
   * * `DischargeDetectionFailure` - Dicharge detection failure
   * * `ParallelContadorRefusalFault` - Parallel contador refusal fault
   * * `ParallelContadorAhesionFault` - Parallel contador adhesion fault
   * * `DCBusOutputFuseFault` - DC bus output fuse fault
   * * `ChargingHostPreChargingFailureFault` - Charging host pre-charging failure fault
   * * `ChargingHostResponseChargingFailureFault` - Charging host response charging failure fault
   * * `BatteryUndervoltage` - During the charging permission stage, the charging station measures the battery voltage lower than 5% of the battery voltage in BCP
   * * `BatteryOvervoltage` - During the charging permission stage, the charging station measures the battery voltage higher than 5% of the battery voltage in BCP
   * * `AbnormalDC` - Abnormal DC meter reading
   * * `GunheadDCRefusalFault` - Gunhead DC output contactor refusal fault
   * * `GunheadDCAdhesionFault` - Gunhead DC output contadctor adhesion fault
   * * `PrechargeTimeout` - Precharge timeout
   * * `AuxiliaryPowerNotPowered` - The auxiliar power supply is not powered on
   * * `CRMTimeout` - CRM timeout
   * * `CRM00Timeout` - CRM00 timeout
   * * `CRMaaTimeout` - CRMaa timeout
   * * `CROTimeout` - CRO timeout
   * * `CTSTimeout` - CTS timeout
   * * `CMLTimeout` - CML timeout
   * * `CCSTimeout` - CSS timeout
   * * `CSTTimeout` - CST timeout
   * * `CSDTimeout` - CSD timeout
   * * `OtherTimeoutFaultBEM` - Other timeout fault as defined in BEM
   * * `ChargerOutputCurrentExcedsDC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the DC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargerOutputCurrentExcedsAC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the AC power meter remains unchanged for a continuous duration of 180 seconds
   * * `ChargingHostEmergencyStop` - Charging host emergency stop
   * * `ChargingostDCBusbarFuse` - Charging host DC busbar fuse
   * * `ChargingHostAccessControlFAilure` - Charging host access control failure
   * * `ChargingHostSmokeDetectorFailure` - Charging host smoke detector failure
   * * `ChargingHostACInputCircuitBreakerFailure` - Charging host AC input circuit breaker failure
   * * `ChargingHostACInputContactorMalfunction` - charging host AC input contactor malfunction
   * * `ChargingHostACInputStickingMalfunction` - charging host AC input sticking malfunction
   * * `ChargingHostFanMalfunction` - Charging host fan malfunction
   * * `ChargingHostParallelContactorMalfunction` - Charging host parallel contactor malfunction
   * * `ChargingHostParallelStickingMalfunction` - Charging host parallel sticking malfunction
   * * `ChargingHostLiquidCoolingModuleMalfunction` - Charging host liquid cooling module malfunction
   * * `ChargingHostLiquidCoolingModuleCommunicationFailure` - Charging host liquid cooling module communication failure
   * * `ChargingHostSurgeArresterMAlfunction` - Charging host surge arrester malfunction
   * * `ChargingHostACEnergyMeterCommunicationFailure` - Charging host AC energy meter communication failure
   * * `ChargingHostOverTemperatureFault` - Charging host over temperature fault
   * * `ChargingHostOverTemperatureWarning` - Charging host over temperature warning
   * * `ChargingHostInputVoltageOvervoltageFault` - Charging host input voltage overvoltage fault
   * * `ChargingHostInputVoltageUndervoltageFault` - Charging host input voltage undervoltage fault
   * * `ChargingHostWaterLevelMonitoringAbnormality` - Charging host water level monitoring abnormality
   * * `ChargingHostPowerModuleFault` - Charging host power module fault
   * * `ChargingHostPowerModuleCommunicationFailure` - Charging host power module communication failure
   * * `ChargingHostPowerModuleFanMalfunction` - Charging host power module fan malfunction
   * * `ChargingHostPowerModuleOverTemperatureFault` - Charging host power module over-temperature fault
   * * `ChargingHostPowerModuleACInputFault` - Charging host power module AC input fault
   * * `ChargingHostPowerModuleOutputShortCircuitFault` - Charging host power module output short circuit fault
   * * `ChargingHostPowerModuleOutputOvercurrentFault` - Charging host power module output overcurrent fault
   * * `ChargingHostModuleOutputOvervoltageFault` - Charging host power module output overvoltage fault
   * * `ChargingHostModuleOutputUndervoltageFault` - Charging host power module output undervoltage fault
   * * `ChargingHostModuleInputOvervoltageFault` - Charging host power module input overvoltage fault
   * * `ChargingHostModuleInputUndevoltagetFault` - Charging host power module input undevoltage fault
   * * `ChargingHostModuleInputPhaseLossFault` - Charging host charging module input phase loss fault
   * * `ChargingHostChargingModuleFault` - Charging host charging module fault
   * * `ChargingHostChargingModuleCommunicationFailure` - Charging host charging module communication failure
   * * `ChargingHostAdhesiveDetectionTimeout` - Charging host adhesive detection response timeout
   * * `ChargingHostChargingStopCompletionTimeout` - Charging host charging stop completion response timeout
   * * `ChargingHostInsulationDetectionFrameTimeout` - Charging host insulation detection frame response timeout
   * * `ChargingHostInsulationDetectionCompletionTimeout` - Charging host insulation detection completion response timeout
   * * `ChargingHostPreChargeFrameTimeout` - Charging host pre-charge frame response timeout
   * * `ChargingHostPreChargeCompletionTimeout` - Charging host pre-charge completion response timeout
   * * `ChargingHostReceptionFirmwareUpgradeFrameTimeout` - Charging host reception of remote firmware upgrade file data frame timeout
   * * `ChargingHostReceptionChargingDemandDataFrameTimeout` - Charging host reception of charging demad data frame timeout
   * * `ChargingHostChargingTerminalTelesinalFrameTimeout` - Charging host charging terminal telesignal frame reception timeout
   * * `ChargingHostChargingStartupTimeout` - Charging host charging startup response timeout
   * * `ChargingHostChargingStopTimeout` - Charging host charging stop response timeout
   * * `ChargingHostTimeSynchronizationOperationTimeout` - Charging host time synchronization operation response timeout
   * * `ChargingHostVersionVerificationTimeout` - Charging host version verification response timeout
   * * `ChargingHostChargingParameterTimeout` - Charging host charging parameter response timeout
   * * `ChargingHostPreChargerTimeout` - Charging host pre-charger response timeout
   * * `ChargingHostInsulationDetectionTimeout` - Charging host insulation detection reponse timeout
   * * `ChargingHostRemoteUpgradeRequestTimeout` - Charging host remote upgrade request response timeout
   * * `ChargingHostDebuggingDataRequestTimeout` - Charging host debugging data request response timeout
   * * `ChargingHostControlRequestTimeout` - Charging host control request response timeout
   * * `ChargingHostRemoteFirmwareTransferFrameTimeout` - Charging host remote firmware upgrade file transfer completion frame reception timeout
   * * `ChargingHostRemoteUpgradeCompletionFrameTimeout` - Chaging host remote upgrade completion reception timeout
   * * `ChargingHostTelecontrolFrameTimeout` - Charging host telecontrol frame reception timeout
   * * `CharginghostTelemetryFrameTimeout` - Charging host telemetry frame reception timeout
   * * `ChargingHostInsulationDetectionCompletionFrameTimeout` - Charging host insulation detection completion frame reception timeout
   * * `ChargingHostAdhesiveDetectionFrameTimeout` - Charging host adhesive detection frame reception timeout
   * * `ChargingHostPreChargeCompletionFrameTimeout` - Charging host pre-charge completion frame reception timeout
   * * `ChargingHostChargingStopFrameTimeout` - Charging host charging stop completion frame reception timeout
   * * `ChargingHostAndSubCommunicationNotCompleted` - Charging host and sub-communication initialization not completed
   * * `ChargingHostHeartbeatReceptionStatus` - Charging host heartbeat reception status
   * * `BSTHighVoltageRelayMalfunction` - BST high voltage relay malfunction
   * * `BSTChargingConnectorMalfunction` - BST charging connector malfunction. Abnormal status
   * * `BSTBatteryPackTemperatureHigh` - BST battery pack temperature too high
   * * `BSTCurrentExceedsRequiredValue` - BST current exceeds the required value
   * * `BSTVoltageAbnormal` - BST voltage abnormal
   * * `BSTDetectionPoint2VoltageDetectionMalfunction` - BST detection point 2 voltage detection malfunction. Abnormal status
   * * `BSTOtherMalfunction` - BST other malfunction
   * * `BSTOutputConnectorOverheated` - BST output connector overheated
   * * `BSTStopSendData0Malfunction` - BST stops and send data as 0 malfunction, not a malfunction.
   * * `BSTVehicleInsulation` - BST vehicle insulation
   * * `BMSCurrentExceedsVoltageMode` - BMS current request exceeds the maximum allowed current in constant voltage mode
   * * `BMSCurrentExceedsCurrentMode` - BMS current request exceeds the maximum allowed current in constant current mode
   * * `ChargingProhibited` - Charging prohibited, 10-minute timeout
   * * `BHMVoltageMatchingFailure` - BHM voltage matching failure
   * * `VoltageDetectionFailure` - Voltage detection failure
   * * `BMSCoponentOutputConnectorOverTemperature` - BHM component output connector over temperature
   * * `BSMIndividualPowerBatteryHigh` - BSM individual power battery voltage too high
   * * `BSMIndividualPowerBatteryLow` - BSM individual power battery voltage too low
   * * `BSMVehiclePowerBatteryHigh` - BSM whole vehicle power battery state of charge (SOC) too high
   * * `BSMVehiclePowerBatterylow` - BSM whole vehicle power battery state of charge (SOC) too low
   * * `BSMVehiclePowerBatteryInsulationAbnormal` - BSM power battery insulation status abnormal
   * * `BSMBatteryOvercurrentCharging` - BSM power battery overcurrent during charging
   * * `BSMBatteryTemperatureHigh` - BSM power battery temperature high
   * * `BSMBatteryOutputConnectorConnectionAbnormal` - BSM power battery pack output connector connection status abnormal
   * * `BMSCommunicationProtocolVersionMismatch` - BMS communication protocol version mismatch
   * * `VehicleFullyCharged` - The vehicle is fully charged; this is feedback from the vehicle
   * * `ReachedSetTotalVoltage` - Reached the set total voltage. Not considered abnormal; can be regarded as fully charged
   * * `ReachedSetIndividualVoltage` - Reached the set individual cell voltage. Not considered abnormal; can be regarded as fully charged
   * * `MetChargerSettingConditions` - Met the charger setting conditions. Not considered abnormal; can be regarded as fully charged
   * * `VehicleSideManualTermination` - Vehicle-side indicates manual temination
   * * `PowerCannotBeTransmitted` - Power cannot be transmitted this is a vehicle malfunction, it might be fully charged.
   * * `CurrentMismatchVehicleMalfunction` - Current mismathc, this is a vehicle malfunction, it might be fully charged
   * * `ChargedTeminated` - Charged teminated
   * * `BRMTimeout` - BRM timeout
   * * `BCPTimeout` - BCP timeout
   * * `BRO_TIMEOUT` - BRO timeout
   * * `BCSTimeout` - BCS timeout
   * * `BCLTimeout` - BCL timeout
   * * `BSTTimeout` - BST timeout
   * * `BSDTimeout` - BSD timeout
   * * `BSMTimeout` - BSM timeout
   * * `CHAdeMoCodeWaitJ3TimeOut` - Waiting for vehicle-side Switch = ON timeout. Vehicle-side malfunction
   * * `CHAdeMoCodeDCVoltExceed10V` - DC bus voltage exceeds 10V before charging. Bus has voltage or vehicle-side malfunction
   * * `CHAdeMoCodeJ3StatusErr` - Vehicle-side Switch status error. Vehicle-side malfunction
   * * `CHAdeMOCodeEvReadyStatusErr` - Vehicel-side readiness status error. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitEVSEOutVoltErr` - Waiting for output voltage timeout
   * * `CHAdeMOCodeDCVoltExceed20V` - Insulation check completed voltage anomaly after discharge
   * * `CHAdeMOCodeCommunicationTimeOut` - Vehicle-side CAN communication timeout
   * * `CHAdeMOCodeWaitCAN10XTimeOut` - Waiting for vehicle-side CAN communication timeout at beginning of charging. Vehicle malfunction
   * * `CHAdeMOCodeWaitEVCurrentReqTimeOut` - Waiting for current request failed. VEhicle-side malfunction
   * * `CHAdeMOCodeWaitEVContadorTimeOut` - Waiting for vehicle-side contacdt closure failed. Vehicle-side malfunction
   * * `CHAdeMOCodeDCVoltExceed10VNormalEnd` - Abnormal discharge at the end of charging. Vehicle-side malfunction
   * * `CHAdeMOCodeCommunicationOpenTimeOut` - Waiting for the vehicle to disconnect communication timeout after charging ends. Vehicle-side malfunction
   * * `CHAdeMOCodeChargingSystemFault` - Vehicle-side reported charging system error. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOverVoltage` - Output voltage abnormal. Vehicle-side malfunction
   * * `CHAdeMOCodeOutOvercurrent` - Output current abnormal.
   * * `CHAdeMOCodeBatterPolarity` - Battery polarity error
   * * `CHAdeMOCodeEVSEIsolationStatusFail` - Insulation fault error
   * * `CHAdeMOCodeMalfunctionDetectionFail` - Charging plug electromagnetic lock failed to lock. Charging cable electromagnetic lock malfunction
   * * `CHAdeMOCodeCANInitFail` - CCAN initialization failed. Board malfunction
   * * `CHAdeMOCodeVehicleShiftPositionStop` - Vehicle-side Vehicle_shift_position stops. Issue on the vehicle side
   * * `CHAdeMOCodeWaitJ3OpenErr` - Waiting for vehicle-side Switch = OFF timeout. Vehicle-side malfunction
   * * `CHAdeMOCodeWaitCommunicationCloseTimeOut` - Wait for communication closure anomaly. Vehicle-side malfunction
   * * `CHAdeMOCodeBEforeChargeJ3StatusErr` - Switch status abnormal before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeTargetBatterVoltageErr` - EEV target battery voltage abnormal. Vehiccle-side malfunction
   * * `CHAdeMOCodeBatteryInccompatibilityErr` - EV battery mismatch. Vehicle-side mismatch
   * * `CHAdeMOCodeRequestCurrentErr` - Current request failed. Vehicle-side malfunction
   * * `CHAdeMOCodeMinimumCurrentErr` - Minimum current error. Vehicle-side malfunction
   * * `CHAdeMOCodeNormalStopRequestBefoeCharging` - Vehicle-side requests to stop before charging. Vehicle-side malfunction
   * * `CHAdeMOCodeRemainingChargingTimeIsZero` - Remaining charging time is 0. Charging stopped
   * * `CHAdeMOCodeWaitPowerReadyTimeout` - Waiting for the power module to be ready exceeded timeout. Power module anomaly
   * * `CHAdeMOCodeVehicleCChargingEnable` - Vehicle-side 'Vehicle_charging_enabled' status error. Vehicle-side malfunction
   * * `CHAdeMOCodeCurrent5AOrLess` - Waiting dot charging to end and current to drop below 5A exceeded timeout. Power module or current detection issue
   * * `CHAdeMOCodeEVErrorCanid1024A` - Vehicle-side reported 102.4 error stop. Vehicle-side malfunction
   * * `CHAdeMOCodeEVErrorCanid10240` - Vehicle-side reported: Battery_Overvoltage
   * * `CHAdeMOCodeEVErrorCanid10241` - Vehicle-side reported: Battery_Undervoltage
   * * `CHAdeMOCodeEVErrorCanid1024` - Vehicle-side reported: Battery_Current_deviation_Error
   * * `CHAdeMOCodeEVErrorCanid10243` - Vehicle-side reported: Battery_High_Temperature
   * * `CHAdeMOCodeEVErrorCanid10244` - Vehicle-side reported: Battery_Voltage_Deviation_Error
   * * `CHAdeMOCodeOther` - Cannot use if not matched, try not to use it
   * * `CCSStopCodePlugOut` - Detected that the charging plug was remover during charging. CP immediately changes to 12v
   * * `CCSStopCodeReadyToChargePerformanceTimeOut` - Waiting to start charging timeout
   * * `CCSStopCodeCommEVSessionStop` - Vehicle-side sent Session stop for normal termination
   * * `CCSStopCodeEVSEIsolationStatusFail` - Stopped due to isulation fault
   * * `CCSStopCodeEVTargetVoltageFail` - Vehicle-side demanded coltage exceeds the maximum allowable voltage for for the vehicle
   * * `CCSStopCodeEVTargetCurrentFail` - Vehicle-side demanded voltage  exceeds the maximum allowable current for the vehicle
   * * `CCSStopCodeEVSEPresentVoltageFail` - DC output over-voltage
   * * `CCSStopCodeEVSEPresentCurrentFail` - DC output overcurrent
   * * `CCSStopCodeCPFail` - CP voltage abnormal, exceeds 6v, 9v with a tolerance of plus or minus 0.8V
   * * `CCSStopCodeEVSEBatterPolarityFail` - BAttery polarity reversed
   * * `CCSStopCodeEvseChargeBeforeOvervoltageFail` - Overvoltage before charging
   * * `CCSStopCodeEvseChargeInsulationAfterOvervoltageFail` - Overvoltage after insulation charge
   * * `CSSStopCodeEVSEUndervoltage` - Output undervoltage
   * * `CCSStopCodeOngoingPerformanceTimeout` - WAiting for charging permission timeout
   * * `CCSStopCodePDVoltAlarm` - American standard plug PD detection error; not applicable for European Standar
   * * `CCSStopCodeOther` - not matched, try not to use
   * * `V2GFailed` - V2G failed
   * * `V2GFailedSequenceError` - V2G failed sequence error
   * * `V2GFailedServiceIdInvalid` - V2G failed service id invalid
   * * `V2GFailedUnknownSession` - V2G failed unknow session
   * * `V2GFailedServiceSelectionInvalid` - V2G failed service selection invalid
   * * `V2GFailedPaymentSelectionInvelid` - V2G failed payment selection invalid
   * * `V2GFailedCertificateExpired` - V2G failed certificate expired
   * * `V2GFailedSignatureError` - V2G failed signature error
   * * `V2GFailedNoCertificateAvailable` - V2G failed no certificate available
   * * `V2GFailedCertChainError` - V2G failed cert chain error
   * * `V2GFailedChallengeInvalid` - V2G failed challenge invalid
   * * `V2GFailedContractCanceled` - V2G failed contract canceled
   * * `V2GFailedWrongChargeParameter` - V2G failed wrong charge parameter
   * * `V2GFailedPowerDeliveryNotApplied` - V2G failed power delivery not applied
   * * `V2GFailedTariffSelectionInvalid` - V2G failed tariff selection invalid
   * * `V2GFailedChargingProfileInvalid` - V2G failed charging profile invalid
   * * `V2GFailedEVSEPresentVoltToLow` - V2G failed EVSE present volt to low
   * * `V2GFailedMeteringsignatureNotValid` - V2G failed metering signature not velid
   * * `V2GFailedWrongEnergyTranferType` - V2G failed wrong energy transfer type
   * * `V2GFailedAppHandResponse` - V2G failed app hand response code type failed no negotiation
   * * `V2GInitErrorQCA7000` - V2G inir error QCA 7000
   * * `V2GInitErrorOther` - V2G init error other
   * * `V2GInitErrorGeneral` - V2G init error general
   * * `V2GInitErrorIfaddr` - V2G init error ifaddr
   * * `V2GInitErrorThread` - V2G init error thread
   * * `V2GInitErrorOpenchannel` - V2G init error openchannel
   * * `V2GInitErrorKey` - V2G init error key
   * * `V2GSlacErrorGeneral` - V2G slac error general
   * * `V2GSlacErrorTimerInit` - V2G slac error timer init
   * * `V2GSlacErrorTimerTimeout` - V2G slac error timer timeout
   * * `V2GSlacErrorTimerMisc` - V2G slac error timer misc
   * * `V2GSlacErrorParamTimeout` - V2G slac error param timeout
   * * `V2GSlacErrorParamSocket` - V2G slac error param socket
   * * `V2GSlacErrorStartAttenCharTimeout` - V2G slac error start atten char timeout
   * * `V2GSlacErrorMNBCSoundTimeout` - V2G slac error MNBC sound timeout
   * * `V2GSlacErrorAttenCharTimeout` - V2G slac error atten char timeout
   * * `V2GSlacErrorAttenCharSocket` - V2G slac error atten char Socket
   * * `V2GSlacErrorValidate1Timeout` - V2G slac error validate 1 timeout
   * * `V2GSlacErrorValidate1Socket` - V2G slac error validate 1 socket
   * * `V2GSlacErrorValidate2Timeout` - V2G slac error validate 2 timeout
   * * `V2GSlacErrorValidate2Socket` - V2G slac error validate 2 socket
   * * `V2GSlacErrorBCBToggleTimeout` - V2G slac error BCB toggle timeout
   * * `V2GSlacErrorMatchTimeout` - V2G slac error match timeout
   * * `V2GSlacErrorMatchSocket` - V2G slac error match Socket
   * * `V2GSlacErrorReadSocket` - V2G slac error read Socket
   * * `V2GSlacErrorSetKey` - V2G slac error set key
   * * `V2GSlacErrorLinkTimeout` - V2G slac error link timeout
   * * `V2GSDPErrorGeneral` - V2G SDP error general
   * * `V2GSDPErrorInitSocket` - V2G SDP error init socket
   * * `V2GSDPErrorInitSockOPT1` - V2G SDP error init sockotp1
   * * `V2GSDPErrorInitSockOPT2` - V2G SDP error init sockotp2
   * * `V2GSDPErrorInitBind` - V2G SDP error init bind
   * * `V2GSDPErrorThreadSocket1` - V2G SDP error thread docket 1
   * * `V2GSDPErrorThreadSocket2` - V2G SDP error thread docket 2
   * * `V2GSDPErrorTimeout` - V2G SDP error timeout
   * * `V2GSDPErrorTCPDisconnected` - V2G SDP error tcp disconnected
   * * `V2GDinErrorGeneral` - V2G DIN error general
   * * `V2GDinErrorInitSocket` - V2G DIN error init socket
   * * `V2GDinErrorInitSockOPT` - V2G DIN error init sockOPT
   * * `V2GDinErrorInitBind` - V2G DIN error init bind
   * * `V2GDinErrorInitListen` - V2G DIN error init listen
   * * `V2GDinErrorInitSelect` - V2G DIN error init select
   * * `V2GDinErrorInitAccept` - V2G DIN error init accept
   * * `V2GDinErrorTimeout` - V2G DIN error timeout
   * * `V2GDinErrorV2GTPHeader` - V2G DIN error V2GTP header
   * * `V2GDinErrorV2GTPHeaderLen` - V2G DIN error V2GTP header Len
   * * `V2GDinErrorV2GTPHeaderWrite` - V2G DIN error V2GTP header write
   * * `V2GDinErrorDecodeExi` - V2G DIN error Decode Exi
   * * `V2GDinErrorEncodeExi` - V2G DIN error Encode Exi
   * * `V2GDinErrorCreateResponse` - V2G DIN error create response
   * * `V2GDinErrorSocketException` - V2G DIN error socket exception
   * * `V2GDinErrorSocketSend` - V2G DIN error socket send
   * * `V2GDinErrorNoProtocol` - V2G DIN error no protocol
   */
  verbose_error?: VerboseErrorEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  connector: number;
}

export interface SubscriptionCreateDelete {
  action_code: string;
}

/**
 * * `Accepted` - Accepted
 * * `Rejected` - Rejected
 */
export enum SyncStatus695Enum {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

/**
 * * `Accepted` - ChargingProfileStatus.accepted
 * * `Rejected` - ChargingProfileStatus.rejected
 * * `NotSupported` - ChargingProfileStatus.not_supported
 * * `Unknown` - ChargingProfileStatus.unknown
 */
export enum SyncStatusD22Enum {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  NotSupported = 'NotSupported',
  Unknown = 'Unknown',
}

/** Task Response Serializer */
export interface TaskResponse {
  /** @maxLength 64 */
  detail?: string;
  /** @maxLength 37 */
  task_id?: string;
  /** @maxLength 10 */
  task_status?: string;
  /**
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  task_result?: string;
}

/** Task Status Serializer */
export interface TaskStatus {
  /** @maxLength 37 */
  task_id?: string;
  /** @maxLength 10 */
  task_status?: string;
  /** @maxLength 10000 */
  task_result: string;
}

/** Theme Serializer */
export interface Theme {
  id: number;
  /** @format uri */
  logo: string;
  /** @format uri */
  favicon: string;
  /** @maxLength 50 */
  name?: string;
  active?: boolean;
  /** @maxLength 50 */
  title?: string;
  /**
   * Color
   * #F5DD5D
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  title_color?: string;
  /** Visible */
  title_visible?: boolean;
  /**
   * Color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  logo_color?: string;
  /**
   * Max width
   * @min 0
   * @max 32767
   */
  logo_max_width?: number;
  /**
   * Max height
   * @min 0
   * @max 32767
   */
  logo_max_height?: number;
  /** Visible */
  logo_visible?: boolean;
  /**
   * Name
   * @maxLength 50
   */
  env_name?: string;
  /**
   * Color
   * (red: #E74C3C, orange: #E67E22, yellow: #F1C40F, green: #2ECC71, blue: #3498DB)
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  env_color?: string;
  /** Visible in header (marker and name) */
  env_visible_in_header?: boolean;
  /** Visible in favicon (marker) */
  env_visible_in_favicon?: boolean;
  /** Active */
  language_chooser_active?: boolean;
  /** Control */
  language_chooser_control?: LanguageChooserControlEnum;
  /** Display */
  language_chooser_display?: LanguageChooserDisplayEnum;
  /**
   * Background color
   * #0C4B33
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_background_color?: string;
  /**
   * Text color
   * #44B78B
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_text_color?: string;
  /**
   * Link color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_link_color?: string;
  /**
   * Link hover color
   * #C9F0DD
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_header_link_hover_color?: string;
  /**
   * Background color
   * #44B78B
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_background_color?: string;
  /**
   * Background selected color
   * #FFFFCC
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_background_selected_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_text_color?: string;
  /**
   * Link color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_color?: string;
  /**
   * Link selected color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_selected_color?: string;
  /**
   * Link hover color
   * #C9F0DD
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_module_link_hover_color?: string;
  /** Rounded corners */
  css_module_rounded_corners?: boolean;
  /**
   * Link color
   * #0C3C26
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_color?: string;
  /**
   * Link hover color
   * #156641
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_hover_color?: string;
  /**
   * Link active color
   * #29B864
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_generic_link_active_color?: string;
  /**
   * Background color
   * #0C4B33
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_background_color?: string;
  /**
   * Background hover color
   * #0C3C26
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_background_hover_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_save_button_text_color?: string;
  /**
   * Background color
   * #BA2121
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_background_color?: string;
  /**
   * Background hover color
   * #A41515
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_background_hover_color?: string;
  /**
   * Text color
   * #FFFFFF
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  css_delete_button_text_color?: string;
  /** Active */
  related_modal_active?: boolean;
  /**
   * Background color
   * #000000
   * @maxLength 10
   * @pattern ^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
   */
  related_modal_background_color?: string;
  /**
   * Background opacity
   * 20%
   *
   * * `0.1` - 10%
   * * `0.2` - 20%
   * * `0.3` - 30%
   * * `0.4` - 40%
   * * `0.5` - 50%
   * * `0.6` - 60%
   * * `0.7` - 70%
   * * `0.8` - 80%
   * * `0.9` - 90%
   */
  related_modal_background_opacity?: RelatedModalBackgroundOpacityEnum;
  /** Rounded corners */
  related_modal_rounded_corners?: boolean;
  /** Close button visible */
  related_modal_close_button_visible?: boolean;
  /** Highlight active */
  list_filter_highlight?: boolean;
  /** Use dropdown */
  list_filter_dropdown?: boolean;
  /** Sticky position */
  list_filter_sticky?: boolean;
  /** Quick remove links for active filters at top of sidebar */
  list_filter_removal_links?: boolean;
  foldable_apps?: boolean;
  /** Fieldsets as tabs */
  show_fieldsets_as_tabs?: boolean;
  /** Inlines as tabs */
  show_inlines_as_tabs?: boolean;
  collapsible_stacked_inlines?: boolean;
  collapsible_stacked_inlines_collapsed?: boolean;
  collapsible_tabular_inlines?: boolean;
  collapsible_tabular_inlines_collapsed?: boolean;
  /** Visible */
  recent_actions_visible?: boolean;
  /** Sticky submit */
  form_submit_sticky?: boolean;
  /** Sticky pagination */
  form_pagination_sticky?: boolean;
}

/**
 * * `Pacific/Midway` - (GMT-11:00) Pacific/Midway
 * * `Pacific/Niue` - (GMT-11:00) Pacific/Niue
 * * `Pacific/Pago_Pago` - (GMT-11:00) Pacific/Pago_Pago
 * * `America/Adak` - (GMT-10:00) America/Adak
 * * `Pacific/Honolulu` - (GMT-10:00) Pacific/Honolulu
 * * `Pacific/Rarotonga` - (GMT-10:00) Pacific/Rarotonga
 * * `Pacific/Tahiti` - (GMT-10:00) Pacific/Tahiti
 * * `US/Hawaii` - (GMT-10:00) US/Hawaii
 * * `Pacific/Marquesas` - (GMT-09:30) Pacific/Marquesas
 * * `America/Anchorage` - (GMT-09:00) America/Anchorage
 * * `America/Juneau` - (GMT-09:00) America/Juneau
 * * `America/Metlakatla` - (GMT-09:00) America/Metlakatla
 * * `America/Nome` - (GMT-09:00) America/Nome
 * * `America/Sitka` - (GMT-09:00) America/Sitka
 * * `America/Yakutat` - (GMT-09:00) America/Yakutat
 * * `Pacific/Gambier` - (GMT-09:00) Pacific/Gambier
 * * `US/Alaska` - (GMT-09:00) US/Alaska
 * * `America/Los_Angeles` - (GMT-08:00) America/Los_Angeles
 * * `America/Tijuana` - (GMT-08:00) America/Tijuana
 * * `America/Vancouver` - (GMT-08:00) America/Vancouver
 * * `Canada/Pacific` - (GMT-08:00) Canada/Pacific
 * * `Pacific/Pitcairn` - (GMT-08:00) Pacific/Pitcairn
 * * `US/Pacific` - (GMT-08:00) US/Pacific
 * * `America/Boise` - (GMT-07:00) America/Boise
 * * `America/Cambridge_Bay` - (GMT-07:00) America/Cambridge_Bay
 * * `America/Ciudad_Juarez` - (GMT-07:00) America/Ciudad_Juarez
 * * `America/Creston` - (GMT-07:00) America/Creston
 * * `America/Dawson` - (GMT-07:00) America/Dawson
 * * `America/Dawson_Creek` - (GMT-07:00) America/Dawson_Creek
 * * `America/Denver` - (GMT-07:00) America/Denver
 * * `America/Edmonton` - (GMT-07:00) America/Edmonton
 * * `America/Fort_Nelson` - (GMT-07:00) America/Fort_Nelson
 * * `America/Hermosillo` - (GMT-07:00) America/Hermosillo
 * * `America/Inuvik` - (GMT-07:00) America/Inuvik
 * * `America/Mazatlan` - (GMT-07:00) America/Mazatlan
 * * `America/Phoenix` - (GMT-07:00) America/Phoenix
 * * `America/Whitehorse` - (GMT-07:00) America/Whitehorse
 * * `Canada/Mountain` - (GMT-07:00) Canada/Mountain
 * * `US/Arizona` - (GMT-07:00) US/Arizona
 * * `US/Mountain` - (GMT-07:00) US/Mountain
 * * `America/Bahia_Banderas` - (GMT-06:00) America/Bahia_Banderas
 * * `America/Belize` - (GMT-06:00) America/Belize
 * * `America/Chicago` - (GMT-06:00) America/Chicago
 * * `America/Chihuahua` - (GMT-06:00) America/Chihuahua
 * * `America/Costa_Rica` - (GMT-06:00) America/Costa_Rica
 * * `America/El_Salvador` - (GMT-06:00) America/El_Salvador
 * * `America/Guatemala` - (GMT-06:00) America/Guatemala
 * * `America/Indiana/Knox` - (GMT-06:00) America/Indiana/Knox
 * * `America/Indiana/Tell_City` - (GMT-06:00) America/Indiana/Tell_City
 * * `America/Managua` - (GMT-06:00) America/Managua
 * * `America/Matamoros` - (GMT-06:00) America/Matamoros
 * * `America/Menominee` - (GMT-06:00) America/Menominee
 * * `America/Merida` - (GMT-06:00) America/Merida
 * * `America/Mexico_City` - (GMT-06:00) America/Mexico_City
 * * `America/Monterrey` - (GMT-06:00) America/Monterrey
 * * `America/North_Dakota/Beulah` - (GMT-06:00) America/North_Dakota/Beulah
 * * `America/North_Dakota/Center` - (GMT-06:00) America/North_Dakota/Center
 * * `America/North_Dakota/New_Salem` - (GMT-06:00) America/North_Dakota/New_Salem
 * * `America/Ojinaga` - (GMT-06:00) America/Ojinaga
 * * `America/Rankin_Inlet` - (GMT-06:00) America/Rankin_Inlet
 * * `America/Regina` - (GMT-06:00) America/Regina
 * * `America/Resolute` - (GMT-06:00) America/Resolute
 * * `America/Swift_Current` - (GMT-06:00) America/Swift_Current
 * * `America/Tegucigalpa` - (GMT-06:00) America/Tegucigalpa
 * * `America/Winnipeg` - (GMT-06:00) America/Winnipeg
 * * `Canada/Central` - (GMT-06:00) Canada/Central
 * * `Pacific/Galapagos` - (GMT-06:00) Pacific/Galapagos
 * * `US/Central` - (GMT-06:00) US/Central
 * * `America/Atikokan` - (GMT-05:00) America/Atikokan
 * * `America/Bogota` - (GMT-05:00) America/Bogota
 * * `America/Cancun` - (GMT-05:00) America/Cancun
 * * `America/Cayman` - (GMT-05:00) America/Cayman
 * * `America/Detroit` - (GMT-05:00) America/Detroit
 * * `America/Eirunepe` - (GMT-05:00) America/Eirunepe
 * * `America/Grand_Turk` - (GMT-05:00) America/Grand_Turk
 * * `America/Guayaquil` - (GMT-05:00) America/Guayaquil
 * * `America/Havana` - (GMT-05:00) America/Havana
 * * `America/Indiana/Indianapolis` - (GMT-05:00) America/Indiana/Indianapolis
 * * `America/Indiana/Marengo` - (GMT-05:00) America/Indiana/Marengo
 * * `America/Indiana/Petersburg` - (GMT-05:00) America/Indiana/Petersburg
 * * `America/Indiana/Vevay` - (GMT-05:00) America/Indiana/Vevay
 * * `America/Indiana/Vincennes` - (GMT-05:00) America/Indiana/Vincennes
 * * `America/Indiana/Winamac` - (GMT-05:00) America/Indiana/Winamac
 * * `America/Iqaluit` - (GMT-05:00) America/Iqaluit
 * * `America/Jamaica` - (GMT-05:00) America/Jamaica
 * * `America/Kentucky/Louisville` - (GMT-05:00) America/Kentucky/Louisville
 * * `America/Kentucky/Monticello` - (GMT-05:00) America/Kentucky/Monticello
 * * `America/Lima` - (GMT-05:00) America/Lima
 * * `America/Nassau` - (GMT-05:00) America/Nassau
 * * `America/New_York` - (GMT-05:00) America/New_York
 * * `America/Panama` - (GMT-05:00) America/Panama
 * * `America/Port-au-Prince` - (GMT-05:00) America/Port-au-Prince
 * * `America/Rio_Branco` - (GMT-05:00) America/Rio_Branco
 * * `America/Toronto` - (GMT-05:00) America/Toronto
 * * `Canada/Eastern` - (GMT-05:00) Canada/Eastern
 * * `Pacific/Easter` - (GMT-05:00) Pacific/Easter
 * * `US/Eastern` - (GMT-05:00) US/Eastern
 * * `America/Anguilla` - (GMT-04:00) America/Anguilla
 * * `America/Antigua` - (GMT-04:00) America/Antigua
 * * `America/Aruba` - (GMT-04:00) America/Aruba
 * * `America/Barbados` - (GMT-04:00) America/Barbados
 * * `America/Blanc-Sablon` - (GMT-04:00) America/Blanc-Sablon
 * * `America/Boa_Vista` - (GMT-04:00) America/Boa_Vista
 * * `America/Campo_Grande` - (GMT-04:00) America/Campo_Grande
 * * `America/Caracas` - (GMT-04:00) America/Caracas
 * * `America/Cuiaba` - (GMT-04:00) America/Cuiaba
 * * `America/Curacao` - (GMT-04:00) America/Curacao
 * * `America/Dominica` - (GMT-04:00) America/Dominica
 * * `America/Glace_Bay` - (GMT-04:00) America/Glace_Bay
 * * `America/Goose_Bay` - (GMT-04:00) America/Goose_Bay
 * * `America/Grenada` - (GMT-04:00) America/Grenada
 * * `America/Guadeloupe` - (GMT-04:00) America/Guadeloupe
 * * `America/Guyana` - (GMT-04:00) America/Guyana
 * * `America/Halifax` - (GMT-04:00) America/Halifax
 * * `America/Kralendijk` - (GMT-04:00) America/Kralendijk
 * * `America/La_Paz` - (GMT-04:00) America/La_Paz
 * * `America/Lower_Princes` - (GMT-04:00) America/Lower_Princes
 * * `America/Manaus` - (GMT-04:00) America/Manaus
 * * `America/Marigot` - (GMT-04:00) America/Marigot
 * * `America/Martinique` - (GMT-04:00) America/Martinique
 * * `America/Moncton` - (GMT-04:00) America/Moncton
 * * `America/Montserrat` - (GMT-04:00) America/Montserrat
 * * `America/Port_of_Spain` - (GMT-04:00) America/Port_of_Spain
 * * `America/Porto_Velho` - (GMT-04:00) America/Porto_Velho
 * * `America/Puerto_Rico` - (GMT-04:00) America/Puerto_Rico
 * * `America/Santo_Domingo` - (GMT-04:00) America/Santo_Domingo
 * * `America/St_Barthelemy` - (GMT-04:00) America/St_Barthelemy
 * * `America/St_Kitts` - (GMT-04:00) America/St_Kitts
 * * `America/St_Lucia` - (GMT-04:00) America/St_Lucia
 * * `America/St_Thomas` - (GMT-04:00) America/St_Thomas
 * * `America/St_Vincent` - (GMT-04:00) America/St_Vincent
 * * `America/Thule` - (GMT-04:00) America/Thule
 * * `America/Tortola` - (GMT-04:00) America/Tortola
 * * `Atlantic/Bermuda` - (GMT-04:00) Atlantic/Bermuda
 * * `Canada/Atlantic` - (GMT-04:00) Canada/Atlantic
 * * `America/St_Johns` - (GMT-03:30) America/St_Johns
 * * `Canada/Newfoundland` - (GMT-03:30) Canada/Newfoundland
 * * `America/Araguaina` - (GMT-03:00) America/Araguaina
 * * `America/Argentina/Buenos_Aires` - (GMT-03:00) America/Argentina/Buenos_Aires
 * * `America/Argentina/Catamarca` - (GMT-03:00) America/Argentina/Catamarca
 * * `America/Argentina/Cordoba` - (GMT-03:00) America/Argentina/Cordoba
 * * `America/Argentina/Jujuy` - (GMT-03:00) America/Argentina/Jujuy
 * * `America/Argentina/La_Rioja` - (GMT-03:00) America/Argentina/La_Rioja
 * * `America/Argentina/Mendoza` - (GMT-03:00) America/Argentina/Mendoza
 * * `America/Argentina/Rio_Gallegos` - (GMT-03:00) America/Argentina/Rio_Gallegos
 * * `America/Argentina/Salta` - (GMT-03:00) America/Argentina/Salta
 * * `America/Argentina/San_Juan` - (GMT-03:00) America/Argentina/San_Juan
 * * `America/Argentina/San_Luis` - (GMT-03:00) America/Argentina/San_Luis
 * * `America/Argentina/Tucuman` - (GMT-03:00) America/Argentina/Tucuman
 * * `America/Argentina/Ushuaia` - (GMT-03:00) America/Argentina/Ushuaia
 * * `America/Asuncion` - (GMT-03:00) America/Asuncion
 * * `America/Bahia` - (GMT-03:00) America/Bahia
 * * `America/Belem` - (GMT-03:00) America/Belem
 * * `America/Cayenne` - (GMT-03:00) America/Cayenne
 * * `America/Fortaleza` - (GMT-03:00) America/Fortaleza
 * * `America/Maceio` - (GMT-03:00) America/Maceio
 * * `America/Miquelon` - (GMT-03:00) America/Miquelon
 * * `America/Montevideo` - (GMT-03:00) America/Montevideo
 * * `America/Paramaribo` - (GMT-03:00) America/Paramaribo
 * * `America/Punta_Arenas` - (GMT-03:00) America/Punta_Arenas
 * * `America/Recife` - (GMT-03:00) America/Recife
 * * `America/Santarem` - (GMT-03:00) America/Santarem
 * * `America/Santiago` - (GMT-03:00) America/Santiago
 * * `America/Sao_Paulo` - (GMT-03:00) America/Sao_Paulo
 * * `Antarctica/Palmer` - (GMT-03:00) Antarctica/Palmer
 * * `Antarctica/Rothera` - (GMT-03:00) Antarctica/Rothera
 * * `Atlantic/Stanley` - (GMT-03:00) Atlantic/Stanley
 * * `America/Noronha` - (GMT-02:00) America/Noronha
 * * `America/Nuuk` - (GMT-02:00) America/Nuuk
 * * `America/Scoresbysund` - (GMT-02:00) America/Scoresbysund
 * * `Atlantic/South_Georgia` - (GMT-02:00) Atlantic/South_Georgia
 * * `Atlantic/Azores` - (GMT-01:00) Atlantic/Azores
 * * `Atlantic/Cape_Verde` - (GMT-01:00) Atlantic/Cape_Verde
 * * `Africa/Abidjan` - (GMT+00:00) Africa/Abidjan
 * * `Africa/Accra` - (GMT+00:00) Africa/Accra
 * * `Africa/Bamako` - (GMT+00:00) Africa/Bamako
 * * `Africa/Banjul` - (GMT+00:00) Africa/Banjul
 * * `Africa/Bissau` - (GMT+00:00) Africa/Bissau
 * * `Africa/Conakry` - (GMT+00:00) Africa/Conakry
 * * `Africa/Dakar` - (GMT+00:00) Africa/Dakar
 * * `Africa/Freetown` - (GMT+00:00) Africa/Freetown
 * * `Africa/Lome` - (GMT+00:00) Africa/Lome
 * * `Africa/Monrovia` - (GMT+00:00) Africa/Monrovia
 * * `Africa/Nouakchott` - (GMT+00:00) Africa/Nouakchott
 * * `Africa/Ouagadougou` - (GMT+00:00) Africa/Ouagadougou
 * * `Africa/Sao_Tome` - (GMT+00:00) Africa/Sao_Tome
 * * `America/Danmarkshavn` - (GMT+00:00) America/Danmarkshavn
 * * `Antarctica/Troll` - (GMT+00:00) Antarctica/Troll
 * * `Atlantic/Canary` - (GMT+00:00) Atlantic/Canary
 * * `Atlantic/Faroe` - (GMT+00:00) Atlantic/Faroe
 * * `Atlantic/Madeira` - (GMT+00:00) Atlantic/Madeira
 * * `Atlantic/Reykjavik` - (GMT+00:00) Atlantic/Reykjavik
 * * `Atlantic/St_Helena` - (GMT+00:00) Atlantic/St_Helena
 * * `Europe/Dublin` - (GMT+00:00) Europe/Dublin
 * * `Europe/Guernsey` - (GMT+00:00) Europe/Guernsey
 * * `Europe/Isle_of_Man` - (GMT+00:00) Europe/Isle_of_Man
 * * `Europe/Jersey` - (GMT+00:00) Europe/Jersey
 * * `Europe/Lisbon` - (GMT+00:00) Europe/Lisbon
 * * `Europe/London` - (GMT+00:00) Europe/London
 * * `GMT` - (GMT+00:00) GMT
 * * `UTC` - (GMT+00:00) UTC
 * * `Africa/Algiers` - (GMT+01:00) Africa/Algiers
 * * `Africa/Bangui` - (GMT+01:00) Africa/Bangui
 * * `Africa/Brazzaville` - (GMT+01:00) Africa/Brazzaville
 * * `Africa/Casablanca` - (GMT+01:00) Africa/Casablanca
 * * `Africa/Ceuta` - (GMT+01:00) Africa/Ceuta
 * * `Africa/Douala` - (GMT+01:00) Africa/Douala
 * * `Africa/El_Aaiun` - (GMT+01:00) Africa/El_Aaiun
 * * `Africa/Kinshasa` - (GMT+01:00) Africa/Kinshasa
 * * `Africa/Lagos` - (GMT+01:00) Africa/Lagos
 * * `Africa/Libreville` - (GMT+01:00) Africa/Libreville
 * * `Africa/Luanda` - (GMT+01:00) Africa/Luanda
 * * `Africa/Malabo` - (GMT+01:00) Africa/Malabo
 * * `Africa/Ndjamena` - (GMT+01:00) Africa/Ndjamena
 * * `Africa/Niamey` - (GMT+01:00) Africa/Niamey
 * * `Africa/Porto-Novo` - (GMT+01:00) Africa/Porto-Novo
 * * `Africa/Tunis` - (GMT+01:00) Africa/Tunis
 * * `Arctic/Longyearbyen` - (GMT+01:00) Arctic/Longyearbyen
 * * `Europe/Amsterdam` - (GMT+01:00) Europe/Amsterdam
 * * `Europe/Andorra` - (GMT+01:00) Europe/Andorra
 * * `Europe/Belgrade` - (GMT+01:00) Europe/Belgrade
 * * `Europe/Berlin` - (GMT+01:00) Europe/Berlin
 * * `Europe/Bratislava` - (GMT+01:00) Europe/Bratislava
 * * `Europe/Brussels` - (GMT+01:00) Europe/Brussels
 * * `Europe/Budapest` - (GMT+01:00) Europe/Budapest
 * * `Europe/Busingen` - (GMT+01:00) Europe/Busingen
 * * `Europe/Copenhagen` - (GMT+01:00) Europe/Copenhagen
 * * `Europe/Gibraltar` - (GMT+01:00) Europe/Gibraltar
 * * `Europe/Ljubljana` - (GMT+01:00) Europe/Ljubljana
 * * `Europe/Luxembourg` - (GMT+01:00) Europe/Luxembourg
 * * `Europe/Madrid` - (GMT+01:00) Europe/Madrid
 * * `Europe/Malta` - (GMT+01:00) Europe/Malta
 * * `Europe/Monaco` - (GMT+01:00) Europe/Monaco
 * * `Europe/Oslo` - (GMT+01:00) Europe/Oslo
 * * `Europe/Paris` - (GMT+01:00) Europe/Paris
 * * `Europe/Podgorica` - (GMT+01:00) Europe/Podgorica
 * * `Europe/Prague` - (GMT+01:00) Europe/Prague
 * * `Europe/Rome` - (GMT+01:00) Europe/Rome
 * * `Europe/San_Marino` - (GMT+01:00) Europe/San_Marino
 * * `Europe/Sarajevo` - (GMT+01:00) Europe/Sarajevo
 * * `Europe/Skopje` - (GMT+01:00) Europe/Skopje
 * * `Europe/Stockholm` - (GMT+01:00) Europe/Stockholm
 * * `Europe/Tirane` - (GMT+01:00) Europe/Tirane
 * * `Europe/Vaduz` - (GMT+01:00) Europe/Vaduz
 * * `Europe/Vatican` - (GMT+01:00) Europe/Vatican
 * * `Europe/Vienna` - (GMT+01:00) Europe/Vienna
 * * `Europe/Warsaw` - (GMT+01:00) Europe/Warsaw
 * * `Europe/Zagreb` - (GMT+01:00) Europe/Zagreb
 * * `Europe/Zurich` - (GMT+01:00) Europe/Zurich
 * * `Africa/Blantyre` - (GMT+02:00) Africa/Blantyre
 * * `Africa/Bujumbura` - (GMT+02:00) Africa/Bujumbura
 * * `Africa/Cairo` - (GMT+02:00) Africa/Cairo
 * * `Africa/Gaborone` - (GMT+02:00) Africa/Gaborone
 * * `Africa/Harare` - (GMT+02:00) Africa/Harare
 * * `Africa/Johannesburg` - (GMT+02:00) Africa/Johannesburg
 * * `Africa/Juba` - (GMT+02:00) Africa/Juba
 * * `Africa/Khartoum` - (GMT+02:00) Africa/Khartoum
 * * `Africa/Kigali` - (GMT+02:00) Africa/Kigali
 * * `Africa/Lubumbashi` - (GMT+02:00) Africa/Lubumbashi
 * * `Africa/Lusaka` - (GMT+02:00) Africa/Lusaka
 * * `Africa/Maputo` - (GMT+02:00) Africa/Maputo
 * * `Africa/Maseru` - (GMT+02:00) Africa/Maseru
 * * `Africa/Mbabane` - (GMT+02:00) Africa/Mbabane
 * * `Africa/Tripoli` - (GMT+02:00) Africa/Tripoli
 * * `Africa/Windhoek` - (GMT+02:00) Africa/Windhoek
 * * `Asia/Beirut` - (GMT+02:00) Asia/Beirut
 * * `Asia/Famagusta` - (GMT+02:00) Asia/Famagusta
 * * `Asia/Gaza` - (GMT+02:00) Asia/Gaza
 * * `Asia/Hebron` - (GMT+02:00) Asia/Hebron
 * * `Asia/Jerusalem` - (GMT+02:00) Asia/Jerusalem
 * * `Asia/Nicosia` - (GMT+02:00) Asia/Nicosia
 * * `Europe/Athens` - (GMT+02:00) Europe/Athens
 * * `Europe/Bucharest` - (GMT+02:00) Europe/Bucharest
 * * `Europe/Chisinau` - (GMT+02:00) Europe/Chisinau
 * * `Europe/Helsinki` - (GMT+02:00) Europe/Helsinki
 * * `Europe/Kaliningrad` - (GMT+02:00) Europe/Kaliningrad
 * * `Europe/Kyiv` - (GMT+02:00) Europe/Kyiv
 * * `Europe/Mariehamn` - (GMT+02:00) Europe/Mariehamn
 * * `Europe/Riga` - (GMT+02:00) Europe/Riga
 * * `Europe/Sofia` - (GMT+02:00) Europe/Sofia
 * * `Europe/Tallinn` - (GMT+02:00) Europe/Tallinn
 * * `Europe/Vilnius` - (GMT+02:00) Europe/Vilnius
 * * `Africa/Addis_Ababa` - (GMT+03:00) Africa/Addis_Ababa
 * * `Africa/Asmara` - (GMT+03:00) Africa/Asmara
 * * `Africa/Dar_es_Salaam` - (GMT+03:00) Africa/Dar_es_Salaam
 * * `Africa/Djibouti` - (GMT+03:00) Africa/Djibouti
 * * `Africa/Kampala` - (GMT+03:00) Africa/Kampala
 * * `Africa/Mogadishu` - (GMT+03:00) Africa/Mogadishu
 * * `Africa/Nairobi` - (GMT+03:00) Africa/Nairobi
 * * `Antarctica/Syowa` - (GMT+03:00) Antarctica/Syowa
 * * `Asia/Aden` - (GMT+03:00) Asia/Aden
 * * `Asia/Amman` - (GMT+03:00) Asia/Amman
 * * `Asia/Baghdad` - (GMT+03:00) Asia/Baghdad
 * * `Asia/Bahrain` - (GMT+03:00) Asia/Bahrain
 * * `Asia/Damascus` - (GMT+03:00) Asia/Damascus
 * * `Asia/Kuwait` - (GMT+03:00) Asia/Kuwait
 * * `Asia/Qatar` - (GMT+03:00) Asia/Qatar
 * * `Asia/Riyadh` - (GMT+03:00) Asia/Riyadh
 * * `Europe/Istanbul` - (GMT+03:00) Europe/Istanbul
 * * `Europe/Kirov` - (GMT+03:00) Europe/Kirov
 * * `Europe/Minsk` - (GMT+03:00) Europe/Minsk
 * * `Europe/Moscow` - (GMT+03:00) Europe/Moscow
 * * `Europe/Simferopol` - (GMT+03:00) Europe/Simferopol
 * * `Europe/Volgograd` - (GMT+03:00) Europe/Volgograd
 * * `Indian/Antananarivo` - (GMT+03:00) Indian/Antananarivo
 * * `Indian/Comoro` - (GMT+03:00) Indian/Comoro
 * * `Indian/Mayotte` - (GMT+03:00) Indian/Mayotte
 * * `Asia/Tehran` - (GMT+03:30) Asia/Tehran
 * * `Asia/Baku` - (GMT+04:00) Asia/Baku
 * * `Asia/Dubai` - (GMT+04:00) Asia/Dubai
 * * `Asia/Muscat` - (GMT+04:00) Asia/Muscat
 * * `Asia/Tbilisi` - (GMT+04:00) Asia/Tbilisi
 * * `Asia/Yerevan` - (GMT+04:00) Asia/Yerevan
 * * `Europe/Astrakhan` - (GMT+04:00) Europe/Astrakhan
 * * `Europe/Samara` - (GMT+04:00) Europe/Samara
 * * `Europe/Saratov` - (GMT+04:00) Europe/Saratov
 * * `Europe/Ulyanovsk` - (GMT+04:00) Europe/Ulyanovsk
 * * `Indian/Mahe` - (GMT+04:00) Indian/Mahe
 * * `Indian/Mauritius` - (GMT+04:00) Indian/Mauritius
 * * `Indian/Reunion` - (GMT+04:00) Indian/Reunion
 * * `Asia/Kabul` - (GMT+04:30) Asia/Kabul
 * * `Antarctica/Mawson` - (GMT+05:00) Antarctica/Mawson
 * * `Antarctica/Vostok` - (GMT+05:00) Antarctica/Vostok
 * * `Asia/Almaty` - (GMT+05:00) Asia/Almaty
 * * `Asia/Aqtau` - (GMT+05:00) Asia/Aqtau
 * * `Asia/Aqtobe` - (GMT+05:00) Asia/Aqtobe
 * * `Asia/Ashgabat` - (GMT+05:00) Asia/Ashgabat
 * * `Asia/Atyrau` - (GMT+05:00) Asia/Atyrau
 * * `Asia/Dushanbe` - (GMT+05:00) Asia/Dushanbe
 * * `Asia/Karachi` - (GMT+05:00) Asia/Karachi
 * * `Asia/Oral` - (GMT+05:00) Asia/Oral
 * * `Asia/Qostanay` - (GMT+05:00) Asia/Qostanay
 * * `Asia/Qyzylorda` - (GMT+05:00) Asia/Qyzylorda
 * * `Asia/Samarkand` - (GMT+05:00) Asia/Samarkand
 * * `Asia/Tashkent` - (GMT+05:00) Asia/Tashkent
 * * `Asia/Yekaterinburg` - (GMT+05:00) Asia/Yekaterinburg
 * * `Indian/Kerguelen` - (GMT+05:00) Indian/Kerguelen
 * * `Indian/Maldives` - (GMT+05:00) Indian/Maldives
 * * `Asia/Colombo` - (GMT+05:30) Asia/Colombo
 * * `Asia/Kolkata` - (GMT+05:30) Asia/Kolkata
 * * `Asia/Kathmandu` - (GMT+05:45) Asia/Kathmandu
 * * `Asia/Bishkek` - (GMT+06:00) Asia/Bishkek
 * * `Asia/Dhaka` - (GMT+06:00) Asia/Dhaka
 * * `Asia/Omsk` - (GMT+06:00) Asia/Omsk
 * * `Asia/Thimphu` - (GMT+06:00) Asia/Thimphu
 * * `Asia/Urumqi` - (GMT+06:00) Asia/Urumqi
 * * `Indian/Chagos` - (GMT+06:00) Indian/Chagos
 * * `Asia/Yangon` - (GMT+06:30) Asia/Yangon
 * * `Indian/Cocos` - (GMT+06:30) Indian/Cocos
 * * `Antarctica/Davis` - (GMT+07:00) Antarctica/Davis
 * * `Asia/Bangkok` - (GMT+07:00) Asia/Bangkok
 * * `Asia/Barnaul` - (GMT+07:00) Asia/Barnaul
 * * `Asia/Ho_Chi_Minh` - (GMT+07:00) Asia/Ho_Chi_Minh
 * * `Asia/Hovd` - (GMT+07:00) Asia/Hovd
 * * `Asia/Jakarta` - (GMT+07:00) Asia/Jakarta
 * * `Asia/Krasnoyarsk` - (GMT+07:00) Asia/Krasnoyarsk
 * * `Asia/Novokuznetsk` - (GMT+07:00) Asia/Novokuznetsk
 * * `Asia/Novosibirsk` - (GMT+07:00) Asia/Novosibirsk
 * * `Asia/Phnom_Penh` - (GMT+07:00) Asia/Phnom_Penh
 * * `Asia/Pontianak` - (GMT+07:00) Asia/Pontianak
 * * `Asia/Tomsk` - (GMT+07:00) Asia/Tomsk
 * * `Asia/Vientiane` - (GMT+07:00) Asia/Vientiane
 * * `Indian/Christmas` - (GMT+07:00) Indian/Christmas
 * * `Antarctica/Casey` - (GMT+08:00) Antarctica/Casey
 * * `Asia/Brunei` - (GMT+08:00) Asia/Brunei
 * * `Asia/Hong_Kong` - (GMT+08:00) Asia/Hong_Kong
 * * `Asia/Irkutsk` - (GMT+08:00) Asia/Irkutsk
 * * `Asia/Kuala_Lumpur` - (GMT+08:00) Asia/Kuala_Lumpur
 * * `Asia/Kuching` - (GMT+08:00) Asia/Kuching
 * * `Asia/Macau` - (GMT+08:00) Asia/Macau
 * * `Asia/Makassar` - (GMT+08:00) Asia/Makassar
 * * `Asia/Manila` - (GMT+08:00) Asia/Manila
 * * `Asia/Shanghai` - (GMT+08:00) Asia/Shanghai
 * * `Asia/Singapore` - (GMT+08:00) Asia/Singapore
 * * `Asia/Taipei` - (GMT+08:00) Asia/Taipei
 * * `Asia/Ulaanbaatar` - (GMT+08:00) Asia/Ulaanbaatar
 * * `Australia/Perth` - (GMT+08:00) Australia/Perth
 * * `Australia/Eucla` - (GMT+08:45) Australia/Eucla
 * * `Asia/Chita` - (GMT+09:00) Asia/Chita
 * * `Asia/Dili` - (GMT+09:00) Asia/Dili
 * * `Asia/Jayapura` - (GMT+09:00) Asia/Jayapura
 * * `Asia/Khandyga` - (GMT+09:00) Asia/Khandyga
 * * `Asia/Pyongyang` - (GMT+09:00) Asia/Pyongyang
 * * `Asia/Seoul` - (GMT+09:00) Asia/Seoul
 * * `Asia/Tokyo` - (GMT+09:00) Asia/Tokyo
 * * `Asia/Yakutsk` - (GMT+09:00) Asia/Yakutsk
 * * `Pacific/Palau` - (GMT+09:00) Pacific/Palau
 * * `Australia/Darwin` - (GMT+09:30) Australia/Darwin
 * * `Antarctica/DumontDUrville` - (GMT+10:00) Antarctica/DumontDUrville
 * * `Asia/Ust-Nera` - (GMT+10:00) Asia/Ust-Nera
 * * `Asia/Vladivostok` - (GMT+10:00) Asia/Vladivostok
 * * `Australia/Brisbane` - (GMT+10:00) Australia/Brisbane
 * * `Australia/Lindeman` - (GMT+10:00) Australia/Lindeman
 * * `Pacific/Chuuk` - (GMT+10:00) Pacific/Chuuk
 * * `Pacific/Guam` - (GMT+10:00) Pacific/Guam
 * * `Pacific/Port_Moresby` - (GMT+10:00) Pacific/Port_Moresby
 * * `Pacific/Saipan` - (GMT+10:00) Pacific/Saipan
 * * `Australia/Adelaide` - (GMT+10:30) Australia/Adelaide
 * * `Australia/Broken_Hill` - (GMT+10:30) Australia/Broken_Hill
 * * `Antarctica/Macquarie` - (GMT+11:00) Antarctica/Macquarie
 * * `Asia/Magadan` - (GMT+11:00) Asia/Magadan
 * * `Asia/Sakhalin` - (GMT+11:00) Asia/Sakhalin
 * * `Asia/Srednekolymsk` - (GMT+11:00) Asia/Srednekolymsk
 * * `Australia/Hobart` - (GMT+11:00) Australia/Hobart
 * * `Australia/Lord_Howe` - (GMT+11:00) Australia/Lord_Howe
 * * `Australia/Melbourne` - (GMT+11:00) Australia/Melbourne
 * * `Australia/Sydney` - (GMT+11:00) Australia/Sydney
 * * `Pacific/Bougainville` - (GMT+11:00) Pacific/Bougainville
 * * `Pacific/Efate` - (GMT+11:00) Pacific/Efate
 * * `Pacific/Guadalcanal` - (GMT+11:00) Pacific/Guadalcanal
 * * `Pacific/Kosrae` - (GMT+11:00) Pacific/Kosrae
 * * `Pacific/Noumea` - (GMT+11:00) Pacific/Noumea
 * * `Pacific/Pohnpei` - (GMT+11:00) Pacific/Pohnpei
 * * `Asia/Anadyr` - (GMT+12:00) Asia/Anadyr
 * * `Asia/Kamchatka` - (GMT+12:00) Asia/Kamchatka
 * * `Pacific/Fiji` - (GMT+12:00) Pacific/Fiji
 * * `Pacific/Funafuti` - (GMT+12:00) Pacific/Funafuti
 * * `Pacific/Kwajalein` - (GMT+12:00) Pacific/Kwajalein
 * * `Pacific/Majuro` - (GMT+12:00) Pacific/Majuro
 * * `Pacific/Nauru` - (GMT+12:00) Pacific/Nauru
 * * `Pacific/Norfolk` - (GMT+12:00) Pacific/Norfolk
 * * `Pacific/Tarawa` - (GMT+12:00) Pacific/Tarawa
 * * `Pacific/Wake` - (GMT+12:00) Pacific/Wake
 * * `Pacific/Wallis` - (GMT+12:00) Pacific/Wallis
 * * `Antarctica/McMurdo` - (GMT+13:00) Antarctica/McMurdo
 * * `Pacific/Apia` - (GMT+13:00) Pacific/Apia
 * * `Pacific/Auckland` - (GMT+13:00) Pacific/Auckland
 * * `Pacific/Fakaofo` - (GMT+13:00) Pacific/Fakaofo
 * * `Pacific/Kanton` - (GMT+13:00) Pacific/Kanton
 * * `Pacific/Tongatapu` - (GMT+13:00) Pacific/Tongatapu
 * * `Pacific/Chatham` - (GMT+13:45) Pacific/Chatham
 * * `Pacific/Kiritimati` - (GMT+14:00) Pacific/Kiritimati
 */
export enum TimezoneEnum {
  PacificMidway = 'Pacific/Midway',
  PacificNiue = 'Pacific/Niue',
  PacificPagoPago = 'Pacific/Pago_Pago',
  AmericaAdak = 'America/Adak',
  PacificHonolulu = 'Pacific/Honolulu',
  PacificRarotonga = 'Pacific/Rarotonga',
  PacificTahiti = 'Pacific/Tahiti',
  USHawaii = 'US/Hawaii',
  PacificMarquesas = 'Pacific/Marquesas',
  AmericaAnchorage = 'America/Anchorage',
  AmericaJuneau = 'America/Juneau',
  AmericaMetlakatla = 'America/Metlakatla',
  AmericaNome = 'America/Nome',
  AmericaSitka = 'America/Sitka',
  AmericaYakutat = 'America/Yakutat',
  PacificGambier = 'Pacific/Gambier',
  USAlaska = 'US/Alaska',
  AmericaLosAngeles = 'America/Los_Angeles',
  AmericaTijuana = 'America/Tijuana',
  AmericaVancouver = 'America/Vancouver',
  CanadaPacific = 'Canada/Pacific',
  PacificPitcairn = 'Pacific/Pitcairn',
  USPacific = 'US/Pacific',
  AmericaBoise = 'America/Boise',
  AmericaCambridgeBay = 'America/Cambridge_Bay',
  AmericaCiudadJuarez = 'America/Ciudad_Juarez',
  AmericaCreston = 'America/Creston',
  AmericaDawson = 'America/Dawson',
  AmericaDawsonCreek = 'America/Dawson_Creek',
  AmericaDenver = 'America/Denver',
  AmericaEdmonton = 'America/Edmonton',
  AmericaFortNelson = 'America/Fort_Nelson',
  AmericaHermosillo = 'America/Hermosillo',
  AmericaInuvik = 'America/Inuvik',
  AmericaMazatlan = 'America/Mazatlan',
  AmericaPhoenix = 'America/Phoenix',
  AmericaWhitehorse = 'America/Whitehorse',
  CanadaMountain = 'Canada/Mountain',
  USArizona = 'US/Arizona',
  USMountain = 'US/Mountain',
  AmericaBahiaBanderas = 'America/Bahia_Banderas',
  AmericaBelize = 'America/Belize',
  AmericaChicago = 'America/Chicago',
  AmericaChihuahua = 'America/Chihuahua',
  AmericaCostaRica = 'America/Costa_Rica',
  AmericaElSalvador = 'America/El_Salvador',
  AmericaGuatemala = 'America/Guatemala',
  AmericaIndianaKnox = 'America/Indiana/Knox',
  AmericaIndianaTellCity = 'America/Indiana/Tell_City',
  AmericaManagua = 'America/Managua',
  AmericaMatamoros = 'America/Matamoros',
  AmericaMenominee = 'America/Menominee',
  AmericaMerida = 'America/Merida',
  AmericaMexicoCity = 'America/Mexico_City',
  AmericaMonterrey = 'America/Monterrey',
  AmericaNorthDakotaBeulah = 'America/North_Dakota/Beulah',
  AmericaNorthDakotaCenter = 'America/North_Dakota/Center',
  AmericaNorthDakotaNewSalem = 'America/North_Dakota/New_Salem',
  AmericaOjinaga = 'America/Ojinaga',
  AmericaRankinInlet = 'America/Rankin_Inlet',
  AmericaRegina = 'America/Regina',
  AmericaResolute = 'America/Resolute',
  AmericaSwiftCurrent = 'America/Swift_Current',
  AmericaTegucigalpa = 'America/Tegucigalpa',
  AmericaWinnipeg = 'America/Winnipeg',
  CanadaCentral = 'Canada/Central',
  PacificGalapagos = 'Pacific/Galapagos',
  USCentral = 'US/Central',
  AmericaAtikokan = 'America/Atikokan',
  AmericaBogota = 'America/Bogota',
  AmericaCancun = 'America/Cancun',
  AmericaCayman = 'America/Cayman',
  AmericaDetroit = 'America/Detroit',
  AmericaEirunepe = 'America/Eirunepe',
  AmericaGrandTurk = 'America/Grand_Turk',
  AmericaGuayaquil = 'America/Guayaquil',
  AmericaHavana = 'America/Havana',
  AmericaIndianaIndianapolis = 'America/Indiana/Indianapolis',
  AmericaIndianaMarengo = 'America/Indiana/Marengo',
  AmericaIndianaPetersburg = 'America/Indiana/Petersburg',
  AmericaIndianaVevay = 'America/Indiana/Vevay',
  AmericaIndianaVincennes = 'America/Indiana/Vincennes',
  AmericaIndianaWinamac = 'America/Indiana/Winamac',
  AmericaIqaluit = 'America/Iqaluit',
  AmericaJamaica = 'America/Jamaica',
  AmericaKentuckyLouisville = 'America/Kentucky/Louisville',
  AmericaKentuckyMonticello = 'America/Kentucky/Monticello',
  AmericaLima = 'America/Lima',
  AmericaNassau = 'America/Nassau',
  AmericaNewYork = 'America/New_York',
  AmericaPanama = 'America/Panama',
  AmericaPortAuPrince = 'America/Port-au-Prince',
  AmericaRioBranco = 'America/Rio_Branco',
  AmericaToronto = 'America/Toronto',
  CanadaEastern = 'Canada/Eastern',
  PacificEaster = 'Pacific/Easter',
  USEastern = 'US/Eastern',
  AmericaAnguilla = 'America/Anguilla',
  AmericaAntigua = 'America/Antigua',
  AmericaAruba = 'America/Aruba',
  AmericaBarbados = 'America/Barbados',
  AmericaBlancSablon = 'America/Blanc-Sablon',
  AmericaBoaVista = 'America/Boa_Vista',
  AmericaCampoGrande = 'America/Campo_Grande',
  AmericaCaracas = 'America/Caracas',
  AmericaCuiaba = 'America/Cuiaba',
  AmericaCuracao = 'America/Curacao',
  AmericaDominica = 'America/Dominica',
  AmericaGlaceBay = 'America/Glace_Bay',
  AmericaGooseBay = 'America/Goose_Bay',
  AmericaGrenada = 'America/Grenada',
  AmericaGuadeloupe = 'America/Guadeloupe',
  AmericaGuyana = 'America/Guyana',
  AmericaHalifax = 'America/Halifax',
  AmericaKralendijk = 'America/Kralendijk',
  AmericaLaPaz = 'America/La_Paz',
  AmericaLowerPrinces = 'America/Lower_Princes',
  AmericaManaus = 'America/Manaus',
  AmericaMarigot = 'America/Marigot',
  AmericaMartinique = 'America/Martinique',
  AmericaMoncton = 'America/Moncton',
  AmericaMontserrat = 'America/Montserrat',
  AmericaPortOfSpain = 'America/Port_of_Spain',
  AmericaPortoVelho = 'America/Porto_Velho',
  AmericaPuertoRico = 'America/Puerto_Rico',
  AmericaSantoDomingo = 'America/Santo_Domingo',
  AmericaStBarthelemy = 'America/St_Barthelemy',
  AmericaStKitts = 'America/St_Kitts',
  AmericaStLucia = 'America/St_Lucia',
  AmericaStThomas = 'America/St_Thomas',
  AmericaStVincent = 'America/St_Vincent',
  AmericaThule = 'America/Thule',
  AmericaTortola = 'America/Tortola',
  AtlanticBermuda = 'Atlantic/Bermuda',
  CanadaAtlantic = 'Canada/Atlantic',
  AmericaStJohns = 'America/St_Johns',
  CanadaNewfoundland = 'Canada/Newfoundland',
  AmericaAraguaina = 'America/Araguaina',
  AmericaArgentinaBuenosAires = 'America/Argentina/Buenos_Aires',
  AmericaArgentinaCatamarca = 'America/Argentina/Catamarca',
  AmericaArgentinaCordoba = 'America/Argentina/Cordoba',
  AmericaArgentinaJujuy = 'America/Argentina/Jujuy',
  AmericaArgentinaLaRioja = 'America/Argentina/La_Rioja',
  AmericaArgentinaMendoza = 'America/Argentina/Mendoza',
  AmericaArgentinaRioGallegos = 'America/Argentina/Rio_Gallegos',
  AmericaArgentinaSalta = 'America/Argentina/Salta',
  AmericaArgentinaSanJuan = 'America/Argentina/San_Juan',
  AmericaArgentinaSanLuis = 'America/Argentina/San_Luis',
  AmericaArgentinaTucuman = 'America/Argentina/Tucuman',
  AmericaArgentinaUshuaia = 'America/Argentina/Ushuaia',
  AmericaAsuncion = 'America/Asuncion',
  AmericaBahia = 'America/Bahia',
  AmericaBelem = 'America/Belem',
  AmericaCayenne = 'America/Cayenne',
  AmericaFortaleza = 'America/Fortaleza',
  AmericaMaceio = 'America/Maceio',
  AmericaMiquelon = 'America/Miquelon',
  AmericaMontevideo = 'America/Montevideo',
  AmericaParamaribo = 'America/Paramaribo',
  AmericaPuntaArenas = 'America/Punta_Arenas',
  AmericaRecife = 'America/Recife',
  AmericaSantarem = 'America/Santarem',
  AmericaSantiago = 'America/Santiago',
  AmericaSaoPaulo = 'America/Sao_Paulo',
  AntarcticaPalmer = 'Antarctica/Palmer',
  AntarcticaRothera = 'Antarctica/Rothera',
  AtlanticStanley = 'Atlantic/Stanley',
  AmericaNoronha = 'America/Noronha',
  AmericaNuuk = 'America/Nuuk',
  AmericaScoresbysund = 'America/Scoresbysund',
  AtlanticSouthGeorgia = 'Atlantic/South_Georgia',
  AtlanticAzores = 'Atlantic/Azores',
  AtlanticCapeVerde = 'Atlantic/Cape_Verde',
  AfricaAbidjan = 'Africa/Abidjan',
  AfricaAccra = 'Africa/Accra',
  AfricaBamako = 'Africa/Bamako',
  AfricaBanjul = 'Africa/Banjul',
  AfricaBissau = 'Africa/Bissau',
  AfricaConakry = 'Africa/Conakry',
  AfricaDakar = 'Africa/Dakar',
  AfricaFreetown = 'Africa/Freetown',
  AfricaLome = 'Africa/Lome',
  AfricaMonrovia = 'Africa/Monrovia',
  AfricaNouakchott = 'Africa/Nouakchott',
  AfricaOuagadougou = 'Africa/Ouagadougou',
  AfricaSaoTome = 'Africa/Sao_Tome',
  AmericaDanmarkshavn = 'America/Danmarkshavn',
  AntarcticaTroll = 'Antarctica/Troll',
  AtlanticCanary = 'Atlantic/Canary',
  AtlanticFaroe = 'Atlantic/Faroe',
  AtlanticMadeira = 'Atlantic/Madeira',
  AtlanticReykjavik = 'Atlantic/Reykjavik',
  AtlanticStHelena = 'Atlantic/St_Helena',
  EuropeDublin = 'Europe/Dublin',
  EuropeGuernsey = 'Europe/Guernsey',
  EuropeIsleOfMan = 'Europe/Isle_of_Man',
  EuropeJersey = 'Europe/Jersey',
  EuropeLisbon = 'Europe/Lisbon',
  EuropeLondon = 'Europe/London',
  GMT = 'GMT',
  UTC = 'UTC',
  AfricaAlgiers = 'Africa/Algiers',
  AfricaBangui = 'Africa/Bangui',
  AfricaBrazzaville = 'Africa/Brazzaville',
  AfricaCasablanca = 'Africa/Casablanca',
  AfricaCeuta = 'Africa/Ceuta',
  AfricaDouala = 'Africa/Douala',
  AfricaElAaiun = 'Africa/El_Aaiun',
  AfricaKinshasa = 'Africa/Kinshasa',
  AfricaLagos = 'Africa/Lagos',
  AfricaLibreville = 'Africa/Libreville',
  AfricaLuanda = 'Africa/Luanda',
  AfricaMalabo = 'Africa/Malabo',
  AfricaNdjamena = 'Africa/Ndjamena',
  AfricaNiamey = 'Africa/Niamey',
  AfricaPortoNovo = 'Africa/Porto-Novo',
  AfricaTunis = 'Africa/Tunis',
  ArcticLongyearbyen = 'Arctic/Longyearbyen',
  EuropeAmsterdam = 'Europe/Amsterdam',
  EuropeAndorra = 'Europe/Andorra',
  EuropeBelgrade = 'Europe/Belgrade',
  EuropeBerlin = 'Europe/Berlin',
  EuropeBratislava = 'Europe/Bratislava',
  EuropeBrussels = 'Europe/Brussels',
  EuropeBudapest = 'Europe/Budapest',
  EuropeBusingen = 'Europe/Busingen',
  EuropeCopenhagen = 'Europe/Copenhagen',
  EuropeGibraltar = 'Europe/Gibraltar',
  EuropeLjubljana = 'Europe/Ljubljana',
  EuropeLuxembourg = 'Europe/Luxembourg',
  EuropeMadrid = 'Europe/Madrid',
  EuropeMalta = 'Europe/Malta',
  EuropeMonaco = 'Europe/Monaco',
  EuropeOslo = 'Europe/Oslo',
  EuropeParis = 'Europe/Paris',
  EuropePodgorica = 'Europe/Podgorica',
  EuropePrague = 'Europe/Prague',
  EuropeRome = 'Europe/Rome',
  EuropeSanMarino = 'Europe/San_Marino',
  EuropeSarajevo = 'Europe/Sarajevo',
  EuropeSkopje = 'Europe/Skopje',
  EuropeStockholm = 'Europe/Stockholm',
  EuropeTirane = 'Europe/Tirane',
  EuropeVaduz = 'Europe/Vaduz',
  EuropeVatican = 'Europe/Vatican',
  EuropeVienna = 'Europe/Vienna',
  EuropeWarsaw = 'Europe/Warsaw',
  EuropeZagreb = 'Europe/Zagreb',
  EuropeZurich = 'Europe/Zurich',
  AfricaBlantyre = 'Africa/Blantyre',
  AfricaBujumbura = 'Africa/Bujumbura',
  AfricaCairo = 'Africa/Cairo',
  AfricaGaborone = 'Africa/Gaborone',
  AfricaHarare = 'Africa/Harare',
  AfricaJohannesburg = 'Africa/Johannesburg',
  AfricaJuba = 'Africa/Juba',
  AfricaKhartoum = 'Africa/Khartoum',
  AfricaKigali = 'Africa/Kigali',
  AfricaLubumbashi = 'Africa/Lubumbashi',
  AfricaLusaka = 'Africa/Lusaka',
  AfricaMaputo = 'Africa/Maputo',
  AfricaMaseru = 'Africa/Maseru',
  AfricaMbabane = 'Africa/Mbabane',
  AfricaTripoli = 'Africa/Tripoli',
  AfricaWindhoek = 'Africa/Windhoek',
  AsiaBeirut = 'Asia/Beirut',
  AsiaFamagusta = 'Asia/Famagusta',
  AsiaGaza = 'Asia/Gaza',
  AsiaHebron = 'Asia/Hebron',
  AsiaJerusalem = 'Asia/Jerusalem',
  AsiaNicosia = 'Asia/Nicosia',
  EuropeAthens = 'Europe/Athens',
  EuropeBucharest = 'Europe/Bucharest',
  EuropeChisinau = 'Europe/Chisinau',
  EuropeHelsinki = 'Europe/Helsinki',
  EuropeKaliningrad = 'Europe/Kaliningrad',
  EuropeKyiv = 'Europe/Kyiv',
  EuropeMariehamn = 'Europe/Mariehamn',
  EuropeRiga = 'Europe/Riga',
  EuropeSofia = 'Europe/Sofia',
  EuropeTallinn = 'Europe/Tallinn',
  EuropeVilnius = 'Europe/Vilnius',
  AfricaAddisAbaba = 'Africa/Addis_Ababa',
  AfricaAsmara = 'Africa/Asmara',
  AfricaDarEsSalaam = 'Africa/Dar_es_Salaam',
  AfricaDjibouti = 'Africa/Djibouti',
  AfricaKampala = 'Africa/Kampala',
  AfricaMogadishu = 'Africa/Mogadishu',
  AfricaNairobi = 'Africa/Nairobi',
  AntarcticaSyowa = 'Antarctica/Syowa',
  AsiaAden = 'Asia/Aden',
  AsiaAmman = 'Asia/Amman',
  AsiaBaghdad = 'Asia/Baghdad',
  AsiaBahrain = 'Asia/Bahrain',
  AsiaDamascus = 'Asia/Damascus',
  AsiaKuwait = 'Asia/Kuwait',
  AsiaQatar = 'Asia/Qatar',
  AsiaRiyadh = 'Asia/Riyadh',
  EuropeIstanbul = 'Europe/Istanbul',
  EuropeKirov = 'Europe/Kirov',
  EuropeMinsk = 'Europe/Minsk',
  EuropeMoscow = 'Europe/Moscow',
  EuropeSimferopol = 'Europe/Simferopol',
  EuropeVolgograd = 'Europe/Volgograd',
  IndianAntananarivo = 'Indian/Antananarivo',
  IndianComoro = 'Indian/Comoro',
  IndianMayotte = 'Indian/Mayotte',
  AsiaTehran = 'Asia/Tehran',
  AsiaBaku = 'Asia/Baku',
  AsiaDubai = 'Asia/Dubai',
  AsiaMuscat = 'Asia/Muscat',
  AsiaTbilisi = 'Asia/Tbilisi',
  AsiaYerevan = 'Asia/Yerevan',
  EuropeAstrakhan = 'Europe/Astrakhan',
  EuropeSamara = 'Europe/Samara',
  EuropeSaratov = 'Europe/Saratov',
  EuropeUlyanovsk = 'Europe/Ulyanovsk',
  IndianMahe = 'Indian/Mahe',
  IndianMauritius = 'Indian/Mauritius',
  IndianReunion = 'Indian/Reunion',
  AsiaKabul = 'Asia/Kabul',
  AntarcticaMawson = 'Antarctica/Mawson',
  AntarcticaVostok = 'Antarctica/Vostok',
  AsiaAlmaty = 'Asia/Almaty',
  AsiaAqtau = 'Asia/Aqtau',
  AsiaAqtobe = 'Asia/Aqtobe',
  AsiaAshgabat = 'Asia/Ashgabat',
  AsiaAtyrau = 'Asia/Atyrau',
  AsiaDushanbe = 'Asia/Dushanbe',
  AsiaKarachi = 'Asia/Karachi',
  AsiaOral = 'Asia/Oral',
  AsiaQostanay = 'Asia/Qostanay',
  AsiaQyzylorda = 'Asia/Qyzylorda',
  AsiaSamarkand = 'Asia/Samarkand',
  AsiaTashkent = 'Asia/Tashkent',
  AsiaYekaterinburg = 'Asia/Yekaterinburg',
  IndianKerguelen = 'Indian/Kerguelen',
  IndianMaldives = 'Indian/Maldives',
  AsiaColombo = 'Asia/Colombo',
  AsiaKolkata = 'Asia/Kolkata',
  AsiaKathmandu = 'Asia/Kathmandu',
  AsiaBishkek = 'Asia/Bishkek',
  AsiaDhaka = 'Asia/Dhaka',
  AsiaOmsk = 'Asia/Omsk',
  AsiaThimphu = 'Asia/Thimphu',
  AsiaUrumqi = 'Asia/Urumqi',
  IndianChagos = 'Indian/Chagos',
  AsiaYangon = 'Asia/Yangon',
  IndianCocos = 'Indian/Cocos',
  AntarcticaDavis = 'Antarctica/Davis',
  AsiaBangkok = 'Asia/Bangkok',
  AsiaBarnaul = 'Asia/Barnaul',
  AsiaHoChiMinh = 'Asia/Ho_Chi_Minh',
  AsiaHovd = 'Asia/Hovd',
  AsiaJakarta = 'Asia/Jakarta',
  AsiaKrasnoyarsk = 'Asia/Krasnoyarsk',
  AsiaNovokuznetsk = 'Asia/Novokuznetsk',
  AsiaNovosibirsk = 'Asia/Novosibirsk',
  AsiaPhnomPenh = 'Asia/Phnom_Penh',
  AsiaPontianak = 'Asia/Pontianak',
  AsiaTomsk = 'Asia/Tomsk',
  AsiaVientiane = 'Asia/Vientiane',
  IndianChristmas = 'Indian/Christmas',
  AntarcticaCasey = 'Antarctica/Casey',
  AsiaBrunei = 'Asia/Brunei',
  AsiaHongKong = 'Asia/Hong_Kong',
  AsiaIrkutsk = 'Asia/Irkutsk',
  AsiaKualaLumpur = 'Asia/Kuala_Lumpur',
  AsiaKuching = 'Asia/Kuching',
  AsiaMacau = 'Asia/Macau',
  AsiaMakassar = 'Asia/Makassar',
  AsiaManila = 'Asia/Manila',
  AsiaShanghai = 'Asia/Shanghai',
  AsiaSingapore = 'Asia/Singapore',
  AsiaTaipei = 'Asia/Taipei',
  AsiaUlaanbaatar = 'Asia/Ulaanbaatar',
  AustraliaPerth = 'Australia/Perth',
  AustraliaEucla = 'Australia/Eucla',
  AsiaChita = 'Asia/Chita',
  AsiaDili = 'Asia/Dili',
  AsiaJayapura = 'Asia/Jayapura',
  AsiaKhandyga = 'Asia/Khandyga',
  AsiaPyongyang = 'Asia/Pyongyang',
  AsiaSeoul = 'Asia/Seoul',
  AsiaTokyo = 'Asia/Tokyo',
  AsiaYakutsk = 'Asia/Yakutsk',
  PacificPalau = 'Pacific/Palau',
  AustraliaDarwin = 'Australia/Darwin',
  AntarcticaDumontDUrville = 'Antarctica/DumontDUrville',
  AsiaUstNera = 'Asia/Ust-Nera',
  AsiaVladivostok = 'Asia/Vladivostok',
  AustraliaBrisbane = 'Australia/Brisbane',
  AustraliaLindeman = 'Australia/Lindeman',
  PacificChuuk = 'Pacific/Chuuk',
  PacificGuam = 'Pacific/Guam',
  PacificPortMoresby = 'Pacific/Port_Moresby',
  PacificSaipan = 'Pacific/Saipan',
  AustraliaAdelaide = 'Australia/Adelaide',
  AustraliaBrokenHill = 'Australia/Broken_Hill',
  AntarcticaMacquarie = 'Antarctica/Macquarie',
  AsiaMagadan = 'Asia/Magadan',
  AsiaSakhalin = 'Asia/Sakhalin',
  AsiaSrednekolymsk = 'Asia/Srednekolymsk',
  AustraliaHobart = 'Australia/Hobart',
  AustraliaLordHowe = 'Australia/Lord_Howe',
  AustraliaMelbourne = 'Australia/Melbourne',
  AustraliaSydney = 'Australia/Sydney',
  PacificBougainville = 'Pacific/Bougainville',
  PacificEfate = 'Pacific/Efate',
  PacificGuadalcanal = 'Pacific/Guadalcanal',
  PacificKosrae = 'Pacific/Kosrae',
  PacificNoumea = 'Pacific/Noumea',
  PacificPohnpei = 'Pacific/Pohnpei',
  AsiaAnadyr = 'Asia/Anadyr',
  AsiaKamchatka = 'Asia/Kamchatka',
  PacificFiji = 'Pacific/Fiji',
  PacificFunafuti = 'Pacific/Funafuti',
  PacificKwajalein = 'Pacific/Kwajalein',
  PacificMajuro = 'Pacific/Majuro',
  PacificNauru = 'Pacific/Nauru',
  PacificNorfolk = 'Pacific/Norfolk',
  PacificTarawa = 'Pacific/Tarawa',
  PacificWake = 'Pacific/Wake',
  PacificWallis = 'Pacific/Wallis',
  AntarcticaMcMurdo = 'Antarctica/McMurdo',
  PacificApia = 'Pacific/Apia',
  PacificAuckland = 'Pacific/Auckland',
  PacificFakaofo = 'Pacific/Fakaofo',
  PacificKanton = 'Pacific/Kanton',
  PacificTongatapu = 'Pacific/Tongatapu',
  PacificChatham = 'Pacific/Chatham',
  PacificKiritimati = 'Pacific/Kiritimati',
}

/**
 * * `VIN` - VIN
 * * `RFID` - RFID
 * * `MAC` - MAC
 */
export enum TokenFormatEnum {
  VIN = 'VIN',
  RFID = 'RFID',
  MAC = 'MAC',
}

export interface Topic {
  topic_name: string;
  actions: Action[];
}

/** Tracker Serializer */
export interface Tracker {
  /**
   * @maxLength 16
   * @pattern ^[0-9]{15}$
   */
  imei: string;
  /**
   * @min 0
   * @max 2147483647
   */
  heartbeat_interval?: number;
  /**
   * @min 1
   * @max 2147483647
   */
  record_interval?: number;
  serial_protocol?: SerialProtocolEnum | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  overflow_management?: boolean;
  /** Enable Log Saving */
  save_logs?: boolean;
  /** Enable as External Integration */
  external_integration?: boolean;
  /** @maxLength 15 */
  geotab_id?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  track_unit_id?: number | null;
  /**
   * Volvo ID (VIN)
   * @maxLength 17
   */
  volvo_id?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  vehicle?: string;
  latest_heartbeat?: number | null;
}

/** Tracker Log Serializer */
export interface TrackerLog {
  type?: GisFeatureEnum;
  id?: number;
  geometry?: {
    type?: 'Point';
    /**
     * @maxItems 3
     * @minItems 2
     * @example [12.9721,77.5933]
     */
    coordinates?: number[];
  };
  properties?: {
    vehicle?: string;
    samples?: TrackerSample[];
    /** @format date-time */
    timestamp?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,2})?$
     */
    altitude?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
     */
    angle?: string;
    /**
     * @min 0
     * @max 2147483647
     */
    satellites?: number;
    /**
     * * `InStation` - In Station
     * * `OnRoute` - On Route
     * * `Charging` - Charging
     */
    place?: 'InStation' | 'OnRoute' | 'Charging';
    process?: boolean;
    tracker?: string;
    /** Latest Vehicle Station */
    latest_station?: number | null;
    path?: number | null;
  };
}

export interface TrackerLogList {
  type?: GisFeatureCollectionEnum;
  features?: TrackerLog[];
}

/** Tracker Path Serializer */
export interface TrackerPath {
  id: number;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * Remaining Kilometer at Start
   * @min 0
   * @max 32767
   */
  rk_start?: number | null;
  /**
   * Remaining Kilometer at Stop
   * @min 0
   * @max 32767
   */
  rk_stop?: number | null;
  /**
   * Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_start?: string | null;
  /**
   * Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_stop?: string | null;
  /**
   * Virtual Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_start?: string | null;
  /**
   * Virtual Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_stop?: string | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Carbon Avoided (g)
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  co2_avoided?: string | null;
  vehicle: string;
  /** Station at Start */
  station_start: number;
  /** Station at Stop */
  station_stop?: number | null;
}

/** Tracker Path Serializer */
export interface TrackerPathMobileWindow {
  id: number;
  station_start: string;
  station_stop: string;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * Remaining Kilometer at Start
   * @min 0
   * @max 32767
   */
  rk_start?: number | null;
  /**
   * Remaining Kilometer at Stop
   * @min 0
   * @max 32767
   */
  rk_stop?: number | null;
  /**
   * Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_start?: string | null;
  /**
   * Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer_stop?: string | null;
  /**
   * Virtual Odometer at Start (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_start?: string | null;
  /**
   * Virtual Odometer at Stop (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  virtual_odometer_stop?: string | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Carbon Avoided (g)
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  co2_avoided?: string | null;
  vehicle: string;
}

/** Tracker Sample Serializer */
export interface TrackerSample {
  id: number;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  value: string;
  /** @format date-time */
  timestamp?: string | null;
  /**
   * * `GPS` - GPS
   * * `Serial` - Serial
   * * `IO-data` - IO-data
   * * `External` - External
   */
  source: SourceEnum;
  /**
   * * `Velocity` - Velocity
   * * `RPM` - Rpm
   * * `RPM2` - Rpm2
   * * `SOC` - Soc
   * * `Odometer` - Odometer
   * * `Virtual Odometer` - Virtual Odometer
   * * `Tachometer` - Tachometer
   * * `Battery Current` - Battery Current
   * * `Battery Voltage` - Battery Voltage
   * * `Remaining Kilometers` - Remaining Kilometer
   * * `Trip Counter` - Trip Counter
   * * `Acceleration Pedal` - Acceleration Pedal
   * * `Gear Shift` - Gear Shift
   * * `Ignition Contact` - Ignition Contact
   * * `Breake Pedal` - Breake Pedal
   * * `Air Conditioner` - Air Conditioner
   * * `Fan` - Fan
   * * `Regeneration` - Regeneration
   * * `Regeneration Level` - Regeneration Level
   * * `Temperature` - Temperature
   * * `Minimum Battery Temperature` - Min Battery Temp
   * * `Maximum Battery Temperature` - Max Battery Temp
   * * `Cumulative Moving Hours` - Cumulative Moving Hours
   * * `Cumulative Operating Hours` - Cumulative Operating Hours
   */
  measurand: TrackerSampleMeasurandEnum;
  /** TrackerLog */
  log: number;
}

/**
 * * `Velocity` - Velocity
 * * `RPM` - Rpm
 * * `RPM2` - Rpm2
 * * `SOC` - Soc
 * * `Odometer` - Odometer
 * * `Virtual Odometer` - Virtual Odometer
 * * `Tachometer` - Tachometer
 * * `Battery Current` - Battery Current
 * * `Battery Voltage` - Battery Voltage
 * * `Remaining Kilometers` - Remaining Kilometer
 * * `Trip Counter` - Trip Counter
 * * `Acceleration Pedal` - Acceleration Pedal
 * * `Gear Shift` - Gear Shift
 * * `Ignition Contact` - Ignition Contact
 * * `Breake Pedal` - Breake Pedal
 * * `Air Conditioner` - Air Conditioner
 * * `Fan` - Fan
 * * `Regeneration` - Regeneration
 * * `Regeneration Level` - Regeneration Level
 * * `Temperature` - Temperature
 * * `Minimum Battery Temperature` - Min Battery Temp
 * * `Maximum Battery Temperature` - Max Battery Temp
 * * `Cumulative Moving Hours` - Cumulative Moving Hours
 * * `Cumulative Operating Hours` - Cumulative Operating Hours
 */
export enum TrackerSampleMeasurandEnum {
  Velocity = 'Velocity',
  RPM = 'RPM',
  RPM2 = 'RPM2',
  SOC = 'SOC',
  Odometer = 'Odometer',
  VirtualOdometer = 'Virtual Odometer',
  Tachometer = 'Tachometer',
  BatteryCurrent = 'Battery Current',
  BatteryVoltage = 'Battery Voltage',
  RemainingKilometers = 'Remaining Kilometers',
  TripCounter = 'Trip Counter',
  AccelerationPedal = 'Acceleration Pedal',
  GearShift = 'Gear Shift',
  IgnitionContact = 'Ignition Contact',
  BreakePedal = 'Breake Pedal',
  AirConditioner = 'Air Conditioner',
  Fan = 'Fan',
  Regeneration = 'Regeneration',
  RegenerationLevel = 'Regeneration Level',
  Temperature = 'Temperature',
  MinimumBatteryTemperature = 'Minimum Battery Temperature',
  MaximumBatteryTemperature = 'Maximum Battery Temperature',
  CumulativeMovingHours = 'Cumulative Moving Hours',
  CumulativeOperatingHours = 'Cumulative Operating Hours',
}

/**
 * * `Online` - Online
 * * `Offline` - Offline
 * * `Waiting` - Waiting
 * * `Disabled` - Disabled
 * * `Out-of-Service` - Out of Service
 */
export enum TrackerStatusEnum {
  Online = 'Online',
  Offline = 'Offline',
  Waiting = 'Waiting',
  Disabled = 'Disabled',
  OutOfService = 'Out-of-Service',
}

/** Transaction Serializer */
export interface Transaction {
  id: number;
  vehicle: VehicleTransaction;
  user_start: UserTransaction;
  user_stop: UserTransaction;
  /** TransactionRequest Serializer for using in Transaction */
  transaction_request?: AuthenticatedTransactionRequestInTransaction;
  /** TransactionRequest Serializer for using in Transaction */
  anonymous_transaction_request?: AnonymousTransactionRequestInTransaction;
  contract_snapshots: ContractSnapshot[];
  pricing_details: PricingDetail[];
  gross_price: string;
  net_price: string;
  /** ModelSerializer for PaymentAuthorization */
  payment_authorization: PaymentAuthorization;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** Finalizing Notification Sent? */
  finalizing_notification_sent?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
  connector: number;
  /** Charging Authorization at Start */
  charging_authorization_start?: number | null;
  /** Charging Authorization at Stop */
  charging_authorization_stop?: number | null;
}

/** Serializer for debt amount of transactions. */
export interface TransactionDebtAmount {
  transaction_id: number;
  debt_amount: string;
}

/** Transaction Simple Serializer (without Vehicle) */
export interface TransactionSimple {
  id: number;
  /**
   * @min 0
   * @max 2147483647
   */
  reservation_id?: number | null;
  /**
   * Identifier of Start
   * @maxLength 21
   */
  id_tag_start: string;
  /**
   * Identifier of Stop
   * @maxLength 21
   */
  id_tag_stop?: string | null;
  /**
   * Value in Wh at Start
   * @min 0
   * @max 2147483647
   */
  meter_start?: number;
  /**
   * Value in Wh at Stop
   * @min 0
   * @max 2147483647
   */
  meter_stop?: number | null;
  /**
   * Timestamp at Start
   * @format date-time
   */
  timestamp_start?: string;
  /**
   * Timestamp at Stop
   * @format date-time
   */
  timestamp_stop?: string | null;
  /** Reason to Stop */
  reason_stop?: ReasonStopEnum | null;
  /**
   * SoC at Start
   * @min 0
   * @max 32767
   */
  soc_start?: number | null;
  /**
   * SoC at Stop
   * @min 0
   * @max 32767
   */
  soc_stop?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cost?: number | null;
  /**
   * * `Waiting` - Waiting
   * * `Pending` - Pending
   * * `Processing` - Processing
   * * `Success` - Success
   * * `Partial` - Partial
   * * `Failed` - Failed
   * * `Void` - Void
   * * `Error` - Error
   * * `Min Price` - Min Price
   */
  payment_status?: PaymentStatusEnum;
  /**
   * Maximum Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  max_power?: string | null;
  /**
   * Average Power
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  avg_power?: string | null;
  /**
   * Value in Wh of Total Energy
   * @min 0
   * @max 2147483647
   */
  total_energy?: number | null;
  /**
   * State of Health
   * @format decimal
   * @pattern ^-?\d{0,9}(?:\.\d{0,2})?$
   */
  soh?: string | null;
  /**
   * Vehicle Odometer (m)
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  odometer?: string | null;
  /**
   * Estimated Charging Time
   * @format decimal
   * @pattern ^-?\d{0,11}(?:\.\d{0,2})?$
   */
  remaining_time?: string | null;
  /** Finalizing Notification Sent? */
  finalizing_notification_sent?: boolean;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  erp_invoice_id?: number | null;
  erp_name?: ErpNameEnum | null;
  connector: number;
  /** Charging Authorization at Start */
  charging_authorization_start?: number | null;
  /** Charging Authorization at Stop */
  charging_authorization_stop?: number | null;
  /** User Who Started */
  user_start?: number | null;
  /** User Who Stopped */
  user_stop?: number | null;
  vehicle?: string | null;
}

/** Transaction Summary Serializer */
export interface TransactionSummary {
  periods?: TransactionSummaryPeriod[];
  /**
   * @maxLength 6
   * @default "none"
   */
  periods_type?: string;
  /** @min 0 */
  count: number;
  /** @min 0 */
  cost?: number;
  /** @min 0 */
  price?: number;
  /** @min 0 */
  total_energy?: number;
}

/** Transaction Summary Period Serializer */
export interface TransactionSummaryPeriod {
  /** @min 0 */
  period: number;
  /** @min 0 */
  count: number;
  /** @min 0 */
  cost?: number;
  /** @min 0 */
  price?: number;
  /** @min 0 */
  total_energy?: number;
}

/** Trigger Message Serializer */
export interface TriggerMessage {
  /**
   * * `BootNotification` - BootNotification
   * * `FirmwareStatusNotification` - FirmwareStatusNotification
   * * `Heartbeat` - Heartbeat
   * * `MeterValues` - MeterValues
   * * `StatusNotification` - StatusNotification
   * * `DiagnosticsStatusNotification` - DiagnosticsStatusNotification
   * * `LogStatusNotification` - LogStatusNotification
   * * `SignChargePointCertificate` - SignChargePointCertificate
   */
  message_trigger: MessageTriggerEnum;
}

/**
 * * `h` - UnitOfMeasure.h
 * * `Wh` - UnitOfMeasure.wh
 * * `kWh` - UnitOfMeasure.kwh
 * * `varh` - UnitOfMeasure.varh
 * * `kvarh` - UnitOfMeasure.kvarh
 * * `W` - UnitOfMeasure.w
 * * `kW` - UnitOfMeasure.kw
 * * `VA` - UnitOfMeasure.va
 * * `kVA` - UnitOfMeasure.kva
 * * `var` - UnitOfMeasure.var
 * * `kvar` - UnitOfMeasure.kvar
 * * `A` - UnitOfMeasure.a
 * * `V` - UnitOfMeasure.v
 * * `Celsius` - UnitOfMeasure.celsius
 * * `Fahrenheit` - UnitOfMeasure.fahrenheit
 * * `K` - UnitOfMeasure.k
 * * `Percent` - UnitOfMeasure.percent
 */
export enum UnitEnum {
  H = 'h',
  Wh = 'Wh',
  KWh = 'kWh',
  Varh = 'varh',
  Kvarh = 'kvarh',
  W = 'W',
  KW = 'kW',
  VA = 'VA',
  KVA = 'kVA',
  Var = 'var',
  Kvar = 'kvar',
  A = 'A',
  V = 'V',
  Celsius = 'Celsius',
  Fahrenheit = 'Fahrenheit',
  K = 'K',
  Percent = 'Percent',
}

/** User Serializer Class */
export interface User {
  id: number;
  /** Profile Serializer Class */
  profile: Profile;
  credit_cards: CreditCard[];
  groups: string[];
  /** @format email */
  username: string;
  /** @format date-time */
  last_login: string | null;
  /**
   * Superuser status
   * Designates that this user has all permissions without explicitly assigning them.
   */
  is_superuser: boolean;
  /** @maxLength 150 */
  first_name: string;
  /** @maxLength 150 */
  last_name: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email: string;
  /**
   * Staff status
   * Designates whether the user can log into this admin site.
   */
  is_staff: boolean;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  is_active: boolean;
  /** @format date-time */
  date_joined: string;
}

/** User Group Serializer */
export interface UserGroup {
  id: number;
  /** @maxLength 32 */
  name: string;
  profiles: number[];
  profiles_count: number;
  contracts: number[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** Serializer for validating CSV files */
export interface UserGroupFileValidation {
  user_group: number;
  profiles: number[];
  errors: Record<string, any[][]>;
}

/**
 * * `Spot` - Spot
 * * `Deferred` - Deferred
 */
export enum UserGroupKindEnum {
  Spot = 'Spot',
  Deferred = 'Deferred',
}

/** Serializer for splitting UserGroups depeding of their kind */
export interface UserGroupList {
  spot_user_groups: UserGroup[];
  deferred_user_groups: UserGroup[];
}

export interface UserGroupResponse {
  spot_user_groups: UserGroup[];
  deferred_user_groups: UserGroup[];
}

/** UserGroup Serializer with a kind (Spot, Deferred) */
export interface UserGroupWithKind {
  id: number;
  /** @maxLength 32 */
  name: string;
  profiles: number[];
  profiles_count: number;
  contracts: number[];
  /**
   * * `Spot` - Spot
   * * `Deferred` - Deferred
   */
  user_group_kind: UserGroupKindEnum;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** User List Serializer class */
export interface UserList {
  id: number;
  /** Profile Serializer Class */
  profile?: Profile;
  credit_cards: CreditCard[];
  groups?: string[];
  /** @format email */
  username: string;
  /** @format date-time */
  last_login?: string | null;
  /**
   * Superuser status
   * Designates that this user has all permissions without explicitly assigning them.
   */
  is_superuser?: boolean;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /**
   * Staff status
   * Designates whether the user can log into this admin site.
   */
  is_staff?: boolean;
  /**
   * Active
   * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
   */
  is_active?: boolean;
  /** @format date-time */
  date_joined?: string;
}

/** User Password Serializer Class */
export interface UserPassword {
  /** @maxLength 256 */
  old_password: string;
  /** @maxLength 256 */
  new_password: string;
}

/** UserRegister Serializer Class */
export interface UserRegister {
  /** @format email */
  email: string;
  /** @maxLength 256 */
  password: string;
  /** @maxLength 256 */
  first_name: string;
  /** @maxLength 256 */
  last_name: string;
  /**
   * * `Passport` - Passport
   * * `RUT` - RUT
   * * `RFC` - RFC
   * * `DNI` - DNI
   * * `NIT` - NIT
   * * `CC` - CC
   * * `CE` - CE
   */
  document_type?: UserRegisterDocumentTypeEnum;
  /** @maxLength 64 */
  document_number?: string;
  /** @maxLength 64 */
  second_last_name?: string;
  /** @maxLength 64 */
  phone_number?: string;
  /** @format date-time */
  eula: string;
}

/**
 * * `Passport` - Passport
 * * `RUT` - RUT
 * * `RFC` - RFC
 * * `DNI` - DNI
 * * `NIT` - NIT
 * * `CC` - CC
 * * `CE` - CE
 */
export enum UserRegisterDocumentTypeEnum {
  Passport = 'Passport',
  RUT = 'RUT',
  RFC = 'RFC',
  DNI = 'DNI',
  NIT = 'NIT',
  CC = 'CC',
  CE = 'CE',
}

/** User Transaction Serializer */
export interface UserTransaction {
  id: number;
  /** @format date-time */
  last_login?: string | null;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  /** @maxLength 150 */
  first_name?: string;
  /** @maxLength 150 */
  last_name?: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string;
  /** @format date-time */
  date_joined?: string;
}

/**
 * * `Raw` - Raw
 * * `SignedData` - SignedData
 */
export enum ValueFormatEnum {
  Raw = 'Raw',
  SignedData = 'SignedData',
}

/** Vehicle Serializer */
export interface Vehicle {
  /**
   * @maxLength 10
   * @pattern ^[A-Z0-9]{1,10}$
   */
  number_plate: string;
  /** Tracker Log Serializer */
  latest_tracker_log?: TrackerLog;
  /** Transaction Simple Serializer (without Vehicle) */
  latest_transaction?: TransactionSimple;
  /**
   * Vehicle Verbose Name
   * @maxLength 10
   */
  verbose_name?: string | null;
  /**
   * Vehicle Identification Number
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin?: string | null;
  /**
   * Vehicle Identification Number 2
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin2?: string | null;
  /** @maxLength 64 */
  brand?: string | null;
  /** @maxLength 64 */
  model?: string | null;
  /**
   * * `Sedan` - Sedan
   * * `Van` - Van
   * * `Bus` - Bus
   * * `Truck` - Truck
   */
  class_type?: ClassTypeEnum;
  /**
   * Nominal Range in km
   * @min 0
   * @max 2147483647
   */
  nominal_range?: number;
  /**
   * Consumption in Wh/km
   * @min 0
   * @max 2147483647
   */
  consumption?: number;
  /**
   * Battery Nominal Capacity in Wh
   * @min 0
   * @max 2147483647
   */
  battery_nominal_capacity?: number | null;
  /**
   * Carbon Footprint of equivalent Internal Combustion Engine Vehicle in gCO2/km
   * @min 0
   * @max 2147483647
   */
  co2eqIC?: number;
  /** Use VIN as ID TAG */
  vin_as_id_tag?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_soc: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_odometer: string | null;
  /**
   * Latest Remaing Kilometers
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_remaing_km: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,3})?$
   */
  latest_temperature: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  /**
   * @min 0
   * @max 32767
   */
  low_soc_threshold?: number;
  /** Has Low SoC Notification been sent? */
  low_soc_notification_sent?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  fleet?: number;
}

/** Vehicle Station Serializer */
export interface VehicleStation {
  type?: GisFeatureEnum;
  id?: number;
  geometry?: {
    type?: 'Polygon';
    /** @example [[[0,0],[0,50],[50,50],[50,0],[0,0]]] */
    coordinates?: number[][][];
  };
  properties?: {
    /** @maxLength 64 */
    name?: string;
    fleets?: number[];
  };
}

export interface VehicleStationList {
  type?: GisFeatureCollectionEnum;
  features?: VehicleStation[];
}

/** Vehicle Transaction Serializer */
export interface VehicleTransaction {
  /**
   * @maxLength 10
   * @pattern ^[A-Z0-9]{1,10}$
   */
  number_plate: string;
  /** Transaction Simple Serializer (without Vehicle) */
  latest_transaction?: TransactionSimple;
  /**
   * Vehicle Verbose Name
   * @maxLength 10
   */
  verbose_name?: string | null;
  /**
   * Vehicle Identification Number
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin?: string | null;
  /**
   * Vehicle Identification Number 2
   * @maxLength 17
   * @pattern ^[A-Z0-9]{0,17}$
   */
  vin2?: string | null;
  /** @maxLength 64 */
  brand?: string | null;
  /** @maxLength 64 */
  model?: string | null;
  /**
   * * `Sedan` - Sedan
   * * `Van` - Van
   * * `Bus` - Bus
   * * `Truck` - Truck
   */
  class_type?: ClassTypeEnum;
  /**
   * Nominal Range in km
   * @min 0
   * @max 2147483647
   */
  nominal_range?: number;
  /**
   * Consumption in Wh/km
   * @min 0
   * @max 2147483647
   */
  consumption?: number;
  /**
   * Battery Nominal Capacity in Wh
   * @min 0
   * @max 2147483647
   */
  battery_nominal_capacity?: number | null;
  /**
   * Carbon Footprint of equivalent Internal Combustion Engine Vehicle in gCO2/km
   * @min 0
   * @max 2147483647
   */
  co2eqIC?: number;
  /** Use VIN as ID TAG */
  vin_as_id_tag?: boolean;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_soc: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_odometer: string | null;
  /**
   * Latest Remaing Kilometers
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,3})?$
   */
  latest_remaing_km: string | null;
  /**
   * @format decimal
   * @pattern ^-?\d{0,3}(?:\.\d{0,3})?$
   */
  latest_temperature: string | null;
  /**
   * * `Online` - Online
   * * `Offline` - Offline
   * * `Waiting` - Waiting
   * * `Disabled` - Disabled
   * * `Out-of-Service` - Out of Service
   */
  status?: TrackerStatusEnum;
  /**
   * @min 0
   * @max 32767
   */
  low_soc_threshold?: number;
  /** Has Low SoC Notification been sent? */
  low_soc_notification_sent?: boolean;
  fleet?: number;
  latest_tracker_log?: number | null;
}

/**
 * * `Error not interpreted` - Not Interpreted
 * * `UpdateFail` - Fail to update software
 * * `ResetFailure` - Fail to reset
 * * `GunTemperature` - Gun over-temperature
 * * `TrialPeriodOver` - The trial period is over
 * * `EmergencyStop` - Emergency stop
 * * `BleederResistor` - Bleeder resistor failure
 * * `Insulation` - Insulation failure (several times)
 * * `OpenDoor` - Open door
 * * `MeterFault` - Meter failure
 * * `BEMAlarmStop` - BEM alarm stop
 * * `BSMMessage` - BSM message
 * * `BROFault` - BRO fault
 * * `OuterVoltageRelay` - Outer voltage relay
 * * `BRMTimeOut` - BRM timeout
 * * `BCPTimeOut` - BCP timeout
 * * `BROTimeOut` - BRO timeout
 * * `BCLTimeOut` - BCL timeout
 * * `BSTTimeOut` - BST timeout
 * * `BSDTimeOut` - BSD timeout
 * * `BSMInsulation` - BSM insulation fault
 * * `BMSOutputTemperature` - BMS output over-temperature
 * * `BMSComponentTemperature` - BMS component over-temperature
 * * `BMSBatteryOverTemperature` - BMS Battery over-temperature
 * * `BMSHighCurrent` - BMS over current
 * * `BMSVoltageAbnormality` - BMS Voltage Abnormality
 * * `BMSOtherErrors` - BMS Other Errors
 * * `PowerModuleCommunicationFault` - Power Module Communication Fault
 * * `InputOverVoltage` - Input Over Voltage
 * * `InputUnderVoltage` - Input Under Voltage
 * * `GenericError` - Generic Error
 * * `MainsPowerSupply` - Mains Power Supply Failure
 * * `TemperatureOutOfRange` - Temperature out of range
 * * `InternalComunicationsError` - Internal communications error
 * * `ConfigurationError` - Configuration Error
 * * `MainsGroundFailure` - Mains ground failure
 * * `MainsVoltageOutOfRange` - Mains voltage out of range
 * * `MainsFrequencyOutOfRange` - Mains Frequency out of range
 * * `HighTemperatureError` - High temperature error
 * * `LowTemperatureError` - Low temperature error
 * * `ExternalComunicationsError` - External communications error
 * * `ErrorMasterEntity` - Error in master entity
 * * `SlaveError` - Error in slave entity
 * * `DoorTamperAlarm` - Door Tamper Error
 * * `TiltError` - Tilt error
 * * `DisplayFailure` - Display Failure
 * * `RfidReaderFailure` - RFID reader failure
 * * `PowerMeterFailure` - Power Meter Comunication Error
 * * `GenericVehicleError` - Generic Vehicle Error
 * * `VehicleComunicationError` - Vehicle Comunication Error
 * * `VehicleNotDetected` - Vehicle not detected
 * * `VehicleOverCurrent` - Vehicle over current consumption
 * * `CordMalfunction` - Cord malfunction
 * * `CordSensorMalfunction` - Cord sensor malfunction
 * * `ConnectorLockFailure` - Connector Lock Failure
 * * `InternalPowerSupplyFailure` - Internal power supply failure
 * * `ComponentTemperatureOutRange` - Component temperature out of range
 * * `HardwareFailureMode4` - Hardware Failure Mode4
 * * `HardwareFailureNodes` - Hardware Failure Nodes
 * * `AcDcConvertersGenericError` - AC/DC converters Error
 * * `AcDcConvertersTimeOutError` - AC/DC converters time out Error
 * * `AcDcConvertersVoltageOutRange` - AC/DC converters voltage out of range
 * * `AcDcConvertersCurrentOutRange` - AC/DC converters current out of range
 * * `WeldingContactor` - Welding Contactor
 * * `CurrentLeakDetected` - Current Leak Detected
 * * `ElectricalProtectionTriggered` - Electrica Protection Triggered
 * * `IsolationError` - Isolation error
 * * `RcdProtectionTriggered` - RCD protection triggered
 * * `McbProtectionTriggered` - MCB protection triggered (Over Current protection Triggered)
 * * `ProgramCounterFailure` - Program Counter Failure
 * * `Invalid` - Reason for stopping cannot be identified
 * * `NoError` - No error ocurred, similar to a normal stop
 * * `UserRequestStop` - User pressed the stop button on HMI
 * * `ConnectorButtonPressed` - CSS1 connector button is pressed by user
 * * `VehicleStop` - This vehicle requested to stop the session by a driver request
 * * `IncompatibleVehicle` - This vehicle cannot be charged on this outlet
 * * `IsolationTestFailed` - Isolation resistance is to low
 * * `CableCheckFailed` - Isolation failure during cable check phase
 * * `BatteryFull` - Stopped because the vehicle battery is full
 * * `BudgetExceeded` - Stopped because the vehicle asked for or tried to draw to much power
 * * `ChargerError` - Chargin Protocol Interface (CPI) board error
 * * `ChargerContactorProblem` - Charger contactor problem
 * * `ChargerLoweringCurrentTimeout` - Charge does not follow the request reduction of current near to full charge
 * * `ConnectorError` - Connector Error
 * * `ConnectorPilotError` - Conector pilot error
 * * `ControlPilotShorCircuit` - Control pilot is in short-circuit. it can be caused by bad wiring
 * * `ConnectorTemperatureError` - The connector is too hot
 * * `Outlet error` - problem of CPI/IMI assebly, CCB or CAN cable between CCB and CPI
 * * `chargerPreChargerTimeout` - Precharger timeout is reached
 * * `ChargerVoltageDrop` - Measure voltage is lower than the expected
 * * `ChargerMaxVoltage` - Maximum voltage exceeded
 * * `ChargedStopTimeout` - Vehicle takes too log to send the stop command
 * * `ChargerConnectorPresenceLost` - Charger was not able to pick Control pilor state changes from the vehicle
 * * `ChargerErrorCurrentDifference` - The charger detected thar the current difference is too large
 * * `ChargerCANCommunicationLost` - he power cabinet internal CAN bus communication is lost
 * * `ChargerMCBTripped` - Charger circuit breaker tripped
 * * `ChargedRCDTriped` - the AC input (from the grid) Residual Current Device tripped
 * * `ChargerRCDCloseError` - Residual Current Device Closing Error
 * * `ChargefTemperatureError` - The temperature of the power cabinet or charge is high
 * * `ChargerNeutralMismatch` - Charger neutral mismatch
 * * `ChargerOutletDetection` - Charger outlet detection
 * * `VehicleProtocolError` - Vehicle protocol error
 * * `PowerPortVipError` - The powerport vip value is showing zero
 * * `Power port power error` - Power module does not respond fast enough
 * * `PowerPortFanFailure` - All power module affected by a fan failure
 * * `PowerPortOverheat` - All power modules show a high temperature
 * * `PowerPortInterlock` - Interlock of power modules acttive
 * * `PowerPortErrorOther` - Umbrella error for any other power modules related errors
 * * `VehicleErrorReversePolarity` - The polarityo the vehicle is reversed
 * * `VehicleErrorVoltageApplied` - There is a voltage applied to the DC output when this is not expected
 * * `LockError` - Unable to lock the connector, no dangerous voltage present
 * * `UnlockError` - Unable to unlock the connector, no dangerous voltage present
 * * `LockTampering` - Tampering with the connector lock detected
 * * `CableError` - Charger cannot detect chargin cable type e.g. after cable replacement
 * * `GlobalInterlockFail` - Global Interlock activated
 * * `VehicleShiftPosition` - Vehicle shift position indicator is incorrect
 * * `VehicleBatteryTemperatureOutOfRange` - Vehicle communicated that its battery temperature is out of range
 * * `VehicleLookError` - Vehicle is unable to lock the connector
 * * `VehicleBatteryMalfunction` - Vehicle battery malfunction
 * * `VehicleCurrentDifference` - Vehicle detected current is not within specs
 * * `VehicleVoltageOutOfRange` - Vehicle detected voltage is out of range
 * * `VehicleError` - General vehicle error
 * * `oardPowerSupplyError` - Charge auxiliary power supply (24V) has issues
 * * `OcmNotAlive` - Over current monitor not alive
 * * `OcmInterlockVeriicationError` - Interlock by over current monitor is not functioning properly
 * * `OcmCableRatingMismatch` - Over current monitor and cable rating does not match
 * * `OnBoardEnergymeterError` - Vehicle onboard energy meter error
 * * `VehicleWeldingDetectionTimeout` - Vehicle contador weldin detection request took to long
 * * `CableCheckCurrentRunning` - The isolation test failed during this session
 * * `CableCheckVoltageTooLow` - Power module that was selected for the cable check is not functioning
 * * `CableCheckVoltageTooHigh` - The power module voltage were too high during the cable check
 * * `CableCheckVoltageNotDropping` - Voltage is not dropping when expected during the cable check
 * * `ChargerTimeCompleted` - stopped because car has been charging long enough
 * * `VehicleNotConnected` - Vehicle not connected
 * * `SoftError` - Software induce error
 * * `StoppedByVehicle` - Stopped by vehicle
 * * `AcsErrorExtending` - Problem happened that prevent the pantograph from extending
 * * `AcsErrorRetracting` - Pantograph error retracting
 * * `AcsExtendedTimeout` - Malfunctioning pantograph motor or lowering arm
 * * `AcsRetractedTimeout` - Malfunctioning pantograph motor or lowering arm
 * * `AccErrorAligment` - No complete chargin circuit when the pantograph is lowered
 * * `ChargerCabinetOvp` - The Over Coltage protection in cabinet is tripped
 * * `ChargerCableCoolerFailure` - Cable cooler is not reachable or gives an error
 * * `ChargerCableCoolerTemperature` - Temperature of cooler out of range
 * * `ChargerCableTemperature` - The cable is too hot at the charger end
 * * `ChargerContactorTemperature` - Contactor temperature is out-of-range
 * * `EstCorrect` - Normal stop
 * * `blocked` - ID tag for OCPP authorization is blocked on server
 * * `Expired` - ID tag for OCPP authorization is expired on server
 * * `InvalidOnServer` - ID tag is marked as Invalid by the OCP server
 * * `InvalidOnCharged` - ID tag is marked as Invalid by the charger software
 * * `RequestReject` - Charged software rejects request for authorization
 * * `WrongMessage` - Wrong parameters provided for the authorization request
 * * `NoMatchingIDs` - ID tags for OCPP Star and Stop do not match
 * * `ServerUnreachable` - The authorization failed as the server could not be reached
 * * `NoCardPresented` - The authorization failed bcause the user did not present a card
 * * `AuthorizedStop` - Authorization was used to stop chargin
 * * `ForcedStop` - Used when it is required to stop the charging without an authorization
 * * `NormalStop` - Normal Stop that does not fall into any of other categories
 * * `ImiDisconnectedFromDcbus` - CPI disconnected from DC bus and thresfore measure 0 Volts
 * * `ChargerCommunicationFailure` - Communication between Host A8 and DCB Failed
 * * `ChargerSubunitCommunicationFailure` - Communication beetween Host A8 and Subunit DCB Failed
 * * `DCElectricMeterCommunicationFailed` - DC Electric Meter communication Detection Failed
 * * `PowerModuleCANCommunicationFailure` - Possibly Due to module Address Configuration Issueor Module CAN communication problem
 * * `InsulationCommunication` - Gun 1 and 2 Insulation Communication module are in alarm state possibly due to power supply or communication issues with the insulation modules
 * * `Timeout` - Self-test Timeout. Abnormal Status. DCB has not Reported charging status messages for a long time
 * * `ACElectricMeterCommunicationFailure` - AC Electric Meter communication Detection Failed
 * * `NFC Communication Failure` - NFC communication failure
 * * `CommunicationFailureLightPanel` - Communication failure with the Light Panel
 * * `BluetoothCommunicationFailure` - Bluetooth board communication failure
 * * `ChargerFANMalfunction` - Charger FAN malfunction
 * * `DCBTCUAbnormality` - DCB Received TCU Abnormality
 * * `ChargerOtherFaults` - Charger other faults (avoid using whenever possible)
 * * `TCUVINVerificationTimedOut` - Waiting fot TCU VIN verification result timed out
 * * `VehicleAuthenticationFailed` - Vehicle authentication Failed (VIN Verification)
 * * `FanSpeedControlFailure` - Fan speed cntrol board communication failure
 * * `InsulationAlarm` - Insulation alarm (Alert without Shutdown)
 * * `InsulationFault` - Insulation Fault
 * * `PowerModuleAlarm` - Power module alarm
 * * `PowerModuleConflict` - (C6) Power module address conflict, (C2) charging station not initialized
 * * `PowerModuleFault` - Power module fault. Record the modules that have experienced a fault in the data
 * * `PowerModuleStatusChange` - Power module status change ( number of availabke modules)
 * * `PowerModulePhaseLossFault` - Power module phase loss fault
 * * `PowerModuleFanFault` - Power module FAN fault
 * * `PowerModuleOvertemperatureFault` - Power module overtemperature fault
 * * `PowerModuleACInputFault` - Power module AC input Fault
 * * `PowerModuleOutputShortCircuitFault` - Power module output short circuit fault
 * * `PowerModuleOutputOvercurrentFault` - Power module output overcurrent fault
 * * `PowerModuleOutputOvervoltageFault` - Power module output overvoltage fault
 * * `PowerModuleOutputUndervoltageFault` - Power module output undervoltage fault
 * * `PowerModuleInputOvervoltageFault` - Power module input overvoltage fault
 * * `PowerModuleInputUndervoltageFault` - Power module input undervoltage fault
 * * `PowerModuleDischargeFault` - Power module discharge fault
 * * `PowerModuleCurrentLimit` - Power module current limit
 * * `PowerModuleShutdown` - Power module shutdown
 * * `NoAvailableSparePowerModule` - No available spare power module
 * * `ChargerAccessControlFailure` - Charger access control failure
 * * `LiquidLevelAlarm` - Liquid level alarm
 * * `ACSurgeAlarm` - AC surge alarm
 * * `DCSurgeAlarm` - DC Surge alarm. If It's a subunit DC surge, specify the subunit number in the data
 * * `GunEndContactFault` - Gun end contactor fault. Displayed as charging port end contact fault on WeChat
 * * `ChargigStationSmokeDetectorFault` - Charging station smoke detector fault
 * * `CabinetTemperatureAlarm` - Cabinet Temperature Alarm. Abnormal Status
 * * `CabinetHumidityAlarm` - Cabinete humidity alarm. Abnormal status
 * * `TiltAngleAlarm` - Tilt angle alarm. abnormal status
 * * `LiquidCooledHeadExceedsShutdown` - Liquid-Cooled gun Head exceeds shutdown temperature. shutdown
 * * `LiquidCooledHeadExceedsCurrentShutdown` - Liquid-Cooled gun head exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
 * * `LiquidCooledTailExceedsShutdown` - Liquid-Cooled gun Tail exceeds shutdown temperature. shutdown
 * * `LiquidCooledTailExceedsCurrentShutdown` - Liquid-Cooled gun Tail exceeds current limit temperature, but not shutdown temperature. Current limit without shutdown
 * * `LiquidCooledHeadTemperatureRiseExceedsShutdown` - Liquid-Cooled gun head temperature rise rate exceeds shutdown rate. Shutdown
 * * `LiquidCooledHeadTemperatureRiseCurrentShutdown` - Liquid-Cooled gun head temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
 * * `LiquidCooledTailTemperatureRiseExceedsShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds shutdown rate. Shutdown
 * * `LiquidCooledTailTemperatureRiseCurrentShutdown` - Liquid-Cooled gun tail temperature rise rate exceeds current limit rate, but not shutdown rate. Current limit without shutdown
 * * `LowLiquidLevel` - Low liquid level in  Liquid cooling, current limit without shutdown.
 * * `LiquidCoolingOvertemperatureOvervoltage` - Liquid coolink liquid overtemperature and overvoltage. Overtemperature and overvoltage are the same fault in this context
 * * `LiquidCooledHeadDifferenceExceeds` - Liquid-cooled gun head and tail temperature difference exceeds current limit rate, but not shutdown rate. current limit without shutdown
 * * `LiquidCooledHeadTailShutdown` - Liquid-Cooled gun head and tail temperature difference exceeds shutdown rate. Shutdown
 * * `LiquidCoolingFault` - Liquid cooling fault
 * * `ChargingStationFault` - Charging station fault
 * * `TiltAngleFault` - Tilt angle fault
 * * `LiquidCoolingCoolantLowLevelFault` - Liquid cooling coolant low level fault, shutdown. This fault may indicate a coolant leak
 * * `OtherHardwareFaultsInLiquidCooling` - Other hardware fault in liquid cooling
 * * `LiquidCoolingDischargeNoShutdown` - Liquid cooling discharge and return temperature difference alarm, but no shutdown
 * * `LiquidCoolingDischargeShutdown` - Liquid cooling discharge and return temperature difference alarm shutdown
 * * `LiquidCoolingReturnNoShutdown` - Liquid cooling return temperature difference alarm, but no shutdown
 * * `LiquidCoolingReturnShutdown` - Liquid cooling return temperature difference alarm, shutdown
 * * `LiquidCoolingPumpLowAlarm` - Liquid cooling pump low temperature alarm, but no shutdown
 * * `LiquidCoolingPumpLowFault` - Liquid cooling pump low temperature fault, shutdown
 * * `LiquidCoolingPumpFault` - Liquid cooling pump temperature fault, shutdown
 * * `LiquidCoolingPumpSesingFault` - Liquid cooling pump temperature sensing fault, shutdown
 * * `EmergencyStopCircuitFault` - Emergency stop circuit fault
 * * `ChargingGunTemperatureAlarm` - Charging gun temperature alarm. Displayed as charging port temperature alarm on WeChat. Abnormal status
 * * `ElectromagneticLockLockingFailed` - Electromagnetic lock locking operation failed. Abnormal status
 * * `ElectromagneticLockUnlockingFailed` - Electromagnetic lock unlocking operation failed. At this point, the charging gun is locked and cannot be removed. Abnormal status
 * * `AbnormalityChargingGunPort` - Abnormality at the charging gun port, meannig a change in CC voltageduring charging (other than 4V), abnormal status
 * * `ChargingGunNotProperlyPositioned` - Charging gun not properly positioned
 * * `BMSVoltageLowOrHigh` - BMS demands voltage too low or high. If it can be ditinguished as 'high' or 'low'
 * * `BMSVoltageHigh` - BMS demands voltage too high
 * * `BMSVoltageLow` - BMS demands voltage too Low
 * * `APhaseHigh` - A-phase voltage too high
 * * `BPhaseHigh` - B-phase voltage too high
 * * `CPhaseHigh` - C-phase voltage too high
 * * `APhaseLow` - A-phase voltage too low
 * * `BPhaseLow` - B-phase voltage too low
 * * `CPhaseLow` - C-phase voltage too low
 * * `GroundWireAlarm` - Ground wire alarm
 * * `NLineNotConnected` - N-Line not connected
 * * `ACInputCircuitBrakerFailure` - AC Input circuit breaker failure
 * * `ACInputContadorRefusarFault` - AC Input contador refursar fault
 * * `ACInputContadorStickingFault` - AC input contador sticking fault
 * * `SystemPowerFailure` - System power failure. 220V no input
 * * `ACPowerMeterReadingAbnormal` - AC power meter reading abnormal
 * * `ACInputPhaseLoss` - AC input phase loss
 * * `VoltageAbnormalityOvervoltage` - Coltage abnormality overvoltage
 * * `VoltageAbnormalityUndervoltage` - Voltage abnormality undervoltage
 * * `VoltageAbnormalityShortCircuit` - Voltageabnormality short circuit
 * * `VoltageAbnormalityOverload` - Voltage abnormality overload
 * * `BatteryReverseConnection` - Battery reverse connection
 * * `DCDetectionFailure` - DC detection failure
 * * `DischargeDetectionFailure` - Dicharge detection failure
 * * `ParallelContadorRefusalFault` - Parallel contador refusal fault
 * * `ParallelContadorAhesionFault` - Parallel contador adhesion fault
 * * `DCBusOutputFuseFault` - DC bus output fuse fault
 * * `ChargingHostPreChargingFailureFault` - Charging host pre-charging failure fault
 * * `ChargingHostResponseChargingFailureFault` - Charging host response charging failure fault
 * * `BatteryUndervoltage` - During the charging permission stage, the charging station measures the battery voltage lower than 5% of the battery voltage in BCP
 * * `BatteryOvervoltage` - During the charging permission stage, the charging station measures the battery voltage higher than 5% of the battery voltage in BCP
 * * `AbnormalDC` - Abnormal DC meter reading
 * * `GunheadDCRefusalFault` - Gunhead DC output contactor refusal fault
 * * `GunheadDCAdhesionFault` - Gunhead DC output contadctor adhesion fault
 * * `PrechargeTimeout` - Precharge timeout
 * * `AuxiliaryPowerNotPowered` - The auxiliar power supply is not powered on
 * * `CRMTimeout` - CRM timeout
 * * `CRM00Timeout` - CRM00 timeout
 * * `CRMaaTimeout` - CRMaa timeout
 * * `CROTimeout` - CRO timeout
 * * `CTSTimeout` - CTS timeout
 * * `CMLTimeout` - CML timeout
 * * `CCSTimeout` - CSS timeout
 * * `CSTTimeout` - CST timeout
 * * `CSDTimeout` - CSD timeout
 * * `OtherTimeoutFaultBEM` - Other timeout fault as defined in BEM
 * * `ChargerOutputCurrentExcedsDC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the DC power meter remains unchanged for a continuous duration of 180 seconds
 * * `ChargerOutputCurrentExcedsAC` - The charger will stop charging if the output current exceeds 6A, and the energy reading on the AC power meter remains unchanged for a continuous duration of 180 seconds
 * * `ChargingHostEmergencyStop` - Charging host emergency stop
 * * `ChargingostDCBusbarFuse` - Charging host DC busbar fuse
 * * `ChargingHostAccessControlFAilure` - Charging host access control failure
 * * `ChargingHostSmokeDetectorFailure` - Charging host smoke detector failure
 * * `ChargingHostACInputCircuitBreakerFailure` - Charging host AC input circuit breaker failure
 * * `ChargingHostACInputContactorMalfunction` - charging host AC input contactor malfunction
 * * `ChargingHostACInputStickingMalfunction` - charging host AC input sticking malfunction
 * * `ChargingHostFanMalfunction` - Charging host fan malfunction
 * * `ChargingHostParallelContactorMalfunction` - Charging host parallel contactor malfunction
 * * `ChargingHostParallelStickingMalfunction` - Charging host parallel sticking malfunction
 * * `ChargingHostLiquidCoolingModuleMalfunction` - Charging host liquid cooling module malfunction
 * * `ChargingHostLiquidCoolingModuleCommunicationFailure` - Charging host liquid cooling module communication failure
 * * `ChargingHostSurgeArresterMAlfunction` - Charging host surge arrester malfunction
 * * `ChargingHostACEnergyMeterCommunicationFailure` - Charging host AC energy meter communication failure
 * * `ChargingHostOverTemperatureFault` - Charging host over temperature fault
 * * `ChargingHostOverTemperatureWarning` - Charging host over temperature warning
 * * `ChargingHostInputVoltageOvervoltageFault` - Charging host input voltage overvoltage fault
 * * `ChargingHostInputVoltageUndervoltageFault` - Charging host input voltage undervoltage fault
 * * `ChargingHostWaterLevelMonitoringAbnormality` - Charging host water level monitoring abnormality
 * * `ChargingHostPowerModuleFault` - Charging host power module fault
 * * `ChargingHostPowerModuleCommunicationFailure` - Charging host power module communication failure
 * * `ChargingHostPowerModuleFanMalfunction` - Charging host power module fan malfunction
 * * `ChargingHostPowerModuleOverTemperatureFault` - Charging host power module over-temperature fault
 * * `ChargingHostPowerModuleACInputFault` - Charging host power module AC input fault
 * * `ChargingHostPowerModuleOutputShortCircuitFault` - Charging host power module output short circuit fault
 * * `ChargingHostPowerModuleOutputOvercurrentFault` - Charging host power module output overcurrent fault
 * * `ChargingHostModuleOutputOvervoltageFault` - Charging host power module output overvoltage fault
 * * `ChargingHostModuleOutputUndervoltageFault` - Charging host power module output undervoltage fault
 * * `ChargingHostModuleInputOvervoltageFault` - Charging host power module input overvoltage fault
 * * `ChargingHostModuleInputUndevoltagetFault` - Charging host power module input undevoltage fault
 * * `ChargingHostModuleInputPhaseLossFault` - Charging host charging module input phase loss fault
 * * `ChargingHostChargingModuleFault` - Charging host charging module fault
 * * `ChargingHostChargingModuleCommunicationFailure` - Charging host charging module communication failure
 * * `ChargingHostAdhesiveDetectionTimeout` - Charging host adhesive detection response timeout
 * * `ChargingHostChargingStopCompletionTimeout` - Charging host charging stop completion response timeout
 * * `ChargingHostInsulationDetectionFrameTimeout` - Charging host insulation detection frame response timeout
 * * `ChargingHostInsulationDetectionCompletionTimeout` - Charging host insulation detection completion response timeout
 * * `ChargingHostPreChargeFrameTimeout` - Charging host pre-charge frame response timeout
 * * `ChargingHostPreChargeCompletionTimeout` - Charging host pre-charge completion response timeout
 * * `ChargingHostReceptionFirmwareUpgradeFrameTimeout` - Charging host reception of remote firmware upgrade file data frame timeout
 * * `ChargingHostReceptionChargingDemandDataFrameTimeout` - Charging host reception of charging demad data frame timeout
 * * `ChargingHostChargingTerminalTelesinalFrameTimeout` - Charging host charging terminal telesignal frame reception timeout
 * * `ChargingHostChargingStartupTimeout` - Charging host charging startup response timeout
 * * `ChargingHostChargingStopTimeout` - Charging host charging stop response timeout
 * * `ChargingHostTimeSynchronizationOperationTimeout` - Charging host time synchronization operation response timeout
 * * `ChargingHostVersionVerificationTimeout` - Charging host version verification response timeout
 * * `ChargingHostChargingParameterTimeout` - Charging host charging parameter response timeout
 * * `ChargingHostPreChargerTimeout` - Charging host pre-charger response timeout
 * * `ChargingHostInsulationDetectionTimeout` - Charging host insulation detection reponse timeout
 * * `ChargingHostRemoteUpgradeRequestTimeout` - Charging host remote upgrade request response timeout
 * * `ChargingHostDebuggingDataRequestTimeout` - Charging host debugging data request response timeout
 * * `ChargingHostControlRequestTimeout` - Charging host control request response timeout
 * * `ChargingHostRemoteFirmwareTransferFrameTimeout` - Charging host remote firmware upgrade file transfer completion frame reception timeout
 * * `ChargingHostRemoteUpgradeCompletionFrameTimeout` - Chaging host remote upgrade completion reception timeout
 * * `ChargingHostTelecontrolFrameTimeout` - Charging host telecontrol frame reception timeout
 * * `CharginghostTelemetryFrameTimeout` - Charging host telemetry frame reception timeout
 * * `ChargingHostInsulationDetectionCompletionFrameTimeout` - Charging host insulation detection completion frame reception timeout
 * * `ChargingHostAdhesiveDetectionFrameTimeout` - Charging host adhesive detection frame reception timeout
 * * `ChargingHostPreChargeCompletionFrameTimeout` - Charging host pre-charge completion frame reception timeout
 * * `ChargingHostChargingStopFrameTimeout` - Charging host charging stop completion frame reception timeout
 * * `ChargingHostAndSubCommunicationNotCompleted` - Charging host and sub-communication initialization not completed
 * * `ChargingHostHeartbeatReceptionStatus` - Charging host heartbeat reception status
 * * `BSTHighVoltageRelayMalfunction` - BST high voltage relay malfunction
 * * `BSTChargingConnectorMalfunction` - BST charging connector malfunction. Abnormal status
 * * `BSTBatteryPackTemperatureHigh` - BST battery pack temperature too high
 * * `BSTCurrentExceedsRequiredValue` - BST current exceeds the required value
 * * `BSTVoltageAbnormal` - BST voltage abnormal
 * * `BSTDetectionPoint2VoltageDetectionMalfunction` - BST detection point 2 voltage detection malfunction. Abnormal status
 * * `BSTOtherMalfunction` - BST other malfunction
 * * `BSTOutputConnectorOverheated` - BST output connector overheated
 * * `BSTStopSendData0Malfunction` - BST stops and send data as 0 malfunction, not a malfunction.
 * * `BSTVehicleInsulation` - BST vehicle insulation
 * * `BMSCurrentExceedsVoltageMode` - BMS current request exceeds the maximum allowed current in constant voltage mode
 * * `BMSCurrentExceedsCurrentMode` - BMS current request exceeds the maximum allowed current in constant current mode
 * * `ChargingProhibited` - Charging prohibited, 10-minute timeout
 * * `BHMVoltageMatchingFailure` - BHM voltage matching failure
 * * `VoltageDetectionFailure` - Voltage detection failure
 * * `BMSCoponentOutputConnectorOverTemperature` - BHM component output connector over temperature
 * * `BSMIndividualPowerBatteryHigh` - BSM individual power battery voltage too high
 * * `BSMIndividualPowerBatteryLow` - BSM individual power battery voltage too low
 * * `BSMVehiclePowerBatteryHigh` - BSM whole vehicle power battery state of charge (SOC) too high
 * * `BSMVehiclePowerBatterylow` - BSM whole vehicle power battery state of charge (SOC) too low
 * * `BSMVehiclePowerBatteryInsulationAbnormal` - BSM power battery insulation status abnormal
 * * `BSMBatteryOvercurrentCharging` - BSM power battery overcurrent during charging
 * * `BSMBatteryTemperatureHigh` - BSM power battery temperature high
 * * `BSMBatteryOutputConnectorConnectionAbnormal` - BSM power battery pack output connector connection status abnormal
 * * `BMSCommunicationProtocolVersionMismatch` - BMS communication protocol version mismatch
 * * `VehicleFullyCharged` - The vehicle is fully charged; this is feedback from the vehicle
 * * `ReachedSetTotalVoltage` - Reached the set total voltage. Not considered abnormal; can be regarded as fully charged
 * * `ReachedSetIndividualVoltage` - Reached the set individual cell voltage. Not considered abnormal; can be regarded as fully charged
 * * `MetChargerSettingConditions` - Met the charger setting conditions. Not considered abnormal; can be regarded as fully charged
 * * `VehicleSideManualTermination` - Vehicle-side indicates manual temination
 * * `PowerCannotBeTransmitted` - Power cannot be transmitted this is a vehicle malfunction, it might be fully charged.
 * * `CurrentMismatchVehicleMalfunction` - Current mismathc, this is a vehicle malfunction, it might be fully charged
 * * `ChargedTeminated` - Charged teminated
 * * `BRMTimeout` - BRM timeout
 * * `BCPTimeout` - BCP timeout
 * * `BRO_TIMEOUT` - BRO timeout
 * * `BCSTimeout` - BCS timeout
 * * `BCLTimeout` - BCL timeout
 * * `BSTTimeout` - BST timeout
 * * `BSDTimeout` - BSD timeout
 * * `BSMTimeout` - BSM timeout
 * * `CHAdeMoCodeWaitJ3TimeOut` - Waiting for vehicle-side Switch = ON timeout. Vehicle-side malfunction
 * * `CHAdeMoCodeDCVoltExceed10V` - DC bus voltage exceeds 10V before charging. Bus has voltage or vehicle-side malfunction
 * * `CHAdeMoCodeJ3StatusErr` - Vehicle-side Switch status error. Vehicle-side malfunction
 * * `CHAdeMOCodeEvReadyStatusErr` - Vehicel-side readiness status error. Vehicle-side malfunction
 * * `CHAdeMOCodeWaitEVSEOutVoltErr` - Waiting for output voltage timeout
 * * `CHAdeMOCodeDCVoltExceed20V` - Insulation check completed voltage anomaly after discharge
 * * `CHAdeMOCodeCommunicationTimeOut` - Vehicle-side CAN communication timeout
 * * `CHAdeMOCodeWaitCAN10XTimeOut` - Waiting for vehicle-side CAN communication timeout at beginning of charging. Vehicle malfunction
 * * `CHAdeMOCodeWaitEVCurrentReqTimeOut` - Waiting for current request failed. VEhicle-side malfunction
 * * `CHAdeMOCodeWaitEVContadorTimeOut` - Waiting for vehicle-side contacdt closure failed. Vehicle-side malfunction
 * * `CHAdeMOCodeDCVoltExceed10VNormalEnd` - Abnormal discharge at the end of charging. Vehicle-side malfunction
 * * `CHAdeMOCodeCommunicationOpenTimeOut` - Waiting for the vehicle to disconnect communication timeout after charging ends. Vehicle-side malfunction
 * * `CHAdeMOCodeChargingSystemFault` - Vehicle-side reported charging system error. Vehicle-side malfunction
 * * `CHAdeMOCodeOutOverVoltage` - Output voltage abnormal. Vehicle-side malfunction
 * * `CHAdeMOCodeOutOvercurrent` - Output current abnormal.
 * * `CHAdeMOCodeBatterPolarity` - Battery polarity error
 * * `CHAdeMOCodeEVSEIsolationStatusFail` - Insulation fault error
 * * `CHAdeMOCodeMalfunctionDetectionFail` - Charging plug electromagnetic lock failed to lock. Charging cable electromagnetic lock malfunction
 * * `CHAdeMOCodeCANInitFail` - CCAN initialization failed. Board malfunction
 * * `CHAdeMOCodeVehicleShiftPositionStop` - Vehicle-side Vehicle_shift_position stops. Issue on the vehicle side
 * * `CHAdeMOCodeWaitJ3OpenErr` - Waiting for vehicle-side Switch = OFF timeout. Vehicle-side malfunction
 * * `CHAdeMOCodeWaitCommunicationCloseTimeOut` - Wait for communication closure anomaly. Vehicle-side malfunction
 * * `CHAdeMOCodeBEforeChargeJ3StatusErr` - Switch status abnormal before charging. Vehicle-side malfunction
 * * `CHAdeMOCodeTargetBatterVoltageErr` - EEV target battery voltage abnormal. Vehiccle-side malfunction
 * * `CHAdeMOCodeBatteryInccompatibilityErr` - EV battery mismatch. Vehicle-side mismatch
 * * `CHAdeMOCodeRequestCurrentErr` - Current request failed. Vehicle-side malfunction
 * * `CHAdeMOCodeMinimumCurrentErr` - Minimum current error. Vehicle-side malfunction
 * * `CHAdeMOCodeNormalStopRequestBefoeCharging` - Vehicle-side requests to stop before charging. Vehicle-side malfunction
 * * `CHAdeMOCodeRemainingChargingTimeIsZero` - Remaining charging time is 0. Charging stopped
 * * `CHAdeMOCodeWaitPowerReadyTimeout` - Waiting for the power module to be ready exceeded timeout. Power module anomaly
 * * `CHAdeMOCodeVehicleCChargingEnable` - Vehicle-side 'Vehicle_charging_enabled' status error. Vehicle-side malfunction
 * * `CHAdeMOCodeCurrent5AOrLess` - Waiting dot charging to end and current to drop below 5A exceeded timeout. Power module or current detection issue
 * * `CHAdeMOCodeEVErrorCanid1024A` - Vehicle-side reported 102.4 error stop. Vehicle-side malfunction
 * * `CHAdeMOCodeEVErrorCanid10240` - Vehicle-side reported: Battery_Overvoltage
 * * `CHAdeMOCodeEVErrorCanid10241` - Vehicle-side reported: Battery_Undervoltage
 * * `CHAdeMOCodeEVErrorCanid1024` - Vehicle-side reported: Battery_Current_deviation_Error
 * * `CHAdeMOCodeEVErrorCanid10243` - Vehicle-side reported: Battery_High_Temperature
 * * `CHAdeMOCodeEVErrorCanid10244` - Vehicle-side reported: Battery_Voltage_Deviation_Error
 * * `CHAdeMOCodeOther` - Cannot use if not matched, try not to use it
 * * `CCSStopCodePlugOut` - Detected that the charging plug was remover during charging. CP immediately changes to 12v
 * * `CCSStopCodeReadyToChargePerformanceTimeOut` - Waiting to start charging timeout
 * * `CCSStopCodeCommEVSessionStop` - Vehicle-side sent Session stop for normal termination
 * * `CCSStopCodeEVSEIsolationStatusFail` - Stopped due to isulation fault
 * * `CCSStopCodeEVTargetVoltageFail` - Vehicle-side demanded coltage exceeds the maximum allowable voltage for for the vehicle
 * * `CCSStopCodeEVTargetCurrentFail` - Vehicle-side demanded voltage  exceeds the maximum allowable current for the vehicle
 * * `CCSStopCodeEVSEPresentVoltageFail` - DC output over-voltage
 * * `CCSStopCodeEVSEPresentCurrentFail` - DC output overcurrent
 * * `CCSStopCodeCPFail` - CP voltage abnormal, exceeds 6v, 9v with a tolerance of plus or minus 0.8V
 * * `CCSStopCodeEVSEBatterPolarityFail` - BAttery polarity reversed
 * * `CCSStopCodeEvseChargeBeforeOvervoltageFail` - Overvoltage before charging
 * * `CCSStopCodeEvseChargeInsulationAfterOvervoltageFail` - Overvoltage after insulation charge
 * * `CSSStopCodeEVSEUndervoltage` - Output undervoltage
 * * `CCSStopCodeOngoingPerformanceTimeout` - WAiting for charging permission timeout
 * * `CCSStopCodePDVoltAlarm` - American standard plug PD detection error; not applicable for European Standar
 * * `CCSStopCodeOther` - not matched, try not to use
 * * `V2GFailed` - V2G failed
 * * `V2GFailedSequenceError` - V2G failed sequence error
 * * `V2GFailedServiceIdInvalid` - V2G failed service id invalid
 * * `V2GFailedUnknownSession` - V2G failed unknow session
 * * `V2GFailedServiceSelectionInvalid` - V2G failed service selection invalid
 * * `V2GFailedPaymentSelectionInvelid` - V2G failed payment selection invalid
 * * `V2GFailedCertificateExpired` - V2G failed certificate expired
 * * `V2GFailedSignatureError` - V2G failed signature error
 * * `V2GFailedNoCertificateAvailable` - V2G failed no certificate available
 * * `V2GFailedCertChainError` - V2G failed cert chain error
 * * `V2GFailedChallengeInvalid` - V2G failed challenge invalid
 * * `V2GFailedContractCanceled` - V2G failed contract canceled
 * * `V2GFailedWrongChargeParameter` - V2G failed wrong charge parameter
 * * `V2GFailedPowerDeliveryNotApplied` - V2G failed power delivery not applied
 * * `V2GFailedTariffSelectionInvalid` - V2G failed tariff selection invalid
 * * `V2GFailedChargingProfileInvalid` - V2G failed charging profile invalid
 * * `V2GFailedEVSEPresentVoltToLow` - V2G failed EVSE present volt to low
 * * `V2GFailedMeteringsignatureNotValid` - V2G failed metering signature not velid
 * * `V2GFailedWrongEnergyTranferType` - V2G failed wrong energy transfer type
 * * `V2GFailedAppHandResponse` - V2G failed app hand response code type failed no negotiation
 * * `V2GInitErrorQCA7000` - V2G inir error QCA 7000
 * * `V2GInitErrorOther` - V2G init error other
 * * `V2GInitErrorGeneral` - V2G init error general
 * * `V2GInitErrorIfaddr` - V2G init error ifaddr
 * * `V2GInitErrorThread` - V2G init error thread
 * * `V2GInitErrorOpenchannel` - V2G init error openchannel
 * * `V2GInitErrorKey` - V2G init error key
 * * `V2GSlacErrorGeneral` - V2G slac error general
 * * `V2GSlacErrorTimerInit` - V2G slac error timer init
 * * `V2GSlacErrorTimerTimeout` - V2G slac error timer timeout
 * * `V2GSlacErrorTimerMisc` - V2G slac error timer misc
 * * `V2GSlacErrorParamTimeout` - V2G slac error param timeout
 * * `V2GSlacErrorParamSocket` - V2G slac error param socket
 * * `V2GSlacErrorStartAttenCharTimeout` - V2G slac error start atten char timeout
 * * `V2GSlacErrorMNBCSoundTimeout` - V2G slac error MNBC sound timeout
 * * `V2GSlacErrorAttenCharTimeout` - V2G slac error atten char timeout
 * * `V2GSlacErrorAttenCharSocket` - V2G slac error atten char Socket
 * * `V2GSlacErrorValidate1Timeout` - V2G slac error validate 1 timeout
 * * `V2GSlacErrorValidate1Socket` - V2G slac error validate 1 socket
 * * `V2GSlacErrorValidate2Timeout` - V2G slac error validate 2 timeout
 * * `V2GSlacErrorValidate2Socket` - V2G slac error validate 2 socket
 * * `V2GSlacErrorBCBToggleTimeout` - V2G slac error BCB toggle timeout
 * * `V2GSlacErrorMatchTimeout` - V2G slac error match timeout
 * * `V2GSlacErrorMatchSocket` - V2G slac error match Socket
 * * `V2GSlacErrorReadSocket` - V2G slac error read Socket
 * * `V2GSlacErrorSetKey` - V2G slac error set key
 * * `V2GSlacErrorLinkTimeout` - V2G slac error link timeout
 * * `V2GSDPErrorGeneral` - V2G SDP error general
 * * `V2GSDPErrorInitSocket` - V2G SDP error init socket
 * * `V2GSDPErrorInitSockOPT1` - V2G SDP error init sockotp1
 * * `V2GSDPErrorInitSockOPT2` - V2G SDP error init sockotp2
 * * `V2GSDPErrorInitBind` - V2G SDP error init bind
 * * `V2GSDPErrorThreadSocket1` - V2G SDP error thread docket 1
 * * `V2GSDPErrorThreadSocket2` - V2G SDP error thread docket 2
 * * `V2GSDPErrorTimeout` - V2G SDP error timeout
 * * `V2GSDPErrorTCPDisconnected` - V2G SDP error tcp disconnected
 * * `V2GDinErrorGeneral` - V2G DIN error general
 * * `V2GDinErrorInitSocket` - V2G DIN error init socket
 * * `V2GDinErrorInitSockOPT` - V2G DIN error init sockOPT
 * * `V2GDinErrorInitBind` - V2G DIN error init bind
 * * `V2GDinErrorInitListen` - V2G DIN error init listen
 * * `V2GDinErrorInitSelect` - V2G DIN error init select
 * * `V2GDinErrorInitAccept` - V2G DIN error init accept
 * * `V2GDinErrorTimeout` - V2G DIN error timeout
 * * `V2GDinErrorV2GTPHeader` - V2G DIN error V2GTP header
 * * `V2GDinErrorV2GTPHeaderLen` - V2G DIN error V2GTP header Len
 * * `V2GDinErrorV2GTPHeaderWrite` - V2G DIN error V2GTP header write
 * * `V2GDinErrorDecodeExi` - V2G DIN error Decode Exi
 * * `V2GDinErrorEncodeExi` - V2G DIN error Encode Exi
 * * `V2GDinErrorCreateResponse` - V2G DIN error create response
 * * `V2GDinErrorSocketException` - V2G DIN error socket exception
 * * `V2GDinErrorSocketSend` - V2G DIN error socket send
 * * `V2GDinErrorNoProtocol` - V2G DIN error no protocol
 */
export enum VerboseErrorEnum {
  ErrorNotInterpreted = 'Error not interpreted',
  UpdateFail = 'UpdateFail',
  ResetFailure = 'ResetFailure',
  GunTemperature = 'GunTemperature',
  TrialPeriodOver = 'TrialPeriodOver',
  EmergencyStop = 'EmergencyStop',
  BleederResistor = 'BleederResistor',
  Insulation = 'Insulation',
  OpenDoor = 'OpenDoor',
  MeterFault = 'MeterFault',
  BEMAlarmStop = 'BEMAlarmStop',
  BSMMessage = 'BSMMessage',
  BROFault = 'BROFault',
  OuterVoltageRelay = 'OuterVoltageRelay',
  BRMTimeOut = 'BRMTimeOut',
  BCPTimeOut = 'BCPTimeOut',
  BROTimeOut = 'BROTimeOut',
  BCLTimeOut = 'BCLTimeOut',
  BSTTimeOut = 'BSTTimeOut',
  BSDTimeOut = 'BSDTimeOut',
  BSMInsulation = 'BSMInsulation',
  BMSOutputTemperature = 'BMSOutputTemperature',
  BMSComponentTemperature = 'BMSComponentTemperature',
  BMSBatteryOverTemperature = 'BMSBatteryOverTemperature',
  BMSHighCurrent = 'BMSHighCurrent',
  BMSVoltageAbnormality = 'BMSVoltageAbnormality',
  BMSOtherErrors = 'BMSOtherErrors',
  PowerModuleCommunicationFault = 'PowerModuleCommunicationFault',
  InputOverVoltage = 'InputOverVoltage',
  InputUnderVoltage = 'InputUnderVoltage',
  GenericError = 'GenericError',
  MainsPowerSupply = 'MainsPowerSupply',
  TemperatureOutOfRange = 'TemperatureOutOfRange',
  InternalComunicationsError = 'InternalComunicationsError',
  ConfigurationError = 'ConfigurationError',
  MainsGroundFailure = 'MainsGroundFailure',
  MainsVoltageOutOfRange = 'MainsVoltageOutOfRange',
  MainsFrequencyOutOfRange = 'MainsFrequencyOutOfRange',
  HighTemperatureError = 'HighTemperatureError',
  LowTemperatureError = 'LowTemperatureError',
  ExternalComunicationsError = 'ExternalComunicationsError',
  ErrorMasterEntity = 'ErrorMasterEntity',
  SlaveError = 'SlaveError',
  DoorTamperAlarm = 'DoorTamperAlarm',
  TiltError = 'TiltError',
  DisplayFailure = 'DisplayFailure',
  RfidReaderFailure = 'RfidReaderFailure',
  PowerMeterFailure = 'PowerMeterFailure',
  GenericVehicleError = 'GenericVehicleError',
  VehicleComunicationError = 'VehicleComunicationError',
  VehicleNotDetected = 'VehicleNotDetected',
  VehicleOverCurrent = 'VehicleOverCurrent',
  CordMalfunction = 'CordMalfunction',
  CordSensorMalfunction = 'CordSensorMalfunction',
  ConnectorLockFailure = 'ConnectorLockFailure',
  InternalPowerSupplyFailure = 'InternalPowerSupplyFailure',
  ComponentTemperatureOutRange = 'ComponentTemperatureOutRange',
  HardwareFailureMode4 = 'HardwareFailureMode4',
  HardwareFailureNodes = 'HardwareFailureNodes',
  AcDcConvertersGenericError = 'AcDcConvertersGenericError',
  AcDcConvertersTimeOutError = 'AcDcConvertersTimeOutError',
  AcDcConvertersVoltageOutRange = 'AcDcConvertersVoltageOutRange',
  AcDcConvertersCurrentOutRange = 'AcDcConvertersCurrentOutRange',
  WeldingContactor = 'WeldingContactor',
  CurrentLeakDetected = 'CurrentLeakDetected',
  ElectricalProtectionTriggered = 'ElectricalProtectionTriggered',
  IsolationError = 'IsolationError',
  RcdProtectionTriggered = 'RcdProtectionTriggered',
  McbProtectionTriggered = 'McbProtectionTriggered',
  ProgramCounterFailure = 'ProgramCounterFailure',
  Invalid = 'Invalid',
  NoError = 'NoError',
  UserRequestStop = 'UserRequestStop',
  ConnectorButtonPressed = 'ConnectorButtonPressed',
  VehicleStop = 'VehicleStop',
  IncompatibleVehicle = 'IncompatibleVehicle',
  IsolationTestFailed = 'IsolationTestFailed',
  CableCheckFailed = 'CableCheckFailed',
  BatteryFull = 'BatteryFull',
  BudgetExceeded = 'BudgetExceeded',
  ChargerError = 'ChargerError',
  ChargerContactorProblem = 'ChargerContactorProblem',
  ChargerLoweringCurrentTimeout = 'ChargerLoweringCurrentTimeout',
  ConnectorError = 'ConnectorError',
  ConnectorPilotError = 'ConnectorPilotError',
  ControlPilotShorCircuit = 'ControlPilotShorCircuit',
  ConnectorTemperatureError = 'ConnectorTemperatureError',
  OutletError = 'Outlet error',
  ChargerPreChargerTimeout = 'chargerPreChargerTimeout',
  ChargerVoltageDrop = 'ChargerVoltageDrop',
  ChargerMaxVoltage = 'ChargerMaxVoltage',
  ChargedStopTimeout = 'ChargedStopTimeout',
  ChargerConnectorPresenceLost = 'ChargerConnectorPresenceLost',
  ChargerErrorCurrentDifference = 'ChargerErrorCurrentDifference',
  ChargerCANCommunicationLost = 'ChargerCANCommunicationLost',
  ChargerMCBTripped = 'ChargerMCBTripped',
  ChargedRCDTriped = 'ChargedRCDTriped',
  ChargerRCDCloseError = 'ChargerRCDCloseError',
  ChargefTemperatureError = 'ChargefTemperatureError',
  ChargerNeutralMismatch = 'ChargerNeutralMismatch',
  ChargerOutletDetection = 'ChargerOutletDetection',
  VehicleProtocolError = 'VehicleProtocolError',
  PowerPortVipError = 'PowerPortVipError',
  PowerPortPowerError = 'Power port power error',
  PowerPortFanFailure = 'PowerPortFanFailure',
  PowerPortOverheat = 'PowerPortOverheat',
  PowerPortInterlock = 'PowerPortInterlock',
  PowerPortErrorOther = 'PowerPortErrorOther',
  VehicleErrorReversePolarity = 'VehicleErrorReversePolarity',
  VehicleErrorVoltageApplied = 'VehicleErrorVoltageApplied',
  LockError = 'LockError',
  UnlockError = 'UnlockError',
  LockTampering = 'LockTampering',
  CableError = 'CableError',
  GlobalInterlockFail = 'GlobalInterlockFail',
  VehicleShiftPosition = 'VehicleShiftPosition',
  VehicleBatteryTemperatureOutOfRange = 'VehicleBatteryTemperatureOutOfRange',
  VehicleLookError = 'VehicleLookError',
  VehicleBatteryMalfunction = 'VehicleBatteryMalfunction',
  VehicleCurrentDifference = 'VehicleCurrentDifference',
  VehicleVoltageOutOfRange = 'VehicleVoltageOutOfRange',
  VehicleError = 'VehicleError',
  OardPowerSupplyError = 'oardPowerSupplyError',
  OcmNotAlive = 'OcmNotAlive',
  OcmInterlockVeriicationError = 'OcmInterlockVeriicationError',
  OcmCableRatingMismatch = 'OcmCableRatingMismatch',
  OnBoardEnergymeterError = 'OnBoardEnergymeterError',
  VehicleWeldingDetectionTimeout = 'VehicleWeldingDetectionTimeout',
  CableCheckCurrentRunning = 'CableCheckCurrentRunning',
  CableCheckVoltageTooLow = 'CableCheckVoltageTooLow',
  CableCheckVoltageTooHigh = 'CableCheckVoltageTooHigh',
  CableCheckVoltageNotDropping = 'CableCheckVoltageNotDropping',
  ChargerTimeCompleted = 'ChargerTimeCompleted',
  VehicleNotConnected = 'VehicleNotConnected',
  SoftError = 'SoftError',
  StoppedByVehicle = 'StoppedByVehicle',
  AcsErrorExtending = 'AcsErrorExtending',
  AcsErrorRetracting = 'AcsErrorRetracting',
  AcsExtendedTimeout = 'AcsExtendedTimeout',
  AcsRetractedTimeout = 'AcsRetractedTimeout',
  AccErrorAligment = 'AccErrorAligment',
  ChargerCabinetOvp = 'ChargerCabinetOvp',
  ChargerCableCoolerFailure = 'ChargerCableCoolerFailure',
  ChargerCableCoolerTemperature = 'ChargerCableCoolerTemperature',
  ChargerCableTemperature = 'ChargerCableTemperature',
  ChargerContactorTemperature = 'ChargerContactorTemperature',
  EstCorrect = 'EstCorrect',
  Blocked = 'blocked',
  Expired = 'Expired',
  InvalidOnServer = 'InvalidOnServer',
  InvalidOnCharged = 'InvalidOnCharged',
  RequestReject = 'RequestReject',
  WrongMessage = 'WrongMessage',
  NoMatchingIDs = 'NoMatchingIDs',
  ServerUnreachable = 'ServerUnreachable',
  NoCardPresented = 'NoCardPresented',
  AuthorizedStop = 'AuthorizedStop',
  ForcedStop = 'ForcedStop',
  NormalStop = 'NormalStop',
  ImiDisconnectedFromDcbus = 'ImiDisconnectedFromDcbus',
  ChargerCommunicationFailure = 'ChargerCommunicationFailure',
  ChargerSubunitCommunicationFailure = 'ChargerSubunitCommunicationFailure',
  DCElectricMeterCommunicationFailed = 'DCElectricMeterCommunicationFailed',
  PowerModuleCANCommunicationFailure = 'PowerModuleCANCommunicationFailure',
  InsulationCommunication = 'InsulationCommunication',
  Timeout = 'Timeout',
  ACElectricMeterCommunicationFailure = 'ACElectricMeterCommunicationFailure',
  NFCCommunicationFailure = 'NFC Communication Failure',
  CommunicationFailureLightPanel = 'CommunicationFailureLightPanel',
  BluetoothCommunicationFailure = 'BluetoothCommunicationFailure',
  ChargerFANMalfunction = 'ChargerFANMalfunction',
  DCBTCUAbnormality = 'DCBTCUAbnormality',
  ChargerOtherFaults = 'ChargerOtherFaults',
  TCUVINVerificationTimedOut = 'TCUVINVerificationTimedOut',
  VehicleAuthenticationFailed = 'VehicleAuthenticationFailed',
  FanSpeedControlFailure = 'FanSpeedControlFailure',
  InsulationAlarm = 'InsulationAlarm',
  InsulationFault = 'InsulationFault',
  PowerModuleAlarm = 'PowerModuleAlarm',
  PowerModuleConflict = 'PowerModuleConflict',
  PowerModuleFault = 'PowerModuleFault',
  PowerModuleStatusChange = 'PowerModuleStatusChange',
  PowerModulePhaseLossFault = 'PowerModulePhaseLossFault',
  PowerModuleFanFault = 'PowerModuleFanFault',
  PowerModuleOvertemperatureFault = 'PowerModuleOvertemperatureFault',
  PowerModuleACInputFault = 'PowerModuleACInputFault',
  PowerModuleOutputShortCircuitFault = 'PowerModuleOutputShortCircuitFault',
  PowerModuleOutputOvercurrentFault = 'PowerModuleOutputOvercurrentFault',
  PowerModuleOutputOvervoltageFault = 'PowerModuleOutputOvervoltageFault',
  PowerModuleOutputUndervoltageFault = 'PowerModuleOutputUndervoltageFault',
  PowerModuleInputOvervoltageFault = 'PowerModuleInputOvervoltageFault',
  PowerModuleInputUndervoltageFault = 'PowerModuleInputUndervoltageFault',
  PowerModuleDischargeFault = 'PowerModuleDischargeFault',
  PowerModuleCurrentLimit = 'PowerModuleCurrentLimit',
  PowerModuleShutdown = 'PowerModuleShutdown',
  NoAvailableSparePowerModule = 'NoAvailableSparePowerModule',
  ChargerAccessControlFailure = 'ChargerAccessControlFailure',
  LiquidLevelAlarm = 'LiquidLevelAlarm',
  ACSurgeAlarm = 'ACSurgeAlarm',
  DCSurgeAlarm = 'DCSurgeAlarm',
  GunEndContactFault = 'GunEndContactFault',
  ChargigStationSmokeDetectorFault = 'ChargigStationSmokeDetectorFault',
  CabinetTemperatureAlarm = 'CabinetTemperatureAlarm',
  CabinetHumidityAlarm = 'CabinetHumidityAlarm',
  TiltAngleAlarm = 'TiltAngleAlarm',
  LiquidCooledHeadExceedsShutdown = 'LiquidCooledHeadExceedsShutdown',
  LiquidCooledHeadExceedsCurrentShutdown = 'LiquidCooledHeadExceedsCurrentShutdown',
  LiquidCooledTailExceedsShutdown = 'LiquidCooledTailExceedsShutdown',
  LiquidCooledTailExceedsCurrentShutdown = 'LiquidCooledTailExceedsCurrentShutdown',
  LiquidCooledHeadTemperatureRiseExceedsShutdown = 'LiquidCooledHeadTemperatureRiseExceedsShutdown',
  LiquidCooledHeadTemperatureRiseCurrentShutdown = 'LiquidCooledHeadTemperatureRiseCurrentShutdown',
  LiquidCooledTailTemperatureRiseExceedsShutdown = 'LiquidCooledTailTemperatureRiseExceedsShutdown',
  LiquidCooledTailTemperatureRiseCurrentShutdown = 'LiquidCooledTailTemperatureRiseCurrentShutdown',
  LowLiquidLevel = 'LowLiquidLevel',
  LiquidCoolingOvertemperatureOvervoltage = 'LiquidCoolingOvertemperatureOvervoltage',
  LiquidCooledHeadDifferenceExceeds = 'LiquidCooledHeadDifferenceExceeds',
  LiquidCooledHeadTailShutdown = 'LiquidCooledHeadTailShutdown',
  LiquidCoolingFault = 'LiquidCoolingFault',
  ChargingStationFault = 'ChargingStationFault',
  TiltAngleFault = 'TiltAngleFault',
  LiquidCoolingCoolantLowLevelFault = 'LiquidCoolingCoolantLowLevelFault',
  OtherHardwareFaultsInLiquidCooling = 'OtherHardwareFaultsInLiquidCooling',
  LiquidCoolingDischargeNoShutdown = 'LiquidCoolingDischargeNoShutdown',
  LiquidCoolingDischargeShutdown = 'LiquidCoolingDischargeShutdown',
  LiquidCoolingReturnNoShutdown = 'LiquidCoolingReturnNoShutdown',
  LiquidCoolingReturnShutdown = 'LiquidCoolingReturnShutdown',
  LiquidCoolingPumpLowAlarm = 'LiquidCoolingPumpLowAlarm',
  LiquidCoolingPumpLowFault = 'LiquidCoolingPumpLowFault',
  LiquidCoolingPumpFault = 'LiquidCoolingPumpFault',
  LiquidCoolingPumpSesingFault = 'LiquidCoolingPumpSesingFault',
  EmergencyStopCircuitFault = 'EmergencyStopCircuitFault',
  ChargingGunTemperatureAlarm = 'ChargingGunTemperatureAlarm',
  ElectromagneticLockLockingFailed = 'ElectromagneticLockLockingFailed',
  ElectromagneticLockUnlockingFailed = 'ElectromagneticLockUnlockingFailed',
  AbnormalityChargingGunPort = 'AbnormalityChargingGunPort',
  ChargingGunNotProperlyPositioned = 'ChargingGunNotProperlyPositioned',
  BMSVoltageLowOrHigh = 'BMSVoltageLowOrHigh',
  BMSVoltageHigh = 'BMSVoltageHigh',
  BMSVoltageLow = 'BMSVoltageLow',
  APhaseHigh = 'APhaseHigh',
  BPhaseHigh = 'BPhaseHigh',
  CPhaseHigh = 'CPhaseHigh',
  APhaseLow = 'APhaseLow',
  BPhaseLow = 'BPhaseLow',
  CPhaseLow = 'CPhaseLow',
  GroundWireAlarm = 'GroundWireAlarm',
  NLineNotConnected = 'NLineNotConnected',
  ACInputCircuitBrakerFailure = 'ACInputCircuitBrakerFailure',
  ACInputContadorRefusarFault = 'ACInputContadorRefusarFault',
  ACInputContadorStickingFault = 'ACInputContadorStickingFault',
  SystemPowerFailure = 'SystemPowerFailure',
  ACPowerMeterReadingAbnormal = 'ACPowerMeterReadingAbnormal',
  ACInputPhaseLoss = 'ACInputPhaseLoss',
  VoltageAbnormalityOvervoltage = 'VoltageAbnormalityOvervoltage',
  VoltageAbnormalityUndervoltage = 'VoltageAbnormalityUndervoltage',
  VoltageAbnormalityShortCircuit = 'VoltageAbnormalityShortCircuit',
  VoltageAbnormalityOverload = 'VoltageAbnormalityOverload',
  BatteryReverseConnection = 'BatteryReverseConnection',
  DCDetectionFailure = 'DCDetectionFailure',
  DischargeDetectionFailure = 'DischargeDetectionFailure',
  ParallelContadorRefusalFault = 'ParallelContadorRefusalFault',
  ParallelContadorAhesionFault = 'ParallelContadorAhesionFault',
  DCBusOutputFuseFault = 'DCBusOutputFuseFault',
  ChargingHostPreChargingFailureFault = 'ChargingHostPreChargingFailureFault',
  ChargingHostResponseChargingFailureFault = 'ChargingHostResponseChargingFailureFault',
  BatteryUndervoltage = 'BatteryUndervoltage',
  BatteryOvervoltage = 'BatteryOvervoltage',
  AbnormalDC = 'AbnormalDC',
  GunheadDCRefusalFault = 'GunheadDCRefusalFault',
  GunheadDCAdhesionFault = 'GunheadDCAdhesionFault',
  PrechargeTimeout = 'PrechargeTimeout',
  AuxiliaryPowerNotPowered = 'AuxiliaryPowerNotPowered',
  CRMTimeout = 'CRMTimeout',
  CRM00Timeout = 'CRM00Timeout',
  CRMaaTimeout = 'CRMaaTimeout',
  CROTimeout = 'CROTimeout',
  CTSTimeout = 'CTSTimeout',
  CMLTimeout = 'CMLTimeout',
  CCSTimeout = 'CCSTimeout',
  CSTTimeout = 'CSTTimeout',
  CSDTimeout = 'CSDTimeout',
  OtherTimeoutFaultBEM = 'OtherTimeoutFaultBEM',
  ChargerOutputCurrentExcedsDC = 'ChargerOutputCurrentExcedsDC',
  ChargerOutputCurrentExcedsAC = 'ChargerOutputCurrentExcedsAC',
  ChargingHostEmergencyStop = 'ChargingHostEmergencyStop',
  ChargingostDCBusbarFuse = 'ChargingostDCBusbarFuse',
  ChargingHostAccessControlFAilure = 'ChargingHostAccessControlFAilure',
  ChargingHostSmokeDetectorFailure = 'ChargingHostSmokeDetectorFailure',
  ChargingHostACInputCircuitBreakerFailure = 'ChargingHostACInputCircuitBreakerFailure',
  ChargingHostACInputContactorMalfunction = 'ChargingHostACInputContactorMalfunction',
  ChargingHostACInputStickingMalfunction = 'ChargingHostACInputStickingMalfunction',
  ChargingHostFanMalfunction = 'ChargingHostFanMalfunction',
  ChargingHostParallelContactorMalfunction = 'ChargingHostParallelContactorMalfunction',
  ChargingHostParallelStickingMalfunction = 'ChargingHostParallelStickingMalfunction',
  ChargingHostLiquidCoolingModuleMalfunction = 'ChargingHostLiquidCoolingModuleMalfunction',
  ChargingHostLiquidCoolingModuleCommunicationFailure = 'ChargingHostLiquidCoolingModuleCommunicationFailure',
  ChargingHostSurgeArresterMAlfunction = 'ChargingHostSurgeArresterMAlfunction',
  ChargingHostACEnergyMeterCommunicationFailure = 'ChargingHostACEnergyMeterCommunicationFailure',
  ChargingHostOverTemperatureFault = 'ChargingHostOverTemperatureFault',
  ChargingHostOverTemperatureWarning = 'ChargingHostOverTemperatureWarning',
  ChargingHostInputVoltageOvervoltageFault = 'ChargingHostInputVoltageOvervoltageFault',
  ChargingHostInputVoltageUndervoltageFault = 'ChargingHostInputVoltageUndervoltageFault',
  ChargingHostWaterLevelMonitoringAbnormality = 'ChargingHostWaterLevelMonitoringAbnormality',
  ChargingHostPowerModuleFault = 'ChargingHostPowerModuleFault',
  ChargingHostPowerModuleCommunicationFailure = 'ChargingHostPowerModuleCommunicationFailure',
  ChargingHostPowerModuleFanMalfunction = 'ChargingHostPowerModuleFanMalfunction',
  ChargingHostPowerModuleOverTemperatureFault = 'ChargingHostPowerModuleOverTemperatureFault',
  ChargingHostPowerModuleACInputFault = 'ChargingHostPowerModuleACInputFault',
  ChargingHostPowerModuleOutputShortCircuitFault = 'ChargingHostPowerModuleOutputShortCircuitFault',
  ChargingHostPowerModuleOutputOvercurrentFault = 'ChargingHostPowerModuleOutputOvercurrentFault',
  ChargingHostModuleOutputOvervoltageFault = 'ChargingHostModuleOutputOvervoltageFault',
  ChargingHostModuleOutputUndervoltageFault = 'ChargingHostModuleOutputUndervoltageFault',
  ChargingHostModuleInputOvervoltageFault = 'ChargingHostModuleInputOvervoltageFault',
  ChargingHostModuleInputUndevoltagetFault = 'ChargingHostModuleInputUndevoltagetFault',
  ChargingHostModuleInputPhaseLossFault = 'ChargingHostModuleInputPhaseLossFault',
  ChargingHostChargingModuleFault = 'ChargingHostChargingModuleFault',
  ChargingHostChargingModuleCommunicationFailure = 'ChargingHostChargingModuleCommunicationFailure',
  ChargingHostAdhesiveDetectionTimeout = 'ChargingHostAdhesiveDetectionTimeout',
  ChargingHostChargingStopCompletionTimeout = 'ChargingHostChargingStopCompletionTimeout',
  ChargingHostInsulationDetectionFrameTimeout = 'ChargingHostInsulationDetectionFrameTimeout',
  ChargingHostInsulationDetectionCompletionTimeout = 'ChargingHostInsulationDetectionCompletionTimeout',
  ChargingHostPreChargeFrameTimeout = 'ChargingHostPreChargeFrameTimeout',
  ChargingHostPreChargeCompletionTimeout = 'ChargingHostPreChargeCompletionTimeout',
  ChargingHostReceptionFirmwareUpgradeFrameTimeout = 'ChargingHostReceptionFirmwareUpgradeFrameTimeout',
  ChargingHostReceptionChargingDemandDataFrameTimeout = 'ChargingHostReceptionChargingDemandDataFrameTimeout',
  ChargingHostChargingTerminalTelesinalFrameTimeout = 'ChargingHostChargingTerminalTelesinalFrameTimeout',
  ChargingHostChargingStartupTimeout = 'ChargingHostChargingStartupTimeout',
  ChargingHostChargingStopTimeout = 'ChargingHostChargingStopTimeout',
  ChargingHostTimeSynchronizationOperationTimeout = 'ChargingHostTimeSynchronizationOperationTimeout',
  ChargingHostVersionVerificationTimeout = 'ChargingHostVersionVerificationTimeout',
  ChargingHostChargingParameterTimeout = 'ChargingHostChargingParameterTimeout',
  ChargingHostPreChargerTimeout = 'ChargingHostPreChargerTimeout',
  ChargingHostInsulationDetectionTimeout = 'ChargingHostInsulationDetectionTimeout',
  ChargingHostRemoteUpgradeRequestTimeout = 'ChargingHostRemoteUpgradeRequestTimeout',
  ChargingHostDebuggingDataRequestTimeout = 'ChargingHostDebuggingDataRequestTimeout',
  ChargingHostControlRequestTimeout = 'ChargingHostControlRequestTimeout',
  ChargingHostRemoteFirmwareTransferFrameTimeout = 'ChargingHostRemoteFirmwareTransferFrameTimeout',
  ChargingHostRemoteUpgradeCompletionFrameTimeout = 'ChargingHostRemoteUpgradeCompletionFrameTimeout',
  ChargingHostTelecontrolFrameTimeout = 'ChargingHostTelecontrolFrameTimeout',
  CharginghostTelemetryFrameTimeout = 'CharginghostTelemetryFrameTimeout',
  ChargingHostInsulationDetectionCompletionFrameTimeout = 'ChargingHostInsulationDetectionCompletionFrameTimeout',
  ChargingHostAdhesiveDetectionFrameTimeout = 'ChargingHostAdhesiveDetectionFrameTimeout',
  ChargingHostPreChargeCompletionFrameTimeout = 'ChargingHostPreChargeCompletionFrameTimeout',
  ChargingHostChargingStopFrameTimeout = 'ChargingHostChargingStopFrameTimeout',
  ChargingHostAndSubCommunicationNotCompleted = 'ChargingHostAndSubCommunicationNotCompleted',
  ChargingHostHeartbeatReceptionStatus = 'ChargingHostHeartbeatReceptionStatus',
  BSTHighVoltageRelayMalfunction = 'BSTHighVoltageRelayMalfunction',
  BSTChargingConnectorMalfunction = 'BSTChargingConnectorMalfunction',
  BSTBatteryPackTemperatureHigh = 'BSTBatteryPackTemperatureHigh',
  BSTCurrentExceedsRequiredValue = 'BSTCurrentExceedsRequiredValue',
  BSTVoltageAbnormal = 'BSTVoltageAbnormal',
  BSTDetectionPoint2VoltageDetectionMalfunction = 'BSTDetectionPoint2VoltageDetectionMalfunction',
  BSTOtherMalfunction = 'BSTOtherMalfunction',
  BSTOutputConnectorOverheated = 'BSTOutputConnectorOverheated',
  BSTStopSendData0Malfunction = 'BSTStopSendData0Malfunction',
  BSTVehicleInsulation = 'BSTVehicleInsulation',
  BMSCurrentExceedsVoltageMode = 'BMSCurrentExceedsVoltageMode',
  BMSCurrentExceedsCurrentMode = 'BMSCurrentExceedsCurrentMode',
  ChargingProhibited = 'ChargingProhibited',
  BHMVoltageMatchingFailure = 'BHMVoltageMatchingFailure',
  VoltageDetectionFailure = 'VoltageDetectionFailure',
  BMSCoponentOutputConnectorOverTemperature = 'BMSCoponentOutputConnectorOverTemperature',
  BSMIndividualPowerBatteryHigh = 'BSMIndividualPowerBatteryHigh',
  BSMIndividualPowerBatteryLow = 'BSMIndividualPowerBatteryLow',
  BSMVehiclePowerBatteryHigh = 'BSMVehiclePowerBatteryHigh',
  BSMVehiclePowerBatterylow = 'BSMVehiclePowerBatterylow',
  BSMVehiclePowerBatteryInsulationAbnormal = 'BSMVehiclePowerBatteryInsulationAbnormal',
  BSMBatteryOvercurrentCharging = 'BSMBatteryOvercurrentCharging',
  BSMBatteryTemperatureHigh = 'BSMBatteryTemperatureHigh',
  BSMBatteryOutputConnectorConnectionAbnormal = 'BSMBatteryOutputConnectorConnectionAbnormal',
  BMSCommunicationProtocolVersionMismatch = 'BMSCommunicationProtocolVersionMismatch',
  VehicleFullyCharged = 'VehicleFullyCharged',
  ReachedSetTotalVoltage = 'ReachedSetTotalVoltage',
  ReachedSetIndividualVoltage = 'ReachedSetIndividualVoltage',
  MetChargerSettingConditions = 'MetChargerSettingConditions',
  VehicleSideManualTermination = 'VehicleSideManualTermination',
  PowerCannotBeTransmitted = 'PowerCannotBeTransmitted',
  CurrentMismatchVehicleMalfunction = 'CurrentMismatchVehicleMalfunction',
  ChargedTeminated = 'ChargedTeminated',
  BRMTimeout = 'BRMTimeout',
  BCPTimeout = 'BCPTimeout',
  BRO_TIMEOUT = 'BRO_TIMEOUT',
  BCSTimeout = 'BCSTimeout',
  BCLTimeout = 'BCLTimeout',
  BSTTimeout = 'BSTTimeout',
  BSDTimeout = 'BSDTimeout',
  BSMTimeout = 'BSMTimeout',
  CHAdeMoCodeWaitJ3TimeOut = 'CHAdeMoCodeWaitJ3TimeOut',
  CHAdeMoCodeDCVoltExceed10V = 'CHAdeMoCodeDCVoltExceed10V',
  CHAdeMoCodeJ3StatusErr = 'CHAdeMoCodeJ3StatusErr',
  CHAdeMOCodeEvReadyStatusErr = 'CHAdeMOCodeEvReadyStatusErr',
  CHAdeMOCodeWaitEVSEOutVoltErr = 'CHAdeMOCodeWaitEVSEOutVoltErr',
  CHAdeMOCodeDCVoltExceed20V = 'CHAdeMOCodeDCVoltExceed20V',
  CHAdeMOCodeCommunicationTimeOut = 'CHAdeMOCodeCommunicationTimeOut',
  CHAdeMOCodeWaitCAN10XTimeOut = 'CHAdeMOCodeWaitCAN10XTimeOut',
  CHAdeMOCodeWaitEVCurrentReqTimeOut = 'CHAdeMOCodeWaitEVCurrentReqTimeOut',
  CHAdeMOCodeWaitEVContadorTimeOut = 'CHAdeMOCodeWaitEVContadorTimeOut',
  CHAdeMOCodeDCVoltExceed10VNormalEnd = 'CHAdeMOCodeDCVoltExceed10VNormalEnd',
  CHAdeMOCodeCommunicationOpenTimeOut = 'CHAdeMOCodeCommunicationOpenTimeOut',
  CHAdeMOCodeChargingSystemFault = 'CHAdeMOCodeChargingSystemFault',
  CHAdeMOCodeOutOverVoltage = 'CHAdeMOCodeOutOverVoltage',
  CHAdeMOCodeOutOvercurrent = 'CHAdeMOCodeOutOvercurrent',
  CHAdeMOCodeBatterPolarity = 'CHAdeMOCodeBatterPolarity',
  CHAdeMOCodeEVSEIsolationStatusFail = 'CHAdeMOCodeEVSEIsolationStatusFail',
  CHAdeMOCodeMalfunctionDetectionFail = 'CHAdeMOCodeMalfunctionDetectionFail',
  CHAdeMOCodeCANInitFail = 'CHAdeMOCodeCANInitFail',
  CHAdeMOCodeVehicleShiftPositionStop = 'CHAdeMOCodeVehicleShiftPositionStop',
  CHAdeMOCodeWaitJ3OpenErr = 'CHAdeMOCodeWaitJ3OpenErr',
  CHAdeMOCodeWaitCommunicationCloseTimeOut = 'CHAdeMOCodeWaitCommunicationCloseTimeOut',
  CHAdeMOCodeBEforeChargeJ3StatusErr = 'CHAdeMOCodeBEforeChargeJ3StatusErr',
  CHAdeMOCodeTargetBatterVoltageErr = 'CHAdeMOCodeTargetBatterVoltageErr',
  CHAdeMOCodeBatteryInccompatibilityErr = 'CHAdeMOCodeBatteryInccompatibilityErr',
  CHAdeMOCodeRequestCurrentErr = 'CHAdeMOCodeRequestCurrentErr',
  CHAdeMOCodeMinimumCurrentErr = 'CHAdeMOCodeMinimumCurrentErr',
  CHAdeMOCodeNormalStopRequestBefoeCharging = 'CHAdeMOCodeNormalStopRequestBefoeCharging',
  CHAdeMOCodeRemainingChargingTimeIsZero = 'CHAdeMOCodeRemainingChargingTimeIsZero',
  CHAdeMOCodeWaitPowerReadyTimeout = 'CHAdeMOCodeWaitPowerReadyTimeout',
  CHAdeMOCodeVehicleCChargingEnable = 'CHAdeMOCodeVehicleCChargingEnable',
  CHAdeMOCodeCurrent5AOrLess = 'CHAdeMOCodeCurrent5AOrLess',
  CHAdeMOCodeEVErrorCanid1024A = 'CHAdeMOCodeEVErrorCanid1024A',
  CHAdeMOCodeEVErrorCanid10240 = 'CHAdeMOCodeEVErrorCanid10240',
  CHAdeMOCodeEVErrorCanid10241 = 'CHAdeMOCodeEVErrorCanid10241',
  CHAdeMOCodeEVErrorCanid1024 = 'CHAdeMOCodeEVErrorCanid1024',
  CHAdeMOCodeEVErrorCanid10243 = 'CHAdeMOCodeEVErrorCanid10243',
  CHAdeMOCodeEVErrorCanid10244 = 'CHAdeMOCodeEVErrorCanid10244',
  CHAdeMOCodeOther = 'CHAdeMOCodeOther',
  CCSStopCodePlugOut = 'CCSStopCodePlugOut',
  CCSStopCodeReadyToChargePerformanceTimeOut = 'CCSStopCodeReadyToChargePerformanceTimeOut',
  CCSStopCodeCommEVSessionStop = 'CCSStopCodeCommEVSessionStop',
  CCSStopCodeEVSEIsolationStatusFail = 'CCSStopCodeEVSEIsolationStatusFail',
  CCSStopCodeEVTargetVoltageFail = 'CCSStopCodeEVTargetVoltageFail',
  CCSStopCodeEVTargetCurrentFail = 'CCSStopCodeEVTargetCurrentFail',
  CCSStopCodeEVSEPresentVoltageFail = 'CCSStopCodeEVSEPresentVoltageFail',
  CCSStopCodeEVSEPresentCurrentFail = 'CCSStopCodeEVSEPresentCurrentFail',
  CCSStopCodeCPFail = 'CCSStopCodeCPFail',
  CCSStopCodeEVSEBatterPolarityFail = 'CCSStopCodeEVSEBatterPolarityFail',
  CCSStopCodeEvseChargeBeforeOvervoltageFail = 'CCSStopCodeEvseChargeBeforeOvervoltageFail',
  CCSStopCodeEvseChargeInsulationAfterOvervoltageFail = 'CCSStopCodeEvseChargeInsulationAfterOvervoltageFail',
  CSSStopCodeEVSEUndervoltage = 'CSSStopCodeEVSEUndervoltage',
  CCSStopCodeOngoingPerformanceTimeout = 'CCSStopCodeOngoingPerformanceTimeout',
  CCSStopCodePDVoltAlarm = 'CCSStopCodePDVoltAlarm',
  CCSStopCodeOther = 'CCSStopCodeOther',
  V2GFailed = 'V2GFailed',
  V2GFailedSequenceError = 'V2GFailedSequenceError',
  V2GFailedServiceIdInvalid = 'V2GFailedServiceIdInvalid',
  V2GFailedUnknownSession = 'V2GFailedUnknownSession',
  V2GFailedServiceSelectionInvalid = 'V2GFailedServiceSelectionInvalid',
  V2GFailedPaymentSelectionInvelid = 'V2GFailedPaymentSelectionInvelid',
  V2GFailedCertificateExpired = 'V2GFailedCertificateExpired',
  V2GFailedSignatureError = 'V2GFailedSignatureError',
  V2GFailedNoCertificateAvailable = 'V2GFailedNoCertificateAvailable',
  V2GFailedCertChainError = 'V2GFailedCertChainError',
  V2GFailedChallengeInvalid = 'V2GFailedChallengeInvalid',
  V2GFailedContractCanceled = 'V2GFailedContractCanceled',
  V2GFailedWrongChargeParameter = 'V2GFailedWrongChargeParameter',
  V2GFailedPowerDeliveryNotApplied = 'V2GFailedPowerDeliveryNotApplied',
  V2GFailedTariffSelectionInvalid = 'V2GFailedTariffSelectionInvalid',
  V2GFailedChargingProfileInvalid = 'V2GFailedChargingProfileInvalid',
  V2GFailedEVSEPresentVoltToLow = 'V2GFailedEVSEPresentVoltToLow',
  V2GFailedMeteringsignatureNotValid = 'V2GFailedMeteringsignatureNotValid',
  V2GFailedWrongEnergyTranferType = 'V2GFailedWrongEnergyTranferType',
  V2GFailedAppHandResponse = 'V2GFailedAppHandResponse',
  V2GInitErrorQCA7000 = 'V2GInitErrorQCA7000',
  V2GInitErrorOther = 'V2GInitErrorOther',
  V2GInitErrorGeneral = 'V2GInitErrorGeneral',
  V2GInitErrorIfaddr = 'V2GInitErrorIfaddr',
  V2GInitErrorThread = 'V2GInitErrorThread',
  V2GInitErrorOpenchannel = 'V2GInitErrorOpenchannel',
  V2GInitErrorKey = 'V2GInitErrorKey',
  V2GSlacErrorGeneral = 'V2GSlacErrorGeneral',
  V2GSlacErrorTimerInit = 'V2GSlacErrorTimerInit',
  V2GSlacErrorTimerTimeout = 'V2GSlacErrorTimerTimeout',
  V2GSlacErrorTimerMisc = 'V2GSlacErrorTimerMisc',
  V2GSlacErrorParamTimeout = 'V2GSlacErrorParamTimeout',
  V2GSlacErrorParamSocket = 'V2GSlacErrorParamSocket',
  V2GSlacErrorStartAttenCharTimeout = 'V2GSlacErrorStartAttenCharTimeout',
  V2GSlacErrorMNBCSoundTimeout = 'V2GSlacErrorMNBCSoundTimeout',
  V2GSlacErrorAttenCharTimeout = 'V2GSlacErrorAttenCharTimeout',
  V2GSlacErrorAttenCharSocket = 'V2GSlacErrorAttenCharSocket',
  V2GSlacErrorValidate1Timeout = 'V2GSlacErrorValidate1Timeout',
  V2GSlacErrorValidate1Socket = 'V2GSlacErrorValidate1Socket',
  V2GSlacErrorValidate2Timeout = 'V2GSlacErrorValidate2Timeout',
  V2GSlacErrorValidate2Socket = 'V2GSlacErrorValidate2Socket',
  V2GSlacErrorBCBToggleTimeout = 'V2GSlacErrorBCBToggleTimeout',
  V2GSlacErrorMatchTimeout = 'V2GSlacErrorMatchTimeout',
  V2GSlacErrorMatchSocket = 'V2GSlacErrorMatchSocket',
  V2GSlacErrorReadSocket = 'V2GSlacErrorReadSocket',
  V2GSlacErrorSetKey = 'V2GSlacErrorSetKey',
  V2GSlacErrorLinkTimeout = 'V2GSlacErrorLinkTimeout',
  V2GSDPErrorGeneral = 'V2GSDPErrorGeneral',
  V2GSDPErrorInitSocket = 'V2GSDPErrorInitSocket',
  V2GSDPErrorInitSockOPT1 = 'V2GSDPErrorInitSockOPT1',
  V2GSDPErrorInitSockOPT2 = 'V2GSDPErrorInitSockOPT2',
  V2GSDPErrorInitBind = 'V2GSDPErrorInitBind',
  V2GSDPErrorThreadSocket1 = 'V2GSDPErrorThreadSocket1',
  V2GSDPErrorThreadSocket2 = 'V2GSDPErrorThreadSocket2',
  V2GSDPErrorTimeout = 'V2GSDPErrorTimeout',
  V2GSDPErrorTCPDisconnected = 'V2GSDPErrorTCPDisconnected',
  V2GDinErrorGeneral = 'V2GDinErrorGeneral',
  V2GDinErrorInitSocket = 'V2GDinErrorInitSocket',
  V2GDinErrorInitSockOPT = 'V2GDinErrorInitSockOPT',
  V2GDinErrorInitBind = 'V2GDinErrorInitBind',
  V2GDinErrorInitListen = 'V2GDinErrorInitListen',
  V2GDinErrorInitSelect = 'V2GDinErrorInitSelect',
  V2GDinErrorInitAccept = 'V2GDinErrorInitAccept',
  V2GDinErrorTimeout = 'V2GDinErrorTimeout',
  V2GDinErrorV2GTPHeader = 'V2GDinErrorV2GTPHeader',
  V2GDinErrorV2GTPHeaderLen = 'V2GDinErrorV2GTPHeaderLen',
  V2GDinErrorV2GTPHeaderWrite = 'V2GDinErrorV2GTPHeaderWrite',
  V2GDinErrorDecodeExi = 'V2GDinErrorDecodeExi',
  V2GDinErrorEncodeExi = 'V2GDinErrorEncodeExi',
  V2GDinErrorCreateResponse = 'V2GDinErrorCreateResponse',
  V2GDinErrorSocketException = 'V2GDinErrorSocketException',
  V2GDinErrorSocketSend = 'V2GDinErrorSocketSend',
  V2GDinErrorNoProtocol = 'V2GDinErrorNoProtocol',
}

/**
 * * `FLAT_RATE` - Flat Rate
 * * `PEAK_RATE` - Peak Rate
 * * `OFF_PEAK_RATE` - Off-peak Rate
 */
export enum VerboseNameEnum {
  FLAT_RATE = 'FLAT_RATE',
  PEAK_RATE = 'PEAK_RATE',
  OFF_PEAK_RATE = 'OFF_PEAK_RATE',
}

/**
 * * `0` - Default
 * * `1` - Monday
 * * `2` - Tuesday
 * * `3` - Wednesday
 * * `4` - Thursday
 * * `5` - Friday
 * * `6` - Saturday
 * * `7` - Sunday
 */
export enum WeekDayEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

/** Serializer for whitelabel variables */
export interface WhitelabelVariables {
  fe_sen: string;
  timezone: string;
  find_waiting_trackers_timeout: string;
  white_label_name: string;
  vat: string;
  phone_code: string;
  currency: string;
  default_latitude: string;
  default_longitude: string;
  document_types: DocumentTypesEnum[];
  default_zoom: string;
  eula: string;
  preauthorization_amount: string;
  preauthorization_treshhold: string;
  maximum_allowed_transaction_duration: string;
  anonymous_transaction_request_min_amount: string;
}
